(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function announcementBar() {
    const STORAGE_KEY_PREFIX = 'mm_announcement_closed:v1:';
    const MS_PER_DAY = 86_400_000;
    const TOUCH_DEBOUNCE_MS = 400;
    const FOCUS_RESTORE_DELAY_MS = 50;

    const $roots = document.querySelectorAll('[data-annc]');
    if (!$roots.length) return;

    /**********************************************/
    /* localStorage helpers (safe for sandboxing) */
    /**********************************************/
    function safeLocalStorageGet(key) {
      try {
        return localStorage.getItem(key);
      } catch (_) {
        return null;
      }
    }

    function safeLocalStorageSet(key, value) {
      try {
        localStorage.setItem(key, value);
      } catch (_) {}
    }

    /****************************/
    /* dismissal state helpers  */
    /****************************/
    function wasPreviouslyDismissed(storageKey) {
      const raw = safeLocalStorageGet(storageKey);
      if (!raw) return false;

      try {
        const data = JSON.parse(raw);
        const isStillValid = !data.expires || Date.now() <= data.expires;

        if (isStillValid) return true;

        localStorage.removeItem(storageKey);
        return false;
      } catch (_) {
        return true;
      }
    }

    function persistDismissal(storageKey, hideDays) {
      const expires = hideDays > 0 ? Date.now() + hideDays * MS_PER_DAY : null;
      safeLocalStorageSet(storageKey, JSON.stringify({ t: Date.now(), expires }));
    }

    function notifyLayoutChanged() {
      window.dispatchEvent(new Event('resize'));
    }

    /******************************/
    /* accessibility: tab control */
    /******************************/
    function isLinkInVisibleSegment($link) {
      const $segment = $link.closest('[data-annc-segment]');
      return $segment && !$segment.hasAttribute('aria-hidden') && !$segment.hasAttribute('inert');
    }

    function isLinkDuplicate($link) {
      return $link.closest('[data-annc-duplicate]') !== null;
    }

    function makeFirstVisibleLinkFocusable($root) {
      const $allLinks = $root.querySelectorAll('[data-annc-track] a');
      let firstVisibleLinkFound = false;

      $allLinks.forEach(($link) => {
        const isFirstVisible = isLinkInVisibleSegment($link) && !isLinkDuplicate($link) && !firstVisibleLinkFound;

        if (isFirstVisible) {
          firstVisibleLinkFound = true;
          $link.setAttribute('tabindex', '0');

          if (!$link.hasAttribute('aria-label')) {
            const linkText = $link.textContent.trim();
            if (linkText) $link.setAttribute('aria-label', linkText);
          }
        } else {
          $link.setAttribute('tabindex', '-1');
        }
      });
    }

    function removeFromTabOrder($element) {
      $element.querySelectorAll('a').forEach(($link) => {
        $link.setAttribute('tabindex', '-1');
      });
    }

    function ensureDuplicatesNotFocusable($root) {
      const $hiddenSegments = $root.querySelectorAll('[data-annc-segment][aria-hidden="true"]');
      $hiddenSegments.forEach(removeFromTabOrder);

      const $duplicateSpans = $root.querySelectorAll('[data-annc-duplicate]');
      $duplicateSpans.forEach(removeFromTabOrder);
    }

    function initAccessibility($root) {
      try {
        makeFirstVisibleLinkFocusable($root);
      } catch (_) {}
      try {
        ensureDuplicatesNotFocusable($root);
      } catch (_) {}
    }

    /***************************************/
    /* pause-on-interaction (touch & click) */
    /***************************************/
    function attachPauseOnInteraction($root, $bar) {
      let lastTouchToggleAt = 0;

      function togglePausedState() {
        const isNowPlaying = !$root.classList.toggle('announcement-bar--paused');

        if (isNowPlaying && $bar) {
          const previousTabindex = $bar.getAttribute('tabindex') || '0';
          $bar.setAttribute('tabindex', '-1');
          $bar.blur();
          setTimeout(() => $bar.setAttribute('tabindex', previousTabindex), FOCUS_RESTORE_DELAY_MS);
        }
      }

      function handleTouchToggle() {
        lastTouchToggleAt = Date.now();
        togglePausedState();
      }

      function isTouchEventRecent() {
        return Date.now() - lastTouchToggleAt < TOUCH_DEBOUNCE_MS;
      }

      if ('PointerEvent' in window) {
        $root.addEventListener(
          'pointerup',
          (event) => {
            const isTouchInput = event.pointerType === 'touch' || event.pointerType === 'pen';
            if (isTouchInput) handleTouchToggle();
          },
          { passive: true }
        );

        if ($bar) {
          $bar.addEventListener('click', () => {
            if (!isTouchEventRecent()) togglePausedState();
          });
        }
      } else {
        const isCoarsePointer = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
        if (isCoarsePointer) $root.addEventListener('click', togglePausedState);
      }
    }

    /************************************/
    /* drag-to-scroll                   */
    /************************************/
    function attachDragToScroll($root, $marquee, $track) {
      if (!$track || !$marquee) return;

      const DRAG_THRESHOLD_PX = 5;
      const DRAG_FLAG_CLEANUP_MS = 500;
      const VELOCITY_BUFFER_SIZE = 5;
      const VELOCITY_MAX_AGE_MS = 100;
      const MOMENTUM_MIN_VELOCITY = 0.3;
      const MOMENTUM_DISTANCE_FACTOR = 0.4;
      const MOMENTUM_MIN_DURATION_MS = 200;
      const MOMENTUM_MAX_DURATION_MS = 1200;
      const MOMENTUM_DURATION_PER_PX = 1.2;

      const BASE_DURATION_MS = parseFloat(getComputedStyle($marquee).animationDuration) * 1000;
      const BASE_CSS = 'animation-duration:' + BASE_DURATION_MS + 'ms;';

      let isPointerDown = false;
      let hasDragged = false;
      let startX = 0;
      let startTranslateX = 0;
      let currentDragX = 0;
      let halfWidth = 0;
      let momentumRafId = 0;
      let activePointerId = -1;
      const velocitySamples = [];

      /* style helpers */
      function applyFrozenStyle(translateX) {
        currentDragX = translateX;
        $marquee.style.cssText = BASE_CSS + 'animation-name:none;' + 'transform:translateX(' + translateX + 'px);';
      }

      function applyRunningStyle(translateX) {
        let progress = translateX / -halfWidth;
        progress = ((progress % 1) + 1) % 1;

        $marquee.style.cssText = BASE_CSS + 'animation-name:none;';
        void $marquee.offsetWidth;
        $marquee.style.cssText = BASE_CSS + 'animation-delay:' + -(progress * BASE_DURATION_MS) + 'ms;';

        if ($track.contains(document.activeElement) || document.activeElement === $track) {
          $track.blur();
        }
      }

      function wrapX(x) {
        x = x % halfWidth;
        if (x > 0) x -= halfWidth;
        return x;
      }

      function easeOutCubic(t) {
        const inv = 1 - t;
        return 1 - inv * inv * inv;
      }

      /* velocity ring buffer */
      function recordSample(x, t) {
        velocitySamples.push({ x, t });
        if (velocitySamples.length > VELOCITY_BUFFER_SIZE) velocitySamples.shift();
      }

      function computeReleaseVelocity(releaseTime) {
        let oldest = null;
        let newest = null;

        for (let i = velocitySamples.length - 1; i >= 0; i--) {
          const sample = velocitySamples[i];
          if (releaseTime - sample.t > VELOCITY_MAX_AGE_MS) break;
          oldest = sample;
          if (!newest) newest = sample;
        }

        if (!oldest || !newest || oldest === newest) return 0;
        const dt = newest.t - oldest.t;
        return dt > 0 ? (newest.x - oldest.x) / dt : 0;
      }

      /* momentum tween */
      function cancelMomentum() {
        if (momentumRafId) {
          cancelAnimationFrame(momentumRafId);
          momentumRafId = 0;
        }
      }

      function startMomentumTween(fromX, velocityPxMs) {
        const projectedDistance = velocityPxMs * 1000 * MOMENTUM_DISTANCE_FACTOR;
        const absDist = Math.abs(projectedDistance);
        const tweenDuration = Math.min(
          MOMENTUM_MAX_DURATION_MS,
          Math.max(MOMENTUM_MIN_DURATION_MS, absDist * MOMENTUM_DURATION_PER_PX)
        );
        const tweenStart = performance.now();

        function tweenStep(now) {
          const rawProgress = Math.min(1, (now - tweenStart) / tweenDuration);
          const currentX = wrapX(fromX + projectedDistance * easeOutCubic(rawProgress));

          if (rawProgress < 1) {
            applyFrozenStyle(currentX);
            momentumRafId = requestAnimationFrame(tweenStep);
          } else {
            momentumRafId = 0;
            finishDrag(currentX);
          }
        }

        momentumRafId = requestAnimationFrame(tweenStep);
      }

      function finishDrag(translateX) {
        $root.classList.remove('announcement-bar--dragging');
        applyRunningStyle(translateX);
      }

      /* pointer handlers */
      function handlePointerDown(event) {
        if (event.button !== 0) return;

        halfWidth = $marquee.offsetWidth / 2;
        if (halfWidth <= 0) return;

        cancelMomentum();

        isPointerDown = true;
        hasDragged = false;
        startX = event.clientX;
        activePointerId = event.pointerId;
        startTranslateX = new DOMMatrix(getComputedStyle($marquee).transform).m41;
        velocitySamples.length = 0;
        recordSample(event.clientX, event.timeStamp);
      }

      function handlePointerMove(event) {
        if (!isPointerDown) return;

        const deltaX = event.clientX - startX;

        if (!hasDragged) {
          if (Math.abs(deltaX) < DRAG_THRESHOLD_PX) return;
          hasDragged = true;
          $track.setPointerCapture(activePointerId);
          applyFrozenStyle(startTranslateX);
          $root.classList.add('announcement-bar--dragging');
        }

        recordSample(event.clientX, event.timeStamp);
        applyFrozenStyle(wrapX(startTranslateX + deltaX));
      }

      function handlePointerUp(event) {
        if (!isPointerDown) return;
        isPointerDown = false;

        if (!hasDragged) {
          if ($marquee.style.getPropertyValue('animation-name') === 'none') {
            finishDrag(startTranslateX);
          }
          return;
        }

        event.stopPropagation();

        $root.dataset.anncDragged = '1';
        setTimeout(function clearDragFlag() {
          delete $root.dataset.anncDragged;
        }, DRAG_FLAG_CLEANUP_MS);

        const velocityPxMs = computeReleaseVelocity(event.timeStamp);

        if (Math.abs(velocityPxMs) > MOMENTUM_MIN_VELOCITY) {
          startMomentumTween(currentDragX, velocityPxMs);
        } else {
          finishDrag(currentDragX);
        }
      }

      function handlePointerCancel() {
        if (!isPointerDown) return;
        isPointerDown = false;
        if (hasDragged) finishDrag(currentDragX);
      }

      /* Suppress link navigation after a drag gesture */
      $root.addEventListener(
        'click',
        function suppressClickAfterDrag(event) {
          if ($root.dataset.anncDragged) {
            event.preventDefault();
            event.stopImmediatePropagation();
            delete $root.dataset.anncDragged;
          }
        },
        true
      );

      $track.addEventListener('pointerdown', handlePointerDown);
      $track.addEventListener('pointermove', handlePointerMove);
      $track.addEventListener('pointerup', handlePointerUp);
      $track.addEventListener('pointercancel', handlePointerCancel);
    }

    /************************************/
    /* per-instance initialization      */
    /************************************/
    function computeMaxOverlap($root, $fullWidthElements) {
      const barRect = $root.getBoundingClientRect();
      const barTop = barRect.top;
      const barBottom = barRect.bottom;
      const barHeight = barBottom - barTop;

      if (barHeight <= 0) return -1;

      let maxOverlap = 0;

      for (let i = 0; i < $fullWidthElements.length; i++) {
        const elRect = $fullWidthElements[i].getBoundingClientRect();
        const intersect = Math.min(barBottom, elRect.bottom) - Math.max(barTop, elRect.top);
        if (intersect > 0) {
          maxOverlap = Math.max(maxOverlap, Math.min(1, intersect / barHeight));
        }
      }

      return maxOverlap;
    }

    function observeFullWidthOverlap($root) {
      const $fullWidthElements = document.querySelectorAll(
        '.orbital-p5-hero, .orbital-video-hero, .campaign-section--width-ultra .campaign-single-placement-media'
      );
      if (!$fullWidthElements.length) return;

      let ticking = false;

      function updateOverlap() {
        const maxOverlap = computeMaxOverlap($root, $fullWidthElements);
        if (maxOverlap >= 0) {
          $root.style.setProperty('--hero-overlap', `${(maxOverlap * 100).toFixed(1)}%`);
        }
      }

      function onScroll() {
        if (!$root.isConnected) {
          window.removeEventListener('scroll', onScroll);
          return;
        }
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(function handleFrame() {
            updateOverlap();
            ticking = false;
          });
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      updateOverlap();
    }

    function initAnnouncementBarInstance($root) {
      if ($root.dataset.announcementInit) return;
      $root.dataset.announcementInit = '1';

      const storageKey = STORAGE_KEY_PREFIX + ($root.dataset.announcementKey || '');
      const hideDays = parseInt($root.dataset.hideDays || '0', 10) || 0;

      if (wasPreviouslyDismissed(storageKey)) {
        $root.remove();
        return;
      }

      const $closeButton = $root.querySelector('[data-annc-close]');
      if ($closeButton) {
        $closeButton.addEventListener('click', () => {
          persistDismissal(storageKey, hideDays);
          $root.remove();
          notifyLayoutChanged();
        });
      }

      const $inner = $root.querySelector('[data-annc-marquee]');
      const $bar = $root.querySelector('[data-annc-track]');
      if (!$inner) return;

      initAccessibility($root);
      attachPauseOnInteraction($root, $bar);
      attachDragToScroll($root, $inner, $bar);
      observeFullWidthOverlap($root);
    }

    $roots.forEach(initAnnouncementBarInstance);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  (function articleFeedback() {
    'use strict';

    const LIKE_BUTTON_SELECTOR = '[data-article-like-button]';
    const LIKE_COUNT_SELECTOR = '[data-article-like-count-label]';
    const HEART_LOTTIE_SELECTOR = '[data-article-heart-lottie]';
    const SHARE_BUTTON_SELECTOR = '[data-article-share-button]';
    const LIKE_STORAGE_KEY_PREFIX = 'mm_article_like:';
    const LIKE_FRAME_START = 0;
    const LIKE_FRAME_END = 24;
    const UNLIKE_FRAME_START = 24;
    const UNLIKE_FRAME_END = 60;
    const UNLIKE_VISUAL_FRAME = 55;

    // Normalize anything count-like into a safe non-negative integer.
    function toPositiveInteger(value, fallback) {
      const parsed = parseInt(value, 10);
      return Number.isFinite(parsed) && parsed >= 0 ? parsed : fallback;
    }

    // Scope stored like state to the current article.
    function getLikeStorageKey(articleId) {
      return LIKE_STORAGE_KEY_PREFIX + String(articleId || '');
    }

    // Read from localStorage defensively so private browsing/storage failures do not break the page.
    function getStoredValue(key) {
      try {
        return window.localStorage.getItem(key);
      } catch (error) {
        return null;
      }
    }

    // Persist best-effort local state without throwing if storage is unavailable.
    function setStoredValue(key, value) {
      try {
        window.localStorage.setItem(key, value);
      } catch (error) {}
    }

    // Keep the visible count and the button dataset in sync.
    function renderLikeCount(button, count) {
      const countLabel = button.querySelector(LIKE_COUNT_SELECTOR);
      const nextCount = toPositiveInteger(count, 0);

      button.dataset.articleLikeCount = String(nextCount);

      if (countLabel) {
        countLabel.textContent = String(nextCount);
      } else {
        button.textContent = String(nextCount);
      }
    }

    function setLikedState(button, isLiked) {
      const likedValue = isLiked ? 'true' : 'false';
      button.dataset.articleLiked = likedValue;
      button.setAttribute('aria-pressed', likedValue);
      button.setAttribute('title', isLiked ? 'You already liked this article' : 'Like this article');
    }

    const SETTLE_DELAY_MS = 800;
    let lottieLoading = false;
    const lottieLoadQueue = [];
    const lottieErrorQueue = [];

    // Lazy-load the Lottie library, reusing a single load across all callers.
    function loadLottieLib(libUrl, callback, onError) {
      if (window.lottie) return callback();
      lottieLoadQueue.push(callback);
      if (typeof onError === 'function') lottieErrorQueue.push(onError);
      if (lottieLoading) return;
      lottieLoading = true;
      const script = document.createElement('script');
      script.src = libUrl;
      script.async = true;
      script.onload = function handleLottieLoaded() {
        lottieLoading = false;
        lottieErrorQueue.length = 0;
        const queue = lottieLoadQueue.slice();
        lottieLoadQueue.length = 0;
        queue.forEach(function runQueued(cb) { try { cb(); } catch (_) {} });
      };
      script.onerror = function handleLottieError() {
        lottieLoading = false;
        lottieLoadQueue.length = 0;
        const errors = lottieErrorQueue.slice();
        lottieErrorQueue.length = 0;
        errors.forEach(function runErrorCb(cb) { try { cb(); } catch (_) {} });
      };
      document.head.appendChild(script);
    }

    function initHeartLottie(container, onReady) {
      if (container._heartAnim) {
        if (container._heartAnimReady) {
          if (onReady) onReady(container._heartAnim);
        } else {
          container._heartAnim.addEventListener('DOMLoaded', function handleReady() {
            if (onReady) onReady(container._heartAnim);
          });
        }
        return container._heartAnim;
      }
      if (!window.lottie) return null;
      container._heartAnimReady = false;
      container._heartAnim = window.lottie.loadAnimation({
        container: container,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: container.dataset.lottiePath,
        rendererSettings: { preserveAspectRatio: 'xMidYMid meet' },
      });
      container._heartAnim.addEventListener('DOMLoaded', function handleDOMLoaded() {
        container._heartAnimReady = true;
        if (onReady) onReady(container._heartAnim);
      });
      return container._heartAnim;
    }

    function playHeartSegment(container, startFrame, endFrame, onFrameReached, triggerFrame) {
      if (!container) return;
      const libUrl = container.dataset.lottieLib || '';

      function playSegment() {
        initHeartLottie(container, function onReady(anim) {
          if (typeof onFrameReached === 'function') {
            let triggered = false;
            function handleEnterFrame(event) {
              if (triggered) return;
              if (event.currentTime >= triggerFrame - startFrame) {
                triggered = true;
                anim.removeEventListener('enterFrame', handleEnterFrame);
                onFrameReached();
              }
            }
            anim.addEventListener('enterFrame', handleEnterFrame);
          }
          anim.playSegments([startFrame, endFrame], true);
        });
      }

      if (window.lottie) {
        playSegment();
      } else if (libUrl) {
        loadLottieLib(libUrl, playSegment, onFrameReached);
      } else if (typeof onFrameReached === 'function') {
        onFrameReached();
      }
    }

    // Show a specific static frame, lazy-loading if needed.
    function showHeartFrame(container, frame) {
      if (!container) return;
      const libUrl = container.dataset.lottieLib || '';

      function stopAtFrame() {
        initHeartLottie(container, function onReady(anim) {
          anim.goToAndStop(frame, true);
        });
      }

      if (window.lottie) {
        stopAtFrame();
      } else if (libUrl) {
        loadLottieLib(libUrl, stopAtFrame);
      }
    }

    function bindLikeButton(button) {
      if (!button || button._articleLikeBound) return;
      button._articleLikeBound = true;

      const articleId = button.dataset.articleId || '';
      const articleHandle = button.dataset.articleHandle || '';
      const endpoint = button.dataset.articleLikeEndpoint || '';
      const lottieContainer = button.querySelector(HEART_LOTTIE_SELECTOR);
      const likeStorageKey = getLikeStorageKey(articleId);
      const initialCount = toPositiveInteger(button.dataset.articleLikeCount, 0);
      let currentCount = initialCount;
      let isLiked = getStoredValue(likeStorageKey) === '1';
      let settleTimer = null;
      let lastSyncedLiked = isLiked;
      let unlikeVisualPending = false;
      let unlikeGeneration = 0;

      renderLikeCount(button, currentCount);
      setLikedState(button, isLiked);

      // Show the correct resting frame on load.
      if (lottieContainer) {
        const restFrame = isLiked ? LIKE_FRAME_END - 1 : 0;
        showHeartFrame(lottieContainer, restFrame);
      }

      // Send the settled state to the server after toggling stops.
      function flushToServer() {
        if (!endpoint || typeof window.fetch !== 'function') return;
        if (isLiked === lastSyncedLiked) return;

        const action = isLiked ? 'like' : 'unlike';
        lastSyncedLiked = isLiked;

        window
          .fetch(endpoint, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              articleId: articleId,
              articleHandle: articleHandle,
              action: action,
            }),
          })
          .then(function handleResponse(response) {
            return response.text().then(function parseResponse(text) {
              let payload = {};

              if (text) {
                try {
                  payload = JSON.parse(text);
                } catch (error) {}
              }

              if (!response.ok) {
                const requestError = new Error(action + ' request failed');
                requestError.payload = payload;
                throw requestError;
              }

              return payload;
            });
          })
          .then(function handlePayload(payload) {
            const nextCount = toPositiveInteger(payload && payload.likeCount, currentCount);
            if (!unlikeVisualPending) {
              currentCount = nextCount;
              renderLikeCount(button, currentCount);
            }
          })
          .catch(function handleError() {
            lastSyncedLiked = !isLiked;
          });
      }

      button.addEventListener('click', function handleLikeClick() {
        if (isLiked) {
          currentCount = Math.max(0, currentCount - 1);
          isLiked = false;
          setStoredValue(likeStorageKey, '0');
          unlikeVisualPending = true;
          const generation = ++unlikeGeneration;

          playHeartSegment(lottieContainer, UNLIKE_FRAME_START, UNLIKE_FRAME_END, function onUnlikeNearEnd() {
            if (generation !== unlikeGeneration) return;
            unlikeVisualPending = false;
            renderLikeCount(button, currentCount);
            setLikedState(button, isLiked);
          }, UNLIKE_VISUAL_FRAME);
        } else {
          currentCount += 1;
          isLiked = true;
          unlikeVisualPending = false;
          unlikeGeneration += 1;
          setStoredValue(likeStorageKey, '1');
          playHeartSegment(lottieContainer, LIKE_FRAME_START, LIKE_FRAME_END);
          renderLikeCount(button, currentCount);
          setLikedState(button, isLiked);
        }

        clearTimeout(settleTimer);
        settleTimer = setTimeout(flushToServer, SETTLE_DELAY_MS);
      });
    }

    function bindShareButton(button) {
      if (!button || button._articleShareBound) return;
      button._articleShareBound = true;

      const title = button.dataset.articleShareTitle || document.title;
      const url = button.dataset.articleShareUrl || window.location.href;

      button.addEventListener('click', function handleShareClick() {
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function ignoreError() {});
          return;
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).catch(function ignoreError() {});
          return;
        }

        window.open(url, '_blank', 'noopener');
      });
    }

    function initArticleFeedback(scope) {
      const root = scope && scope.querySelectorAll ? scope : document;

      root.querySelectorAll(LIKE_BUTTON_SELECTOR).forEach(function bindEachLikeButton(button) {
        bindLikeButton(button);
      });

      root.querySelectorAll(SHARE_BUTTON_SELECTOR).forEach(function bindEachShareButton(button) {
        bindShareButton(button);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function onReady() {
        initArticleFeedback(document);
      });
    } else {
      initArticleFeedback(document);
    }

    document.addEventListener('shopify:section:load', function handleSectionLoad(event) {
      const target = event.target || document;
      initArticleFeedback(target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
  (function blog() {
    'use strict';

    const STORAGE_KEY_PREFIX = 'mm_blog_loaded_count:';
    const SECTION_SELECTOR = '[data-blog-section]';
    const GRID_SELECTOR = '[data-blog-grid]';
    const BUTTON_SELECTOR = '[data-blog-load-more-btn]';
    const WRAPPER_SELECTOR = '[data-blog-load-more-wrapper]';
    const SUMMARY_SELECTOR = '[data-blog-load-more-summary]';

    function getStorageKey() {
      return STORAGE_KEY_PREFIX + window.location.pathname;
    }

    function getStoredCount(key) {
      try {
        const raw = window.sessionStorage.getItem(key);
        if (!raw) return null;
        const n = parseInt(raw, 10);
        return isNaN(n) || n <= 0 ? null : n;
      } catch (e) {
        return null;
      }
    }

    function setStoredCount(key, count) {
      try {
        window.sessionStorage.setItem(key, String(count));
      } catch (e) { /* sessionStorage unavailable */ }
    }

    function fetchPageDocument(url) {
      return window
        .fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function handleResponse(response) {
          if (!response.ok) {
            const error = new Error('Network response was not ok');
            error.status = response.status;
            throw error;
          }
          return response.text();
        })
        .then(function parseHTML(html) {
          return new DOMParser().parseFromString(html, 'text/html');
        });
    }

    function appendArticles(doc, $grid, $button, $wrapper, $summary, storageKey) {
      const $newGrid = doc.querySelector(GRID_SELECTOR);
      const $newButton = doc.querySelector(BUTTON_SELECTOR);
      const $newSummary = doc.querySelector(SUMMARY_SELECTOR);

      if (!$newGrid) return { hasMore: false, firstNew: null };

      const $firstNew = $newGrid.firstElementChild;

      while ($newGrid.firstElementChild) {
        $grid.appendChild($newGrid.firstElementChild);
      }

      if ($newSummary && $summary) {
        $summary.textContent = $newSummary.textContent;
      }

      setStoredCount(storageKey, $grid.children.length);

      if ($newButton && $newButton.getAttribute('data-next-url')) {
        $button.setAttribute('data-next-url', $newButton.getAttribute('data-next-url'));
        return { hasMore: true, firstNew: $firstNew };
      }

      $button.removeAttribute('data-next-url');
      return { hasMore: false, firstNew: $firstNew };
    }

    function restoreFromStorage($section, $grid, $button, $wrapper, $summary, storageKey) {
      const storedCount = getStoredCount(storageKey);
      if (!storedCount) return Promise.resolve();
      if (!$button || !$button.getAttribute('data-next-url')) return Promise.resolve();

      const pageSize = $grid.children.length;
      if (!pageSize || pageSize >= storedCount) return Promise.resolve();

      const nextUrl = $button.getAttribute('data-next-url');
      const origin = window.location.origin;
      let currentPage = 1;

      try {
        const parsed = new URL(nextUrl, origin);
        const nextPageNum = parseInt(parsed.searchParams.get('page') || '2', 10);
        if (!isNaN(nextPageNum) && nextPageNum > 1) currentPage = nextPageNum - 1;
      } catch (e) {
        return Promise.resolve();
      }

      const pagesNeeded = Math.ceil((storedCount - pageSize) / pageSize);
      if (pagesNeeded <= 0) return Promise.resolve();

      const urls = [];
      for (let p = currentPage + 1; p <= currentPage + pagesNeeded; p++) {
        try {
          const u = new URL(nextUrl, origin);
          u.searchParams.set('page', String(p));
          urls.push(u.pathname + u.search + u.hash);
        } catch (e) {
          return Promise.resolve();
        }
      }
      if (!urls.length) return Promise.resolve();

      $button.disabled = true;

      return Promise.all(
        urls.map(function fetchPage(u) {
          return fetchPageDocument(u).catch(function swallowError() {
            return null;
          });
        })
      )
        .then(function applyPages(docs) {
          docs.forEach(function applyPage(doc) {
            if (!doc) return;
            appendArticles(doc, $grid, $button, $wrapper, $summary, storageKey);
          });
        })
        .then(function enableButton() {
          if ($button.parentNode) {
            $button.disabled = false;
          }
        });
    }

    function initBlogLoadMore($section) {
      if (!$section) return;

      const $grid = $section.querySelector(GRID_SELECTOR);
      const $button = $section.querySelector(BUTTON_SELECTOR);
      const $wrapper = $section.querySelector(WRAPPER_SELECTOR);
      const $summary = $section.querySelector(SUMMARY_SELECTOR);

      if (!$grid || !$button) return;
      if ($button._blogLoadMoreBound) return;
      $button._blogLoadMoreBound = true;

      const storageKey = getStorageKey();
      const defaultLabel = $button.getAttribute('data-load-more-label') || $button.textContent.trim();
      const loadingLabel = $button.getAttribute('data-loading-label') || defaultLabel;
      const loadLessLabel = $button.getAttribute('data-load-less-label') || 'Load less';
      const pageSize = parseInt($button.getAttribute('data-page-size') || '6', 10);
      const initialNextUrl = $button.getAttribute('data-next-url');
      const totalItems = $summary ? parseInt($summary.getAttribute('data-total-items') || '0', 10) : 0;
      let isLoading = false;
      let isRestoring = true;
      let isFullyLoaded = false;

      function saveOriginalItems() {
        if (!$grid._originalItems) {
          $grid._originalItems = Array.from($grid.children).map(function cloneItem($item) {
            return $item.cloneNode(true);
          });
        }
      }

      saveOriginalItems();

      function updateSummary() {
        if (!$summary) return;
        const viewedCount = Math.min($grid.children.length, totalItems);
        $summary.textContent = "You've viewed " + viewedCount + ' of ' + totalItems + ' articles';
      }

      function collapseToDefault() {
        while ($grid.firstChild) {
          $grid.removeChild($grid.firstChild);
        }
        $grid._originalItems.forEach(function restoreItem($item) {
          $grid.appendChild($item.cloneNode(true));
        });
        isFullyLoaded = false;
        $button.textContent = defaultLabel;
        $button.setAttribute('data-next-url', initialNextUrl);
        setStoredCount(storageKey, 0);
        updateSummary();
      }

      restoreFromStorage($section, $grid, $button, $wrapper, $summary, storageKey)
        .then(function restoreComplete() {
          isRestoring = false;
          const nextUrl = $button.getAttribute('data-next-url');
          if (!nextUrl && $grid.children.length > pageSize) {
            isFullyLoaded = true;
            $button.textContent = loadLessLabel;
          }
          updateSummary();
        });

      $button.addEventListener('click', function handleLoadMoreClick() {
        if (isLoading || isRestoring) return;

        if (isFullyLoaded) {
          collapseToDefault();
          $grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }

        const nextUrl = $button.getAttribute('data-next-url');
        if (!nextUrl) return;

        $button.textContent = loadingLabel;
        $button.disabled = true;
        $button.setAttribute('aria-busy', 'true');
        isLoading = true;

        fetchPageDocument(nextUrl)
          .then(function handleFetchedPage(doc) {
            const result = appendArticles(doc, $grid, $button, $wrapper, $summary, storageKey);

            if (result.firstNew) {
              result.firstNew.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }

            if (result.hasMore) {
              $button.textContent = defaultLabel;
              $button.disabled = false;
              $button.removeAttribute('aria-busy');
              updateSummary();
            } else {
              isFullyLoaded = true;
              $button.textContent = loadLessLabel;
              $button.disabled = false;
              $button.removeAttribute('aria-busy');
              updateSummary();
            }
          })
          .catch(function handleFetchError() {
            window.location.href = nextUrl;
          })
          .finally(function resetLoadingState() {
            isLoading = false;
          });
      });
    }

    function initAllBlogSections() {
      const $sections = document.querySelectorAll(SECTION_SELECTOR);
      $sections.forEach(function initEachSection($section) {
        initBlogLoadMore($section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllBlogSections);
    } else {
      initAllBlogSections();
    }

    document.addEventListener('shopify:section:load', function handleSectionLoad(event) {
      const $target = event.target || (event.detail && event.detail.sectionId &&
        document.querySelector('[data-section-id="' + event.detail.sectionId + '"]'));
      if (!$target || !$target.matches(SECTION_SELECTOR)) return;
      initBlogLoadMore($target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deck-of-cards-upsell"] && !Shopify.designMode) return;
  try {
    
  (function deckOfCardsUpsell() {
    const $deck = document.querySelector('[data-deck-upsell-cards]');
    if (!$deck) return;

    const $deckMobile = $deck.closest('[data-deck-upsell]');
    const $instructions = $deckMobile?.querySelector('[data-deck-upsell-instructions]');
    const $ctaWrapper = $deckMobile?.querySelector('[data-deck-upsell-cta-wrapper]');
    const $ctaTitle = $deckMobile?.querySelector('[data-deck-upsell-cta-title]');
    const $cta = $deckMobile?.querySelector('[data-deck-upsell-cta]');

    const ROTATION_FACTOR = 0.1;

    let animationStartTimeout = null;
    let animationCycleTimeout = null;
    let isDragging = false;
    let isHorizontalSwipe = null;
    let startX = 0;
    let startY = 0;
    let currentX = 0;
    let currentY = 0;
    let startTime = 0;
    let $activeCard = null;
    let $nextCard = null;
    let inFlightCards = new Set();
    let isTransitioning = false;
    let instructionsDismissed = false;
    let instructionsReappearTimeout = null;

    function startInstructionsAnimation() {
      const INSTRUCTIONS_ANIMATION_START_DELAY = 5000;
      
      if (!$instructions) return;

      if (animationStartTimeout) clearTimeout(animationStartTimeout);
      if (animationCycleTimeout) clearTimeout(animationCycleTimeout);

      $instructions.classList.remove('deck-upsell__instructions--animate');
      
      animationStartTimeout = setTimeout(function addAnimationClass() {
        $instructions.classList.add('deck-upsell__instructions--animate');
      }, INSTRUCTIONS_ANIMATION_START_DELAY);
    }

    if ($instructions) {
      $instructions.addEventListener('animationiteration', function onAnimationIteration() {
        const INSTRUCTIONS_ANIMATION_CYCLE_DELAY = 10000;
        
        $instructions.classList.remove('deck-upsell__instructions--animate');
        animationCycleTimeout = setTimeout(function restartAnimation() {
          $instructions.classList.add('deck-upsell__instructions--animate');
        }, INSTRUCTIONS_ANIMATION_CYCLE_DELAY);
      });

      startInstructionsAnimation();
    }

    function updateCta($card) {
      if (!$card) return;
      const title = $card.dataset.deckUpsellTitle;
      const href = $card.dataset.deckUpsellHref;
      const btn = $card.dataset.deckUpsellBtn;
      if (title && $ctaTitle) $ctaTitle.textContent = title;
      if (href && $cta) $cta.href = href;
      if (btn && $cta) $cta.textContent = btn;
    }

    const $cards = Array.from($deck.querySelectorAll('[data-deck-upsell-card]'));
    if ($cards.length === 0) return;

    $cards.forEach(function setCardZIndex($card, i) {
      $card.style.zIndex = $cards.length - i;
    });

    const $topCard = $cards[0];
    if ($topCard) {
      $topCard.style.transition = 'none';
      $topCard.classList.add('deck-upsell__cards__card--top');
      void $topCard.offsetWidth;
      $topCard.style.transition = '';
      updateCta($topCard);
    }

    function scheduleInstructionsReappear() {
      const INSTRUCTIONS_REAPPEAR_DELAY = 7500;
      
      if (instructionsReappearTimeout) {
        clearTimeout(instructionsReappearTimeout);
      }
      instructionsReappearTimeout = setTimeout(function reappearInstructions() {
        if ($instructions) {
          instructionsDismissed = false;
          $instructions.style.opacity = '';
          startInstructionsAnimation();
        }
        instructionsReappearTimeout = null;
      }, INSTRUCTIONS_REAPPEAR_DELAY);
    }

    function cancelInstructionsReappear() {
      if (instructionsReappearTimeout) {
        clearTimeout(instructionsReappearTimeout);
        instructionsReappearTimeout = null;
      }
    }

    function getTopCard() {
      let topCard = null;
      let maxZ = -1;
      $cards.forEach(function findTopCard($card) {
        if (inFlightCards.has($card)) return;
        const z = parseInt($card.style.zIndex) || 0;
        if (z > maxZ) {
          maxZ = z;
          topCard = $card;
        }
      });
      return topCard;
    }

    function getSecondCard() {
      let secondCard = null;
      let maxZ = -1;
      let secondMaxZ = -1;
      let topCard = null;
      $cards.forEach(function findSecondCard($card) {
        if (inFlightCards.has($card)) return;
        const z = parseInt($card.style.zIndex) || 0;
        if (z > maxZ) {
          secondMaxZ = maxZ;
          secondCard = topCard;
          maxZ = z;
          topCard = $card;
        } else if (z > secondMaxZ) {
          secondMaxZ = z;
          secondCard = $card;
        }
      });
      return secondCard;
    }

    function onPointerDown(e) {
      if (isTransitioning) return;
      
      const $card = getTopCard();
      if (!$card || $card !== e.target.closest('[data-deck-upsell-card]')) return;

      cancelInstructionsReappear();

      isDragging = true;
      isHorizontalSwipe = null;
      $activeCard = $card;
      $nextCard = getSecondCard();
      
      if ($nextCard) {
        $nextCard.style.transition = 'none';
      }
      
      startX = e.clientX || e.touches?.[0]?.clientX || 0;
      startY = e.clientY || e.touches?.[0]?.clientY || 0;
      currentX = 0;
      currentY = 0;
      startTime = Date.now();

      $card.classList.add('deck-upsell__cards__card--dragging');
      $card.classList.remove('deck-upsell__cards__card--animating');
    }

    function onPointerMove(e) {
      const DIRECTION_LOCK_THRESHOLD = 10;
      const HORIZONTAL_ANGLE_LIMIT = 45;
      const CARD_BASE_SCALE = 0.95;
      const CARD_SCALE_INCREMENT = 0.05;
      
      if (!isDragging || !$activeCard) return;

      const clientX = e.clientX || e.touches?.[0]?.clientX || 0;
      const clientY = e.clientY || e.touches?.[0]?.clientY || 0;

      currentX = clientX - startX;
      currentY = clientY - startY;

      if (isHorizontalSwipe === null) {
        const distance = Math.sqrt(currentX * currentX + currentY * currentY);
        if (distance > DIRECTION_LOCK_THRESHOLD) {
          const angle = Math.abs(Math.atan2(Math.abs(currentY), Math.abs(currentX)) * (180 / Math.PI));
          isHorizontalSwipe = angle <= HORIZONTAL_ANGLE_LIMIT;
          
          if (!isHorizontalSwipe) {
            isDragging = false;
            $activeCard.classList.remove('deck-upsell__cards__card--dragging');
            $activeCard.style.transform = '';
            if ($nextCard) {
              $nextCard.style.transition = '';
              $nextCard.style.scale = '';
            }
            $activeCard = null;
            $nextCard = null;
            return;
          }
        } else {
          return;
        }
      }

      if (e.cancelable) {
        e.preventDefault();
      }

      const rotation = currentX * ROTATION_FACTOR;
      const distance = Math.sqrt(currentX * currentX + currentY * currentY);
      
      const maxDistance = Math.sqrt(Math.pow(window.innerWidth / 2, 2) + Math.pow(window.innerHeight / 2, 2));
      const progress = Math.min(distance / maxDistance, 1);

      if ($nextCard) {
        const nextScale = CARD_BASE_SCALE + (CARD_SCALE_INCREMENT * progress);
        $nextCard.style.scale = nextScale;
      }

      if ($instructions && !instructionsDismissed) {
        $instructions.style.opacity = 1 - progress;
      }

      if ($ctaWrapper) {
        $ctaWrapper.style.opacity = 1 - progress;
      }

      $activeCard.style.transform = `translate(${currentX}px, ${currentY}px) rotate(${rotation}deg)`;
    }

    function onPointerUp(e) {
      const SWIPE_THRESHOLD = 100;
      const VELOCITY_THRESHOLD = 0.5;
      
      if (!isDragging || !$activeCard) return;
      isDragging = false;

      const $card = $activeCard;
      const $next = $nextCard;
      $activeCard = null;
      $nextCard = null;

      $card.classList.remove('deck-upsell__cards__card--dragging');
      $card.classList.add('deck-upsell__cards__card--animating');

      const elapsed = Math.max(1, Date.now() - startTime);
      const velocityX = Math.abs(currentX) / elapsed;
      const velocityY = Math.abs(currentY) / elapsed;
      const velocity = Math.sqrt(velocityX * velocityX + velocityY * velocityY);

      const distance = Math.sqrt(currentX * currentX + currentY * currentY);

      const shouldSwipe = distance > SWIPE_THRESHOLD || velocity > VELOCITY_THRESHOLD;

      if (shouldSwipe) {
        dismissCard($card, currentX, currentY, $next);
      } else {
        $card.style.transform = '';
        if ($next) {
          $next.style.transition = '';
          $next.style.scale = '';
        }
        if ($instructions && !instructionsDismissed) {
          $instructions.style.opacity = '';
        }
        if ($ctaWrapper) {
          $ctaWrapper.style.opacity = '';
        }
        scheduleInstructionsReappear();
      }
    }

    function dismissCard($card, deltaX, deltaY, $next) {
      const HIGH_Z_INDEX_OFFSET = 100;
      const SWIPE_ROTATION_MULTIPLIER = 2;
      const CARD_RESET_DELAY = 300;
      const SCALE_DURATION = 150;
      
      const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
      const directionX = deltaX / distance;
      const directionY = deltaY / distance;

      const flyDistance = Math.max(window.innerWidth, window.innerHeight);
      const endX = directionX * flyDistance;
      const endY = directionY * flyDistance;
      const rotation = deltaX * ROTATION_FACTOR * SWIPE_ROTATION_MULTIPLIER;

      const highZ = $cards.length + HIGH_Z_INDEX_OFFSET;
      $card.style.zIndex = highZ;

      if ($instructions && !instructionsDismissed) {
        $instructions.style.opacity = '0';
        instructionsDismissed = true;
      }

      if ($ctaWrapper) {
        $ctaWrapper.style.opacity = '0';
      }

      inFlightCards.add($card);
      isTransitioning = true;
      $card.style.scale = '1';
      $card.classList.remove('deck-upsell__cards__card--top');
      $card.style.transform = `translate(${endX}px, ${endY}px) rotate(${rotation}deg)`;

      if ($next) {
        $next.style.transition = '';
        $next.style.scale = '';
      }

      const $nextTop = getTopCard();
      if ($nextTop) {
        $nextTop.classList.add('deck-upsell__cards__card--top');
      }

      setTimeout(function endTransition() {
        isTransitioning = false;
      }, SCALE_DURATION);

      setTimeout(function resetCard() {
        $card.classList.remove('deck-upsell__cards__card--animating');
        $card.style.transition = 'none';
        $card.style.transform = '';
        $card.style.scale = '';
        void $card.offsetWidth;
        $card.style.transition = '';
        
        $cards.forEach(function incrementZIndex($c) {
          if ($c !== $card && !inFlightCards.has($c)) {
            const currentZ = parseInt($c.style.zIndex) || 0;
            $c.style.zIndex = currentZ + 1;
          }
        });
        $card.style.zIndex = 0;
        inFlightCards.delete($card);

        const $newTopCard = getTopCard();
        updateCta($newTopCard);
        if ($ctaWrapper) {
          $ctaWrapper.style.opacity = '';
        }
        scheduleInstructionsReappear();
      }, CARD_RESET_DELAY);
    }

    $deck.addEventListener('mousedown', onPointerDown);
    $deck.addEventListener('touchstart', onPointerDown, { passive: true });

    window.addEventListener('mousemove', onPointerMove);
    window.addEventListener('touchmove', onPointerMove, { passive: false });

    window.addEventListener('mouseup', onPointerUp);
    window.addEventListener('touchend', onPointerUp);
    window.addEventListener('touchcancel', onPointerUp);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deck-of-cards"] && !Shopify.designMode) return;
  try {
    
  (function deckOfCards() {
    const $deck = document.querySelector('[data-deck-cards]');
    if (!$deck) return;

    const $deckContainer = $deck.closest('.deck');
    const $title = $deckContainer.querySelector('[data-deck-title]');
    const $cards = Array.from($deck.querySelectorAll('[data-deck-card]'));
    const $leftBtn = $deck.querySelector('[data-deck-left-btn]');
    const $rightBtn = $deck.querySelector('[data-deck-right-btn]');
    const $controlsTitle = $deck.querySelector('[data-deck-controls-title]');
    const $controlsCaption = $deck.querySelector('[data-deck-controls-caption]');
    const $cta = $deck.querySelector('[data-deck-cta]');
    const totalCards = $cards.length;

    let resizeTimeout = null;
    let visibleIndices = [totalCards - 1, 0, 1];
    let isNavigating = false;
    let navigationQueue = [];
    let resumeTimeout = null;
    let fanInCheckInterval = null;
    let leftAnim = null;
    let rightAnim = null;

    const POSITION_CLASSES = {
      left: 'deck__cards__card--pos-left',
      center: 'deck__cards__card--pos-center',
      right: 'deck__cards__card--pos-right',
      offLeft: 'deck__cards__card--pos-off-left',
      offRight: 'deck__cards__card--pos-off-right',
      active: 'deck__cards__card--active',
    };

    function fitTitle() {
      if (!$title) return;
      const maxWidth = $deckContainer.offsetWidth * 0.95;
      let fontSize = 360;

      $title.style.fontSize = fontSize + 'px';

      while ($title.scrollWidth > maxWidth && fontSize > 10) {
        fontSize -= 2;
        $title.style.fontSize = fontSize + 'px';
      }
    }

    function clearAllInlineStyles() {
      $cards.forEach(function clearCardStyles($card) {
        const $wrapper = $card.querySelector('[data-card-img-wrapper]');
        if ($wrapper) {
          $wrapper.style.transition = '';
          $wrapper.style.rotate = '';
          $wrapper.style.translate = '';
          $wrapper.style.width = '';
        }
      });
    }

    window.addEventListener('resize', function handleResize() {
      const RESIZE_DEBOUNCE_DELAY = 150;

      $deckContainer.classList.add('deck--resizing');
      clearAllInlineStyles();
      fitTitle();

      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function removeResizingClass() {
        $deckContainer.classList.remove('deck--resizing');
      }, RESIZE_DEBOUNCE_DELAY);
    });

    if (totalCards < 3) return;

    function getDeckVars() {
      const $deckEl = $deck.closest('.deck');
      const styles = getComputedStyle($deckEl);
      return {
        cardWidth: parseFloat(styles.getPropertyValue('--deck-card-width')) || 424,
        cardWidthStacked: parseFloat(styles.getPropertyValue('--deck-card-width-stacked')) || 392,
        idleOffsetX: parseFloat(styles.getPropertyValue('--deck-idle-offset-x')) || 17,
        idleOffsetY: parseFloat(styles.getPropertyValue('--deck-idle-offset-y')) || 10,
        transitionDuration: parseFloat(styles.getPropertyValue('--deck-transition-duration')) * 1000 || 1200,
        transitionEasing: styles.getPropertyValue('--deck-transition-easing').trim() || 'cubic-bezier(0.9, 0, 0.1, 1)',
      };
    }

    function clearPositionClasses($card) {
      $card.classList.remove(
        POSITION_CLASSES.left,
        POSITION_CLASSES.center,
        POSITION_CLASSES.right,
        POSITION_CLASSES.offLeft,
        POSITION_CLASSES.offRight,
        POSITION_CLASSES.active
      );
    }

    function updateControlsTitle() {
      const $centerCard = $cards[visibleIndices[1]];
      const title = $centerCard?.querySelector('[data-card-title]')?.textContent || '';
      const caption = $centerCard?.querySelector('[data-card-caption]')?.textContent || '';
      if ($controlsTitle) {
        $controlsTitle.textContent = title;
        $controlsTitle.classList.toggle('deck__cards__controls__content__title--empty', title.trim() === '');
      }
      if ($controlsCaption) {
        $controlsCaption.textContent = caption;
        $controlsCaption.classList.toggle('deck__cards__controls__content__caption--empty', caption.trim() === '');
      }
    }

    function updateCta() {
      if (!$cta) return;
      const $centerCard = $cards[visibleIndices[1]];
      if (!$centerCard) return;
      const text = $centerCard.dataset.deckCtaText;
      const href = $centerCard.dataset.deckCtaHref;
      const showCta = $centerCard.dataset.deckCtaShow;
      if (text) $cta.textContent = text;
      if (href) $cta.href = href;
      $cta.classList.toggle('deck__cards__controls__btn--empty', !text || text.trim() === '');
      const $btnWrapper = $cta.closest('[data-deck-controls-btn]');
      if ($btnWrapper) $btnWrapper.dataset.deckControlsBtn = showCta === 'on' ? 'on' : 'off';
    }

    function setCardPosition(cardIndex, position) {
      const $card = $cards[cardIndex];
      clearPositionClasses($card);
      if (position) {
        $card.classList.add(POSITION_CLASSES[position]);
        if (position === 'center') {
          $card.classList.add(POSITION_CLASSES.active);
        }
      }
    }

    function updateVisibleCards() {
      $cards.forEach(function clearAllPositionClasses($card, index) {
        clearPositionClasses($card);
      });

      setCardPosition(visibleIndices[0], 'left');
      setCardPosition(visibleIndices[1], 'center');
      setCardPosition(visibleIndices[2], 'right');
    }

    function processQueue() {
      if (isNavigating || navigationQueue.length === 0) return;

      const direction = navigationQueue.shift();
      if (direction === 'right') {
        executeNavigateRight();
      } else {
        executeNavigateLeft();
      }
    }

    function createDepartureClone($card) {
      const $clone = $card.cloneNode(true);
      $clone.removeAttribute('data-deck-card');
      $clone.style.pointerEvents = 'none';
      $deck.appendChild($clone);
      return $clone;
    }

    function teleportCardTo($card, position) {
      $card.style.transition = 'none';
      clearPositionClasses($card);
      $card.classList.add(POSITION_CLASSES[position]);
      void $deck.offsetWidth;
      $card.style.transition = '';
    }

    function animateCloneDeparture($clone, departPosition) {
      clearPositionClasses($clone);
      $clone.classList.add(POSITION_CLASSES[departPosition]);
    }

    function scheduleCtaUpdate(delay, duration) {
      setTimeout(function fadeInCta() {
        updateCta();
        if ($cta) {
          $cta.style.transition = `opacity ${duration}ms cubic-bezier(0.9, 0, 0.1, 1)`;
          $cta.style.opacity = '';
        }
      }, delay);
    }

    function scheduleNavigationComplete($elementToClean, transitionDuration, isClone) {
      setTimeout(function completeNavigation() {
        if (isClone) {
          $elementToClean.remove();
        } else {
          clearPositionClasses($elementToClean);
        }
        if ($cta) $cta.style.transition = '';
        isNavigating = false;
        processQueue();
      }, transitionDuration);
    }

    function fadeOutCta(duration) {
      if ($cta) {
        $cta.style.transition = `opacity ${duration}ms cubic-bezier(0.9, 0, 0.1, 1)`;
        $cta.style.opacity = '0';
      }
    }

    function executeNavigateRight() {
      const CTA_FADE_DURATION = 500;
      const CTA_FADE_DELAY = 900;

      isNavigating = true;
      const { transitionDuration } = getDeckVars();
      const oldLeftIndex = visibleIndices[0];
      const newRightIndex = (visibleIndices[2] + 1) % totalCards;
      const isDepartureAndArrivalSameCard = newRightIndex === oldLeftIndex;
      let $departureClone = null;

      fadeOutCta(CTA_FADE_DURATION);

      if (isDepartureAndArrivalSameCard) {
        const $card = $cards[oldLeftIndex];
        $departureClone = createDepartureClone($card);

        teleportCardTo($card, 'offRight');
        animateCloneDeparture($departureClone, 'offLeft');
        setCardPosition(oldLeftIndex, 'right');
      } else {
        const $newCard = $cards[newRightIndex];
        teleportCardTo($newCard, 'offRight');
        setCardPosition(oldLeftIndex, 'offLeft');
        setCardPosition(newRightIndex, 'right');
      }

      setCardPosition(visibleIndices[1], 'left');
      setCardPosition(visibleIndices[2], 'center');

      visibleIndices = [visibleIndices[1], visibleIndices[2], newRightIndex];
      updateControlsTitle();
      scheduleCtaUpdate(CTA_FADE_DELAY, CTA_FADE_DURATION);

      if (isDepartureAndArrivalSameCard) {
        scheduleNavigationComplete($departureClone, transitionDuration, true);
      } else {
        scheduleNavigationComplete($cards[oldLeftIndex], transitionDuration, false);
      }
    }

    function executeNavigateLeft() {
      const CTA_FADE_DURATION = 500;
      const CTA_FADE_DELAY = 900;

      isNavigating = true;
      const { transitionDuration } = getDeckVars();
      const oldRightIndex = visibleIndices[2];
      const newLeftIndex = (visibleIndices[0] - 1 + totalCards) % totalCards;
      const isDepartureAndArrivalSameCard = newLeftIndex === oldRightIndex;
      let $departureClone = null;

      fadeOutCta(CTA_FADE_DURATION);

      if (isDepartureAndArrivalSameCard) {
        const $card = $cards[oldRightIndex];
        $departureClone = createDepartureClone($card);

        teleportCardTo($card, 'offLeft');
        animateCloneDeparture($departureClone, 'offRight');
        setCardPosition(oldRightIndex, 'left');
      } else {
        const $newCard = $cards[newLeftIndex];
        teleportCardTo($newCard, 'offLeft');
        setCardPosition(oldRightIndex, 'offRight');
        setCardPosition(newLeftIndex, 'left');
      }

      setCardPosition(visibleIndices[1], 'right');
      setCardPosition(visibleIndices[0], 'center');

      visibleIndices = [newLeftIndex, visibleIndices[0], visibleIndices[1]];
      updateControlsTitle();
      scheduleCtaUpdate(CTA_FADE_DELAY, CTA_FADE_DURATION);

      if (isDepartureAndArrivalSameCard) {
        scheduleNavigationComplete($departureClone, transitionDuration, true);
      } else {
        scheduleNavigationComplete($cards[oldRightIndex], transitionDuration, false);
      }
    }

    function navigateRight() {
      if (navigationQueue.length < 1) {
        navigationQueue.push('right');
        processQueue();
      }
    }

    function navigateLeft() {
      if (navigationQueue.length < 1) {
        navigationQueue.push('left');
        processQueue();
      }
    }

    function getLeftCardWrapper() {
      return $cards[visibleIndices[0]]?.querySelector('[data-card-img-wrapper]');
    }

    function getRightCardWrapper() {
      return $cards[visibleIndices[2]]?.querySelector('[data-card-img-wrapper]');
    }

    function getCenterCardWrapper() {
      return $cards[visibleIndices[1]]?.querySelector('[data-card-img-wrapper]');
    }

    function createIdleAnimationKeyframes() {
      const { idleOffsetX, idleOffsetY, transitionEasing } = getDeckVars();

      const left = [
        { rotate: '0deg', translate: '0 0', offset: 0, easing: transitionEasing },
        { rotate: '-4deg', translate: `${-idleOffsetX}px ${-idleOffsetY}px`, offset: 0.12 },
        { rotate: '-4deg', translate: `${-idleOffsetX}px ${-idleOffsetY}px`, offset: 0.5, easing: transitionEasing },
        { rotate: '0deg', translate: '0 0', offset: 0.62 },
        { rotate: '0deg', translate: '0 0', offset: 1 },
      ];

      const right = [
        { rotate: '0deg', translate: '0 0', offset: 0 },
        { rotate: '0deg', translate: '0 0', offset: 0.07, easing: transitionEasing },
        { rotate: '4deg', translate: `${idleOffsetX}px ${-idleOffsetY}px`, offset: 0.19 },
        { rotate: '4deg', translate: `${idleOffsetX}px ${-idleOffsetY}px`, offset: 0.5, easing: transitionEasing },
        { rotate: '0deg', translate: '0 0', offset: 0.62 },
        { rotate: '0deg', translate: '0 0', offset: 1 },
      ];

      return { left, right };
    }

    function createIdleAnimationOptions(withDelay) {
      return {
        duration: 6000,
        iterations: Infinity,
        easing: 'linear',
        delay: withDelay ? 1500 : 0,
      };
    }

    function startIdleAnimation(withDelay = false) {
      if ($deck.classList.contains('deck--fanned')) return;

      const $left = getLeftCardWrapper();
      const $right = getRightCardWrapper();
      if (!$left || !$right) return;

      if (leftAnim) {
        leftAnim.cancel();
        leftAnim = null;
      }

      if (rightAnim) {
        rightAnim.cancel();
        rightAnim = null;
      }

      const keyframes = createIdleAnimationKeyframes();
      const options = createIdleAnimationOptions(withDelay);

      leftAnim = $left.animate(keyframes.left, options);
      rightAnim = $right.animate(keyframes.right, options);
    }

    function fanOutCards() {
      const MIN_REMAINING_DURATION = 200;

      if (fanInCheckInterval) {
        clearInterval(fanInCheckInterval);
        fanInCheckInterval = null;
      }

      if (resumeTimeout) {
        clearTimeout(resumeTimeout);
        resumeTimeout = null;
      }

      const { cardWidth, cardWidthStacked, transitionDuration, transitionEasing } = getDeckVars();
      const widthDelta = cardWidth - cardWidthStacked;

      const $left = getLeftCardWrapper();
      const $right = getRightCardWrapper();

      let leftCurrentWidth = cardWidthStacked;
      let rightCurrentWidth = cardWidthStacked;

      if ($left) {
        const leftRotate = getComputedStyle($left).rotate;
        const leftTranslate = getComputedStyle($left).translate;
        const leftWidth = getComputedStyle($left).width;
        leftCurrentWidth = parseFloat(leftWidth) || cardWidthStacked;

        if (leftAnim) leftAnim.cancel();

        $left.style.transition = 'none';
        $left.style.rotate = leftRotate;
        $left.style.translate = leftTranslate;
        $left.style.width = leftWidth;
      }

      if ($right) {
        const rightRotate = getComputedStyle($right).rotate;
        const rightTranslate = getComputedStyle($right).translate;
        const rightWidth = getComputedStyle($right).width;
        rightCurrentWidth = parseFloat(rightWidth) || cardWidthStacked;

        if (rightAnim) rightAnim.cancel();

        $right.style.transition = 'none';
        $right.style.rotate = rightRotate;
        $right.style.translate = rightTranslate;
        $right.style.width = rightWidth;
      }

      void $deck.offsetWidth;

      $deck.classList.add('deck--fanned');

      const leftProgress = (leftCurrentWidth - cardWidthStacked) / widthDelta;
      const rightProgress = (rightCurrentWidth - cardWidthStacked) / widthDelta;
      const avgProgress = (leftProgress + rightProgress) / 2;
      const remainingDuration = Math.max(MIN_REMAINING_DURATION, (1 - avgProgress) * transitionDuration);

      const customTransition =
        `rotate ${transitionDuration}ms ${transitionEasing}, ` +
        `translate ${transitionDuration}ms ${transitionEasing}, ` +
        `width ${remainingDuration}ms ${transitionEasing}`;

      if ($left) {
        $left.style.transition = customTransition;
        $left.style.rotate = '0deg';
        $left.style.translate = '0 0';
        $left.style.width = cardWidth + 'px';
      }

      if ($right) {
        $right.style.transition = customTransition;
        $right.style.rotate = '0deg';
        $right.style.translate = '0 0';
        $right.style.width = cardWidth + 'px';
      }
    }

    function fanInCards() {
      const NAVIGATION_CHECK_INTERVAL = 50;

      if (fanInCheckInterval) {
        clearInterval(fanInCheckInterval);
        fanInCheckInterval = null;
      }

      navigationQueue = [];

      if (isNavigating) {
        fanInCheckInterval = setInterval(function waitForNavigationComplete() {
          if (!isNavigating) {
            clearInterval(fanInCheckInterval);
            fanInCheckInterval = null;
            executeFanIn();
          }
        }, NAVIGATION_CHECK_INTERVAL);
        return;
      }

      executeFanIn();
    }

    function executeFanIn() {
      const FAN_IN_DELAY = 1500;

      if (resumeTimeout) {
        clearTimeout(resumeTimeout);
        resumeTimeout = null;
      }

      const { cardWidthStacked, transitionDuration } = getDeckVars();

      const $left = getLeftCardWrapper();
      const $right = getRightCardWrapper();
      const $center = getCenterCardWrapper();

      if ($center) {
        $center.style.transition = '';
        $center.style.rotate = '';
        $center.style.translate = '';
        $center.style.width = '';
      }

      if ($left) {
        const leftWidth = getComputedStyle($left).width;
        $left.style.transition = 'none';
        $left.style.width = leftWidth;
      }
      if ($right) {
        const rightWidth = getComputedStyle($right).width;
        $right.style.transition = 'none';
        $right.style.width = rightWidth;
      }

      $deck.classList.remove('deck--fanned');
      void $deck.offsetWidth;

      if ($left) {
        $left.style.transition = '';
        $left.style.width = cardWidthStacked + 'px';
      }
      if ($right) {
        $right.style.transition = '';
        $right.style.width = cardWidthStacked + 'px';
      }

      resumeTimeout = setTimeout(function resetCards() {
        const $left = getLeftCardWrapper();
        const $right = getRightCardWrapper();

        if ($left) {
          $left.style.rotate = '';
          $left.style.translate = '';
          $left.style.width = '';
        }
        if ($right) {
          $right.style.rotate = '';
          $right.style.translate = '';
          $right.style.width = '';
        }

        startIdleAnimation(false);
        resumeTimeout = null;
      }, transitionDuration + FAN_IN_DELAY);
    }

    let isDeckHovered = false;

    $leftBtn?.addEventListener('click', navigateLeft);
    $rightBtn?.addEventListener('click', navigateRight);
    $deck.addEventListener('mouseenter', function handleMouseEnter() {
      isDeckHovered = true;
      fanOutCards();
    });
    $deck.addEventListener('mouseleave', function handleMouseLeave() {
      isDeckHovered = false;
      if ($deck.contains(document.activeElement)) {
        document.activeElement.blur();
      } else {
        fanInCards();
      }
    });

    $deck.addEventListener('focusin', function handleFocusIn(e) {
      if (!$deck.contains(e.relatedTarget)) {
        startCenterIndex = visibleIndices[1];
        hasNavigated = false;
        fanOutCards();
      }
    });

    $deck.addEventListener('focusout', function handleFocusOut(e) {
      if (!$deck.contains(e.relatedTarget)) {
        startCenterIndex = null;
        hasNavigated = false;
        if (!isDeckHovered) {
          fanInCards();
        }
      }
    });

    let startCenterIndex = null;
    let hasNavigated = false;

    $deck.addEventListener('keydown', function handleKeydown(e) {
      if (e.key === 'Tab' && e.target === $deck) {
        if (hasNavigated && visibleIndices[1] === startCenterIndex) {
          return;
        }
        e.preventDefault();
        hasNavigated = true;
        if (e.shiftKey) {
          navigateLeft();
        } else {
          navigateRight();
        }
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        navigateRight();
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        navigateLeft();
      } else if (e.key === 'Enter' && e.target === $deck) {
        const $centerCard = $cards[visibleIndices[1]];
        const href = $centerCard?.dataset?.deckCtaHref;
        if (href && href !== '#') {
          window.location.href = href;
        }
      }
    });

    fitTitle();
    updateControlsTitle();
    updateCta();

    (function initCardsWithPriority() {
      const $centerCard = $cards[visibleIndices[1]];
      const $centerImg = $centerCard ? $centerCard.querySelector('.deck__cards__card__img') : null;

      setCardPosition(visibleIndices[1], 'center');

      let revealed = false;
      function revealSideCards() {
        if (revealed) return;
        revealed = true;
        setCardPosition(visibleIndices[0], 'left');
        setCardPosition(visibleIndices[2], 'right');

        if ($deck.matches(':hover')) {
          fanOutCards();
        } else {
          startIdleAnimation(true);
        }
      }

      if ($centerImg && !$centerImg.complete) {
        $centerImg.addEventListener('load', revealSideCards, { once: true });
        setTimeout(revealSideCards, 3000); // safety fallback in case load event never fires
      } else {
        revealSideCards(); // image already cached / complete — reveal immediately
      }
    })();
  })();

  (function mobileDeckOfCards() {
    const $deck = document.querySelector('[data-deck-mobile-cards]');
    if (!$deck) return;

    const $deckMobile = $deck.closest('[data-deck-mobile]');
    const $instructions = $deckMobile?.querySelector('[data-deck-mobile-instructions]');
    const $title = $deckMobile?.querySelector('[data-deck-mobile-title]');
    const $ctaWrapper = $deckMobile?.querySelector('.deck-mobile__cta-wrapper');
    const $cta = $deckMobile?.querySelector('[data-deck-mobile-cta]');
    const $ctaTitle = $deckMobile?.querySelector('[data-deck-mobile-cta-title-el]');
    const $ctaSubtitle = $deckMobile?.querySelector('[data-deck-mobile-cta-subtitle-el]');
    const $ctaElements = [$cta, $ctaTitle, $ctaSubtitle].filter(Boolean);

    const ROTATION_FACTOR = 0.1;

    let animationStartTimeout = null;
    let animationCycleTimeout = null;
    let isDragging = false;
    let isHorizontalSwipe = null;
    let startX = 0;
    let startY = 0;
    let currentX = 0;
    let currentY = 0;
    let startTime = 0;
    let $activeCard = null;
    let $nextCard = null;
    let inFlightCards = new Set();
    let isTransitioning = false;
    let instructionsDismissed = false;
    let instructionsReappearTimeout = null;

    function startInstructionsAnimation() {
      const INSTRUCTIONS_ANIMATION_START_DELAY = 1500;

      if (!$instructions) return;

      if (animationStartTimeout) clearTimeout(animationStartTimeout);
      if (animationCycleTimeout) clearTimeout(animationCycleTimeout);

      $instructions.classList.remove('deck-mobile__instructions--animate');

      animationStartTimeout = setTimeout(function addAnimationClass() {
        $instructions.classList.add('deck-mobile__instructions--animate');
      }, INSTRUCTIONS_ANIMATION_START_DELAY);
    }

    if ($instructions) {
      $instructions.addEventListener('animationiteration', function onAnimationIteration() {
        const INSTRUCTIONS_ANIMATION_CYCLE_DELAY = 10000;

        $instructions.classList.remove('deck-mobile__instructions--animate');
        animationCycleTimeout = setTimeout(function restartAnimation() {
          $instructions.classList.add('deck-mobile__instructions--animate');
        }, INSTRUCTIONS_ANIMATION_CYCLE_DELAY);
      });

      startInstructionsAnimation();
    }

    function fitTitle() {
      const CARD_MAX_WIDTH = 424;
      const WINDOW_WIDTH_RATIO = 0.9;
      const TITLE_MAX_FONT_SIZE = 70;
      const TITLE_MIN_FONT_SIZE = 10;
      const TITLE_BASE_BOTTOM_POSITION = 96;
      const TITLE_MIN_BOTTOM_POSITION = 92;
      const TITLE_BASE_GRADIENT_HEIGHT = 55;
      const TITLE_BASE_GRADIENT_STOP = 27.94;
      const TITLE_MAX_GRADIENT_STOP = 50;

      if (!$title) return;
      const maxWidth = Math.min(CARD_MAX_WIDTH, window.innerWidth * WINDOW_WIDTH_RATIO);

      const $clone = $title.cloneNode(true);
      $clone.style.position = 'absolute';
      $clone.style.visibility = 'hidden';
      $clone.style.whiteSpace = 'nowrap';
      $clone.style.width = 'auto';
      document.body.appendChild($clone);

      let fontSize = TITLE_MAX_FONT_SIZE;
      $clone.style.fontSize = fontSize + 'px';

      while ($clone.scrollWidth > maxWidth && fontSize > TITLE_MIN_FONT_SIZE) {
        fontSize -= 1;
        $clone.style.fontSize = fontSize + 'px';
      }

      document.body.removeChild($clone);
      $title.style.fontSize = fontSize + 'px';

      const fontRatio = fontSize / TITLE_MAX_FONT_SIZE;

      const bottom = TITLE_MIN_BOTTOM_POSITION + (TITLE_BASE_BOTTOM_POSITION - TITLE_MIN_BOTTOM_POSITION) * fontRatio;
      $title.style.bottom = bottom + '%';

      const gradientHeight = TITLE_BASE_GRADIENT_HEIGHT * fontRatio;
      $title.style.setProperty('--title-gradient-height', gradientHeight + 'px');

      const gradientStop =
        TITLE_BASE_GRADIENT_STOP + (TITLE_MAX_GRADIENT_STOP - TITLE_BASE_GRADIENT_STOP) * (1 - fontRatio);
      $title.style.setProperty('--title-gradient-stop', gradientStop + '%');
    }

    fitTitle();
    window.addEventListener('resize', fitTitle);

    function setCtaOpacity(value) {
      $ctaElements.forEach(function applyOpacity($el) {
        $el.style.opacity = value;
      });
    }

    function updateCta($card) {
      if (!$card) return;
      const text = $card.dataset.deckMobileCtaText;
      const href = $card.dataset.deckMobileCtaHref;
      const titleText = $card.dataset.deckMobileCtaTitleText;
      const subtitleText = $card.dataset.deckMobileCtaSubtitleText;
      const showBtn = $card.dataset.deckMobileCtaBtn;
      const showTitle = $card.dataset.deckMobileCtaTitle;
      const showSubtitle = $card.dataset.deckMobileCtaSubtitle;
      if ($cta) {
        if (text) $cta.textContent = text;
        if (href) $cta.href = href;
      }
      if ($ctaTitle && titleText !== undefined) $ctaTitle.textContent = titleText;
      if ($ctaSubtitle && subtitleText !== undefined) $ctaSubtitle.textContent = subtitleText;
      if ($ctaWrapper) {
        $ctaWrapper.dataset.deckMobileCtaBtn = showBtn === 'off' ? 'off' : 'on';
        $ctaWrapper.dataset.deckMobileCtaTitle = showTitle === 'off' ? 'off' : 'on';
        $ctaWrapper.dataset.deckMobileCtaSubtitle = showSubtitle === 'off' ? 'off' : 'on';
      }
    }

    const $cards = Array.from($deck.querySelectorAll('[data-deck-mobile-card]'));
    if ($cards.length === 0) return;

    $cards.forEach(function setCardZIndex($card, i) {
      $card.style.zIndex = $cards.length - i;
    });

    const $topCard = $cards[0];
    if ($topCard) {
      $topCard.style.transition = 'none';
      $topCard.classList.add('deck-mobile__cards__card--top');
      void $topCard.offsetWidth;
      $topCard.style.transition = '';
      updateCta($topCard);
    }

    function scheduleInstructionsReappear() {
      const INSTRUCTIONS_REAPPEAR_DELAY = 7500;

      if (instructionsReappearTimeout) {
        clearTimeout(instructionsReappearTimeout);
      }
      instructionsReappearTimeout = setTimeout(function reappearInstructions() {
        if ($instructions) {
          instructionsDismissed = false;
          $instructions.style.opacity = '';
          startInstructionsAnimation();
        }
        instructionsReappearTimeout = null;
      }, INSTRUCTIONS_REAPPEAR_DELAY);
    }

    function cancelInstructionsReappear() {
      if (instructionsReappearTimeout) {
        clearTimeout(instructionsReappearTimeout);
        instructionsReappearTimeout = null;
      }
    }

    function getTopCard() {
      let topCard = null;
      let maxZ = -1;
      $cards.forEach(function findTopCard($card) {
        if (inFlightCards.has($card)) return;
        const z = parseInt($card.style.zIndex) || 0;
        if (z > maxZ) {
          maxZ = z;
          topCard = $card;
        }
      });
      return topCard;
    }

    function getSecondCard() {
      let secondCard = null;
      let maxZ = -1;
      let secondMaxZ = -1;
      let topCard = null;
      $cards.forEach(function findSecondCard($card) {
        if (inFlightCards.has($card)) return;
        const z = parseInt($card.style.zIndex) || 0;
        if (z > maxZ) {
          secondMaxZ = maxZ;
          secondCard = topCard;
          maxZ = z;
          topCard = $card;
        } else if (z > secondMaxZ) {
          secondMaxZ = z;
          secondCard = $card;
        }
      });
      return secondCard;
    }

    function onPointerDown(e) {
      if (isTransitioning) return;

      const $card = getTopCard();
      if (!$card || $card !== e.target.closest('[data-deck-mobile-card]')) return;

      cancelInstructionsReappear();

      isDragging = true;
      isHorizontalSwipe = null;
      $activeCard = $card;
      $nextCard = getSecondCard();

      if ($nextCard) {
        $nextCard.style.transition = 'none';
      }

      startX = e.clientX || e.touches?.[0]?.clientX || 0;
      startY = e.clientY || e.touches?.[0]?.clientY || 0;
      currentX = 0;
      currentY = 0;
      startTime = Date.now();

      $card.classList.add('deck-mobile__cards__card--dragging');
      $card.classList.remove('deck-mobile__cards__card--animating');
    }

    function onPointerMove(e) {
      const DIRECTION_LOCK_THRESHOLD = 10;
      const HORIZONTAL_ANGLE_LIMIT = 45;
      const RADIANS_TO_DEGREES = 180;
      const CARD_BASE_SCALE = 0.95;
      const CARD_SCALE_INCREMENT = 0.05;

      if (!isDragging || !$activeCard) return;

      const clientX = e.clientX || e.touches?.[0]?.clientX || 0;
      const clientY = e.clientY || e.touches?.[0]?.clientY || 0;

      currentX = clientX - startX;
      currentY = clientY - startY;

      if (isHorizontalSwipe === null) {
        const distance = Math.sqrt(currentX * currentX + currentY * currentY);
        if (distance > DIRECTION_LOCK_THRESHOLD) {
          const angle = Math.abs(Math.atan2(Math.abs(currentY), Math.abs(currentX)) * (RADIANS_TO_DEGREES / Math.PI));
          isHorizontalSwipe = angle <= HORIZONTAL_ANGLE_LIMIT;

          if (!isHorizontalSwipe) {
            isDragging = false;
            $activeCard.classList.remove('deck-mobile__cards__card--dragging');
            $activeCard.style.transform = '';
            if ($nextCard) {
              $nextCard.style.transition = '';
              $nextCard.style.scale = '';
            }
            $activeCard = null;
            $nextCard = null;
            return;
          }
        } else {
          return;
        }
      }

      if (e.cancelable) {
        e.preventDefault();
      }

      const rotation = currentX * ROTATION_FACTOR;
      const distance = Math.sqrt(currentX * currentX + currentY * currentY);

      const maxDistance = Math.sqrt(Math.pow(window.innerWidth / 2, 2) + Math.pow(window.innerHeight / 2, 2));
      const progress = Math.min(distance / maxDistance, 1);

      if ($nextCard) {
        const nextScale = CARD_BASE_SCALE + CARD_SCALE_INCREMENT * progress;
        $nextCard.style.scale = nextScale;
      }

      if ($instructions && !instructionsDismissed) {
        $instructions.style.opacity = 1 - progress;
      }

      setCtaOpacity(1 - progress);

      $activeCard.style.transform = `translate(${currentX}px, ${currentY}px) rotate(${rotation}deg)`;
    }

    function onPointerUp(e) {
      const SWIPE_THRESHOLD = 100;
      const VELOCITY_THRESHOLD = 0.5;

      if (!isDragging || !$activeCard) return;
      isDragging = false;

      const $card = $activeCard;
      const $next = $nextCard;
      $activeCard = null;
      $nextCard = null;

      $card.classList.remove('deck-mobile__cards__card--dragging');
      $card.classList.add('deck-mobile__cards__card--animating');

      const elapsed = Math.max(1, Date.now() - startTime);
      const velocityX = Math.abs(currentX) / elapsed;
      const velocityY = Math.abs(currentY) / elapsed;
      const velocity = Math.sqrt(velocityX * velocityX + velocityY * velocityY);

      const distance = Math.sqrt(currentX * currentX + currentY * currentY);

      const shouldSwipe = distance > SWIPE_THRESHOLD || velocity > VELOCITY_THRESHOLD;

      if (shouldSwipe) {
        dismissCard($card, currentX, currentY, $next);
      } else {
        $card.style.transform = '';
        if ($next) {
          $next.style.transition = '';
          $next.style.scale = '';
        }
        if ($instructions && !instructionsDismissed) {
          $instructions.style.opacity = '';
        }
        setCtaOpacity('');
        scheduleInstructionsReappear();
      }
    }

    function dismissCard($card, deltaX, deltaY, $next) {
      const HIGH_Z_INDEX_OFFSET = 100;
      const SWIPE_ROTATION_MULTIPLIER = 2;
      const CARD_RESET_DELAY = 300;
      const SCALE_DURATION = 150;

      const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
      const directionX = deltaX / distance;
      const directionY = deltaY / distance;

      const flyDistance = Math.max(window.innerWidth, window.innerHeight);
      const endX = directionX * flyDistance;
      const endY = directionY * flyDistance;
      const rotation = deltaX * ROTATION_FACTOR * SWIPE_ROTATION_MULTIPLIER;

      const highZ = $cards.length + HIGH_Z_INDEX_OFFSET;
      $card.style.zIndex = highZ;

      if ($instructions && !instructionsDismissed) {
        $instructions.style.opacity = '0';
        instructionsDismissed = true;
      }

      setCtaOpacity('0');

      inFlightCards.add($card);
      isTransitioning = true;
      $card.style.scale = '1';
      $card.classList.remove('deck-mobile__cards__card--top');
      $card.style.transform = `translate(${endX}px, ${endY}px) rotate(${rotation}deg)`;

      if ($next) {
        $next.style.transition = '';
        $next.style.scale = '';
      }

      const $nextTop = getTopCard();
      if ($nextTop) {
        $nextTop.classList.add('deck-mobile__cards__card--top');
      }

      setTimeout(function endTransition() {
        isTransitioning = false;
      }, SCALE_DURATION);

      setTimeout(function resetCard() {
        $card.classList.remove('deck-mobile__cards__card--animating');
        $card.style.transition = 'none';
        $card.style.transform = '';
        $card.style.scale = '';
        void $card.offsetWidth;
        $card.style.transition = '';

        $cards.forEach(function incrementZIndex($c) {
          if ($c !== $card && !inFlightCards.has($c)) {
            const currentZ = parseInt($c.style.zIndex) || 0;
            $c.style.zIndex = currentZ + 1;
          }
        });
        $card.style.zIndex = 0;
        inFlightCards.delete($card);

        const $newTopCard = getTopCard();
        updateCta($newTopCard);
        setCtaOpacity('');
        scheduleInstructionsReappear();
      }, CARD_RESET_DELAY);
    }

    $deck.addEventListener('mousedown', onPointerDown);
    $deck.addEventListener('touchstart', onPointerDown, { passive: true });

    window.addEventListener('mousemove', onPointerMove);
    window.addEventListener('touchmove', onPointerMove, { passive: false });

    window.addEventListener('mouseup', onPointerUp);
    window.addEventListener('touchend', onPointerUp);
    window.addEventListener('touchcancel', onPointerUp);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  (function productCarousel() {
    const $sections = document.querySelectorAll('[data-product-carousel-section]');
    if (!$sections.length) return;

    function initSection($section) {
      const $btnPrev = $section.querySelector('[data-product-carousel-nav-btn="prev"]');
      const $btnNext = $section.querySelector('[data-product-carousel-nav-btn="next"]');
      const $trackButtons = Array.from($section.querySelectorAll('[data-product-carousel-track-btn]'));
      const $tracks = Array.from($section.querySelectorAll('[data-product-carousel-track]'));
      const $viewAllLink = $section.querySelector('[data-view-all-link]');

      if (!$btnPrev || !$btnNext || !$tracks.length) return;

      function getVisibleTrack() {
        return $tracks.find(function isActive($t) {
          return $t.classList.contains('is-active');
        });
      }

      function getTrackById(trackId) {
        return $tracks.find(function matches($t) {
          return $t.getAttribute('data-product-carousel-track') === trackId;
        });
      }

      function getButtonById(trackId) {
        return $trackButtons.find(function matches($b) {
          return $b.getAttribute('data-product-carousel-track-btn') === trackId;
        });
      }

      function updateButtonStates() {
        const $currentTrack = getVisibleTrack() || $tracks[0];
        if (!$currentTrack) return;

        const scrollLeft = $currentTrack.scrollLeft;
        const maxScroll = $currentTrack.scrollWidth - $currentTrack.clientWidth;

        $btnPrev.disabled = scrollLeft <= 1;
        $btnNext.disabled = scrollLeft >= maxScroll - 1;
      }

      function applyHeightIfMultilineTitles() {
        const MULTILINE_THRESHOLD = 1.5;

        function isTitleMultiline($title) {
          const computedStyle = getComputedStyle($title);
          const lineHeightValue = computedStyle.lineHeight;
          const fontSize = parseFloat(computedStyle.fontSize) || 16;
          const lineHeight =
            lineHeightValue === 'normal' ? fontSize * 1.2 : parseFloat(lineHeightValue) || fontSize * 1.2;
          const actualHeight = $title.offsetHeight;
          return actualHeight > lineHeight * MULTILINE_THRESHOLD;
        }

        function trackHasMultilineTitles($track) {
          const $titles = $track.querySelectorAll('.product-tile__content__title');
          return Array.from($titles).some(isTitleMultiline);
        }

        function updateTrackHeightClass($track) {
          const hasMultiline = trackHasMultilineTitles($track);
          $track.classList.toggle('product-carousel__track--has-multiline', hasMultiline);
        }

        $tracks.forEach(updateTrackHeightClass);
      }

      function setViewAllHrefForTrack(trackId) {
        if (!$viewAllLink) return;
        const $btn = getButtonById(trackId);
        if (!$btn) return;
        $viewAllLink.href = $btn.dataset.trackUrl || '#';
      }

      function activateTrack(trackId) {
        const $targetTrack = getTrackById(trackId);
        if (!$targetTrack) return;

        $tracks.forEach(function toggleTrack($t) {
          const isActive = $t === $targetTrack;
          $t.classList.toggle('is-active', isActive);
          if (isActive) {
            $t.removeAttribute('hidden');
          } else {
            $t.setAttribute('hidden', '');
          }
        });

        $trackButtons.forEach(function setActiveButton($b) {
          const isActive = $b.getAttribute('data-product-carousel-track-btn') === trackId;
          const isHighlighted = $b.hasAttribute('data-is-highlighted');
          if (isHighlighted) {
            $b.classList.toggle('product-carousel__btn--new', isActive);
            $b.classList.remove('product-carousel__btn--active');
          } else {
            $b.classList.toggle('product-carousel__btn--active', isActive);
            $b.classList.remove('product-carousel__btn--new');
          }
        });

        $targetTrack.scrollLeft = 0;
        setViewAllHrefForTrack(trackId);
        updateButtonStates();
        applyHeightIfMultilineTitles();
      }

      (function initializeTrackSwitching() {
        const $initialTrack = getVisibleTrack() || $tracks[0];
        if ($initialTrack) {
          const trackId = $initialTrack.getAttribute('data-product-carousel-track');
          if (trackId) setViewAllHrefForTrack(trackId);
        }

        if ($trackButtons.length <= 1) {
          updateButtonStates();
          applyHeightIfMultilineTitles();
          return;
        }

        $trackButtons.forEach(function attachTrackButton($btn) {
          $btn.addEventListener('click', function handleClick() {
            const trackId = $btn.getAttribute('data-product-carousel-track-btn');
            if (!trackId) return;
            if (
              $btn.classList.contains('product-carousel__btn--active') ||
              $btn.classList.contains('product-carousel__btn--new')
            )
              return;
            activateTrack(trackId);
          });
        });
      })();

      (function initializeButtonNavigation() {
        function scrollPrev() {
          const $currentTrack = getVisibleTrack() || $tracks[0];
          if (!$currentTrack) return;
          $currentTrack.scrollBy({ left: -300, behavior: 'smooth' });
        }

        function scrollNext() {
          const $currentTrack = getVisibleTrack() || $tracks[0];
          if (!$currentTrack) return;
          $currentTrack.scrollBy({ left: 300, behavior: 'smooth' });
        }

        function handleTrackScroll() {
          updateButtonStates();
        }

        $btnPrev.addEventListener('click', scrollPrev);
        $btnNext.addEventListener('click', scrollNext);
        $tracks.forEach(function attachScrollListener($track) {
          $track.addEventListener('scroll', handleTrackScroll);
        });
        updateButtonStates();
      })();

      applyHeightIfMultilineTitles();
      window.addEventListener('resize', applyHeightIfMultilineTitles);

      (function initializeDragScrolling() {
        const DRAG_THRESHOLD = 5;
        const DECELERATION = 0.92;
        const MIN_VELOCITY = 0.3;
        const VELOCITY_SAMPLES = 5;
        const MOMENTUM_SCALE = 8;
        const EDGE_PROXIMITY_THRESHOLD = 250;
        const EDGE_DECELERATION_MIN = 0.5;
        const STATIONARY_THRESHOLD_MS = 50;

        $tracks.forEach(function setupTrackDragging($track) {
          let isDown = false;
          let startX = 0;
          let scrollLeft = 0;
          let hasDragged = false;
          let velocityX = 0;
          let lastX = 0;
          let lastTime = 0;
          let animationId = null;
          let velocityHistory = [];

          function getMaxScroll() {
            return $track.scrollWidth - $track.clientWidth;
          }

          function calculateEdgeFriction(distanceToEdge) {
            const t = distanceToEdge / EDGE_PROXIMITY_THRESHOLD;
            const easedT = t * t;
            return EDGE_DECELERATION_MIN + (1 - EDGE_DECELERATION_MIN) * easedT;
          }

          function momentumStep() {
            const maxScroll = getMaxScroll();
            const currentScroll = $track.scrollLeft;

            if (Math.abs(velocityX) <= MIN_VELOCITY) {
              animationId = null;
              updateButtonStates();
              return;
            }

            const distanceToStart = currentScroll;
            const distanceToEnd = maxScroll - currentScroll;
            const movingTowardStart = velocityX < 0;
            const movingTowardEnd = velocityX > 0;
            const nearStart = distanceToStart < EDGE_PROXIMITY_THRESHOLD;
            const nearEnd = distanceToEnd < EDGE_PROXIMITY_THRESHOLD;

            if (movingTowardStart && nearStart) {
              velocityX *= calculateEdgeFriction(distanceToStart);
            } else if (movingTowardEnd && nearEnd) {
              velocityX *= calculateEdgeFriction(distanceToEnd);
            } else {
              velocityX *= DECELERATION;
            }

            const newScroll = Math.max(0, Math.min(maxScroll, currentScroll + velocityX));
            $track.scrollLeft = newScroll;

            const atEdge = newScroll <= 0 || newScroll >= maxScroll;
            const lowVelocity = Math.abs(velocityX) < 2;
            if (atEdge && lowVelocity) {
              velocityX = 0;
            }

            if (Math.abs(velocityX) > MIN_VELOCITY) {
              animationId = requestAnimationFrame(momentumStep);
            }

            updateButtonStates();
          }

          function applyMomentum() {
            if (animationId) {
              cancelAnimationFrame(animationId);
            }
            animationId = requestAnimationFrame(momentumStep);
          }

          function calculateAverageVelocity() {
            if (velocityHistory.length === 0) return 0;
            const sum = velocityHistory.reduce(function addVelocity(a, b) {
              return a + b;
            }, 0);
            return sum / velocityHistory.length;
          }

          function startDragging(e) {
            if (animationId) {
              cancelAnimationFrame(animationId);
              animationId = null;
            }

            isDown = true;
            hasDragged = false;
            velocityX = 0;
            velocityHistory = [];
            $track.style.cursor = 'grabbing';
            $track.classList.add('product-carousel__track--dragging');
            startX = e.pageX - $track.offsetLeft;
            lastX = startX;
            lastTime = performance.now();
            scrollLeft = $track.scrollLeft;
            e.preventDefault();
          }

          function stopDragging() {
            if (!isDown) return;

            document.removeEventListener('mouseup', stopDragging);
            document.removeEventListener('mousemove', handleDragMove);

            isDown = false;
            $track.style.cursor = 'grab';
            $track.classList.remove('product-carousel__track--dragging');

            const timeSinceLastMove = performance.now() - lastTime;
            const isStationary = timeSinceLastMove > STATIONARY_THRESHOLD_MS;

            if (isStationary) {
              velocityX = 0;
              return;
            }

            velocityX = calculateAverageVelocity() * MOMENTUM_SCALE;

            if (Math.abs(velocityX) > MIN_VELOCITY) {
              applyMomentum();
            }
          }

          function handleDragMove(e) {
            if (!isDown) return;
            e.preventDefault();

            const currentTime = performance.now();
            const x = e.pageX - $track.offsetLeft;
            const walk = x - startX;

            if (Math.abs(walk) > DRAG_THRESHOLD) {
              hasDragged = true;
            }

            const timeDelta = currentTime - lastTime;
            if (timeDelta > 0) {
              const instantVelocity = (lastX - x) / timeDelta;
              velocityHistory.push(instantVelocity);
              if (velocityHistory.length > VELOCITY_SAMPLES) {
                velocityHistory.shift();
              }
            }

            lastX = x;
            lastTime = currentTime;

            const maxScroll = getMaxScroll();
            const targetScroll = scrollLeft - walk;
            $track.scrollLeft = Math.max(0, Math.min(maxScroll, targetScroll));

            updateButtonStates();
          }

          function preventClickAfterDrag(e) {
            if (hasDragged) {
              e.preventDefault();
              e.stopPropagation();
            }
          }

          function preventLinkDrag(e) {
            e.preventDefault();
          }

          function setupLinkDragPrevention() {
            const $links = $track.querySelectorAll('a');
            $links.forEach(function attachPreventDrag($link) {
              $link.addEventListener('dragstart', preventLinkDrag);
            });
          }

          setupLinkDragPrevention();
          $track.addEventListener('mousedown', function handleMouseDown(e) {
            startDragging(e);
            document.addEventListener('mouseup', stopDragging);
            document.addEventListener('mousemove', handleDragMove);
          });
          $track.addEventListener('click', preventClickAfterDrag, true);
        });
      })();
    }

    $sections.forEach(initSection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-launches-hero"] && !Shopify.designMode) return;
  try {
    
  (function featuredLaunchesHero() {
    const $root = document.querySelector('[data-flh]');
    if (!$root) return;

    const $cardsContainer = $root.querySelector('[data-flh-cards]');
    const $cards = Array.from($root.querySelectorAll('[data-flh-card]'));
    const $cardLinks = $cards.map(function getLink($card) {
      return $card.querySelector('[data-flh-card-link]');
    });
    const $prevBtn = $root.querySelector('[data-flh-prev]');
    const $nextBtn = $root.querySelector('[data-flh-next]');
    const $centerTitle = $root.querySelector('[data-flh-center-title]');
    const $centerSubtitle = $root.querySelector('[data-flh-center-subtitle]');
    const $centerCta = $root.querySelector('[data-flh-center-cta]');
    const $sideLeftTitle = $root.querySelector('[data-flh-side-left-title]');
    const $sideRightTitle = $root.querySelector('[data-flh-side-right-title]');
    const $centerContent = $root.querySelector('[data-flh-center-info]');
    const $swipeHint = $root.querySelector('[data-flh-swipe-hint]');

    const TOTAL = $cards.length;
    const HALF = TOTAL / 2;
    const BTN_ANIM_DURATION = 1200;
    const SNAP_DURATION = 200;
    const MOMENTUM_FRICTION = 0.92;
    const MOMENTUM_MIN_VELOCITY = 0.00005;
    const FLING_MIN_VELOCITY = 0.0003;
    const VELOCITY_SMOOTHING = 0.8;
    const CROSSFADE_DURATION = 1200;
    const CROSSFADE_EASING = 'cubic-bezier(0.9, 0, 0.1, 1)';
    const CROSSFADE_ATTR = 'data-flh-crossfade-clone';
    const MAX_SLOT = 3;

    /* ---- layout params (read from CSS, updated on resize) ---- */
    let cardWidth = 0;
    let cardGap = 0;
    let scaleChild = 0;
    let scaleGrandchild = 0;
    let slotPositions = [];
    let slotScales = [];
    let slotOpacities = [];
    let stride = 0;

    function readLayoutParams() {
      const style = getComputedStyle($root);
      const $measure = $cards[0];
      const savedTransform = $measure.style.transform;
      $measure.style.transform = 'none';
      cardWidth = $measure.getBoundingClientRect().width;
      $measure.style.transform = savedTransform;
      cardGap = parseFloat(style.getPropertyValue('--flh-card-gap'));
      scaleChild = parseFloat(style.getPropertyValue('--flh-scale-child'));
      scaleGrandchild = parseFloat(style.getPropertyValue('--flh-scale-grandchild'));

      const childOffset = cardWidth / 2 + cardGap + cardWidth * scaleChild / 2;
      const grandchildOffset = childOffset + cardWidth * scaleChild / 2 + cardGap + cardWidth * scaleGrandchild / 2;

      slotPositions = [0, childOffset, grandchildOffset, grandchildOffset];
      slotScales = [1, scaleChild, scaleGrandchild, 0.25];
      slotOpacities = [1, 1, 1, 0];
      stride = cardWidth + cardGap;
    }

    /* ---- state ---- */
    let offset = 0;
    let lastCenterIndex = 0;
    let hasDragged = false;
    let momentumRafId = null;
    let btnAnimRafId = null;
    let isAnimating = false;
    let queuedDirection = null;

    let swipeHintDismissed = false;
    let swipeHintAnimStartTimeout = null;
    let swipeHintAnimCycleTimeout = null;

    /* ---- cubic-bezier solver for button animation ---- */
    function makeCubicBezier(mX1, mY1, mX2, mY2) {
      function A(a1, a2) { return 1 - 3 * a2 + 3 * a1; }
      function B(a1, a2) { return 3 * a2 - 6 * a1; }
      function C(a1) { return 3 * a1; }

      function calcBezier(t, a1, a2) {
        return ((A(a1, a2) * t + B(a1, a2)) * t + C(a1)) * t;
      }

      function getSlope(t, a1, a2) {
        return 3 * A(a1, a2) * t * t + 2 * B(a1, a2) * t + C(a1);
      }

      function solveTForX(x) {
        let t = x;
        for (let i = 0; i < 8; i++) {
          const slope = getSlope(t, mX1, mX2);
          if (Math.abs(slope) < 1e-6) break;
          t -= (calcBezier(t, mX1, mX2) - x) / slope;
        }
        return Math.max(0, Math.min(1, t));
      }

      return function bezierEasing(x) {
        if (x <= 0) return 0;
        if (x >= 1) return 1;
        return calcBezier(solveTForX(x), mY1, mY2);
      };
    }

    const dramaticEasing = makeCubicBezier(0.9, 0, 0.1, 1);

    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    /* ---- layout math ---- */
    function lerpArray(arr, absSlot) {
      if (absSlot <= 0) return arr[0];
      if (absSlot >= MAX_SLOT) return arr[MAX_SLOT];
      const floor = Math.floor(absSlot);
      const frac = absSlot - floor;
      return arr[floor] + (arr[floor + 1] - arr[floor]) * frac;
    }

    function getCardLayout(slot) {
      const absSlot = Math.abs(slot);
      const sign = slot < 0 ? -1 : 1;

      /* Fade out near the wrap boundary so cards are invisible before they
         jump to the other side. Between slot 2 and HALF (2.5) the fade
         multiplier goes from 1 → 0. */
      const FADE_START = 2;
      const wrapFade = absSlot <= FADE_START ? 1 :
                       absSlot >= HALF ? 0 :
                       1 - (absSlot - FADE_START) / (HALF - FADE_START);

      return {
        x: sign * lerpArray(slotPositions, absSlot),
        scale: lerpArray(slotScales, absSlot),
        opacity: lerpArray(slotOpacities, absSlot) * wrapFade,
      };
    }

    function wrapSlot(rawSlot) {
      return ((rawSlot % TOTAL) + TOTAL + HALF) % TOTAL - HALF;
    }

    function wrapIndex(i) {
      return ((i % TOTAL) + TOTAL) % TOTAL;
    }

    function getCenterIndex() {
      return wrapIndex(Math.round(offset));
    }

    function setOptionalHref($link, href) {
      if (!$link) return;

      if (href) {
        $link.setAttribute('href', href);
      } else {
        $link.removeAttribute('href');
      }
    }

    /* ---- render ---- */
    function render() {
      for (let i = 0; i < TOTAL; i++) {
        const slot = wrapSlot(i - offset);
        const layout = getCardLayout(slot);
        const $card = $cards[i];

        if (layout.opacity <= 0.01 || layout.scale <= 0.01) {
          $card.style.transform = 'translateX(0) scale(0)';
          $card.style.opacity = '0';
          $card.style.zIndex = '0';
          $card.style.pointerEvents = 'none';
          $card.style.cursor = '';
          if ($cardLinks[i]) $cardLinks[i].removeAttribute('href');
        } else {
          $card.style.transform = 'translateX(' + layout.x + 'px) scale(' + layout.scale + ')';
          $card.style.opacity = String(layout.opacity);
          $card.style.zIndex = String(MAX_SLOT + 1 - Math.ceil(Math.abs(slot)));
          $card.style.pointerEvents = Math.abs(slot) < 2.5 ? 'auto' : 'none';
          $card.style.cursor = Math.abs(slot) < 0.5 && $card.dataset.flhHref ? 'pointer' : '';
          if ($cardLinks[i]) {
            if (Math.abs(slot) < 0.5) {
              setOptionalHref($cardLinks[i], $card.dataset.flhHref);
            } else {
              $cardLinks[i].removeAttribute('href');
            }
          }
        }
      }
    }

    /* ---- crossfade controls ---- */
    const crossfadeCleanupTimers = new WeakMap();

    function crossfadeElement($el, updateFn) {
      const prevTimerId = crossfadeCleanupTimers.get($el);
      if (prevTimerId) clearTimeout(prevTimerId);

      const $parent = $el.parentNode;

      const $staleClones = $parent.querySelectorAll('[' + CROSSFADE_ATTR + ']');
      $staleClones.forEach(function removeStale($old) { $old.remove(); });

      const $clone = $el.cloneNode(true);
      $clone.setAttribute(CROSSFADE_ATTR, '');
      const parentRect = $parent.getBoundingClientRect();
      const elRect = $el.getBoundingClientRect();

      const parentPosition = getComputedStyle($parent).position;
      if (parentPosition === 'static') {
        $parent.style.position = 'relative';
      }

      $clone.style.position = 'absolute';
      $clone.style.top = (elRect.top - parentRect.top) + 'px';
      $clone.style.left = (elRect.left - parentRect.left) + 'px';
      $clone.style.width = elRect.width + 'px';
      $clone.style.margin = '0';
      $clone.style.pointerEvents = 'none';
      $clone.style.transition = 'opacity ' + CROSSFADE_DURATION + 'ms ' + CROSSFADE_EASING;
      $parent.appendChild($clone);

      $el.style.transition = 'none';
      updateFn();
      $el.style.opacity = '0';
      $el.offsetHeight;
      $el.style.transition = 'opacity ' + CROSSFADE_DURATION + 'ms ' + CROSSFADE_EASING;

      requestAnimationFrame(function beginCrossfade() {
        requestAnimationFrame(function applyCrossfade() {
          $clone.style.opacity = '0';
          $el.style.opacity = '1';
        });
      });

      const cleanupTimerId = setTimeout(function removeCrossfadeClone() {
        crossfadeCleanupTimers.delete($el);
        if ($clone.parentNode) $clone.remove();
        $el.style.opacity = '';
        $el.style.transition = '';
        if (parentPosition === 'static' && !$parent.querySelector('[' + CROSSFADE_ATTR + ']')) {
          $parent.style.position = '';
        }
      }, CROSSFADE_DURATION + 50);
      crossfadeCleanupTimers.set($el, cleanupTimerId);
    }

    function setControlsImmediate(centerIdx) {
      const $c = $cards[centerIdx];
      const $l = $cards[wrapIndex(centerIdx - 1)];
      const $r = $cards[wrapIndex(centerIdx + 1)];

      $centerTitle.textContent = $c.dataset.flhTitle;
      $centerSubtitle.textContent = $c.dataset.flhSubtitle;
      $centerCta.textContent = $c.dataset.flhCtaLabel;
      setOptionalHref($centerCta, $c.dataset.flhHref);
      $sideLeftTitle.textContent = $l.dataset.flhTitle;
      $sideRightTitle.textContent = $r.dataset.flhTitle;
    }

    function updateControlsCrossfade(centerIdx) {
      const $c = $cards[centerIdx];
      const $l = $cards[wrapIndex(centerIdx - 1)];
      const $r = $cards[wrapIndex(centerIdx + 1)];

      crossfadeElement($centerContent, function updateCenter() {
        $centerTitle.textContent = $c.dataset.flhTitle;
        $centerSubtitle.textContent = $c.dataset.flhSubtitle;
      });

      crossfadeElement($centerCta, function updateCta() {
        $centerCta.textContent = $c.dataset.flhCtaLabel;
        setOptionalHref($centerCta, $c.dataset.flhHref);
      });

      crossfadeElement($sideLeftTitle, function updateLeft() {
        $sideLeftTitle.textContent = $l.dataset.flhTitle;
      });

      crossfadeElement($sideRightTitle, function updateRight() {
        $sideRightTitle.textContent = $r.dataset.flhTitle;
      });
    }

    function checkCenterChanged(useCrossfade) {
      const newCenter = getCenterIndex();
      if (newCenter !== lastCenterIndex) {
        lastCenterIndex = newCenter;
        if (useCrossfade) {
          updateControlsCrossfade(newCenter);
        } else {
          setControlsImmediate(newCenter);
        }
      }
    }

    /* ---- animation helpers ---- */
    function cancelAllAnimations() {
      if (momentumRafId) { cancelAnimationFrame(momentumRafId); momentumRafId = null; }
      if (btnAnimRafId) { cancelAnimationFrame(btnAnimRafId); btnAnimRafId = null; }
      isAnimating = false;
      queuedDirection = null;
    }

    function animateToOffset(target, duration, easingFn, useCrossfade) {
      cancelAllAnimations();
      isAnimating = true;

      const start = offset;
      const delta = target - start;
      const startTime = performance.now();
      const targetCenter = wrapIndex(Math.round(target));

      if (useCrossfade && targetCenter !== lastCenterIndex) {
        updateControlsCrossfade(targetCenter);
        lastCenterIndex = targetCenter;
      }

      function animFrame(now) {
        const elapsed = now - startTime;
        const t = Math.min(1, elapsed / duration);
        offset = start + delta * easingFn(t);
        render();

        if (!useCrossfade) {
          checkCenterChanged(false);
        }

        if (t < 1) {
          btnAnimRafId = requestAnimationFrame(animFrame);
        } else {
          offset = target;
          render();
          lastCenterIndex = getCenterIndex();
          isAnimating = false;
          btnAnimRafId = null;
          processQueue();
        }
      }

      btnAnimRafId = requestAnimationFrame(animFrame);
    }

    /* ---- momentum ---- */
    function startMomentum(velocityPerMs) {
      cancelAllAnimations();
      let lastTime = performance.now();
      let vel = velocityPerMs;

      function momentumFrame(now) {
        const dt = now - lastTime;
        lastTime = now;

        offset += vel * dt;
        vel *= Math.pow(MOMENTUM_FRICTION, dt / 16.67);

        render();
        checkCenterChanged(false);

        if (Math.abs(vel) > MOMENTUM_MIN_VELOCITY) {
          momentumRafId = requestAnimationFrame(momentumFrame);
        } else {
          momentumRafId = null;
          snapToNearest();
        }
      }

      momentumRafId = requestAnimationFrame(momentumFrame);
    }

    function snapToNearest() {
      const target = Math.round(offset);
      if (Math.abs(offset - target) < 0.002) {
        offset = target;
        render();
        setControlsImmediate(getCenterIndex());
        isAnimating = false;
        return;
      }
      animateToOffset(target, SNAP_DURATION, easeOutCubic, false);
    }

    /* ---- drag handling ---- */
    const DRAG_LOCK_THRESHOLD = 8;

    function handleDragStart(event) {
      dismissSwipeHint();
      cancelAllAnimations();

      hasDragged = false;

      const isTouch = event.type === 'touchstart';
      const startX = isTouch ? event.touches[0].clientX : event.clientX;
      const startY = isTouch ? event.touches[0].clientY : event.clientY;
      const startOffset = offset;
      let prevX = startX;
      let prevTime = performance.now();
      let velocityPx = 0;
      let dragAxis = null;

      $cardsContainer.classList.add('flh--dragging');

      function handleDragMove(moveEvent) {
        const isMovTouch = moveEvent.type === 'touchmove';
        const currX = isMovTouch ? moveEvent.touches[0].clientX : moveEvent.clientX;
        const currY = isMovTouch ? moveEvent.touches[0].clientY : moveEvent.clientY;

        if (dragAxis === null) {
          const absX = Math.abs(currX - startX);
          const absY = Math.abs(currY - startY);
          if (absX < DRAG_LOCK_THRESHOLD && absY < DRAG_LOCK_THRESHOLD) return;
          dragAxis = absX >= absY ? 'horizontal' : 'vertical';
          if (dragAxis === 'vertical') {
            handleDragEnd();
            return;
          }
        }

        if (isMovTouch) moveEvent.preventDefault();

        const now = performance.now();
        const dx = currX - prevX;
        const dt = now - prevTime;

        if (dt > 0) {
          const instantVel = dx / dt;
          velocityPx = VELOCITY_SMOOTHING * instantVel + (1 - VELOCITY_SMOOTHING) * velocityPx;
        }

        prevX = currX;
        prevTime = now;

        const totalDelta = currX - startX;
        if (Math.abs(totalDelta) > 5) hasDragged = true;

        offset = startOffset - totalDelta / stride;
        render();
        checkCenterChanged(false);
      }

      function handleDragEnd() {
        document.removeEventListener('mousemove', handleDragMove);
        document.removeEventListener('mouseup', handleDragEnd);
        document.removeEventListener('touchmove', handleDragMove);
        document.removeEventListener('touchend', handleDragEnd);
        document.removeEventListener('touchcancel', handleDragEnd);

        $cardsContainer.classList.remove('flh--dragging');

        const velOffsetPerMs = -velocityPx / stride;

        if (hasDragged && Math.abs(velOffsetPerMs) > FLING_MIN_VELOCITY) {
          startMomentum(velOffsetPerMs);
        } else {
          snapToNearest();
        }
      }

      document.addEventListener('mousemove', handleDragMove);
      document.addEventListener('mouseup', handleDragEnd);
      document.addEventListener('touchmove', handleDragMove, { passive: false });
      document.addEventListener('touchend', handleDragEnd);
      document.addEventListener('touchcancel', handleDragEnd);
    }

    /* ---- card click ---- */
    function handleCardClick(event) {
      if (hasDragged) {
        event.preventDefault();
        return;
      }

      const $card = event.currentTarget;
      const cardIndex = $cards.indexOf($card);
      const slot = wrapSlot(cardIndex - offset);
      const href = $card.dataset.flhHref;

      if (Math.abs(slot) < 0.3) {
        if (!href) {
          event.preventDefault();
        }
        dismissSwipeHint();
        return;
      }

      if (Math.abs(slot) < 2.5) {
        event.preventDefault();
        cancelAllAnimations();
        dismissSwipeHint();
        const targetOffset = offset + slot;
        animateToOffset(targetOffset, BTN_ANIM_DURATION, dramaticEasing, true);
      }
    }

    /* ---- navigation queue ---- */
    function processQueue() {
      if (isAnimating || queuedDirection === null) return;
      const direction = queuedDirection;
      queuedDirection = null;
      const target = Math.round(offset) + direction;
      animateToOffset(target, BTN_ANIM_DURATION, dramaticEasing, true);
    }

    /* ---- button clicks (use dramatic easing) ---- */
    function handlePrevClick() {
      dismissSwipeHint();
      if (isAnimating) {
        queuedDirection = -1;
        return;
      }
      const target = Math.round(offset) - 1;
      animateToOffset(target, BTN_ANIM_DURATION, dramaticEasing, true);
    }

    function handleNextClick() {
      dismissSwipeHint();
      if (isAnimating) {
        queuedDirection = 1;
        return;
      }
      const target = Math.round(offset) + 1;
      animateToOffset(target, BTN_ANIM_DURATION, dramaticEasing, true);
    }

    /* ---- swipe hint ---- */
    function dismissSwipeHint() {
      if (swipeHintDismissed || !$swipeHint) return;
      swipeHintDismissed = true;
      if (swipeHintAnimStartTimeout) clearTimeout(swipeHintAnimStartTimeout);
      if (swipeHintAnimCycleTimeout) clearTimeout(swipeHintAnimCycleTimeout);
      $swipeHint.classList.remove('flh__swipe-hint--animate');
      $swipeHint.style.opacity = '0';
    }

    function startSwipeHintAnimation() {
      const SWIPE_HINT_START_DELAY = 1500;

      if (!$swipeHint || swipeHintDismissed) return;

      if (swipeHintAnimStartTimeout) clearTimeout(swipeHintAnimStartTimeout);
      if (swipeHintAnimCycleTimeout) clearTimeout(swipeHintAnimCycleTimeout);

      $swipeHint.classList.remove('flh__swipe-hint--animate');

      swipeHintAnimStartTimeout = setTimeout(function addSwipeHintAnimation() {
        $swipeHint.classList.add('flh__swipe-hint--animate');
      }, SWIPE_HINT_START_DELAY);
    }

    function bindSwipeHint() {
      if (!$swipeHint) return;

      $swipeHint.addEventListener('animationiteration', function onSwipeHintCycle() {
        const SWIPE_HINT_CYCLE_DELAY = 10000;

        $swipeHint.classList.remove('flh__swipe-hint--animate');
        swipeHintAnimCycleTimeout = setTimeout(function restartSwipeHintAnimation() {
          if (!swipeHintDismissed) {
            $swipeHint.classList.add('flh__swipe-hint--animate');
          }
        }, SWIPE_HINT_CYCLE_DELAY);
      });

      startSwipeHintAnimation();
    }

    /* ---- resize ---- */
    function handleResize() {
      readLayoutParams();
      render();
    }

    /* ---- init ---- */
    function init() {
      readLayoutParams();
      render();
      setControlsImmediate(getCenterIndex());

      $cards.forEach(function attachClick($card) {
        $card.addEventListener('click', handleCardClick);
      });

      $cardsContainer.addEventListener('mousedown', handleDragStart);
      $cardsContainer.addEventListener('touchstart', handleDragStart, { passive: true });

      $prevBtn.addEventListener('click', handlePrevClick);
      $nextBtn.addEventListener('click', handleNextClick);

      new ResizeObserver(handleResize).observe($root);
      bindSwipeHint();
    }

    init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    'use strict';

    // ============================================
    // CONSTANTS
    // ============================================
    const CONSTANTS = {
      RESIZE_DEBOUNCE_MS: 200,
      COFFEE_ANIM_DURATION_MS: 1200,
      CLOCK_UPDATE_INTERVAL_MS: 1000,
      TIMEZONES: {
        LONDON: 'Europe/London',
        BERLIN: 'Europe/Berlin',
      },
    };

    // ============================================
    // UTILITY FUNCTIONS
    // ============================================
    const Utils = {
      /**
       * Check if Intl API is available
       * @returns {boolean}
       */
      supportsIntl() {
        return !!(window.Intl && Intl.DateTimeFormat);
      },
    };

    // ============================================
    // LOCALIZATION FORM CLASS
    // ============================================
    /**
     * Manages the footer localization form.
     * Auto-submits when language or country is changed.
     */
    class LocalizationForm {
      constructor() {
        this.form = document.getElementById('FooterLocalizationForm');
        if (this.form) {
          this.init();
        }
      }

      init() {
        this.form.addEventListener('change', (e) => this.handleChange(e));
      }

      handleChange(event) {
        const el = event.target;
        if (!el) return;

        if (el.name === 'locale_code' || el.name === 'country_code') {
          if (typeof this.form.requestSubmit === 'function') {
            this.form.requestSubmit();
          } else {
            this.form.submit();
          }
        }
      }
    }

    // ============================================
    // FOOTER LAYOUT CLASS
    // ============================================
    /**
     * Manages footer layout calculations and resize behavior.
     * Handles link container width updates and resize transition suppression.
     */
    class FooterLayout {
      constructor() {
        this.footer = document.querySelector('.footer');
        this.links = this.footer?.querySelector('.footer__links-container');
        this.resizeTimeoutId = null;

        if (this.footer && this.links) {
          this.init();
        }
      }

      init() {
        this.setupLinkWidthObserver();
        this.setupResizeHandler();
      }

      setupLinkWidthObserver() {
        const setWidth = () => {
          const w = Math.round(this.links.getBoundingClientRect().width);
          this.footer.style.setProperty('--footer-links-width', `${w}px`);
        };

        // Observe width changes of the links container
        if ('ResizeObserver' in window) {
          const ro = new ResizeObserver(setWidth);
          ro.observe(this.links);
        }

        // Initial set (in case observer fires late)
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', setWidth, { once: true });
        } else {
          setWidth();
        }

        // Update on viewport resize as an extra safeguard
        window.addEventListener('resize', setWidth);
      }

      setupResizeHandler() {
        window.addEventListener('resize', () => this.handleResize(), { passive: true });
      }

      handleResize() {
        document.body.classList.add('is-resizing');
        window.clearTimeout(this.resizeTimeoutId);
        this.resizeTimeoutId = window.setTimeout(() => {
          document.body.classList.remove('is-resizing');
        }, CONSTANTS.RESIZE_DEBOUNCE_MS);
      }
    }

    // ============================================
    // WEATHER CLOCKS CLASS
    // ============================================
    /**
     * Manages live weather clocks for UK and DE offices.
     * Updates time every second, pauses when footer is offscreen.
     */
    class WeatherClocks {
      constructor() {
        if (!Utils.supportsIntl()) return;

        this.nodes = document.querySelectorAll('time[data-timezone]');
        this.footerEl = document.querySelector('footer.footer-hero');
        this.timeFormatters = Object.create(null);
        this.tzNameFormatters = Object.create(null);
        this.timerId = null;

        if (this.nodes.length) {
          this.init();
        }
      }

      init() {
        this.setupIntersectionObserver();
      }

      getTimeFormatter(tz) {
        return (
          this.timeFormatters[tz] ||
          (this.timeFormatters[tz] = new Intl.DateTimeFormat('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
            timeZone: tz,
          }))
        );
      }

      getTzNameFormatter(tz) {
        return (
          this.tzNameFormatters[tz] ||
          (this.tzNameFormatters[tz] = new Intl.DateTimeFormat('en-GB', {
            timeZone: tz,
            timeZoneName: 'short',
          }))
        );
      }

      formatTzAbbr(now, tz) {
        const tzPart =
          (
            this.getTzNameFormatter(tz)
              .formatToParts(now)
              .find((p) => p.type === 'timeZoneName') || {}
          ).value || '';
        const n = String(tzPart).toUpperCase();

        // Prefer native abbreviations when available
        if (n.indexOf('BST') > -1) return 'BST';
        if (n.indexOf('GMT') > -1) return 'GMT';
        if (n.indexOf('CEST') > -1) return 'CEST';
        if (n.indexOf('CET') > -1) return 'CET';
        if (n.indexOf('UTC') > -1) return 'GMT';

        // Fallback for browsers that return numeric offsets (e.g., GMT+1)
        if (n.indexOf('+') > -1 || n.indexOf('-') > -1) {
          if (tz === CONSTANTS.TIMEZONES.LONDON) {
            return n.indexOf('+1') > -1 ? 'BST' : 'GMT';
          }
          if (tz === CONSTANTS.TIMEZONES.BERLIN) {
            if (n.indexOf('+2') > -1) return 'CEST';
            if (n.indexOf('+1') > -1) return 'CET';
          }
        }

        // Final sensible defaults per zone
        if (tz === CONSTANTS.TIMEZONES.LONDON) return 'GMT';
        if (tz === CONSTANTS.TIMEZONES.BERLIN) return 'CET';
        return n || 'GMT';
      }

      updateElement(el, now) {
        const tz = el.getAttribute('data-timezone');
        const country = el.getAttribute('data-country') || '';
        if (!tz) return;

        const timeStr = this.getTimeFormatter(tz).format(now);
        const abbr = this.formatTzAbbr(now, tz);
        el.textContent = `${timeStr} (${abbr}${country ? ', ' + country : ''})`;
        el.setAttribute('datetime', now.toISOString());
      }

      updateAll() {
        const now = new Date();
        this.nodes.forEach((node) => this.updateElement(node, now));
      }

      start() {
        if (this.timerId !== null) return;

        this.updateAll();
        const now = new Date();
        const delay = CONSTANTS.CLOCK_UPDATE_INTERVAL_MS - now.getMilliseconds();

        this.timerId = window.setTimeout(() => {
          this.updateAll();
          this.timerId = window.setInterval(() => this.updateAll(), CONSTANTS.CLOCK_UPDATE_INTERVAL_MS);
        }, Math.max(0, delay));
      }

      stop() {
        if (this.timerId === null) return;
        window.clearTimeout(this.timerId);
        window.clearInterval(this.timerId);
        this.timerId = null;
      }

      setupIntersectionObserver() {
        if ('IntersectionObserver' in window && this.footerEl) {
          const io = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  this.start();
                } else {
                  this.stop();
                }
              });
            },
            { root: null, threshold: 0 }
          );
          io.observe(this.footerEl);
        } else {
          this.start();
        }
      }
    }

    // ============================================
    // COFFEE BUTTON CLASS
    // ============================================
    /**
     * Manages the Ko-fi coffee button Lottie animation.
     * Lazy-loads the Lottie library, plays on hover/focus, handles mobile interactions.
     */
    class CoffeeButton {
      constructor() {
        this.btn = document.querySelector('footer.footer-hero .btn--coffee');
        this.container = this.btn?.querySelector('.btn--coffee__lottie');
        this.anim = null;
        this.loading = false;
        this.pending = [];
        this.isCoarsePointer =
          (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) || 'ontouchstart' in window;
        this.prefersReducedMotion =
          (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) || false;

        if (this.btn && this.container) {
          this.init();
        }
      }

      init() {
        this.setupIntersectionObserver();
        this.attachEventListeners();
        this.setupPageLifecycleHandlers();
      }

      loadLib(cb) {
        if (window.lottie) return cb();

        this.pending.push(cb);
        if (this.loading) return;

        this.loading = true;
        const s = document.createElement('script');
        const src = this.container?.dataset.lottieLib;

        if (!src) {
          this.loading = false;
          this.pending.length = 0;
          return;
        }

        s.src = src;
        s.async = true;
        s.onload = () => {
          this.loading = false;
          const q = this.pending.slice();
          this.pending.length = 0;
          q.forEach((callback) => {
            try {
              callback();
            } catch (_) {}
          });
        };
        s.onerror = () => {
          this.loading = false;
          this.pending.length = 0;
        };
        document.head.appendChild(s);
      }

      initAnim() {
        if (this.anim || !window.lottie) return;
        this.anim = window.lottie.loadAnimation({
          container: this.container,
          renderer: 'svg',
          loop: false,
          autoplay: false,
          path: this.container.dataset.lottiePath,
          rendererSettings: { preserveAspectRatio: 'xMidYMid slice' },
        });
      }

      ensureAnim(cb) {
        if (!this.container.isConnected) return;
        if (this.anim) return cb();
        this.loadLib(() => {
          if (!this.container.isConnected) return;
          this.initAnim();
          cb();
        });
      }

      playOnce() {
        this.btn.classList.add('btn--coffee--animating');
        this.ensureAnim(() => {
          try {
            this.anim.goToAndPlay(0, true);
          } catch (_) {}
        });
      }

      reset() {
        this.btn.classList.remove('btn--coffee--animating');
        try {
          if (this.anim) this.anim.goToAndStop(0, true);
        } catch (_) {}
      }

      setupIntersectionObserver() {
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver((entries, obs) => {
            if (entries.some((e) => e.isIntersecting)) {
              this.loadLib(() => this.initAnim());
              obs.unobserve(this.btn);
            }
          });
          io.observe(this.btn);
        } else {
          this.loadLib(() => this.initAnim());
        }
      }

      markTap() {
        try {
          sessionStorage.setItem('mm_coffee_tapped', '1');
        } catch (_) {}
        setTimeout(() => {
          try {
            this.btn.blur();
          } catch (_) {}
        }, 0);
      }

      attachEventListeners() {
        this.btn.addEventListener('mouseenter', () => this.playOnce());
        this.btn.addEventListener('focus', () => this.playOnce());
        this.btn.addEventListener('mouseleave', () => this.reset());
        this.btn.addEventListener('blur', () => this.reset());
        this.btn.addEventListener(
          'touchstart',
          () => {
            this.playOnce();
            this.markTap();
          },
          { passive: true }
        );
        this.btn.addEventListener('touchend', () => this.resetAfterTouch(), { passive: true });
        this.btn.addEventListener('touchcancel', () => this.resetAfterTouch(), { passive: true });

        this.btn.addEventListener('click', () => {
          if (this.isCoarsePointer) this.markTap();
        });
      }

      resetAfterTouch() {
        clearTimeout(this._touchResetTimer);
        this._touchResetTimer = setTimeout(() => this.reset(), CONSTANTS.COFFEE_ANIM_DURATION_MS);
      }

      setupPageLifecycleHandlers() {
        window.addEventListener('pagehide', () => {
          this.reset();
          try {
            this.btn.blur();
          } catch (_) {}
        });

        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'hidden') {
            this.reset();
            try {
              this.btn.blur();
            } catch (_) {}
          }
        });

        window.addEventListener('pageshow', () => {
          let flagged = false;
          try {
            flagged = sessionStorage.getItem('mm_coffee_tapped') === '1';
            if (flagged) sessionStorage.removeItem('mm_coffee_tapped');
          } catch (_) {}

          if (!this.isCoarsePointer || this.prefersReducedMotion || !flagged) return;

          this.ensureAnim(() => {
            this.playOnce();
            window.setTimeout(() => this.reset(), CONSTANTS.COFFEE_ANIM_DURATION_MS);
          });
        });
      }
    }

    // ============================================
    // INITIALIZATION
    // ============================================
    new LocalizationForm();
    new FooterLayout();
    new WeatherClocks();
    new CoffeeButton();

    (function initFooterNewsletterLink() {
      const $link = document.querySelector('[data-footer-newsletter-link]');
      if (!$link) return;
      $link.addEventListener('click', function handleNewsletterClick() {
        document.dispatchEvent(new CustomEvent('megamac:newsletter:open'));
      });
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function header() {
    function withImageWidth(url, width) {
      if (!url) return '';
      try {
        const parsed = new URL(url, window.location.origin);
        parsed.searchParams.set('width', String(width));
        return parsed.toString();
      } catch (e) {
        const source = String(url);
        const separator = source.indexOf('?') === -1 ? '?' : '&';
        return `${source}${separator}width=${encodeURIComponent(String(width))}`;
      }
    }

    /********************************************************/
    /* desktop lottie logo animation implementation details */
    /********************************************************/
    (function desktopLottieLogoAnimation() {
      const $logoLottie = document.querySelector('[data-logo-lottie]');

      if (!$logoLottie) return;

      let lottieAnimationInstance = null;
      let isLottieLibraryLoading = false;
      let libraryLoadCallbacks = [];
      let isLogoAnimationInitialized = false;

      function ensureLottieLibraryLoaded(onLibraryReady) {
        if (window.lottie) return onLibraryReady();

        libraryLoadCallbacks.push(onLibraryReady);
        if (isLottieLibraryLoading) return;

        isLottieLibraryLoading = true;
        const script = document.createElement('script');
        const libraryUrl = $logoLottie.dataset.lottieLib;

        if (!libraryUrl) {
          isLottieLibraryLoading = false;
          libraryLoadCallbacks.length = 0;
          return;
        }

        script.src = libraryUrl;
        script.async = true;
        script.onload = () => {
          isLottieLibraryLoading = false;
          const callbacks = libraryLoadCallbacks.slice();
          libraryLoadCallbacks.length = 0;
          callbacks.forEach((callback) => {
            try {
              callback();
            } catch (_) {}
          });
        };
        script.onerror = () => {
          isLottieLibraryLoading = false;
          libraryLoadCallbacks.length = 0;
        };
        document.head.appendChild(script);
      }

      function createAnimation() {
        if (lottieAnimationInstance || !window.lottie) return;

        lottieAnimationInstance = window.lottie.loadAnimation({
          container: $logoLottie,
          renderer: 'svg',
          loop: false,
          autoplay: false,
          path: $logoLottie.dataset.lottiePath,
          rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
          },
        });

        lottieAnimationInstance.addEventListener('DOMLoaded', () => {
          $logoLottie.classList.add('header__logo__lottie--loaded');
          lottieAnimationInstance.goToAndStop(1, true);
        });
      }

      const MEGAMAC_FRAMES = { reveal: [10, 50], return: [100, 140] };
      const SCROLL_THRESHOLD_FOR_TRANSITION = 50;
      const MEGAMAC_RETURN_FRAME_START = 100;

      let isTransitioning = false;
      let currentVisualState = 'megamac';
      let desiredVisualState = 'megamac';

      function checkAndTransitionToDesiredState() {
        if (currentVisualState === desiredVisualState) return;

        if (desiredVisualState === 'laptop') {
          transitionToLaptop();
        } else {
          transitionToMegaMac();
        }
      }

      function transitionToLaptop() {
        if (isTransitioning || !lottieAnimationInstance || currentVisualState === 'laptop') return;

        currentVisualState = 'laptop';
        isTransitioning = true;

        const currentFrame = Math.round(lottieAnimationInstance.currentFrame);
        const isAtReturnAnimationEnd = currentFrame >= MEGAMAC_RETURN_FRAME_START;

        if (isAtReturnAnimationEnd) {
          lottieAnimationInstance.goToAndStop(MEGAMAC_FRAMES.reveal[0], true);
        }

        lottieAnimationInstance.playSegments(MEGAMAC_FRAMES.reveal, true);

        const onAnimationComplete = () => {
          lottieAnimationInstance.removeEventListener('complete', onAnimationComplete);
          isTransitioning = false;
          checkAndTransitionToDesiredState();
        };

        lottieAnimationInstance.addEventListener('complete', onAnimationComplete);
      }

      function transitionToMegaMac() {
        if (isTransitioning || !lottieAnimationInstance || currentVisualState === 'megamac') return;

        currentVisualState = 'megamac';
        isTransitioning = true;

        lottieAnimationInstance.playSegments(MEGAMAC_FRAMES.return, true);

        const onAnimationComplete = () => {
          lottieAnimationInstance.removeEventListener('complete', onAnimationComplete);
          isTransitioning = false;
          checkAndTransitionToDesiredState();
        };

        lottieAnimationInstance.addEventListener('complete', onAnimationComplete);
      }

      function updateLogoBasedOnScrollPosition() {
        if (!lottieAnimationInstance) return;

        const isAtTopOfPage = window.scrollY <= SCROLL_THRESHOLD_FOR_TRANSITION;
        desiredVisualState = isAtTopOfPage ? 'megamac' : 'laptop';

        if (!isTransitioning) checkAndTransitionToDesiredState();
      }

      function attachScrollListener() {
        let isScheduled = false;

        window.addEventListener('scroll', () => {
          if (isScheduled) return;

          isScheduled = true;
          window.requestAnimationFrame(() => {
            updateLogoBasedOnScrollPosition();
            isScheduled = false;
          });
        });
      }

      function initializeIfDesktop() {
        if (isLogoAnimationInitialized || window.innerWidth < 1220) return;

        isLogoAnimationInitialized = true;

        ensureLottieLibraryLoaded(() => {
          createAnimation();
          attachScrollListener();
        });
      }

      initializeIfDesktop();

      window.addEventListener('resize', () => {
        const shouldInitialize = !isLogoAnimationInitialized && window.innerWidth >= 1220;
        shouldInitialize && initializeIfDesktop();
      });
    })();

    /********************************************************/
    /* mini cart: see assets/mini-cart.js                    */
    /********************************************************/

    /***************************************/
    /* desktop menu implementation details */
    /***************************************/
    (function desktopMenu() {
      const $menu = document.querySelector('[data-menu]');
      const $megaMenu = document.querySelector('[data-mega-menu]');

      if (!$menu || !$megaMenu) return;

      const $menuButtons = document.querySelectorAll('[data-menu-button]');
      const $megaMenuWrappers = $megaMenu.querySelectorAll('[data-mega-menu-category]');
      const $featuredSection = $megaMenu.querySelector('[data-mega-menu-featured]');
      const $featuredItems = $featuredSection ? $featuredSection.querySelectorAll('[data-featured-category]') : [];

      let currentMenuButton = null;

      function clearActiveStates() {
        $menuButtons.forEach((btn) => {
          btn.classList.remove('header__menu__button--active');
          btn.setAttribute('aria-expanded', 'false');
        });

        $megaMenuWrappers.forEach((wrapper) => wrapper.classList.remove('header__mega-menu__menu__wrapper--active'));
      }

      function setActiveCategory(button, category) {
        currentMenuButton = button;
        const $activeWrapper = document.querySelector(`[data-mega-menu-category="${category}"]`);
        button.classList.add('header__menu__button--active');
        button.setAttribute('aria-expanded', 'true');
        $activeWrapper?.classList.add('header__mega-menu__menu__wrapper--active');
      }

      function showFeaturedIfApplicable(category) {
        if (!$featuredSection) return;

        let hasVisible = false;

        $featuredItems.forEach((item) => {
          const itemCategory = item.getAttribute('data-featured-category');
          const isMatch = itemCategory === category;

          item.style.display = isMatch ? 'block' : 'none';

          if (isMatch) hasVisible = true;
        });

        if (hasVisible) {
          $featuredSection.classList.add('header__mega-menu__featured--visible');
        } else {
          $featuredSection.classList.remove('header__mega-menu__featured--visible');
        }
      }

      function openMegaMenu() {
        $megaMenu.classList.add('header__mega-menu--open');
        $menu.classList.add('header__menu--mega-open');
      }

      function closeMegaMenu() {
        $megaMenu.classList.remove('header__mega-menu--open');
        $menu.classList.remove('header__menu--mega-open');
        clearActiveStates();
        if ($featuredSection) {
          $featuredSection.classList.remove('header__mega-menu__featured--visible');
          $featuredItems.forEach((item) => {
            item.style.display = 'none';
          });
        }
      }

      function activateMegaMenuForCategory(event) {
        const category = event.target.getAttribute('data-menu-button');
        clearActiveStates();
        setActiveCategory(event.target, category);
        showFeaturedIfApplicable(category);
        openMegaMenu();
      }

      function closeMegaMenuOnMouseLeave() {
        closeMegaMenu();
      }

      function handleMegaMenuKeyboardNavigation(event) {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          const category = event.target.getAttribute('data-menu-button');
          const $activeWrapper = document.querySelector(`[data-mega-menu-category="${category}"]`);
          const $firstLink = $activeWrapper?.querySelector('[data-mega-menu-link]');
          $firstLink?.focus();
        } else if (event.key === 'Tab' && !event.shiftKey) {
          const currentIndex = Array.from($menuButtons).indexOf(event.target);
          const isLastButton = currentIndex === $menuButtons.length - 1;
          isLastButton && closeMegaMenu();
        }
      }

      function handleMegaMenuLinkTabNavigation(event) {
        const isNotTabOrNoCurrentMenuButton = event.key !== 'Tab' || !currentMenuButton;
        if (isNotTabOrNoCurrentMenuButton) return;

        const $activeWrapper = document.querySelector('.header__mega-menu__menu__wrapper--active');
        const $allLinks = $activeWrapper?.querySelectorAll('[data-mega-menu-link]');
        const $firstLink = $allLinks?.[0];
        const $lastLink = $allLinks?.[$allLinks?.length - 1];

        const isShiftTab = event.shiftKey;
        const isFirstLink = event.target === $firstLink;
        const isLastLink = event.target === $lastLink;

        if (isShiftTab && isFirstLink) {
          event.preventDefault();
          currentMenuButton.focus();
        }

        if (!isShiftTab && isLastLink) {
          event.preventDefault();
          const currentIndex = Array.from($menuButtons).indexOf(currentMenuButton);
          const nextButton = $menuButtons[currentIndex + 1] || $menuButtons[0];
          nextButton.focus();
        }
      }

      function closeMegaMenuOnEscape(event) {
        const isEscapeOpen = event.key === 'Escape' && $megaMenu?.classList.contains('header__mega-menu--open');
        isEscapeOpen && closeMegaMenu();
      }

      $menuButtons.forEach((button) => button.addEventListener('mouseenter', activateMegaMenuForCategory));
      $menuButtons.forEach((button) => button.addEventListener('focus', activateMegaMenuForCategory));
      $menuButtons.forEach((button) => button.addEventListener('keydown', handleMegaMenuKeyboardNavigation));
      $menu.addEventListener('mouseleave', closeMegaMenuOnMouseLeave);
      document.addEventListener('keydown', closeMegaMenuOnEscape);
      document.querySelectorAll('[data-mega-menu-link]').forEach((link) => {
        link.addEventListener('keydown', handleMegaMenuLinkTabNavigation);
      });
    })();

    /*********************************************************************/
    /* desktop icon panel (search, account, cart) implementation details */
    /*********************************************************************/
    (function desktopIconPanel() {
      const $desktopIconPanelButtons = document.querySelectorAll('[data-panel-button]');
      const $mobileIconPanelButtons = document.querySelectorAll('[data-mobile-icon-button]');
      const $desktopIconPanelWrapper = document.querySelector('[data-panel-wrapper]');
      const $desktopIconPanelContents = document.querySelectorAll('[data-panel-content]');
      const $desktopIconPanelCloseButton = document.querySelector('[data-panel-close]');

      let triggeringButton = null;

      function isPanelActive() {
        return $desktopIconPanelWrapper?.classList.contains('header__icons__panel__wrapper--active');
      }

      function updateBodyScroll() {
        const shouldLockScroll = isPanelActive() && window.innerWidth <= 1220;
        document.body.style.overflow = shouldLockScroll ? 'hidden' : '';
      }

      function clearActiveButtons() {
        $desktopIconPanelButtons.forEach((btn) => {
          btn.classList.remove('header__icons__button--active');
          btn.setAttribute('aria-expanded', 'false');
        });
        $mobileIconPanelButtons.forEach((btn) => {
          btn.setAttribute('aria-expanded', 'false');
        });
      }

      function clearActiveContent() {
        $desktopIconPanelContents.forEach((content) =>
          content.classList.remove('header__icons__panel__content--active')
        );
      }

      function closeDesktopIconPanel() {
        $desktopIconPanelButtons.forEach(
          (btn) => (btn.style.transition = 'background-color 300ms cubic-bezier(0.9, 0, 0.1, 1)')
        );
        $desktopIconPanelWrapper?.classList.remove('header__icons__panel__wrapper--active');
        $desktopIconPanelWrapper?.setAttribute('data-panel-wrapper', '');

        updateBodyScroll();

        clearActiveButtons();
        clearActiveContent();

        setTimeout(() => {
          triggeringButton?.focus();
          triggeringButton = null;
        }, 100);

        setTimeout(() => {
          $desktopIconPanelButtons.forEach((btn) => (btn.style.transition = ''));
        }, 300);
      }

      function openDesktopIconPanel(panelType, button) {
        const $targetContent = document.querySelector(`[data-panel-content="${panelType}"]`);
        $desktopIconPanelWrapper?.classList.add('header__icons__panel__wrapper--active');
        $desktopIconPanelWrapper?.setAttribute('data-panel-wrapper', panelType);
        $targetContent?.classList.add('header__icons__panel__content--active');
        button?.classList.add('header__icons__button--active');
        button?.setAttribute('aria-expanded', 'true');

        updateBodyScroll();

        // The cart panel re-reads the cart on open if its last read is old or failed.
        try {
          document.dispatchEvent(new CustomEvent('megamac:panel:opened', { detail: { panel: panelType } }));
        } catch (_) {}

        // By default we move focus to the close button for accessibility.
        // When we auto-open after a login-triggered reload, skip this once to avoid
        // showing a focus ring on initial page load.
        const skipNextFocus = window.__mmPanelSkipNextFocus === true;
        if (skipNextFocus) window.__mmPanelSkipNextFocus = false;

        if (!skipNextFocus) {
          setTimeout(() => {
            if (panelType === 'search') {
              const $searchInput = document.querySelector('#search-input');
              $searchInput?.focus();
            } else {
              const $closeButton = document.querySelector('[data-panel-close]');
              $closeButton?.focus();
            }
          }, 100);
        }
      }

      function applyTransitionToButtons() {
        $desktopIconPanelButtons.forEach(
          (btn) => (btn.style.transition = 'background-color 300ms cubic-bezier(0.9, 0, 0.1, 1)')
        );
      }

      function removeTransitionFromButtons() {
        $desktopIconPanelButtons.forEach((btn) => (btn.style.transition = 'none'));
        requestAnimationFrame(() => {
          $desktopIconPanelButtons.forEach((btn) => (btn.style.transition = ''));
        });
      }

      function toggleDesktopIconPanel(event) {
        const $button = event.currentTarget;
        const panelType = $button.getAttribute('data-panel-button');
        const $targetContent = document.querySelector(`[data-panel-content="${panelType}"]`);

        const isWrapperActive = $desktopIconPanelWrapper?.classList.contains('header__icons__panel__wrapper--active');
        const isTargetContentActive = $targetContent?.classList.contains('header__icons__panel__content--active');
        const isAlreadyOpen = isWrapperActive && isTargetContentActive;

        if (isAlreadyOpen) {
          closeDesktopIconPanel();
          return;
        }

        triggeringButton = $button;

        const isSwitchingBetweenPanels = isWrapperActive;
        if (isSwitchingBetweenPanels) {
          applyTransitionToButtons();
        } else {
          removeTransitionFromButtons();
        }

        clearActiveButtons();
        clearActiveContent();
        openDesktopIconPanel(panelType, $button);
      }

      function handleMobileIconButtonClick(event) {
        const $button = event.currentTarget;
        const panelType = $button.getAttribute('data-mobile-icon-button');
        const $targetContent = document.querySelector(`[data-panel-content="${panelType}"]`);

        const isWrapperActive = $desktopIconPanelWrapper?.classList.contains('header__icons__panel__wrapper--active');
        const isTargetContentActive = $targetContent?.classList.contains('header__icons__panel__content--active');
        const isAlreadyOpen = isWrapperActive && isTargetContentActive;

        if (isAlreadyOpen) {
          closeDesktopIconPanel();
          return;
        }

        triggeringButton = $button;

        clearActiveButtons();
        clearActiveContent();
        openDesktopIconPanel(panelType, $button);
      }

      function closePanelOnEscape(event) {
        const isEscapePressed =
          event.key === 'Escape' &&
          $desktopIconPanelWrapper?.classList.contains('header__icons__panel__wrapper--active');
        isEscapePressed && closeDesktopIconPanel();
      }

      function closePanelOnClickOutside(event) {
        if (!isPanelActive()) return;
        // Only real clicks close the panel: scripts click page buttons on the shopper's behalf (e.g. the panel's
        // copy of a cart page undo message triggers the page's Undo), and those land outside the panel.
        if (event.isTrusted === false) return;

        const isClickOnDesktopButton = Array.from($desktopIconPanelButtons).some((btn) => btn.contains(event.target));
        if (isClickOnDesktopButton) return;

        const isClickOnMobileButton = Array.from($mobileIconPanelButtons).some((btn) => btn.contains(event.target));
        if (isClickOnMobileButton) return;

        const $activeContent = document.querySelector('.header__icons__panel__content--active');
        // Check the path recorded when the click happened: the cart's remove and undo buttons take the clicked
        // element out of the page before this runs, so `contains(event.target)` would read as an outside click.
        const clickPath = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
        const isClickInsideContent = !!$activeContent && clickPath.includes($activeContent);

        if (!isClickInsideContent) {
          closeDesktopIconPanel();
        }
      }

      window.MegaMacUI = window.MegaMacUI || {};
      window.MegaMacUI.openCartPanel = function openCartPanel() {
        const $button =
          Array.from(document.querySelectorAll('[data-panel-button="cart"], [data-mobile-icon-button="cart"]')).find(
            (el) => el.offsetParent !== null
          ) || document.querySelector('[data-panel-button="cart"]');

        const $targetContent = document.querySelector('[data-panel-content="cart"]');

        const isWrapperActive = $desktopIconPanelWrapper?.classList.contains('header__icons__panel__wrapper--active');
        const isTargetContentActive = $targetContent?.classList.contains('header__icons__panel__content--active');
        const isAlreadyOpen = isWrapperActive && isTargetContentActive;

        if (isAlreadyOpen) return;

        triggeringButton = $button || null;

        const isSwitchingBetweenPanels = isWrapperActive;
        if (isSwitchingBetweenPanels) {
          applyTransitionToButtons();
        } else {
          removeTransitionFromButtons();
        }

        clearActiveButtons();
        clearActiveContent();
        openDesktopIconPanel('cart', $button);
      };

      $desktopIconPanelButtons.forEach((button) => button.addEventListener('click', toggleDesktopIconPanel));
      $mobileIconPanelButtons.forEach((button) => button.addEventListener('click', handleMobileIconButtonClick));
      $desktopIconPanelCloseButton?.addEventListener('click', closeDesktopIconPanel);
      document.addEventListener('keydown', closePanelOnEscape);
      document.addEventListener('click', closePanelOnClickOutside);
      window.addEventListener('resize', updateBodyScroll);
    })();

    /*********************************************************************/
    /* predictive search (light panel behavior)                           */
    /*********************************************************************/
    (function predictiveSearchPanel() {
      const $panel = document.querySelector('[data-search-panel]');
      const $form = document.querySelector('[data-search-form]');
      const $input = document.querySelector('[data-search-input]');
      const $emptyState = document.querySelector('[data-search-empty-state]');
      const $resultState = document.querySelector('[data-search-result-state]');
      const $noResultState = document.querySelector('[data-search-no-result-state]');
      const $suggestionsWrapper = document.querySelector('[data-search-suggestions-wrapper]');
      const $suggestionsTitle = document.querySelector('[data-search-suggestions-title]');
      const $suggestions = document.querySelector('[data-search-suggestions]');
      const $products = document.querySelector('[data-search-products]');
      const $viewAll = document.querySelector('[data-search-view-all]');
      const $viewAllWrapper = document.querySelector('[data-search-view-all-wrapper]');
      const $queryLabel = document.querySelector('[data-search-query-label]');

      if (
        !$panel ||
        !$form ||
        !$input ||
        !$emptyState ||
        !$resultState ||
        !$noResultState ||
        !$suggestionsWrapper ||
        !$suggestionsTitle ||
        !$suggestions ||
        !$products ||
        !$viewAll ||
        !$viewAllWrapper ||
        !$queryLabel
      ) {
        return;
      }

      /* ── constants ── */

      const searchEndpoint = $panel.getAttribute('data-search-url') || '/search';
      const predictiveSearchUrl = $panel.getAttribute('data-predictive-search-url') || '/search/suggest';
      const predictiveEndpoint = `${predictiveSearchUrl}.json`;
      const SEARCH_PREFIX = 'last';
      const SEARCH_TYPE = 'product';
      const SEARCH_FIELDS = 'title,product_type,variants.title,variants.sku,tag';
      const SEARCH_DEBOUNCE_MS = 150;
      const QUERY_CACHE_MAX_ENTRIES = 24;
      const VISIBLE_PRODUCT_TILE_COUNT = 5;
      const SEARCH_THUMB_CSS_PX = 104;
      const SUGGESTION_LINK_CLASS = 'header__icons__panel__search__content__state-result__suggestions__link';
      const MAX_SUGGESTIONS = 3;
      const PREDICTIVE_RESOURCE_LIMIT = 10;
      const PANEL_RESULTS_SECTION_ID = 'search-panel-results';
      const SCROLL_APPEND_BATCH_SIZE = 10;
      const SCROLL_PRELOAD_MARGIN_PX = 300;
      const PRODUCT_CARD_CLASS = 'header__icons__panel__search__content__state-result__gallery__card';
      const SENTINEL_CLASS = 'header__icons__panel__search__content__state-result__gallery__sentinel';

      const menuCollectionLinksRaw = $panel.getAttribute('data-search-menu-collections') || '';
      const allowedMenuCollectionPaths = new Set(
        menuCollectionLinksRaw
          .split('||')
          .map(function normalizeMenuUrl(url) {
            return normalizeCollectionPath(url);
          })
          .filter(Boolean)
      );

      /* ── mutable state ── */

      let debounceTimer = null;
      let requestToken = 0;
      let lastRenderedRequestId = 0;
      let lastRenderedQueryKey = '';
      let lastRenderedVisibleProductKeys = [];
      let activeSearchController = null;
      let viewAllCountFadeFrame = null;
      let scrollState = null;
      let hasWarmedImageCdn = false;

      const $sentinel = document.createElement('div');
      $sentinel.className = SENTINEL_CLASS;
      $sentinel.setAttribute('data-search-products-sentinel', '');

      /* ── LRU cache factory ── */

      function createLruCache(maxEntries) {
        const store = new Map();

        function read(key) {
          if (!key || !store.has(key)) return null;
          const value = store.get(key);
          store.delete(key);
          store.set(key, value);
          return value;
        }

        function write(key, value) {
          if (!key) return;
          if (store.has(key)) store.delete(key);
          store.set(key, value);
          while (store.size > maxEntries) {
            const oldestKey = store.keys().next().value;
            if (!oldestKey) break;
            store.delete(oldestKey);
          }
        }

        return { read: read, write: write };
      }

      const payloadCache = createLruCache(QUERY_CACHE_MAX_ENTRIES);
      const countCache = createLruCache(QUERY_CACHE_MAX_ENTRIES);

      /* ── HTML utilities ── */

      const HTML_ESCAPE_MAP = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

      function escapeHtml(value) {
        if (value === null || value === undefined) return '';
        return String(value).replace(/[&<>"']/g, function matchHtmlChar(char) {
          return HTML_ESCAPE_MAP[char];
        });
      }

      /* ── URL / path helpers ── */

      function normalizeUrlPath(rawUrl) {
        const source = String(rawUrl || '').trim();
        if (!source) return '';
        try {
          return (new URL(source, window.location.origin).pathname || '').replace(/\/+$/, '').toLowerCase();
        } catch (e) {
          return source.split('?')[0].split('#')[0].replace(/\/+$/, '').toLowerCase();
        }
      }

      function normalizeCollectionPath(rawUrl) {
        const pathname = normalizeUrlPath(rawUrl);
        const match = pathname.match(/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/collections\/([^/]+)/i);
        if (!match || !match[1]) return '';
        return `/collections/${match[1].toLowerCase()}`;
      }

      function buildSearchHref(query) {
        const params = new URLSearchParams();
        params.set('q', query);
        params.set('type', SEARCH_TYPE);
        params.set('options[prefix]', SEARCH_PREFIX);
        return `${searchEndpoint}?${params.toString()}`;
      }

      function buildQueryCacheKey(query) {
        const normalizedQuery = String(query || '')
          .trim()
          .toLowerCase();
        return normalizedQuery || '';
      }

      /* ── abort controller ── */

      function abortActiveSearchRequest() {
        if (!activeSearchController) return;
        activeSearchController.abort();
        activeSearchController = null;
      }

      function createActiveSearchSignal() {
        abortActiveSearchRequest();
        activeSearchController = new AbortController();
        return activeSearchController.signal;
      }

      /* ── UI state management ── */

      function showState(state) {
        const isEmpty = state === 'empty';
        const isResult = state === 'result';
        const isNoResult = state === 'no-result';

        $emptyState.hidden = !isEmpty;
        $resultState.hidden = !isResult;
        $noResultState.hidden = !isNoResult;
        $suggestionsWrapper.hidden = !isResult;
        $viewAllWrapper.hidden = !isResult;
        $panel.setAttribute('data-search-state', state);
      }

      function setViewAllLabel(totalCount, hasExactCount) {
        if (viewAllCountFadeFrame) {
          window.cancelAnimationFrame(viewAllCountFadeFrame);
          viewAllCountFadeFrame = null;
        }
        $viewAll.classList.remove('header__icons__panel__search__content__state-result__view-all-btn--count-visible');
        if (!hasExactCount) {
          $viewAll.removeAttribute('data-search-view-all-count');
          $viewAll.textContent = 'View all results';
          return;
        }

        const safeCount = String(Math.max(0, totalCount));
        $viewAll.setAttribute('data-search-view-all-count', safeCount);
        $viewAll.innerHTML = `View all <span class="header__icons__panel__search__content__state-result__view-all-btn__count">${safeCount}</span> results`;
        viewAllCountFadeFrame = window.requestAnimationFrame(function fadeViewAllCount() {
          viewAllCountFadeFrame = null;
          $viewAll.classList.add('header__icons__panel__search__content__state-result__view-all-btn--count-visible');
        });
      }

      function getProductCount(products) {
        return Array.isArray(products) ? products.length : 0;
      }

      function shouldCacheSearchCount(totalCount, productCount) {
        if (typeof totalCount !== 'number') return false;
        if (totalCount === 0 && productCount > 0) return false;
        return true;
      }

      function resolveExactViewAllCount(storefrontCount, productCount) {
        const visibleCount = typeof productCount === 'number' ? productCount : 0;
        if (typeof storefrontCount !== 'number') return null;
        if (storefrontCount === 0 && visibleCount > 0) {
          if (visibleCount >= PREDICTIVE_RESOURCE_LIMIT) return null;
          return visibleCount;
        }
        return Math.max(storefrontCount, visibleCount);
      }

      function applyViewAllCount(storefrontCount, productCount) {
        const exactCount = resolveExactViewAllCount(storefrontCount, productCount);
        if (typeof exactCount !== 'number') {
          setViewAllLabel(0, false);
          return;
        }
        setViewAllLabel(exactCount, true);
      }

      /* ── product data helpers ── */

      function parseNonNegativeInteger(value) {
        const parsed = parseInt(String(value || '').replace(/,/g, ''), 10);
        if (Number.isNaN(parsed) || parsed < 0) return null;
        return parsed;
      }

      function getImageUrl(product) {
        const featured = product && product.featured_image ? product.featured_image : null;
        if (!featured) return '';
        if (typeof featured === 'string') return featured;
        if (featured.url) return featured.url;
        return '';
      }

      function withSearchThumbUrl(url, width) {
        if (!url) return '';
        try {
          const parsed = new URL(url, window.location.origin);
          parsed.searchParams.set('width', String(width));
          parsed.searchParams.set('height', String(width));
          parsed.searchParams.set('crop', 'center');
          return parsed.toString();
        } catch (e) {
          const source = String(url);
          const separator = source.indexOf('?') === -1 ? '?' : '&';
          return `${source}${separator}width=${encodeURIComponent(String(width))}&height=${encodeURIComponent(
            String(width)
          )}&crop=center`;
        }
      }

      // Tiles render at 98×103 CSS px (object-fit: cover), so request just enough pixels for the screen's
      // density: 120 / 220 / 320px at 1x / 2x / 3x. Rounded to 20px steps to keep CDN variants few.
      function getSearchThumbPixelWidth() {
        const dpr = Math.min(Math.max(window.devicePixelRatio || 1, 1), 3);
        return Math.ceil((SEARCH_THUMB_CSS_PX * dpr) / 20) * 20;
      }

      function getSearchThumbSrc(url) {
        if (!url) return '';
        return withSearchThumbUrl(url, getSearchThumbPixelWidth());
      }

      function preloadSearchProductImages(products) {
        (Array.isArray(products) ? products : [])
          .slice(0, VISIBLE_PRODUCT_TILE_COUNT)
          .forEach(function preloadThumb(product) {
            const url = getImageUrl(product);
            if (!url) return;
            const img = new Image();
            img.decoding = 'async';
            img.fetchPriority = 'high';
            img.src = getSearchThumbSrc(url);
          });
      }

      function getDisplayTitleForProduct(product) {
        return product && product.title ? product.title : 'Product';
      }

      // Predictive search returns prices as decimal strings in the active market's currency (e.g. "669.00").
      function formatProductPrice(value) {
        const amount = Number(value);
        if (!Number.isFinite(amount)) return String(value || '');
        const cents = Math.round(amount * 100);
        if (window.MegaMacCart && typeof window.MegaMacCart.formatMoney === 'function') {
          return window.MegaMacCart.formatMoney(cents);
        }
        return amount.toLocaleString(document.documentElement.lang || undefined, {
          minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
          maximumFractionDigits: 2,
        });
      }

      function buildVisibleProductKeys(items) {
        return (Array.isArray(items) ? items : [])
          .slice(0, VISIBLE_PRODUCT_TILE_COUNT)
          .map(function toProductKey(product, index) {
            return normalizeUrlPath(product && product.url ? product.url : '') || `index:${index}`;
          });
      }

      function productKeysMatch(currentKeys, nextKeys) {
        if (!Array.isArray(currentKeys) || !Array.isArray(nextKeys)) return false;
        if (currentKeys.length !== nextKeys.length) return false;

        for (let index = 0; index < currentKeys.length; index += 1) {
          if (currentKeys[index] !== nextKeys[index]) return false;
        }

        return true;
      }

      /* ── DOM rendering ── */

      function buildProductCardHtml(product, index) {
        const title = escapeHtml(getDisplayTitleForProduct(product));
        const url = escapeHtml(product && product.url ? product.url : '#');
        const price = escapeHtml(formatProductPrice(product && product.price));
        const rawImageUrl = getImageUrl(product);
        const thumbSrc = escapeHtml(getSearchThumbSrc(rawImageUrl));
        // All thumbs load eagerly: native lazy-loading inside this scroller waits until a card is almost on
        // screen, leaving blank tiles on a fast scroll. Priority keeps the visible cards first; the rest are
        // ~3–4 KB each and are only added to the list shortly before they scroll into view.
        const isAboveFold = index < VISIBLE_PRODUCT_TILE_COUNT;
        const fetchpriority = isAboveFold ? 'high' : 'low';

        return `
          <a class="${PRODUCT_CARD_CLASS}" href="${url}">
            <div class="header__icons__panel__search__content__state-result__gallery__img-wrapper">
              ${
                rawImageUrl
                  ? `<img class="header__icons__panel__search__content__state-result__gallery__img" src="${thumbSrc}" alt="${title}" loading="eager" fetchpriority="${fetchpriority}" decoding="async" width="120" height="120">`
                  : ''
              }
            </div>
            <div class="header__icons__panel__search__content__state-result__gallery__details">
              <span class="header__icons__panel__search__content__state-result__gallery__title">${title}</span>
              <span class="header__icons__panel__search__content__state-result__gallery__price">${price}</span>
            </div>
          </a>
        `;
      }

      function renderSuggestions(items) {
        if (!items.length) {
          if ($suggestions.innerHTML !== '') $suggestions.innerHTML = '';
          return;
        }

        const nextHtml = items
          .map(function buildSuggestionLink(item) {
            const title = escapeHtml(item && item.title ? item.title : '');
            const url = escapeHtml(item && item.url ? item.url : '#');
            return `<a class="${SUGGESTION_LINK_CLASS}" href="${url}">→ ${title}</a>`;
          })
          .join('');

        if ($suggestions.innerHTML !== nextHtml) $suggestions.innerHTML = nextHtml;
      }

      function renderProducts(items, options) {
        const products = Array.isArray(items) ? items : [];
        lastRenderedVisibleProductKeys = buildVisibleProductKeys(products);

        if (!products.length) {
          if ($products.innerHTML !== '') $products.innerHTML = '';
          return;
        }

        // The top cards are unchanged, so leave them in place (no image flicker) but rebuild everything
        // after them — otherwise the previous query's lower and scroll-loaded cards would linger.
        if (options && options.preserveVisible) {
          const cards = $products.querySelectorAll(`.${PRODUCT_CARD_CLASS}`);
          for (let index = VISIBLE_PRODUCT_TILE_COUNT; index < cards.length; index += 1) {
            cards[index].remove();
          }
          const restHtml = products
            .slice(VISIBLE_PRODUCT_TILE_COUNT)
            .map(function buildCard(product, offset) {
              return buildProductCardHtml(product, VISIBLE_PRODUCT_TILE_COUNT + offset);
            })
            .join('');
          if (restHtml) $products.insertAdjacentHTML('beforeend', restHtml);
          return;
        }

        $products.innerHTML = products.map(buildProductCardHtml).join('');
      }

      /* ── debounce ── */

      function clearDebounce() {
        if (debounceTimer) {
          window.clearTimeout(debounceTimer);
          debounceTimer = null;
        }
      }

      /* ── state reset ── */

      function resetToEmptyState() {
        requestToken += 1;
        lastRenderedRequestId = requestToken;
        clearDebounce();
        abortActiveSearchRequest();
        stopInfiniteScroll();
        renderSuggestions([]);
        $suggestionsTitle.hidden = true;
        $viewAllWrapper.hidden = true;
        setViewAllLabel(0, false);
        renderProducts([]);
        lastRenderedQueryKey = '';
        showState('empty');
      }

      /* ── suggestion filtering ── */

      function buildSuggestionsFromResources(resources) {
        const collections = Array.isArray(resources.collections) ? resources.collections : [];
        return collections
          .filter(function isAllowedCollection(collection) {
            if (!allowedMenuCollectionPaths.size) return false;
            const collectionPath = normalizeCollectionPath(collection && collection.url ? collection.url : '');
            if (!collectionPath) return false;
            return allowedMenuCollectionPaths.has(collectionPath);
          })
          .slice(0, MAX_SUGGESTIONS);
      }

      /* ── product deduplication ── */

      function dedupeProducts(products) {
        const byUrl = new Map();
        (Array.isArray(products) ? products : []).forEach(function trackUniqueProduct(product, index) {
          const rawUrl = product && product.url ? String(product.url) : '';
          const key = normalizeUrlPath(rawUrl) || `index:${index}`;
          if (byUrl.has(key)) return;
          byUrl.set(key, product);
        });
        return Array.from(byUrl.values());
      }

      /* ── network fetching ── */

      async function fetchPredictiveResources(query, signal) {
        const params = new URLSearchParams();
        params.set('q', query);
        params.set('resources[type]', 'collection,product');
        params.set('resources[limit]', String(PREDICTIVE_RESOURCE_LIMIT));
        params.set('resources[limit_scope]', 'each');
        params.set('resources[options][unavailable_products]', 'hide');
        params.set('resources[options][fields]', SEARCH_FIELDS);

        const response = await fetch(`${predictiveEndpoint}?${params.toString()}`, { signal: signal });
        if (!response.ok) throw new Error('Predictive search request failed');

        const payload = await response.json();
        const resources = payload && payload.resources && payload.resources.results ? payload.resources.results : {};
        const products = Array.isArray(resources.products) ? resources.products : [];
        const availableProducts = products.filter(function keepAvailable(product) {
          return !product || product.available !== false;
        });

        return {
          suggestions: buildSuggestionsFromResources(resources),
          products: dedupeProducts(availableProducts),
        };
      }

      async function fetchPanelResultsPage(query, page, signal) {
        const params = new URLSearchParams();
        params.set('section_id', PANEL_RESULTS_SECTION_ID);
        if (page > 1) params.set('page', String(page));

        const response = await fetch(`${buildSearchHref(query)}&${params.toString()}`, { signal: signal });
        if (!response.ok) throw new Error('Search panel results request failed');

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const dataNode = doc.querySelector('[data-search-panel-page]');
        if (!dataNode) throw new Error('Search panel results missing');

        const data = JSON.parse(dataNode.textContent || '{}');
        return {
          totalCount: parseNonNegativeInteger(data.count),
          pages: parseNonNegativeInteger(data.pages) || 0,
          items: Array.isArray(data.items) ? data.items : [],
        };
      }

      async function fetchSearchCount(query, signal) {
        const searchPageMeta = await fetchPanelResultsPage(query, 1, signal);
        return searchPageMeta ? searchPageMeta.totalCount : null;
      }

      async function fetchSearchPayload(query, signal) {
        const cacheKey = buildQueryCacheKey(query);
        const cachedPayload = payloadCache.read(cacheKey);
        if (cachedPayload) {
          preloadSearchProductImages(cachedPayload.products);
          return cachedPayload;
        }

        const searchPageMetaPromise = fetchPanelResultsPage(query, 1, signal).catch(function handleMetaError(error) {
          return null;
        });

        const predictiveResources = await fetchPredictiveResources(query, signal);
        preloadSearchProductImages(predictiveResources.products);
        const payload = {
          suggestions: Array.isArray(predictiveResources.suggestions) ? predictiveResources.suggestions : [],
          products: Array.isArray(predictiveResources.products) ? predictiveResources.products : [],
          totalCount: countCache.read(cacheKey),
          firstPage: null,
          searchPageMetaPromise: null,
        };

        payload.searchPageMetaPromise = searchPageMetaPromise.then(function applySearchPageMeta(searchPageMeta) {
          if (!searchPageMeta) return null;

          payload.firstPage = searchPageMeta;

          if (typeof searchPageMeta.totalCount === 'number') {
            if (shouldCacheSearchCount(searchPageMeta.totalCount, getProductCount(payload.products))) {
              countCache.write(cacheKey, searchPageMeta.totalCount);
            }
            payload.totalCount = searchPageMeta.totalCount;
          }

          payloadCache.write(cacheKey, payload);

          return searchPageMeta;
        });

        return payload;
      }

      /* ── request staleness check ── */

      function isStillCurrentSearchRequest(query, requestId) {
        if (requestId < lastRenderedRequestId) return false;
        const currentInput = ($input.value || '').trim().toLowerCase();
        if (!currentInput) return false;
        if (
          currentInput !==
          String(query || '')
            .trim()
            .toLowerCase()
        )
          return false;
        if ($panel.getAttribute('data-search-state') !== 'result') return false;
        return true;
      }

      /* ── search count side-channel ── */

      function fetchAndApplySearchCount(query, requestId, signal, productCount) {
        const cacheKey = buildQueryCacheKey(query);
        const visibleCount = typeof productCount === 'number' ? productCount : 0;
        const cachedCount = countCache.read(cacheKey);
        if (typeof cachedCount === 'number') {
          if (isStillCurrentSearchRequest(query, requestId)) applyViewAllCount(cachedCount, visibleCount);
          return;
        }

        fetchSearchCount(query, signal)
          .then(function applySearchCount(totalCount) {
            if (typeof totalCount !== 'number') return;
            if (shouldCacheSearchCount(totalCount, visibleCount)) {
              countCache.write(cacheKey, totalCount);
            }
            if (!isStillCurrentSearchRequest(query, requestId)) return;
            applyViewAllCount(totalCount, visibleCount);
          })
          .catch(function ignoreAbort(error) {
            if (error && error.name === 'AbortError') return;
          });
      }

      /* ── infinite scroll ── */

      // Predictive search supplies the first 10 cards; the rest come from the search-panel-results section,
      // one 50-product page at a time, appended as the sentinel after the last card nears the bottom.

      function getProductKey(product) {
        return normalizeUrlPath(product && product.url ? product.url : '');
      }

      function normalizePanelResultItem(item) {
        // The section gives prices in cents; the card builder expects predictive search's decimal prices.
        const cents = Number(item && item.price);
        return {
          url: item && item.url ? item.url : '',
          title: item && item.title ? item.title : '',
          price: Number.isFinite(cents) ? cents / 100 : '',
          featured_image: item && item.image ? { url: item.image } : null,
        };
      }

      function setSentinelState(kind) {
        if (kind === 'loading') {
          $products.setAttribute('aria-busy', 'true');
          $sentinel.innerHTML = `
            <div class="${PRODUCT_CARD_CLASS} ${SENTINEL_CLASS}__skeleton" aria-hidden="true">
              <div class="header__icons__panel__search__content__state-result__gallery__img-wrapper"></div>
            </div>
          `;
          return;
        }

        $products.removeAttribute('aria-busy');
        $sentinel.innerHTML =
          kind === 'error'
            ? `<button type="button" class="${SENTINEL_CLASS}__retry" data-search-products-retry>Load more results</button>`
            : '';
      }

      function stopInfiniteScroll() {
        scrollState = null;
        $sentinel.remove();
        setSentinelState('idle');
      }

      function finishInfiniteScroll(state) {
        state.done = true;
        if (scrollState === state) {
          $sentinel.remove();
          setSentinelState('idle');
        }
      }

      function showLoadFailure(state) {
        state.failed = true;
        setSentinelState('error');
      }

      function acceptResultsPage(state, requestedPage, page) {
        state.totalPages = page.pages;
        state.nextPage = requestedPage + 1;
        page.items.forEach(function queueItem(item) {
          state.buffer.push(normalizePanelResultItem(item));
        });
      }

      function appendNextBatch(state) {
        const batch = [];

        while (state.buffer.length && batch.length < SCROLL_APPEND_BATCH_SIZE) {
          const product = state.buffer.shift();
          const key = getProductKey(product);
          if (!key || state.shownKeys.has(key)) continue;
          state.shownKeys.add(key);
          batch.push(product);
        }

        if (!batch.length) return false;

        const html = batch
          .map(function buildCard(product, offset) {
            return buildProductCardHtml(product, state.shownCount + offset);
          })
          .join('');
        $sentinel.insertAdjacentHTML('beforebegin', html);
        state.shownCount += batch.length;
        return true;
      }

      function isSentinelNearView() {
        if (!$sentinel.isConnected || !$products.clientHeight) return false;
        const containerRect = $products.getBoundingClientRect();
        const sentinelRect = $sentinel.getBoundingClientRect();
        return sentinelRect.top <= containerRect.bottom + SCROLL_PRELOAD_MARGIN_PX;
      }

      function loadNextResultsPage(state) {
        const requestedPage = state.nextPage;
        state.loading = true;
        setSentinelState('loading');

        fetchPanelResultsPage(state.query, requestedPage, state.signal)
          .then(function handleResultsPage(page) {
            if (scrollState !== state) return;
            state.loading = false;
            setSentinelState('idle');
            acceptResultsPage(state, requestedPage, page);
            maybeLoadMore();
          })
          .catch(function handleResultsPageError(error) {
            if (scrollState !== state) return;
            state.loading = false;
            if (error && error.name === 'AbortError') return;
            showLoadFailure(state);
          });
      }

      function maybeLoadMore() {
        const state = scrollState;
        if (!state || state.done || state.loading || state.failed || !state.pageOneSettled) return;
        if (!isStillCurrentSearchRequest(state.query, state.requestId)) return;

        if (!isSentinelNearView()) return;

        if (appendNextBatch(state)) {
          // Keep filling while the sentinel is still in view (the observer only fires on changes).
          window.requestAnimationFrame(maybeLoadMore);
          return;
        }

        if (state.totalPages === null || state.nextPage > state.totalPages) {
          finishInfiniteScroll(state);
          return;
        }

        loadNextResultsPage(state);
      }

      function settleFirstResultsPage(state, page) {
        if (scrollState !== state) return;
        state.pageOneSettled = true;

        if (!page) {
          // Fewer than a full predictive set means there is nothing more to fetch.
          if (state.shownCount < PREDICTIVE_RESOURCE_LIMIT) {
            finishInfiniteScroll(state);
            return;
          }
          state.nextPage = 1;
          showLoadFailure(state);
          return;
        }

        acceptResultsPage(state, 1, page);
        maybeLoadMore();
      }

      function startInfiniteScroll(query, requestId, products, payload, signal) {
        const state = {
          query: query,
          requestId: requestId,
          signal: signal,
          shownKeys: new Set(products.map(getProductKey).filter(Boolean)),
          shownCount: products.length,
          buffer: [],
          nextPage: 2,
          totalPages: null,
          pageOneSettled: false,
          loading: false,
          failed: false,
          done: false,
        };

        scrollState = state;
        setSentinelState('idle');
        $products.appendChild($sentinel);
        if (sentinelObserver) {
          // Re-observing forces a fresh callback now that the sentinel sits after a new set of cards.
          sentinelObserver.unobserve($sentinel);
          sentinelObserver.observe($sentinel);
        }

        if (payload && payload.firstPage) {
          settleFirstResultsPage(state, payload.firstPage);
        } else if (payload && payload.searchPageMetaPromise) {
          payload.searchPageMetaPromise.then(function handleFirstResultsPage() {
            settleFirstResultsPage(state, payload.firstPage);
          });
        } else {
          settleFirstResultsPage(state, null);
        }
      }

      const sentinelObserver =
        'IntersectionObserver' in window
          ? new IntersectionObserver(
              function handleSentinelIntersection(entries) {
                if (entries.some((entry) => entry.isIntersecting)) maybeLoadMore();
              },
              { root: $products, rootMargin: `0px 0px ${SCROLL_PRELOAD_MARGIN_PX}px 0px` }
            )
          : null;

      if (!sentinelObserver) {
        $products.addEventListener('scroll', maybeLoadMore, { passive: true });
      }

      $sentinel.addEventListener('click', function handleRetryClick(event) {
        if (!event.target.closest('[data-search-products-retry]')) return;
        const state = scrollState;
        if (!state || !state.failed) return;
        state.failed = false;
        setSentinelState('idle');
        loadNextResultsPage(state);
      });

      /* ── main render orchestration ── */

      function renderSearchPayload(query, requestId, payload, signal) {
        if (requestId < lastRenderedRequestId) return;

        const currentInputKey = buildQueryCacheKey($input.value || '');
        const queryKey = buildQueryCacheKey(query);
        if (!currentInputKey || !queryKey || currentInputKey !== queryKey) return;

        const suggestions = Array.isArray(payload && payload.suggestions) ? payload.suggestions : [];
        const products = Array.isArray(payload && payload.products) ? payload.products : [];
        const totalCount = payload && typeof payload.totalCount === 'number' ? payload.totalCount : null;

        const nextVisibleProductKeys = buildVisibleProductKeys(products);
        const shouldPreserveVisibleProducts = productKeysMatch(lastRenderedVisibleProductKeys, nextVisibleProductKeys);

        lastRenderedRequestId = requestId;
        lastRenderedQueryKey = queryKey;
        stopInfiniteScroll();
        $viewAll.href = buildSearchHref(query);
        setViewAllLabel(0, false);
        $queryLabel.textContent = query;

        if (!products.length) {
          $suggestionsTitle.hidden = true;
          $viewAllWrapper.hidden = true;
          renderProducts([]);
          showState('no-result');
          return;
        }

        renderSuggestions(suggestions);
        $suggestionsTitle.hidden = suggestions.length === 0;
        $viewAllWrapper.hidden = false;

        renderProducts(products, { preserveVisible: shouldPreserveVisibleProducts });

        showState('result');
        // Reset only once the list is visible: while hidden (e.g. after the query was cleared) the browser
        // ignores scrollTop and later restores the old offset, leaving the top cards scrolled out of view.
        $products.scrollTop = 0;
        startInfiniteScroll(query, requestId, products, payload, signal);

        if (typeof totalCount === 'number') {
          applyViewAllCount(totalCount, products.length);
        } else if (payload.searchPageMetaPromise) {
          payload.searchPageMetaPromise.then(function applyLateSearchPageMeta() {
            if (!isStillCurrentSearchRequest(query, requestId)) return;
            if (typeof payload.totalCount === 'number') {
              applyViewAllCount(payload.totalCount, products.length);
            } else {
              fetchAndApplySearchCount(query, requestId, signal, products.length);
            }
          });
        } else {
          fetchAndApplySearchCount(query, requestId, signal, products.length);
        }
      }

      /* ── top-level search flow ── */

      async function fetchAndRenderPredictiveSearch(rawQuery) {
        const query = rawQuery.trim();
        if (!query) {
          resetToEmptyState();
          return;
        }

        requestToken += 1;
        const requestId = requestToken;
        const signal = createActiveSearchSignal();

        try {
          const payloadPromise = fetchSearchPayload(query, signal);
          payloadPromise.catch(function preventUnhandledRejection() {});
          const payload = await payloadPromise;
          renderSearchPayload(query, requestId, payload, signal);
        } catch (error) {
          if (error && error.name === 'AbortError') return;
          if (requestId < lastRenderedRequestId) return;
          const currentInput = ($input.value || '').trim();
          if (!currentInput || currentInput !== query) return;
          lastRenderedRequestId = requestId;
          $suggestionsTitle.hidden = true;
          $viewAllWrapper.hidden = true;
          showState('no-result');
        }
      }

      /* ── event handlers ── */

      function handleInput() {
        const nextQuery = $input.value || '';
        clearDebounce();
        debounceTimer = window.setTimeout(function debouncedSearch() {
          fetchAndRenderPredictiveSearch(nextQuery);
        }, SEARCH_DEBOUNCE_MS);
      }

      // Predictive search thumbnails come from cdn.shopify.com. Shopify preconnects on page load, but that
      // connection is often idle-closed by the time someone searches, so re-warm it when the box is focused.
      function warmImageCdnConnection() {
        if (hasWarmedImageCdn) return;
        hasWarmedImageCdn = true;
        const link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = 'https://cdn.shopify.com';
        document.head.appendChild(link);
      }

      function handlePanelOpenFocus() {
        warmImageCdnConnection();
        const panelType = $panel.getAttribute('data-panel-content');
        if (panelType !== 'search') return;
        if (!$panel.classList.contains('header__icons__panel__content--active')) return;
        const query = ($input.value || '').trim();
        if (!query) return;
        const queryKey = query.toLowerCase();
        if (queryKey && queryKey === lastRenderedQueryKey && $panel.getAttribute('data-search-state') === 'result') {
          return;
        }
        handleInput();
      }

      function handleFormSubmit(event) {
        const query = ($input.value || '').trim();
        if (!query) {
          event.preventDefault();
          return;
        }
        $form.action = searchEndpoint;
      }

      $input.addEventListener('input', handleInput);
      $input.addEventListener('focus', handlePanelOpenFocus);
      $form.addEventListener('submit', handleFormSubmit);

      showState('empty');
    })();

    /************************************************************************/
    /* adjust desktop icon panel spacing for announcement bar              */
    /************************************************************************/
    (function adjustDesktopIconPanelForAnnouncementBar() {
      const $desktopIconPanelWrapper = document.querySelector('[data-panel-wrapper]');

      if (!$desktopIconPanelWrapper) return;

      function updateAnnouncementBarHeight() {
        const $announcementBar = document.querySelector('.announcement-bar');
        if ($announcementBar && window.getComputedStyle($announcementBar).display !== 'none') {
          const height = $announcementBar.offsetHeight;
          document.documentElement.style.setProperty('--announcement-bar-height', height + 'px');
        } else {
          document.documentElement.style.setProperty('--announcement-bar-height', '0px');
        }
      }

      updateAnnouncementBarHeight();

      const observer = new MutationObserver(function handleDomMutations(mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'childList' || mutation.type === 'attributes') {
            updateAnnouncementBarHeight();
          }
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
      });
      observer.observe(document.head, { childList: true });
      window.addEventListener('resize', updateAnnouncementBarHeight);
    })();

    /*************************************************/
    /* Style shop login button via shadow DOM       */
    /*************************************************/
    (function styleShopLoginButton() {
      let styled = false;

      function applyStyles() {
        if (styled) return;

        const shopLoginButton = document.querySelector('shop-login-button');
        if (!shopLoginButton) return;
        if (!shopLoginButton.shadowRoot) return;

        const button = shopLoginButton.shadowRoot.querySelector('button');
        if (!button) return;

        button.style.width = '100%';
        button.style.height = '38px';
        button.style.marginTop = '12px';

        styled = true;
      }

      const checkInterval = setInterval(function () {
        applyStyles();
        if (styled) {
          clearInterval(checkInterval);
        }
      }, 100);

      setTimeout(function () {
        clearInterval(checkInterval);
      }, 10000);
    })();

    /*************************************************/
    /* mobile menu navigation implementation details */
    /*************************************************/
    const mobileMenuNavigation = (function initMobileMenuNavigation() {
      const $mobileMenuBreadcrumb = document.querySelector('[data-mobile-menu-breadcrumb]');
      const $mobileHeaderLogo = document.querySelector('[data-mobile-header-logo]');
      const $allLevels = document.querySelectorAll('[data-mobile-menu-level]');
      const $allButtons = document.querySelectorAll('[data-mobile-menu-button]');
      const $breadcrumbText = document.querySelector('[data-mobile-menu-breadcrumb-text]');

      let currentLevel = 'root';
      let isAnimating = false;

      function getLevelElement(levelName) {
        return document.querySelector(`[data-mobile-menu-level="${levelName}"]`);
      }

      function hideAllLevels() {
        $allLevels.forEach((level) => {
          level.classList.remove('header-mobile-menu-panel__level--active');
        });
      }

      function updateBreadcrumb(levelName) {
        if (!$breadcrumbText) return;

        if (levelName === 'root') {
          $breadcrumbText.textContent = 'Menu';
          return;
        }

        const levelElement = getLevelElement(levelName);
        const ancestorLabel = levelElement?.getAttribute('data-mobile-menu-ancestor-label');

        if (ancestorLabel) {
          $breadcrumbText.textContent = `Menu / ${ancestorLabel}`;
        } else {
          $breadcrumbText.textContent = 'Menu';
        }
      }

      function updateLogoVisibility(levelName) {
        if (!$mobileHeaderLogo) return;

        if (levelName === 'root' || window.innerWidth >= 940) {
          $mobileHeaderLogo.classList.remove('header-mobile__logo--hidden');
        } else {
          $mobileHeaderLogo.classList.add('header-mobile__logo--hidden');
        }
      }

      function showLevel(levelName, direction = 'forward') {
        if (isAnimating) return;

        const previousLevelElement = getLevelElement(currentLevel);
        const targetLevel = getLevelElement(levelName);

        if (!targetLevel) return;

        currentLevel = levelName;
        isAnimating = true;

        if (levelName === 'root') {
          $mobileMenuBreadcrumb?.classList.remove('header-mobile-menu-panel__breadcrumb--visible');
        }

        if (previousLevelElement && previousLevelElement !== targetLevel) {
          const exitClass =
            direction === 'forward'
              ? 'header-mobile-menu-panel__level--exiting'
              : 'header-mobile-menu-panel__level--exiting-back';

          previousLevelElement.classList.add(exitClass);
        }

        const delay = previousLevelElement && previousLevelElement !== targetLevel ? 150 : 0;

        setTimeout(() => {
          hideAllLevels();
          $allLevels.forEach((level) => {
            level.classList.remove(
              'header-mobile-menu-panel__level--exiting',
              'header-mobile-menu-panel__level--exiting-back',
              'header-mobile-menu-panel__level--entering',
              'header-mobile-menu-panel__level--entering-back'
            );
          });

          const enterClass =
            direction === 'forward'
              ? 'header-mobile-menu-panel__level--entering'
              : 'header-mobile-menu-panel__level--entering-back';

          targetLevel.classList.add('header-mobile-menu-panel__level--active', enterClass);

          targetLevel.offsetHeight;

          requestAnimationFrame(() => {
            targetLevel.classList.remove(enterClass);
            isAnimating = false;
          });

          updateBreadcrumb(levelName);
          if (levelName !== 'root') {
            $mobileMenuBreadcrumb?.classList.add('header-mobile-menu-panel__breadcrumb--visible');
          }
        }, delay);

        updateLogoVisibility(levelName);
      }

      function navigateToMobileMenuLevel(event) {
        const button = event.currentTarget;
        const targetLevel = button.getAttribute('data-mobile-menu-button');
        if (targetLevel) {
          showLevel(targetLevel);
        }
      }

      function navigateBack() {
        const currentLevelElement = getLevelElement(currentLevel);

        if (!currentLevelElement) {
          showLevel('root', 'back');
          return;
        }

        const parentLevel = currentLevelElement.getAttribute('data-mobile-menu-parent') || 'root';

        if (parentLevel === currentLevel) {
          showLevel('root', 'back');
        } else {
          showLevel(parentLevel, 'back');
        }
      }

      $allButtons.forEach((button) => {
        button.addEventListener('click', navigateToMobileMenuLevel);
      });

      function reset() {
        hideAllLevels();
        $allLevels.forEach((level) => {
          level.classList.remove(
            'header-mobile-menu-panel__level--exiting',
            'header-mobile-menu-panel__level--exiting-back',
            'header-mobile-menu-panel__level--entering',
            'header-mobile-menu-panel__level--entering-back'
          );
        });

        const rootLevel = getLevelElement('root');
        if (rootLevel) {
          rootLevel.classList.add('header-mobile-menu-panel__level--active');
        }

        currentLevel = 'root';
        updateBreadcrumb('root');
        $mobileMenuBreadcrumb?.classList.remove('header-mobile-menu-panel__breadcrumb--visible');
        updateLogoVisibility('root');
      }

      function updateLogoVisibilityOnResize() {
        updateLogoVisibility(currentLevel);
      }

      $mobileMenuBreadcrumb?.addEventListener('click', navigateBack);
      window.addEventListener('resize', updateLogoVisibilityOnResize);

      return { reset };
    })();

    /**************************************/
    /* mobile menu implementation details */
    /**************************************/
    (function handleMobileMenu() {
      const $mobileMenuPanel = document.querySelector('[data-mobile-menu-panel]');
      const $mobileMenuBlurLayer = document.querySelector('[data-mobile-menu-blur-layer]');
      const $mobileMenuOpenButton = document.querySelector('[data-mobile-menu-open]');
      const $mobileMenuCloseButton = document.querySelector('[data-mobile-menu-close]');
      const MOBILE_MENU_RESET_DELAY_MS = 450;

      function openMobileMenu() {
        $mobileMenuBlurLayer?.classList.add('header-mobile-menu-panel__blur-layer--open');
        $mobileMenuPanel?.classList.add('header-mobile-menu-panel--open');
        $mobileMenuOpenButton?.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        mobileMenuNavigation.reset();

        setTimeout(() => {
          $mobileMenuCloseButton?.focus();
        }, 100);
      }

      function closeMobileMenu() {
        closeMobileMenuInternal({ shouldRestoreFocus: true });
      }

      function closeMobileMenuInternal(options) {
        const { shouldRestoreFocus } = options;

        $mobileMenuBlurLayer?.classList.remove('header-mobile-menu-panel__blur-layer--open');
        $mobileMenuPanel?.classList.remove('header-mobile-menu-panel--open');
        $mobileMenuOpenButton?.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';

        if (shouldRestoreFocus) {
          setTimeout(() => {
            $mobileMenuOpenButton?.focus();
          }, 100);
        }

        setTimeout(() => {
          mobileMenuNavigation.reset();
        }, MOBILE_MENU_RESET_DELAY_MS);
      }

      function closeMobileMenuOnResize() {
        const isWideScreenAndMenuOpen =
          window.innerWidth >= 1220 && $mobileMenuPanel?.classList.contains('header-mobile-menu-panel--open');
        if (isWideScreenAndMenuOpen) {
          closeMobileMenuInternal({ shouldRestoreFocus: false });
        }
      }

      function closeMobileMenuOnEscape(event) {
        const isEscapePressed =
          event.key === 'Escape' && $mobileMenuPanel?.classList.contains('header-mobile-menu-panel--open');
        isEscapePressed && closeMobileMenu();
      }

      $mobileMenuOpenButton?.addEventListener('click', openMobileMenu);
      $mobileMenuCloseButton?.addEventListener('click', closeMobileMenu);
      window.addEventListener('resize', closeMobileMenuOnResize);
      document.addEventListener('keydown', closeMobileMenuOnEscape);
    })();

    /*********************************************************************/
    /* reopen account panel after login reload                            */
    /*********************************************************************/
    (function reopenAccountPanelAfterLogin() {
      const STORAGE_KEY = 'mm:open-account-panel-after-login';

      let shouldOpen = false;
      try {
        shouldOpen = sessionStorage.getItem(STORAGE_KEY) === '1';
        sessionStorage.removeItem(STORAGE_KEY);
      } catch (e) {
        shouldOpen = false;
      }

      if (!shouldOpen) return;

      // Use the existing click handler to open the panel.
      // This keeps focus behavior and aria attributes consistent.
      requestAnimationFrame(() => {
        // Prevent focusing the close "X" on initial load.
        window.__mmPanelSkipNextFocus = true;
        document.querySelector('[data-panel-button="account"]')?.click();
      });
    })();

    (function accountPillTabs() {
      const ACTIVE_CLASS = 'header__icons__panel__account__content__pill--active';
      const $pillsWrapper = document.querySelector('[data-account-pills]');

      if (!$pillsWrapper) return;

      const $pills = $pillsWrapper.querySelectorAll('[data-account-pill]');
      const $wrapper = document.querySelector('.header__icons__panel__account__content__wrapper');

      if (!$wrapper) return;

      const $tabs = $wrapper.querySelectorAll('[data-account-tab]');

      function switchToTab(tabKey) {
        $pills.forEach(function updatePill($pill) {
          const isMatch = $pill.dataset.accountPill === tabKey;
          $pill.classList.toggle(ACTIVE_CLASS, isMatch);
          $pill.setAttribute('aria-pressed', String(isMatch));
        });

        $tabs.forEach(function updateTab($tab) {
          const isMatch = $tab.dataset.accountTab === tabKey;
          $tab.hidden = !isMatch;
        });
      }

      $pillsWrapper.addEventListener('click', function onPillClick(event) {
        const $pill = event.target.closest('[data-account-pill]');
        if (!$pill) return;

        const tabKey = $pill.dataset.accountPill;
        switchToTab(tabKey);
      });
    })();

    /*********************************************************************/
    /* mobile header progressive scroll animation implementation details */
    /*********************************************************************/
    // (function mobileHeaderProgressiveScrollAnimation() {
    //   const $mobileHeader = document.querySelector('[data-mobile-header]');

    //   if (!$mobileHeader) return;

    //   const STORAGE_KEY = 'mm_mobile_header_state';
    //   const HEADER_HEIGHT = 44;
    //   const TRANSLATE_PERCENT_RATIO = 110;

    //   let lastScrollPosition = window.scrollY;
    //   let currentTranslateY = 0;

    //   function isHeaderFullyHidden() {
    //     return currentTranslateY <= -HEADER_HEIGHT;
    //   }

    //   function applyTransform(translateY) {
    //     const translateYPercent = (translateY / HEADER_HEIGHT) * TRANSLATE_PERCENT_RATIO;
    //     $mobileHeader.style.transform = `translateY(${translateYPercent}%)`;
    //   }

    //   function hideHeaderImmediately() {
    //     currentTranslateY = -HEADER_HEIGHT;
    //     applyTransform(currentTranslateY);
    //   }

    //   function showHeaderImmediately() {
    //     currentTranslateY = 0;
    //     $mobileHeader.style.transform = '';
    //   }

    //   function restoreHeaderStateFromSession() {
    //     try {
    //       const savedState = sessionStorage.getItem(STORAGE_KEY);
    //       const shouldStartHidden = savedState === 'hidden';

    //       if (shouldStartHidden) {
    //         hideHeaderImmediately();
    //       }
    //     } catch (e) {
    //       const isPageScrolled = lastScrollPosition > 0;
    //       if (isPageScrolled) {
    //         hideHeaderImmediately();
    //       }
    //     }
    //   }

    //   function saveHeaderStateToSession() {
    //     try {
    //       const state = isHeaderFullyHidden() ? 'hidden' : 'visible';
    //       sessionStorage.setItem(STORAGE_KEY, state);
    //     } catch (e) {}
    //   }

    //   function handleScrollToTop() {
    //     showHeaderImmediately();
    //     lastScrollPosition = 0;
    //   }

    //   function updateHeaderPosition(scrollDelta) {
    //     currentTranslateY -= scrollDelta;
    //     currentTranslateY = Math.max(-HEADER_HEIGHT, Math.min(0, currentTranslateY));
    //     applyTransform(currentTranslateY);
    //   }

    //   function handleScroll() {
    //     const currentScrollPosition = window.scrollY;
    //     const scrollDelta = currentScrollPosition - lastScrollPosition;

    //     if (currentScrollPosition <= 0) {
    //       handleScrollToTop();
    //       return;
    //     }

    //     updateHeaderPosition(scrollDelta);
    //     lastScrollPosition = currentScrollPosition;
    //   }

    //   restoreHeaderStateFromSession();
    //   window.addEventListener('beforeunload', saveHeaderStateToSession);
    //   window.addEventListener('scroll', handleScroll);
    // })();

    /*********************************************************/
    /* mobile header scroll animation implementation details */
    /*********************************************************/
    (function mobileHeaderScrollAnimation() {
      const $mobileHeaderBg = document.querySelector('[data-mobile-header-bg]');
      const $mobileHeaderLogo = document.querySelector('[data-mobile-header-logo]');
      const $mobileHeader = document.querySelector('[data-mobile-header]');

      const isAnyElementMissing = !$mobileHeaderBg || !$mobileHeaderLogo || !$mobileHeader;
      if (isAnyElementMissing) return;

      const SCROLL_POSITION_TO_START_SCALING = 100;
      const SCROLL_POSITION_TO_COLLAPSE = 260;
      const SCROLL_DELTA_TO_TRIGGER_TRANSITION = 50;
      const LOGO_MAXIMUM_SCALE = 1.03;

      const HEADER_STATES = Object.freeze({
        NEVER_COLLAPSED: Symbol('NEVER_COLLAPSED'),
        COLLAPSED_TO_PILL: Symbol('COLLAPSED_TO_PILL'),
        EXPANDED_FROM_PILL: Symbol('EXPANDED_FROM_PILL'),
      });

      let currentHeaderState = HEADER_STATES.NEVER_COLLAPSED;
      let previousScrollPosition = window.scrollY;
      let accumulatedScrollDelta = 0;
      let currentScrollDirection = null;
      let isExpandingFromPill = false;
      let isResizing = false;
      let resizeTimeout = null;

      function setLogoScaleAndHeaderOpacity(scale, opacity) {
        $mobileHeaderLogo.style.transform = `translate(-50%, -50%) scale(${scale})`;
        $mobileHeader.style.opacity = opacity;
        $mobileHeader.style.pointerEvents = opacity === 0 ? 'none' : '';
      }

      function calculateScaleBasedOnScrollPosition(scrollY) {
        if (scrollY < SCROLL_POSITION_TO_START_SCALING) return 1;
        if (scrollY >= SCROLL_POSITION_TO_COLLAPSE) return LOGO_MAXIMUM_SCALE;

        const scrollRange = SCROLL_POSITION_TO_COLLAPSE - SCROLL_POSITION_TO_START_SCALING;
        const scrollProgress = (scrollY - SCROLL_POSITION_TO_START_SCALING) / scrollRange;
        return 1 + (LOGO_MAXIMUM_SCALE - 1) * scrollProgress;
      }

      function calculateOpacityBasedOnScrollPosition(scrollY) {
        if (scrollY < SCROLL_POSITION_TO_START_SCALING) return 1;
        if (scrollY >= SCROLL_POSITION_TO_COLLAPSE) return 0;

        const scrollRange = SCROLL_POSITION_TO_COLLAPSE - SCROLL_POSITION_TO_START_SCALING;
        const scrollProgress = (scrollY - SCROLL_POSITION_TO_START_SCALING) / scrollRange;
        return 1 - scrollProgress;
      }

      function calculateScaleBasedOnDelta(delta) {
        if (delta <= 0) return 1;
        if (delta >= SCROLL_DELTA_TO_TRIGGER_TRANSITION) return LOGO_MAXIMUM_SCALE;

        const deltaProgress = delta / SCROLL_DELTA_TO_TRIGGER_TRANSITION;
        return 1 + (LOGO_MAXIMUM_SCALE - 1) * deltaProgress;
      }

      function calculateOpacityBasedOnDelta(delta) {
        if (delta <= 0) return 1;
        if (delta >= SCROLL_DELTA_TO_TRIGGER_TRANSITION) return 0;

        const deltaProgress = delta / SCROLL_DELTA_TO_TRIGGER_TRANSITION;
        return 1 - deltaProgress;
      }

      function handleBgMorphAnimationEnd(event) {
        if (event.animationName !== 'header-mobile__bg--morph') return;

        $mobileHeaderBg.removeEventListener('animationend', handleBgMorphAnimationEnd);
        $mobileHeaderBg.classList.add('header-mobile__bg--pill');
      }

      function handleBgExpandAnimationEnd(event) {
        if (event.animationName !== 'header-mobile__bg--expand') return;

        $mobileHeaderBg.removeEventListener('animationend', handleBgExpandAnimationEnd);
        $mobileHeaderBg.classList.remove('header-mobile__bg--expanding');
        setLogoScaleAndHeaderOpacity(1, 1);
        isExpandingFromPill = false;
      }

      function collapseToPillWithAnimation() {
        currentHeaderState = HEADER_STATES.COLLAPSED_TO_PILL;
        accumulatedScrollDelta = 0;

        $mobileHeaderBg.classList.add('header-mobile__bg--morphing');
        $mobileHeaderLogo.classList.add('header-mobile__logo--pill-position'); // move logo utility class
        $mobileHeaderLogo.classList.add('header-mobile__logo--bouncing');
        setLogoScaleAndHeaderOpacity(1, 0);

        $mobileHeaderLogo.addEventListener(
          'animationend',
          function cleanupLogoBouncingAnimation(event) {
            // Only handle the collapse bounce animation
            if (event.animationName !== 'header-mobile__logo--bounce') return;
            $mobileHeaderLogo.classList.remove('header-mobile__logo--bouncing');
          },
          { once: true }
        );

        // Ensure only a single morph handler is attached
        $mobileHeaderBg.removeEventListener('animationend', handleBgMorphAnimationEnd);
        $mobileHeaderBg.addEventListener('animationend', handleBgMorphAnimationEnd);
      }

      function expandFromPillWithAnimation() {
        currentHeaderState = HEADER_STATES.EXPANDED_FROM_PILL;
        accumulatedScrollDelta = 0;
        isExpandingFromPill = true;

        $mobileHeaderBg.classList.remove('header-mobile__bg--morphing', 'header-mobile__bg--pill');
        $mobileHeaderBg.classList.add('header-mobile__bg--expanding');

        // Ensure we don't keep the collapse bounce animation class when expanding
        $mobileHeaderLogo.classList.remove('header-mobile__logo--pill-position', 'header-mobile__logo--bouncing'); // move logo utility class + clear collapse bounce
        $mobileHeaderLogo.classList.add('header-mobile__logo--bouncing-expand');
        setLogoScaleAndHeaderOpacity(1, 0);

        // Ensure only a single expand handler is attached
        $mobileHeaderBg.removeEventListener('animationend', handleBgExpandAnimationEnd);
        $mobileHeaderBg.addEventListener('animationend', handleBgExpandAnimationEnd);

        $mobileHeaderLogo.addEventListener(
          'animationend',
          function cleanupLogoExpandAnimation(event) {
            // Only handle the expand bounce animation
            if (event.animationName !== 'header-mobile__logo--bounce-expand') return;
            $mobileHeaderLogo.classList.remove('header-mobile__logo--bouncing-expand');
          },
          { once: true }
        );
      }

      function processNeverCollapsedState(scrollY) {
        if (currentScrollDirection !== 'down') {
          setLogoScaleAndHeaderOpacity(1, 1);
          return;
        }

        const scale = calculateScaleBasedOnScrollPosition(scrollY);
        const opacity = calculateOpacityBasedOnScrollPosition(scrollY);
        setLogoScaleAndHeaderOpacity(scale, opacity);

        const shouldCollapse = scrollY >= SCROLL_POSITION_TO_COLLAPSE;
        if (shouldCollapse) collapseToPillWithAnimation();
      }

      function processCollapsedToPillState() {
        if (currentScrollDirection !== 'up') {
          setLogoScaleAndHeaderOpacity(1, 0);
          return;
        }

        const scale = calculateScaleBasedOnDelta(accumulatedScrollDelta);
        setLogoScaleAndHeaderOpacity(scale, 0);

        const shouldExpand = accumulatedScrollDelta >= SCROLL_DELTA_TO_TRIGGER_TRANSITION;
        if (shouldExpand) expandFromPillWithAnimation();
      }

      function processExpandedFromPillState() {
        if (isExpandingFromPill) return;

        if (currentScrollDirection !== 'down') {
          setLogoScaleAndHeaderOpacity(1, 1);
          return;
        }

        const scale = calculateScaleBasedOnDelta(accumulatedScrollDelta);
        const opacity = calculateOpacityBasedOnDelta(accumulatedScrollDelta);
        setLogoScaleAndHeaderOpacity(scale, opacity);

        const shouldCollapse = accumulatedScrollDelta >= SCROLL_DELTA_TO_TRIGGER_TRANSITION;
        if (shouldCollapse) collapseToPillWithAnimation();
      }

      function onScroll() {
        if (isResizing) return;

        const currentScrollPosition = window.scrollY;
        const scrollDifference = currentScrollPosition - previousScrollPosition;
        const newScrollDirection = scrollDifference > 0 ? 'down' : scrollDifference < 0 ? 'up' : currentScrollDirection;
        const hasDirectionChanged = newScrollDirection !== currentScrollDirection && newScrollDirection !== null;

        if (hasDirectionChanged) {
          accumulatedScrollDelta = 0;
          currentScrollDirection = newScrollDirection;

          const isExpandedFromPill = currentHeaderState === HEADER_STATES.EXPANDED_FROM_PILL;
          const isCollapsedToPill = currentHeaderState === HEADER_STATES.COLLAPSED_TO_PILL;

          // Avoid flashing controls visible while the expand-from-pill animation is still running
          if (isExpandedFromPill && !isExpandingFromPill) {
            setLogoScaleAndHeaderOpacity(1, 1);
          }

          if (isCollapsedToPill) {
            setLogoScaleAndHeaderOpacity(1, 0);
          }
        }

        const shouldResetToNeverCollapsed =
          currentScrollPosition < SCROLL_POSITION_TO_START_SCALING &&
          currentHeaderState !== HEADER_STATES.NEVER_COLLAPSED;

        if (shouldResetToNeverCollapsed) {
          currentHeaderState = HEADER_STATES.NEVER_COLLAPSED;
          accumulatedScrollDelta = 0;
          isExpandingFromPill = false;

          // Clear any pill / animation classes so the header fully resets
          $mobileHeaderBg.classList.remove(
            'header-mobile__bg--morphing',
            'header-mobile__bg--pill',
            'header-mobile__bg--expanding'
          );
          $mobileHeaderLogo.classList.remove(
            'header-mobile__logo--pill-position',
            'header-mobile__logo--bouncing',
            'header-mobile__logo--bouncing-expand'
          );

          setLogoScaleAndHeaderOpacity(1, 1);
        }

        const shouldAccumulateDelta =
          currentHeaderState !== HEADER_STATES.NEVER_COLLAPSED &&
          currentScrollPosition >= SCROLL_POSITION_TO_START_SCALING;

        if (shouldAccumulateDelta) {
          accumulatedScrollDelta = Math.min(
            accumulatedScrollDelta + Math.abs(scrollDifference),
            SCROLL_DELTA_TO_TRIGGER_TRANSITION
          );
        }

        switch (currentHeaderState) {
          case HEADER_STATES.NEVER_COLLAPSED:
            processNeverCollapsedState(currentScrollPosition);
            break;
          case HEADER_STATES.COLLAPSED_TO_PILL:
            processCollapsedToPillState();
            break;
          case HEADER_STATES.EXPANDED_FROM_PILL:
            processExpandedFromPillState();
            break;
          default:
            break;
        }

        previousScrollPosition = currentScrollPosition;
      }

      function onLogoTap(event) {
        if (currentHeaderState === HEADER_STATES.COLLAPSED_TO_PILL) {
          event.preventDefault();
          expandFromPillWithAnimation();
        }
      }

      function onPillTap() {
        if (currentHeaderState === HEADER_STATES.COLLAPSED_TO_PILL) expandFromPillWithAnimation();
      }

      function onResize() {
        isResizing = true;

        if (resizeTimeout) {
          clearTimeout(resizeTimeout);
        }

        resizeTimeout = setTimeout(() => {
          isResizing = false;
          previousScrollPosition = window.scrollY;
        }, 150);
      }

      window.addEventListener('scroll', onScroll);
      window.addEventListener('resize', onResize);
      $mobileHeaderLogo.addEventListener('click', onLogoTap);
      $mobileHeaderBg.addEventListener('click', onPillTap);
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-center"] && !Shopify.designMode) return;
  try {
    
  (function initHelpCenterShippingAccordions() {
    const panels = document.querySelectorAll('.section-help-center [data-help-center-shipping-rates] [data-accordion-panel]');

    panels.forEach(function attachPanelListener(panel) {
      panel.addEventListener('click', function preventLabelToggle(event) {
        const isLink = event.target.closest('a');

        if (!isLink) {
          event.preventDefault();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["idle-screen"]) return;
  try {
    
  (function idleScreenInit() {
    const $overlay = document.querySelector('[data-idle-screen]');
    const $video = document.querySelector('[data-idle-video]');
    if (!$overlay || !$video) return;

    const SECONDS_TO_MS = 1000;
    const IDLE_TIMEOUT_MS = parseInt($overlay.dataset.idleTimeout, 10) * SECONDS_TO_MS;
    const FADE_DURATION_MS = parseInt($overlay.dataset.idleFade, 10) * SECONDS_TO_MS;
    const DESKTOP_MIN_WIDTH = 1220;
    const ACTIVE_CLASS = 'idle-screen--active';

    let idleTimer = null;
    let isIdle = false;

    function isDesktop() {
      return window.innerWidth >= DESKTOP_MIN_WIDTH;
    }

    function showIdleScreen() {
      if (!isDesktop()) return;
      isIdle = true;
      $video.play().catch(function ignoreAutoplayBlock() {});
      $overlay.classList.add(ACTIVE_CLASS);
      document.documentElement.style.overflow = 'hidden';
    }

    function hideIdleScreen() {
      if (!isIdle) return;
      isIdle = false;
      $overlay.classList.remove(ACTIVE_CLASS);
      document.documentElement.style.overflow = '';
      setTimeout(function stopVideoAfterFade() {
        if (!isIdle) {
          $video.pause();
        }
      }, FADE_DURATION_MS);
    }

    function resetIdleTimer() {
      clearTimeout(idleTimer);
      hideIdleScreen();
      idleTimer = setTimeout(showIdleScreen, IDLE_TIMEOUT_MS);
    }

    function handleActivity() {
      resetIdleTimer();
    }

    function startIdleTracking() {
      document.addEventListener('mousemove', handleActivity, { passive: true });
      document.addEventListener('mousedown', handleActivity);
      document.addEventListener('keydown', handleActivity);
      document.addEventListener('scroll', handleActivity, { passive: true });
      document.addEventListener('touchstart', handleActivity, { passive: true });
      window.addEventListener('resize', function dismissOnMobile() {
        if (isIdle && !isDesktop()) {
          resetIdleTimer();
        }
      });
      resetIdleTimer();
    }

    if ('prerendering' in document && document.prerendering) {
      document.addEventListener('prerenderingchange', startIdleTracking, { once: true });
      return;
    }

    startIdleTracking();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["illustration-carousel-component"] && !Shopify.designMode) return;
  try {
    
  (function illustrationCarousel() {
    const ACTIVE_CLASS = 'is-active';
    const ANIMATION_DURATION = 600;
    const DRAG_LOCK_THRESHOLD = 8;
    const MOMENTUM_FRICTION = 0.92;
    const MOMENTUM_MIN_VELOCITY = 0.00005;
    const FLING_MIN_VELOCITY = 0.0003;
    const FAST_FLING_MIN_VELOCITY = 0.0015;
    const VELOCITY_SMOOTHING = 0.8;
    const RELEASE_VELOCITY_TIMEOUT = 100;
    const carouselCleanups = new WeakMap();

    function initializeCarousel($carousel) {
      if ($carousel.dataset.illustrationCarouselInitialized === 'true') return;

      const $track = $carousel.querySelector('[data-illustration-carousel-track]');
      const $stage = $carousel.querySelector('[data-illustration-carousel-stage]');
      const $slides = Array.from($carousel.querySelectorAll('[data-illustration-carousel-slide]'));
      const $pills = Array.from($carousel.querySelectorAll('[data-illustration-carousel-pill]'));
      const $pillNavigation = $carousel.querySelector('.illustration-carousel__content__nav');
      const $previousButton = $carousel.querySelector('[data-illustration-carousel-previous]');
      const $nextButton = $carousel.querySelector('[data-illustration-carousel-next]');
      const $section = $carousel.closest('.shopify-section');
      const mobileMediaQuery = window.matchMedia('(max-width: 768px)');
      const slideCount = $slides.length;

      if (slideCount === 0) return;

      let activeIndex = Number($carousel.dataset.initialSlideIndex);
      let isAnimating = false;
      let queuedDirection = null;
      let navigationEndTimer;
      let pillScrollAnimationFrame;
      let resizeAnimationFrame;
      let readyAnimationFrame;
      let resizeEndTimer;
      let viewportWidth = window.innerWidth;
      let shouldCenterPillAfterResize = false;
      let drag = null;
      let suppressDragClick = false;
      let momentumAnimationFrame;
      let slideCenters = [];
      let slideStride = 1;

      function measureSlides() {
        slideCenters = $slides.map(function measureSlide($slide) {
          return $slide.offsetLeft + $slide.offsetWidth / 2;
        });
        slideStride = slideCount > 1 ? $slides[1].offsetLeft - $slides[0].offsetLeft : 1;
      }

      function measurePills() {
        $pills.forEach(function measurePill($pill) {
          const $restingLabel = $pill.querySelector('.illustration-carousel__content__nav__label--resting');
          const $activeLabel = $pill.querySelector('.illustration-carousel__content__nav__label--active');
          if (!$restingLabel || !$activeLabel) return;

          $pill.style.setProperty('--illustration-carousel-pill-resting-width', $restingLabel.scrollWidth + 'px');
          $pill.style.setProperty('--illustration-carousel-pill-active-width', $activeLabel.scrollWidth + 'px');
          $pill.style.setProperty('--illustration-carousel-pill-resting-height', $restingLabel.scrollHeight + 'px');
          $pill.style.setProperty('--illustration-carousel-pill-active-height', $activeLabel.scrollHeight + 'px');
        });
        $carousel.classList.add('has-measured-pills');
      }

      function updateTrackPosition() {
        if (drag?.isDragging || momentumAnimationFrame !== undefined) return;
        $track.style.setProperty('--illustration-carousel-track-offset', -slideCenters[activeIndex] + 'px');
      }

      function carouselEase(progress) {
        let curvePosition = progress;

        for (let iteration = 0; iteration < 5; iteration += 1) {
          const curveX = ((2.8 * curvePosition - 4.2) * curvePosition + 2.4) * curvePosition;
          const curveSlope = (8.4 * curvePosition - 8.4) * curvePosition + 2.4;
          curvePosition -= (curveX - progress) / curveSlope;
        }

        return curvePosition * curvePosition * (3 - 2 * curvePosition);
      }

      function centerActivePill(animate) {
        window.cancelAnimationFrame(pillScrollAnimationFrame);
        if (!$pillNavigation) return;
        if (mobileMediaQuery.matches) {
          $pillNavigation.scrollLeft = 0;
          return;
        }

        const $activePill = $pills.find(function findActivePill($pill) {
          return Number($pill.dataset.slideIndex) === activeIndex;
        });
        if (!$activePill) return;

        function getCenteredScrollLeft() {
          const navigationRect = $pillNavigation.getBoundingClientRect();
          const activePillRect = $activePill.getBoundingClientRect();
          return (
            $pillNavigation.scrollLeft +
            activePillRect.left -
            navigationRect.left -
            ($pillNavigation.clientWidth - activePillRect.width) / 2
          );
        }

        if (!animate) {
          $pillNavigation.scrollLeft = getCenteredScrollLeft();
          return;
        }

        const initialScrollLeft = $pillNavigation.scrollLeft;
        const animationStart = performance.now();

        function animatePillNavigation(timestamp) {
          const progress = Math.min((timestamp - animationStart) / ANIMATION_DURATION, 1);
          const scrollDistance = getCenteredScrollLeft() - initialScrollLeft;
          $pillNavigation.scrollLeft = initialScrollLeft + scrollDistance * carouselEase(progress);

          if (progress < 1) {
            pillScrollAnimationFrame = window.requestAnimationFrame(animatePillNavigation);
          }
        }

        pillScrollAnimationFrame = window.requestAnimationFrame(animatePillNavigation);
      }

      function scheduleResizeUpdate(centerPill) {
        shouldCenterPillAfterResize = shouldCenterPillAfterResize || centerPill;
        if (resizeAnimationFrame) return;

        resizeAnimationFrame = window.requestAnimationFrame(function updateAfterResize() {
          resizeAnimationFrame = undefined;
          measureSlides();
          updateTrackPosition();
          if (shouldCenterPillAfterResize) centerActivePill(false);
          shouldCenterPillAfterResize = false;
        });
      }

      function handleWindowResize() {
        if (window.innerWidth === viewportWidth) return;
        viewportWidth = window.innerWidth;
        cancelMomentum();
        $carousel.classList.add('is-resizing');
        window.clearTimeout(resizeEndTimer);
        scheduleResizeUpdate(true);
        resizeEndTimer = window.setTimeout(function finishResize() {
          $carousel.classList.remove('is-resizing');
        }, 100);
      }

      function handleCarouselResize() {
        scheduleResizeUpdate(false);
      }

      function updateCarousel(nextIndex, animate) {
        const shouldAnimate = animate !== false;
        activeIndex = Math.max(0, Math.min(nextIndex, slideCount - 1));
        updateTrackPosition();

        $slides.forEach(function updateSlide($slide, index) {
          const isActive = index === activeIndex;
          $slide.classList.toggle(ACTIVE_CLASS, isActive);
          $slide.classList.toggle('is-adjacent', Math.abs(index - activeIndex) === 1);
          $slide.setAttribute('aria-hidden', String(!isActive));

          const $slideLink = $slide.querySelector('[data-illustration-carousel-slide-link]');
          if ($slideLink) $slideLink.tabIndex = isActive ? 0 : -1;
        });

        if ($previousButton) $previousButton.disabled = activeIndex === 0;
        if ($nextButton) $nextButton.disabled = activeIndex === slideCount - 1;

        $pills.forEach(function updatePill($pill) {
          const isActive = Number($pill.dataset.slideIndex) === activeIndex;
          $pill.classList.toggle(ACTIVE_CLASS, isActive);
          $pill.setAttribute('aria-current', String(isActive));
          const $label = $pill.querySelector(
            isActive
              ? '.illustration-carousel__content__nav__label--active'
              : '.illustration-carousel__content__nav__label--resting'
          );
          if ($label) $pill.setAttribute('aria-label', $label.textContent.trim());
        });

        centerActivePill(shouldAnimate);
      }

      function cancelArrowNavigation() {
        cancelMomentum();
        window.clearTimeout(navigationEndTimer);
        isAnimating = false;
        queuedDirection = null;
      }

      function processArrowQueue() {
        if (isAnimating || queuedDirection === null) return;

        const direction = queuedDirection;
        queuedDirection = null;
        navigateBy(direction);
      }

      function navigateBy(direction) {
        cancelMomentum();
        const nextIndex = Math.max(0, Math.min(activeIndex + direction, slideCount - 1));
        if (nextIndex === activeIndex) return;

        isAnimating = true;
        updateCarousel(nextIndex);
        navigationEndTimer = window.setTimeout(function finishNavigation() {
          isAnimating = false;
          processArrowQueue();
        }, ANIMATION_DURATION);
      }

      function handlePreviousClick() {
        if (isAnimating) {
          queuedDirection = -1;
          return;
        }
        navigateBy(-1);
      }

      function handleNextClick() {
        if (isAnimating) {
          queuedDirection = 1;
          return;
        }
        navigateBy(1);
      }

      function handlePointerDown(event) {
        if (drag || !event.isPrimary || event.button !== 0) return;
        suppressDragClick = false;
        if (
          slideCount < 2 ||
          event.target.closest('button') ||
          event.ctrlKey ||
          event.metaKey ||
          event.altKey ||
          event.shiftKey
        )
          return;

        drag = {
          pointerId: event.pointerId,
          startX: event.clientX,
          startY: event.clientY,
          isDragging: false,
          startOffset: 0,
          offset: 0,
          previousTime: performance.now(),
          velocity: 0,
        };
        window.addEventListener('pointermove', handlePointerMove, { passive: false });
        window.addEventListener('pointerup', handlePointerEnd);
        window.addEventListener('pointercancel', handlePointerEnd);
      }

      function removePointerListeners() {
        window.removeEventListener('pointermove', handlePointerMove);
        window.removeEventListener('pointerup', handlePointerEnd);
        window.removeEventListener('pointercancel', handlePointerEnd);
      }

      function handlePointerMove(event) {
        if (!drag || event.pointerId !== drag.pointerId) return;

        const deltaX = event.clientX - drag.startX;
        const deltaY = event.clientY - drag.startY;
        if (!drag.isDragging) {
          if (Math.max(Math.abs(deltaX), Math.abs(deltaY)) < DRAG_LOCK_THRESHOLD) return;
          if (Math.abs(deltaY) > Math.abs(deltaX)) {
            drag = null;
            removePointerListeners();
            return;
          }

          drag.startOffset = new DOMMatrixReadOnly(window.getComputedStyle($track).transform).m41;
          drag.offset = drag.startOffset;
          drag.isDragging = true;
          suppressDragClick = true;
          cancelArrowNavigation();
          window.cancelAnimationFrame(pillScrollAnimationFrame);
          $carousel.classList.add('is-dragging');
          $stage.setPointerCapture(event.pointerId);
        }

        event.preventDefault();
        const now = performance.now();
        const elapsed = now - drag.previousTime;
        const previousOffset = drag.offset;
        drag.offset = clampTrackOffset(drag.startOffset + deltaX);
        if (elapsed > 0) {
          const instantVelocity = (drag.offset - previousOffset) / elapsed;
          drag.velocity = VELOCITY_SMOOTHING * instantVelocity + (1 - VELOCITY_SMOOTHING) * drag.velocity;
        }
        drag.previousTime = now;
        renderMovingTrack(drag.offset);
      }

      function renderMovingTrack(offset) {
        $track.style.setProperty('--illustration-carousel-track-offset', offset + 'px');
        $slides.forEach(function scaleMovingSlide($slide, index) {
          const distance = Math.abs(slideCenters[index] + offset);
          const scale = 1 - 0.5 * Math.min(distance / slideStride, 1);
          $slide.style.setProperty('--illustration-carousel-slide-scale', String(scale));
        });

        const closestIndex = getClosestSlideIndex(offset);
        if (closestIndex !== activeIndex) updateCarousel(closestIndex);
      }

      function clampTrackOffset(offset) {
        const maximumOffset = -slideCenters[0];
        const minimumOffset = -slideCenters[slideCount - 1];
        return Math.max(minimumOffset, Math.min(offset, maximumOffset));
      }

      function getClosestSlideIndex(offset) {
        let closestIndex = 0;
        let closestDistance = Infinity;
        slideCenters.forEach(function findClosestSlide(center, index) {
          const distance = Math.abs(center + offset);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });
        return closestIndex;
      }

      function cancelMomentum() {
        window.cancelAnimationFrame(momentumAnimationFrame);
        momentumAnimationFrame = undefined;
        $carousel.classList.remove('is-coasting');
      }

      function snapToNearest(offset, targetIndex = getClosestSlideIndex(offset)) {
        $track.getBoundingClientRect();
        $carousel.classList.remove('is-dragging');
        cancelMomentum();
        updateCarousel(targetIndex);
      }

      function startMomentum(offset, velocity, stride, minimumIndex) {
        let previousTime = performance.now();
        const direction = Math.sign(velocity);
        $carousel.classList.add('is-coasting');
        $carousel.classList.remove('is-dragging');

        function animateMomentum(timestamp) {
          const elapsed = Math.min(timestamp - previousTime, 64);
          previousTime = timestamp;
          const nextOffset = offset + velocity * elapsed;
          offset = clampTrackOffset(nextOffset);
          velocity *= Math.pow(MOMENTUM_FRICTION, elapsed / 16.67);
          renderMovingTrack(offset);

          if (offset !== nextOffset || Math.abs(velocity) / stride <= MOMENTUM_MIN_VELOCITY) {
            let targetIndex = getClosestSlideIndex(offset);
            if (minimumIndex !== undefined) {
              targetIndex = direction < 0 ? Math.max(targetIndex, minimumIndex) : Math.min(targetIndex, minimumIndex);
            }
            snapToNearest(offset, targetIndex);
            return;
          }
          momentumAnimationFrame = window.requestAnimationFrame(animateMomentum);
        }

        momentumAnimationFrame = window.requestAnimationFrame(animateMomentum);
      }

      function handlePointerEnd(event) {
        if (event.type === 'lostpointercapture' && event.target !== $stage) return;
        if (!drag || event.pointerId !== drag.pointerId) return;
        const finishedDrag = drag;
        drag = null;
        removePointerListeners();
        if ($stage.hasPointerCapture(event.pointerId)) $stage.releasePointerCapture(event.pointerId);
        if (!finishedDrag.isDragging) return;

        const releaseVelocity =
          performance.now() - finishedDrag.previousTime < RELEASE_VELOCITY_TIMEOUT ? finishedDrag.velocity : 0;
        if (event.type === 'pointerup' && Math.abs(releaseVelocity) / slideStride > FLING_MIN_VELOCITY) {
          let minimumIndex;
          if (
            Math.abs(releaseVelocity) / slideStride >= FAST_FLING_MIN_VELOCITY &&
            (finishedDrag.offset - finishedDrag.startOffset) * releaseVelocity > 0
          ) {
            minimumIndex = Math.max(
              0,
              Math.min(getClosestSlideIndex(finishedDrag.startOffset) - Math.sign(releaseVelocity), slideCount - 1)
            );
          }
          startMomentum(finishedDrag.offset, releaseVelocity, slideStride, minimumIndex);
        } else {
          snapToNearest(finishedDrag.offset);
        }
      }

      function handleStageClick(event) {
        if (!suppressDragClick || event.detail === 0) return;
        suppressDragClick = false;
        event.preventDefault();
        event.stopPropagation();
      }

      function handleNativeDragStart(event) {
        event.preventDefault();
      }

      function handleSlideClick(event) {
        const slideIndex = Number(event.currentTarget.dataset.slideIndex);
        if (slideIndex === activeIndex) return;

        event.preventDefault();
        if (slideIndex === activeIndex - 1) handlePreviousClick();
        if (slideIndex === activeIndex + 1) handleNextClick();
      }

      function handlePillClick(event) {
        const pillIndex = Number(event.currentTarget.dataset.slideIndex);
        if (pillIndex === activeIndex && event.currentTarget.matches('a[href]')) return;

        event.preventDefault();
        cancelArrowNavigation();
        updateCarousel(pillIndex);
      }

      function handleBlockSelect(event) {
        const selectedIndex = $slides.findIndex(function findSelectedSlide($slide) {
          return $slide.dataset.blockId === event.detail.blockId;
        });
        if (selectedIndex >= 0) {
          cancelArrowNavigation();
          updateCarousel(selectedIndex);
        }
      }

      $previousButton?.addEventListener('click', handlePreviousClick);
      $nextButton?.addEventListener('click', handleNextClick);
      $stage.addEventListener('pointerdown', handlePointerDown);
      $stage.addEventListener('lostpointercapture', handlePointerEnd);
      $stage.addEventListener('click', handleStageClick, true);
      $stage.addEventListener('dragstart', handleNativeDragStart);
      $slides.forEach(function bindSlide($slide) {
        $slide.addEventListener('click', handleSlideClick);
      });
      $pills.forEach(function bindPill($pill) {
        $pill.addEventListener('click', handlePillClick);
      });
      $section?.addEventListener('shopify:block:select', handleBlockSelect);
      window.addEventListener('resize', handleWindowResize, { passive: true });

      const resizeObserver = new ResizeObserver(handleCarouselResize);
      resizeObserver.observe($carousel);

      carouselCleanups.set($carousel, function cleanupCarousel() {
        cancelMomentum();
        $previousButton?.removeEventListener('click', handlePreviousClick);
        $nextButton?.removeEventListener('click', handleNextClick);
        $stage.removeEventListener('pointerdown', handlePointerDown);
        $stage.removeEventListener('lostpointercapture', handlePointerEnd);
        $stage.removeEventListener('click', handleStageClick, true);
        $stage.removeEventListener('dragstart', handleNativeDragStart);
        removePointerListeners();
        if (drag && $stage.hasPointerCapture(drag.pointerId)) $stage.releasePointerCapture(drag.pointerId);
        drag = null;
        $carousel.classList.remove('is-dragging');
        $slides.forEach(function unbindSlide($slide) {
          $slide.removeEventListener('click', handleSlideClick);
        });
        $pills.forEach(function unbindPill($pill) {
          $pill.removeEventListener('click', handlePillClick);
        });
        $section?.removeEventListener('shopify:block:select', handleBlockSelect);
        window.removeEventListener('resize', handleWindowResize);
        resizeObserver.disconnect();
        window.clearTimeout(navigationEndTimer);
        window.cancelAnimationFrame(pillScrollAnimationFrame);
        window.cancelAnimationFrame(resizeAnimationFrame);
        window.cancelAnimationFrame(readyAnimationFrame);
        window.clearTimeout(resizeEndTimer);
        $carousel.classList.remove('is-resizing');
        $carousel.classList.remove('has-measured-pills');
        $carousel.classList.remove('is-ready');
        carouselCleanups.delete($carousel);
        delete $carousel.dataset.illustrationCarouselInitialized;
      });

      $carousel.dataset.illustrationCarouselInitialized = 'true';
      measureSlides();
      measurePills();
      updateCarousel(activeIndex, false);
      readyAnimationFrame = window.requestAnimationFrame(function enableReady() {
        readyAnimationFrame = undefined;
        $carousel.classList.add('is-ready');
      });
    }

    function initializeCarousels(scope) {
      const $carousels = scope.querySelectorAll('[data-illustration-carousel]');
      $carousels.forEach(initializeCarousel);
    }

    function handleSectionLoad(event) {
      initializeCarousels(event.target);
    }

    function handleSectionUnload(event) {
      const $carousels = event.target.querySelectorAll('[data-illustration-carousel]');
      $carousels.forEach(function cleanupCarousel($carousel) {
        carouselCleanups.get($carousel)?.();
      });
    }

    initializeCarousels(document);
    document.addEventListener('shopify:section:load', handleSectionLoad);
    document.addEventListener('shopify:section:unload', handleSectionUnload);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["launch-countdown"] && !Shopify.designMode) return;
  try {
    
  (function launchCountdown() {
    const MS_PER_SECOND = 1000;
    const MS_PER_MINUTE = MS_PER_SECOND * 60;
    const MS_PER_HOUR = MS_PER_MINUTE * 60;
    const MS_PER_DAY = MS_PER_HOUR * 24;
    const COUNTDOWN_POLL_INTERVAL_MS = 200;
    const COUNTDOWN_CATCH_UP_INTERVAL_MS = 80;
    const MAX_VISUAL_CATCH_UP_SECONDS = 1;

    const $countdowns = document.querySelectorAll('[data-lc-countdown]');
    const countdownTimerHandles = new WeakMap();
    if (!$countdowns.length) return;

    function padTwo(value) {
      return String(value).padStart(2, '0');
    }

    function calculatePartsFromTotalSeconds(totalSeconds) {
      const safeTotalSeconds = Math.max(0, totalSeconds);
      const days = Math.floor(safeTotalSeconds / (MS_PER_DAY / MS_PER_SECOND));
      const hours = Math.floor((safeTotalSeconds % (MS_PER_DAY / MS_PER_SECOND)) / (MS_PER_HOUR / MS_PER_SECOND));
      const minutes = Math.floor((safeTotalSeconds % (MS_PER_HOUR / MS_PER_SECOND)) / (MS_PER_MINUTE / MS_PER_SECOND));
      const seconds = safeTotalSeconds % (MS_PER_MINUTE / MS_PER_SECOND);
      return { days, hours, minutes, seconds };
    }

    function normalizeToUTC(dateStr) {
      if (/[Zz]$/.test(dateStr) || /[+-]\d{2}:?\d{2}$/.test(dateStr)) return dateStr;
      return dateStr + 'Z';
    }

    function initCountdown($countdown) {
      const existingTimerId = countdownTimerHandles.get($countdown);
      if (existingTimerId !== undefined) {
        clearTimeout(existingTimerId);
        countdownTimerHandles.delete($countdown);
      }

      const targetDateStr = $countdown.getAttribute('data-lc-target');
      if (!targetDateStr) return;

      const targetMs = new Date(normalizeToUTC(targetDateStr)).getTime();
      if (Number.isNaN(targetMs)) return;

      const $dayHundreds = $countdown.querySelector('[data-lc-day-hundreds]');
      const $dayTens = $countdown.querySelector('[data-lc-day-tens]');
      const $dayOnes = $countdown.querySelector('[data-lc-day-ones]');
      const $hourTens = $countdown.querySelector('[data-lc-hour-tens]');
      const $hourOnes = $countdown.querySelector('[data-lc-hour-ones]');
      const $minTens = $countdown.querySelector('[data-lc-min-tens]');
      const $minOnes = $countdown.querySelector('[data-lc-min-ones]');
      const $secTens = $countdown.querySelector('[data-lc-sec-tens]');
      const $secOnes = $countdown.querySelector('[data-lc-sec-ones]');

      function splitDigits(value) {
        const padded = padTwo(value);
        return [padded[0], padded[1]];
      }

      function renderDisplayFromParts(parts) {
        const daysPadded = String(parts.days).padStart(3, '0');
        const d0 = daysPadded[daysPadded.length - 3];
        const d1 = daysPadded[daysPadded.length - 2];
        const d2 = daysPadded[daysPadded.length - 1];
        const [h1, h2] = splitDigits(parts.hours);
        const [m1, m2] = splitDigits(parts.minutes);
        const [s1, s2] = splitDigits(parts.seconds);
        $dayHundreds.textContent = d0;
        $dayHundreds.classList.toggle('lc__countdown__char--hidden', d0 === '0');
        $dayTens.textContent = d1;
        $dayOnes.textContent = d2;
        $hourTens.textContent = h1;
        $hourOnes.textContent = h2;
        $minTens.textContent = m1;
        $minOnes.textContent = m2;
        $secTens.textContent = s1;
        $secOnes.textContent = s2;
      }

      let displayedTotalSeconds = null;
      let countdownTimerId = null;

      function scheduleTick(delayMs) {
        countdownTimerId = setTimeout(tick, delayMs);
        countdownTimerHandles.set($countdown, countdownTimerId);
      }

      function clearScheduledTick() {
        if (countdownTimerId === null) return;
        clearTimeout(countdownTimerId);
        countdownTimerId = null;
        countdownTimerHandles.delete($countdown);
      }

      function getRemainingTotalSeconds() {
        const remainingMs = Math.max(0, targetMs - Date.now());
        return Math.floor(remainingMs / MS_PER_SECOND);
      }

      function tick() {
        countdownTimerId = null;
        countdownTimerHandles.delete($countdown);

        const actualTotalSeconds = getRemainingTotalSeconds();

        if (displayedTotalSeconds === null) {
          displayedTotalSeconds = actualTotalSeconds;
          renderDisplayFromParts(calculatePartsFromTotalSeconds(displayedTotalSeconds));
        } else if (actualTotalSeconds < displayedTotalSeconds - MAX_VISUAL_CATCH_UP_SECONDS) {
          // After long tab inactivity, snap to real time instead of fast-forward animation.
          displayedTotalSeconds = actualTotalSeconds;
          renderDisplayFromParts(calculatePartsFromTotalSeconds(displayedTotalSeconds));
        } else if (actualTotalSeconds < displayedTotalSeconds) {
          displayedTotalSeconds -= 1;
          renderDisplayFromParts(calculatePartsFromTotalSeconds(displayedTotalSeconds));
          scheduleTick(COUNTDOWN_CATCH_UP_INTERVAL_MS);
          return;
        } else if (actualTotalSeconds !== displayedTotalSeconds) {
          displayedTotalSeconds = actualTotalSeconds;
          renderDisplayFromParts(calculatePartsFromTotalSeconds(displayedTotalSeconds));
        }

        if (displayedTotalSeconds > 0) {
          scheduleTick(COUNTDOWN_POLL_INTERVAL_MS);
        } else {
          clearScheduledTick();
        }
      }

      tick();
    }

    $countdowns.forEach(initCountdown);
  })();

  (function launchCountdownSignup() {
    const $openBtn = document.querySelector('[data-lc-open-panel]');
    if (!$openBtn) return;

    const panelImageUrl = $openBtn.dataset.lcPanelImage;
    if (panelImageUrl) {
      const $preload = new Image();
      $preload.src = panelImageUrl;
    }

    $openBtn.addEventListener('click', function handleOpenClick() {
      const detail = {};
      const title = $openBtn.dataset.lcPanelTitle;
      const imageUrl = $openBtn.dataset.lcPanelImage;
      const imageText = $openBtn.dataset.lcPanelImageText;
      const description = $openBtn.dataset.lcPanelDescription;
      const tag = $openBtn.dataset.lcPanelTag;

      if (title) detail.title = title;
      if (imageUrl) detail.imageUrl = imageUrl;
      if (imageText) detail.imageText = imageText;
      if (description) detail.description = description;
      if (tag) detail.tag = tag;

      document.dispatchEvent(new CustomEvent('megamac:newsletter:open', { detail: detail }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-cart"] && !Shopify.designMode) return;
  try {
    
  (function cartLightweight() {
    window.MegaMacCart = window.MegaMacCart || {};

    function emitCartUpdated(cart) {
      try {
        document.dispatchEvent(
          new CustomEvent('megamac:cart:updated', {
            detail: { cart: cart },
          })
        );
      } catch (_) {}
    }

    window.MegaMacCart.emitCartUpdated = emitCartUpdated;

    function emitCartAdded(cart, addedItem, addedQuantity, source, imageUrl) {
      try {
        document.dispatchEvent(
          new CustomEvent('megamac:cart:added', {
            detail: {
              cart: cart,
              addedItem: addedItem,
              addedQuantity: addedQuantity || 1,
              source: source || 'add',
              imageUrl: imageUrl || '',
            },
          })
        );
      } catch (_) {}
    }

    window.MegaMacCart.emitCartAdded = emitCartAdded;

    function emitCartRemoved(cart, removedVariantId, removedQuantity) {
      try {
        document.dispatchEvent(
          new CustomEvent('megamac:cart:removed', {
            detail: { cart: cart, removedVariantId: removedVariantId, removedQuantity: removedQuantity },
          })
        );
      } catch (_) {}
    }

    window.MegaMacCart.emitCartRemoved = emitCartRemoved;

    function emitCartQuantityChanged(cart) {
      try {
        document.dispatchEvent(new CustomEvent('megamac:cart:quantity-changed', { detail: { cart: cart } }));
      } catch (_) {}
    }

    window.MegaMacCart.emitCartQuantityChanged = emitCartQuantityChanged;

    async function fetchCartAndEmit() {
      try {
        const res = await fetch('/cart.js', {
          headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
          },
          cache: 'no-store',
          credentials: 'same-origin',
        });
        if (!res.ok) return;
        const cart = await res.json();
        emitCartUpdated(cart);
        return cart;
      } catch (_) {}
    }

    window.MegaMacCart.fetchCartAndEmit = fetchCartAndEmit;

    let pendingNewCartFocus = null;
    let pendingFastCheckoutOpen = false;

    function parseCartCents(value) {
      const n = parseInt(value, 10);
      return Number.isFinite(n) ? n : null;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      const prec = precision == null ? 2 : precision;
      const thou = thousands == null ? ',' : thousands;
      const dec = decimal == null ? '.' : decimal;
      const num = Number(number);
      if (Number.isNaN(num)) return '';
      const fixed = num.toFixed(prec);
      const parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(dec);
    }

    function stripTags(input) {
      return String(input || '').replace(/<[^>]*>/g, '');
    }

    function decodeEntities(input) {
      const txt = document.createElement('textarea');
      txt.innerHTML = String(input || '');
      return txt.value;
    }

    function getCartMoneyContext() {
      const $form = document.getElementById('cart-form');
      const $mini = document.querySelector('[data-mini-cart]');
      const source = $form || $mini;
      if (!source) return null;
      let moneyFormat = '';
      const raw = source.dataset.moneyFormat;
      if (raw) {
        try {
          moneyFormat = JSON.parse(raw) || '';
        } catch (_) {}
      }
      return {
        moneyFormat: moneyFormat,
        currencyCode: source.dataset.currencyCode || '',
        locale: source.dataset.locale || document.documentElement.lang || '',
      };
    }

    function formatCartMoney(cents) {
      const ctx = getCartMoneyContext();
      if (!ctx) return '';
      const formatString = ctx.moneyFormat || '';
      const placeholderRegex = new RegExp('\\{\\{\\s*(\\w+)\\s*\\}\\}');
      const match = formatString.match(placeholderRegex);
      const placeholder = match ? match[1] : null;
      const currencyCode = ctx.currencyCode;
      const locale = ctx.locale;

      const centsNumber = typeof cents === 'string' ? Number(cents.replace('.', '')) : Number(cents);
      const valueCents = Number.isNaN(centsNumber) ? 0 : centsNumber;
      const isWhole = valueCents % 100 === 0;

      if (placeholder) {
        let value = '';
        switch (placeholder) {
          case 'amount':
            value = formatWithDelimiters(valueCents / 100, isWhole ? 0 : 2);
            break;
          case 'amount_no_decimals':
            value = formatWithDelimiters(valueCents / 100, 0);
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(valueCents / 100, isWhole ? 0 : 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(valueCents / 100, 0, '.', ',');
            break;
          case 'amount_with_apostrophe_separator':
            value = formatWithDelimiters(valueCents / 100, isWhole ? 0 : 2, "'", '.');
            break;
          default:
            value = formatWithDelimiters(valueCents / 100, 2);
        }

        return decodeEntities(stripTags(formatString.replace(placeholderRegex, value)));
      }

      if (typeof Intl !== 'undefined' && currencyCode) {
        try {
          const base = new Intl.NumberFormat(locale || undefined, {
            style: 'currency',
            currency: currencyCode,
          });

          const maxDigits = base.resolvedOptions().maximumFractionDigits;
          const factor = Math.pow(10, maxDigits);
          const isWhole = maxDigits === 0 ? true : valueCents % factor === 0;

          const fmt = new Intl.NumberFormat(locale || undefined, {
            style: 'currency',
            currency: currencyCode,
            minimumFractionDigits: isWhole ? 0 : maxDigits,
            maximumFractionDigits: maxDigits,
          });

          return fmt.format(valueCents / 100);
        } catch (_) {}
      }

      return formatWithDelimiters(valueCents / 100, 2);
    }

    // Checkout is disabled and reads "Recalculating…" while a change is still on its way to Shopify. A watchdog
    // clears it if nothing re-arms it, so a failed path can never leave checkout stuck.
    let summaryPendingWatchdog = null;

    function markNewCartSummaryPending(isPending) {
      const $table = document.querySelector('[data-cart-summary]');
      const $checkouts = document.querySelectorAll('[data-cart-checkout]');
      if (!$table && !$checkouts.length) return;
      if (summaryPendingWatchdog) window.clearTimeout(summaryPendingWatchdog);
      summaryPendingWatchdog = null;
      if (isPending) {
        if ($table) {
          $table.setAttribute('data-cart-summary-pending', 'true');
          $table.setAttribute('aria-busy', 'true');
        }
        $checkouts.forEach(function ($btn) {
          $btn.setAttribute('data-cart-checkout-pending', 'true');
          $btn.disabled = true;
        });
        summaryPendingWatchdog = window.setTimeout(function () {
          summaryPendingWatchdog = null;
          const busy =
            window.MegaMacCart._newCartPendingUpdates ||
            window.MegaMacCart._newCartUpdateInFlight ||
            (window.MegaMacCart.cartRequestsInFlight || 0) > 0 ||
            (typeof window.MegaMacCart.hasPendingPanelCartWork === 'function' &&
              window.MegaMacCart.hasPendingPanelCartWork());
          if (busy) markNewCartSummaryPending(true);
          else markNewCartSummaryPending(false);
        }, 8000);
      } else {
        if ($table) {
          $table.removeAttribute('data-cart-summary-pending');
          $table.removeAttribute('aria-busy');
        }
        $checkouts.forEach(function ($btn) {
          $btn.removeAttribute('data-cart-checkout-pending');
          $btn.disabled = false;
        });
      }
    }

    // For the header cart panel: clear this page's pending state when the panel's last request has landed and
    // nothing of this page's own is queued.
    window.MegaMacCart.clearCartSummaryPendingIfIdle = function clearCartSummaryPendingIfIdle() {
      if (window.MegaMacCart._newCartPendingUpdates || window.MegaMacCart._newCartUpdateInFlight) return;
      if ((window.MegaMacCart.cartRequestsInFlight || 0) > 0) return;
      markNewCartSummaryPending(false);
    };
    window.MegaMacCart.setCartSummaryPending = markNewCartSummaryPending;

    function paintOptimisticSubtotal(delta, unitCents) {
      const $form = document.getElementById('cart-form');
      const $subtotal = document.querySelector('[data-cart-subtotal]');
      const $miniSubtotal = document.querySelector('[data-mini-cart-subtotal]');
      if (!$form && !$subtotal && !$miniSubtotal) return;

      const currentCents = parseCartCents(
        ($form && $form.getAttribute('data-cart-subtotal-cents')) ||
          ($subtotal && $subtotal.getAttribute('data-cart-subtotal-cents'))
      );
      if (currentCents == null) return;
      const nextCents = currentCents + delta * unitCents;
      if (!Number.isFinite(nextCents) || nextCents < 0) return;
      const formatted = formatCartMoney(nextCents);
      if (!formatted) return;

      if ($form) $form.setAttribute('data-cart-subtotal-cents', String(nextCents));
      if ($subtotal) {
        $subtotal.textContent = formatted;
        $subtotal.setAttribute('data-cart-subtotal-cents', String(nextCents));
      }
      if ($miniSubtotal) $miniSubtotal.textContent = formatted;
    }

    function paintOptimisticItemCount(delta) {
      const $form = document.getElementById('cart-form');
      const current = parseCartCents($form && $form.getAttribute('data-cart-total-item-count'));
      if (current == null) return;
      const nextCount = current + delta;
      if (!Number.isFinite(nextCount) || nextCount < 0) return;

      if ($form) $form.setAttribute('data-cart-total-item-count', String(nextCount));

      const mod10 = nextCount % 10;
      const mod100 = nextCount % 100;

      const buttons = document.querySelectorAll(
        'button[data-panel-button="cart"], button[data-mobile-icon-button="cart"]'
      );
      if (buttons.length) {
        const one = $form && $form.getAttribute('data-cart-aria-label-one');
        const few = $form && $form.getAttribute('data-cart-aria-label-few');
        const other = $form && $form.getAttribute('data-cart-aria-label-other');
        const template =
          nextCount === 1
            ? one
            : few && mod10 >= 2 && mod10 <= 4 && mod100 !== 12 && mod100 !== 13 && mod100 !== 14
            ? few
            : other;
        const label =
          nextCount > 0 && template
            ? template.replace('__N__', String(nextCount))
            : nextCount > 0
            ? 'Shopping cart, ' + nextCount + ' item' + (nextCount === 1 ? '' : 's')
            : 'Shopping cart';
        buttons.forEach(function (btn) {
          btn.setAttribute('aria-label', label);
          const filled = btn.querySelector('[data-cart-icon="filled"]');
          const empty = btn.querySelector('[data-cart-icon="empty"]');
          if (filled) filled.hidden = nextCount <= 0;
          if (empty) empty.hidden = nextCount > 0;
        });
      }

      const $summaryCount = document.querySelector('[data-cart-summary-item-count]');
      if ($summaryCount && $form) {
        const summaryOne = $form.getAttribute('data-cart-summary-count-one');
        const summaryFew = $form.getAttribute('data-cart-summary-count-few');
        const summaryOther = $form.getAttribute('data-cart-summary-count-other');
        const summaryTemplate =
          nextCount === 1
            ? summaryOne
            : summaryFew && mod10 >= 2 && mod10 <= 4 && mod100 !== 12 && mod100 !== 13 && mod100 !== 14
            ? summaryFew
            : summaryOther;
        if (summaryTemplate) {
          $summaryCount.textContent = summaryTemplate.replace('__N__', String(nextCount));
        }
      }

      const cartPanel = document.querySelector('[data-mini-cart]');
      if (!cartPanel) return;
      const titleEl = cartPanel.querySelector('.header__icons__panel__cart__content__title');
      if (!titleEl) return;
      const cartTitle = cartPanel.dataset.cartTitle || 'Cart';
      titleEl.textContent = nextCount > 0 ? cartTitle + ' (' + nextCount + ')' : cartTitle;
    }

    function paintOptimisticQuantityChange($input, previousQty, nextQty) {
      if (!$input) return;
      const prev = parseInt(previousQty, 10);
      const next = parseInt(nextQty, 10);
      if (!Number.isFinite(prev) || !Number.isFinite(next) || prev === next) return;
      const delta = next - prev;
      markNewCartSummaryPending(true);

      const $item = $input.closest('[data-cart-item]');
      if ($item) {
        const unitCents = parseCartCents($item.getAttribute('data-unit-price-cents'));
        if (unitCents != null) {
          // Line totals are not in this markup.
          paintOptimisticSubtotal(delta, unitCents);
        }
      }

      paintOptimisticItemCount(delta);
    }

    // Shopify's /cart/add.js always puts a re-added line first, and line order can't be set, so an undone row
    // goes to the top straight away rather than jumping there when the section re-renders.
    function moveCartRowToTop($row) {
      const list = $row && $row.parentElement;
      const firstRow = list && list.querySelector('[data-cart-item]');
      if (firstRow && firstRow !== $row) firstRow.before($row);
    }

    // Hooks for the header cart panel, so this page moves at the same moment as the panel instead of waiting
    // ~1s for Shopify to re-render the section. That re-render still follows and corrects anything that differs.
    function findPageLine(lineKey) {
      const form = document.getElementById('cart-form');
      if (!form || !lineKey) return null;
      const $primary = form.querySelector('input[name="updates[' + lineKey + ']"]');
      const $item = $primary && $primary.closest('[data-cart-item]');
      return $item ? { $primary: $primary, $item: $item } : null;
    }

    window.MegaMacCart.previewLineQuantity = function previewLineQuantity(lineKey, quantity) {
      const line = findPageLine(lineKey);
      const next = parseInt(quantity, 10);
      if (!line || !Number.isFinite(next)) return;

      const $primary = line.$primary;
      const baseline = parseInt($primary.getAttribute('data-cart-qty-baseline'), 10);
      const previous = Number.isFinite(baseline) ? baseline : parseInt($primary.value, 10);
      if (!Number.isFinite(previous) || previous === next) return;

      const inputs = [$primary].concat(
        Array.from(line.$item.querySelectorAll('[data-cart-item-counter-input]')).filter(function ($el) {
          return $el !== $primary && $el.getAttribute('data-cart-item-key') === lineKey;
        })
      );
      inputs.forEach(function ($el) {
        $el.value = next;
        $el.setAttribute('value', next);
        $el.setAttribute('size', String(next).length);
        $el.setAttribute('data-cart-qty-baseline', String(next));
      });
      // Left out of this page's own quantity posts until the panel's request has been rendered.
      $primary.setAttribute('data-panel-pending', 'true');

      // Keep a burst from this page's own counter in step with the panel's value.
      const intent = window.MegaMacCart._cartQtyIntent;
      if (intent && intent[lineKey] != null) intent[lineKey] = next;

      paintOptimisticQuantityChange($primary, previous, next);
    };

    // The panel's change for this line has landed: this page may post the line again. (The flag would
    // otherwise outlive redraws, because the counter elements are kept across them.)
    window.MegaMacCart.clearPanelPending = function clearPanelPending(lineKey) {
      const line = findPageLine(lineKey);
      if (line) line.$primary.removeAttribute('data-panel-pending');
    };

    window.MegaMacCart.previewLineRemoved = function previewLineRemoved(lineKey) {
      const line = findPageLine(lineKey);
      if (!line || line.$item.style.display === 'none') return;

      const quantity = parseInt(line.$primary.getAttribute('data-cart-qty-baseline') || line.$primary.value, 10);
      const unitCents = parseCartCents(line.$item.getAttribute('data-unit-price-cents'));
      const form = document.getElementById('cart-form');
      const itemCount = parseCartCents(form && form.getAttribute('data-cart-total-item-count'));

      // Keep a copy, so an undo after this page has re-rendered without the row can show it again at once.
      if (typeof window.MegaMacCart.savePageRemovalSnapshot === 'function') {
        window.MegaMacCart.savePageRemovalSnapshot(lineKey, line.$item);
      }
      line.$item.style.display = 'none';
      // Keep this page's own quantity posts from carrying the line, as its own remove does.
      line.$primary.disabled = true;
      markNewCartSummaryPending(true);
      // Like this page's own remove: removing the last item waits for the empty-cart render instead.
      if (Number.isFinite(quantity) && unitCents != null && itemCount != null && itemCount - quantity > 0) {
        paintOptimisticSubtotal(-quantity, unitCents);
        paintOptimisticItemCount(-quantity);
      }
    };

    window.MegaMacCart.previewLineRestored = function previewLineRestored(lineKey) {
      let line = findPageLine(lineKey);
      if (line && line.$item.style.display !== 'none') return;

      if (!line) {
        // This page has already re-rendered without the row: put the saved copy back.
        if (typeof window.MegaMacCart.restorePageRemovalSnapshot !== 'function') return;
        const restored = window.MegaMacCart.restorePageRemovalSnapshot(lineKey);
        // The whole section was swapped back (last item), totals included.
        if (restored !== 'row') return;
        line = findPageLine(lineKey);
        if (!line) return;
      }

      const quantity = parseInt(line.$primary.getAttribute('data-cart-qty-baseline') || line.$primary.value, 10);
      const unitCents = parseCartCents(line.$item.getAttribute('data-unit-price-cents'));

      line.$item.style.display = '';
      line.$primary.disabled = false;
      moveCartRowToTop(line.$item);
      markNewCartSummaryPending(true);
      if (Number.isFinite(quantity) && unitCents != null) {
        paintOptimisticSubtotal(quantity, unitCents);
        paintOptimisticItemCount(quantity);
      }
    };

    function captureNewCartFocus(rootEl) {
      pendingNewCartFocus = null;
      const active = document.activeElement;
      if (!active || !rootEl || !rootEl.contains(active)) return;
      if (!active.hasAttribute('data-cart-item-counter-input')) return;
      const key =
        active.getAttribute('data-cart-item-key') || (active.getAttribute('name') || '').replace(/^updates\[|\]$/g, '');
      if (!key) return;
      pendingNewCartFocus = {
        key: key,
        isMirror: active.hasAttribute('data-cart-item-counter-mirror'),
        selectionStart: active.selectionStart,
        selectionEnd: active.selectionEnd,
      };
    }

    function restoreNewCartFocus() {
      const snapshot = pendingNewCartFocus;
      pendingNewCartFocus = null;
      if (!snapshot || !snapshot.key) return;

      const inputs = document.querySelectorAll('[data-cart-item-counter-input]');
      let $input = null;
      inputs.forEach(function (el) {
        if ($input) return;
        if ((el.getAttribute('data-cart-item-key') || '') !== snapshot.key) return;
        if (el.hasAttribute('data-cart-item-counter-mirror') !== snapshot.isMirror) return;
        $input = el;
      });
      if (!$input || typeof $input.focus !== 'function') return;

      try {
        $input.focus({ preventScroll: true });
      } catch (_) {
        return;
      }
      try {
        if (
          typeof snapshot.selectionStart === 'number' &&
          typeof snapshot.selectionEnd === 'number' &&
          typeof $input.setSelectionRange === 'function'
        ) {
          $input.setSelectionRange(snapshot.selectionStart, snapshot.selectionEnd);
        }
      } catch (_) {}
    }

    function captureNewCartFastCheckoutOpen(rootEl) {
      pendingFastCheckoutOpen = false;
      if (!rootEl || typeof rootEl.querySelector !== 'function') return;
      const $input = rootEl.querySelector('.cart__summary__fast-checkout__input');
      if (!$input) return;
      pendingFastCheckoutOpen = !!$input.checked;
    }

    function restoreNewCartFastCheckoutOpen() {
      const wasOpen = pendingFastCheckoutOpen;
      pendingFastCheckoutOpen = false;
      if (!wasOpen) return;
      const $input = document.querySelector('.cart__summary__fast-checkout__input');
      if (!$input) return;
      const $wrap = $input.closest('.cart__summary__fast-checkout');
      // A style flush between the swap and this restore commits the
      // accordion's closed state, so setting checked would transition
      // 0fr -> 1fr visibly. Suppress transitions for the restore frame.
      if ($wrap) $wrap.classList.add('cart__summary__fast-checkout--restoring');
      $input.checked = true;
      if ($wrap) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            $wrap.classList.remove('cart__summary__fast-checkout--restoring');
          });
        });
      }
    }

    function initNewCartPaymentButtons() {
      if (!window.Shopify || !Shopify.PaymentButton) return;
      if (typeof Shopify.PaymentButton.init !== 'function') return;
      try {
        Shopify.PaymentButton.init();
      } catch (_) {}
    }

    // Product images of rows that left a render, parked (still in the document, so still decoded) for the undo
    // window: a row put back by undo takes its image from here rather than re-decoding it, which blinks in Safari.
    const heldCartImages = new Map();

    function holdCartImage(lineKey, $img, src) {
      const previous = heldCartImages.get(lineKey);
      if (previous) window.clearTimeout(previous.timer);
      const entry = { img: $img, src: src, timer: null };
      entry.timer = window.setTimeout(function () {
        if (heldCartImages.get(lineKey) === entry) {
          heldCartImages.delete(lineKey);
          if ($img.parentNode) $img.remove();
        }
      }, 16000);
      heldCartImages.set(lineKey, entry);
    }

    window.MegaMacCart.takeHeldCartImage = function takeHeldCartImage(lineKey, src) {
      const entry = heldCartImages.get(lineKey);
      if (!entry || entry.src !== (src || '')) return null;
      window.clearTimeout(entry.timer);
      heldCartImages.delete(lineKey);
      return entry.img;
    };

    let refreshRequestId = 0;
    let lastNewCartSectionId = '';
    let pendingStockLimitToast = null;
    const cartStackPositionAnimations = new WeakMap();

    function animateCartStackPosition(element, previousTop) {
      const previousAnimation = cartStackPositionAnimations.get(element);
      if (previousAnimation) {
        cartStackPositionAnimations.delete(element);
        previousAnimation.cancel();
      }
      const delta = previousTop - element.getBoundingClientRect().top;
      if (delta === 0) return;
      const animation = element.animate([{ translate: `0 ${delta}px` }, { translate: '0 0' }], {
        duration: 450,
        easing: 'cubic-bezier(0.9, 0, 0.1, 1)',
      });
      cartStackPositionAnimations.set(element, animation);
      function clearCartStackPositionAnimation() {
        if (cartStackPositionAnimations.get(element) === animation) {
          cartStackPositionAnimations.delete(element);
        }
      }
      animation.finished.then(clearCartStackPositionAnimation, clearCartStackPositionAnimation);
    }

    function animateCartNoticeRegionMutation(region, mutation) {
      if (!region) return;
      const wrapper = region.closest('.cart__items-wrapper');
      const stackPositions = new Map();
      if (wrapper) {
        Array.from(wrapper.children).forEach(function (element) {
          if (element === region || element.style.display === 'none') return;
          stackPositions.set(element, element.getBoundingClientRect().top);
        });
      }
      const noticePositions = new Map();
      Array.from(region.children).forEach(function (toast) {
        noticePositions.set(toast, toast.getBoundingClientRect().top);
      });
      mutation();

      noticePositions.forEach(function (previousTop, toast) {
        if (!toast.isConnected) return;
        animateCartStackPosition(toast, previousTop);
      });
      stackPositions.forEach(function (previousTop, element) {
        if (!element.isConnected || element.style.display === 'none') return;
        animateCartStackPosition(element, previousTop);
      });
    }

    function insertCartNotice(region, toast, before, replacedToasts) {
      if (!region || !toast) return;
      animateCartNoticeRegionMutation(region, function insertNotice() {
        Array.from(replacedToasts || []).forEach(function (existingToast) {
          existingToast.remove();
        });
        region.insertBefore(toast, before || null);
      });
    }

    async function fetchCartPageDoc(url) {
      const res = await fetch(url.toString(), {
        headers: {
          Accept: 'text/html',
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          'X-Requested-With': 'XMLHttpRequest',
        },
        cache: 'no-store',
        credentials: 'same-origin',
      });
      if (!res.ok) throw new Error(`Cart refresh failed (${res.status})`);
      const html = await res.text();
      return new DOMParser().parseFromString(html, 'text/html');
    }

    function swapNewCartFromDoc(doc, wrapperId, wrapperEl, sectionId, sectionEl, allowMainFallback) {
      const oldUpsellRoot = document.querySelector('[data-cart-upsell-root]');
      const oldUpsellCarousel = oldUpsellRoot ? oldUpsellRoot.querySelector('[data-cart-upsell-carousel]') : null;
      const oldUpsellState = oldUpsellRoot ? oldUpsellRoot.getAttribute('data-cart-upsell-state') : '';
      const oldUpsellProductIds = oldUpsellRoot ? oldUpsellRoot.dataset.cartProductIds || '' : '';
      // Which card is on show, so the same card (or the one taking its place) is in view after the swap.
      const oldUpsellViewedIndex =
        oldUpsellCarousel && window.MegaMacCart && typeof window.MegaMacCart.cartUpsellViewedCardIndex === 'function'
          ? window.MegaMacCart.cartUpsellViewedCardIndex(oldUpsellCarousel)
          : 0;
      const oldUpsellViewedCard = oldUpsellCarousel
        ? oldUpsellCarousel.querySelectorAll('[data-upsell-product-id]')[oldUpsellViewedIndex]
        : null;
      const oldUpsellViewedId = oldUpsellViewedCard ? oldUpsellViewedCard.getAttribute('data-upsell-product-id') : '';

      const oldShipPanel = document.querySelector('[data-cart-shipping-progress-panel]');
      const oldShipCaption = oldShipPanel ? oldShipPanel.querySelector('.cart__shipping-progress__caption') : null;
      const oldShipBarWrapper = oldShipPanel
        ? oldShipPanel.querySelector('.cart__shipping-progress__bar-wrapper')
        : null;
      const oldShipBar = oldShipBarWrapper ? oldShipBarWrapper.querySelector('.cart__shipping-progress__bar') : null;
      // Detaching the bar (section replaceWith) restarts CSS animations.
      // Capture WAAPI time now, and hoist nodes out of the replaced subtree
      // so they stay in the document.
      const oldShipGradientTime =
        oldShipBar && typeof oldShipBar.getAnimations === 'function'
          ? (
              oldShipBar.getAnimations().find(function (anim) {
                return anim.animationName === 'gradientShift';
              }) || {}
            ).currentTime
          : null;

      const preservedUpsellFragment = document.createDocumentFragment();
      function detachLoadedUpsellChildren() {
        if (!oldUpsellCarousel || oldUpsellState !== 'loaded') return;
        if (preservedUpsellFragment.childNodes.length) return;
        while (oldUpsellCarousel.firstChild) {
          preservedUpsellFragment.appendChild(oldUpsellCarousel.firstChild);
        }
      }

      function getShippingProgressHold() {
        let hold = document.getElementById('cart-shipping-progress-hold');
        if (!hold) {
          hold = document.createElement('div');
          hold.id = 'cart-shipping-progress-hold';
          hold.setAttribute('aria-hidden', 'true');
          // Stay in-document and painted (not display:none) so gradientShift
          // does not cancel. Parked off-screen until reattached.
          hold.style.cssText =
            'position:fixed;left:0;top:0;width:0;height:0;overflow:hidden;opacity:0;pointer-events:none;';
          document.body.appendChild(hold);
        }
        return hold;
      }

      function hoistShippingProgress() {
        if (!oldShipCaption && !oldShipBarWrapper) return;
        const hold = getShippingProgressHold();
        if (oldShipCaption) hold.appendChild(oldShipCaption);
        if (oldShipBarWrapper) hold.appendChild(oldShipBarWrapper);
      }

      // iOS binds a touch sequence to the node that received touchstart and
      // dispatches the synthesized click to that same node. Replacing a +/-
      // button mid-burst therefore drops the tap (or fires it on a detached
      // node that cannot bubble to the document listener). Keep the counter
      // subtrees alive across the swap and reconcile them against the fresh
      // server render instead.
      const preservedCounters = new Map();

      function counterPreserveKey($counter) {
        const $input = $counter.querySelector('[data-cart-item-counter-input]');
        if (!$input) return '';
        const key =
          $input.getAttribute('data-cart-item-key') ||
          ($input.getAttribute('name') || '').replace(/^updates\[|\]$/g, '');
        if (!key) return '';
        return key + '|' + ($input.hasAttribute('data-cart-item-counter-mirror') ? 'm' : 'p');
      }

      function hoistCounters() {
        // Moving a focused input blurs it. Do that first, while the counter is
        // still inside the live <form>, so handleBlur's submit sees the whole
        // set of updates[] inputs. captureNewCartFocus already ran, so focus is
        // restored after the swap.
        const active = document.activeElement;
        if (active && active.hasAttribute && active.hasAttribute('data-cart-item-counter-input')) {
          active.blur();
        }
        const hold = getShippingProgressHold();
        document.querySelectorAll('[data-cart-item-counter]').forEach(function ($counter) {
          const key = counterPreserveKey($counter);
          if (!key || preservedCounters.has(key)) return;
          preservedCounters.set(key, $counter);
          hold.appendChild($counter);
        });
      }

      function reconcileCounter($live, $fresh, hasPendingIntent) {
        const $liveInput = $live.querySelector('[data-cart-item-counter-input]');
        const $freshInput = $fresh.querySelector('[data-cart-item-counter-input]');
        if (!$liveInput || !$freshInput) return;

        // Stock (and therefore the cap) can move between renders.
        const nextMax = $freshInput.getAttribute('max');
        if (nextMax != null) $liveInput.setAttribute('max', nextMax);

        // The server render is authoritative unless the user has newer
        // changes still queued; reapplyCartQtyIntent owns that case.
        if (hasPendingIntent) return;
        const serverValue = parseInt($freshInput.getAttribute('value'), 10);
        if (Number.isNaN(serverValue)) return;
        $liveInput.value = serverValue;
        $liveInput.setAttribute('value', serverValue);
        $liveInput.setAttribute('data-cart-qty-baseline', String(serverValue));
      }

      function restorePreservedCounters() {
        if (!preservedCounters.size) return;
        const hold = document.getElementById('cart-shipping-progress-hold');
        const hasPendingIntent = !!(
          window.MegaMacCart._newCartPendingUpdates || window.MegaMacCart._newCartUpdateInFlight
        );
        document.querySelectorAll('[data-cart-item-counter]').forEach(function ($fresh) {
          if (hold && hold.contains($fresh)) return;
          const key = counterPreserveKey($fresh);
          const $live = key ? preservedCounters.get(key) : null;
          if (!$live) return;
          preservedCounters.delete(key);
          reconcileCounter($live, $fresh, hasPendingIntent);
          $fresh.replaceWith($live);
        });
        // Lines that disappeared from the new render have no twin to take.
        preservedCounters.forEach(function ($orphan) {
          if ($orphan.parentNode) $orphan.remove();
        });
        preservedCounters.clear();
      }

      // Like the counters: a re-render replaces every <img>, and Safari re-decodes the new element, so the
      // product pictures blink on each change. Keep the live elements and put them into the fresh rows.
      const preservedImages = new Map();

      function rowLineKey($row) {
        const $input = $row.querySelector('[data-cart-item-counter-input]');
        return $input ? $input.getAttribute('data-cart-item-key') || '' : '';
      }

      function hoistImages() {
        const hold = getShippingProgressHold();
        document.querySelectorAll('#cart-form [data-cart-item]').forEach(function ($row) {
          const key = rowLineKey($row);
          const $img = $row.querySelector('img.cart__item__img');
          if (!key || !$img || !$img.complete) return;
          preservedImages.set(key, { img: $img, src: $img.getAttribute('src') || '', parent: $img.parentNode });
          hold.appendChild($img);
        });
      }

      function restorePreservedImages(swapped) {
        if (!preservedImages.size) return;
        if (!swapped) {
          // The old render stayed: put the pictures back where they were.
          preservedImages.forEach(function (saved) {
            if (saved.parent && saved.parent.isConnected) saved.parent.appendChild(saved.img);
          });
          preservedImages.clear();
          return;
        }
        document.querySelectorAll('#cart-form [data-cart-item]').forEach(function ($row) {
          const key = rowLineKey($row);
          const saved = key ? preservedImages.get(key) : null;
          const $fresh = $row.querySelector('img.cart__item__img');
          if (!saved || !$fresh || ($fresh.getAttribute('src') || '') !== saved.src) return;
          $fresh.replaceWith(saved.img);
          preservedImages.delete(key);
        });
        // Lines that left this render: park their pictures for an undo.
        preservedImages.forEach(function (saved, key) {
          holdCartImage(key, saved.img, saved.src);
        });
        preservedImages.clear();
      }

      function preparePreservedNodes() {
        detachLoadedUpsellChildren();
        hoistShippingProgress();
        // Images first: they're keyed by the counter's input, which hoistCounters moves out of the row.
        hoistImages();
        hoistCounters();
      }

      const focusRoot =
        (wrapperId && document.getElementById(wrapperId)) ||
        wrapperEl ||
        sectionEl ||
        document.getElementById('cart-form');
      captureNewCartFocus(focusRoot);
      captureNewCartFastCheckoutOpen(focusRoot);

      let replaced = false;

      // Prefer swapping the Shopify section wrapper if we can identify it.
      if (wrapperId) {
        const nextWrapper = doc.getElementById(wrapperId);
        const currentWrapper = document.getElementById(wrapperId) || wrapperEl;
        if (nextWrapper && currentWrapper) {
          preparePreservedNodes();
          currentWrapper.replaceWith(document.importNode(nextWrapper, true));
          replaced = true;
        }
      }

      // Fallback: swap the inner section element if present.
      if (!replaced && sectionId) {
        const nextSection = doc.querySelector(`section#${CSS.escape(sectionId)}`);
        if (nextSection && sectionEl) {
          preparePreservedNodes();
          sectionEl.replaceWith(document.importNode(nextSection, true));
          replaced = true;
        }
      }

      // <main> only exists on a full-page response — never against ?section_id=.
      if (!replaced && allowMainFallback) {
        const nextMain = doc.querySelector('main');
        const currentMain = document.querySelector('main');
        if (nextMain && currentMain) {
          preparePreservedNodes();
          currentMain.replaceWith(document.importNode(nextMain, true));
          replaced = true;
        }
      }

      if (replaced) restorePreservedCounters();
      restorePreservedImages(replaced);

      if (replaced && oldUpsellCarousel && oldUpsellState === 'loaded') {
        const newRoot = document.querySelector('[data-cart-upsell-root]');
        const newCarousel = newRoot ? newRoot.querySelector('[data-cart-upsell-carousel]') : null;
        // Keep the loaded recommendations on screen across adds and removes rather than hiding the block while
        // it refetches. Cards for products now in the cart are dropped at once; fresh recommendations are then
        // fetched in the background (data-cart-upsell-refresh) and swapped in when they arrive.
        let keepUpsell = !!(newRoot && newCarousel);
        let productsAdded = false;
        if (keepUpsell && (newRoot.dataset.cartProductIds || '') !== oldUpsellProductIds) {
          const inCart = new Set(
            (window.MegaMacCart.safeJsonParse(newRoot.dataset.cartProductIds || '[]', []) || []).map(String)
          );
          const wasInCart = new Set(
            (window.MegaMacCart.safeJsonParse(oldUpsellProductIds || '[]', []) || []).map(String)
          );
          inCart.forEach(function (id) {
            if (!wasInCart.has(id)) productsAdded = true;
          });
          Array.from(preservedUpsellFragment.querySelectorAll('[data-upsell-product-id]')).forEach(function (card) {
            if (inCart.has(String(card.getAttribute('data-upsell-product-id')))) card.remove();
          });
          const cards = preservedUpsellFragment.querySelectorAll('[data-upsell-product-id]');
          keepUpsell = inCart.size > 0 && cards.length > 0;
          if (keepUpsell && !preservedUpsellFragment.querySelector('[data-cart-upsell-content]')) {
            cards[0].setAttribute('data-cart-upsell-content', '');
          }
        }
        if (keepUpsell) {
          // The cards on screen stay as they are. A product added to the cart brings its own recommendations,
          // appended at the end; a removal changes nothing (the current cards are still good suggestions).
          if (oldUpsellRoot && oldUpsellRoot.dataset.upsellFetchedIds) {
            newRoot.dataset.upsellFetchedIds = oldUpsellRoot.dataset.upsellFetchedIds;
          }
          if (productsAdded) newRoot.setAttribute('data-cart-upsell-refresh', 'true');
          newCarousel.innerHTML = '';
          newCarousel.appendChild(preservedUpsellFragment);
          newRoot.setAttribute('data-cart-upsell-state', 'loaded');
          const panel = newRoot.closest('[data-cart-shipping-progress-panel]');
          if (panel) panel.setAttribute('data-cart-upsell-state', 'loaded');
          if (window.MegaMacCart && typeof window.MegaMacCart.scrollCartUpsellToCard === 'function') {
            const cardsNow = Array.from(newCarousel.querySelectorAll('[data-upsell-product-id]'));
            const sameCard = cardsNow.findIndex(function (card) {
              return card.getAttribute('data-upsell-product-id') === oldUpsellViewedId;
            });
            // The viewed card is gone (added to the cart): the card now at that position takes its place.
            window.MegaMacCart.scrollCartUpsellToCard(newCarousel, sameCard >= 0 ? sameCard : oldUpsellViewedIndex);
          }
          try {
            document.dispatchEvent(new CustomEvent('cart-upsell:loaded'));
          } catch (_) {}
        }
      }

      if (replaced && oldShipCaption && oldShipBarWrapper) {
        const newPanel = document.querySelector('[data-cart-shipping-progress-panel]');
        const newCaption = newPanel ? newPanel.querySelector('.cart__shipping-progress__caption') : null;
        const newBarWrapper = newPanel ? newPanel.querySelector('.cart__shipping-progress__bar-wrapper') : null;
        // Only morph when both renders have the same structure; otherwise
        // (panel appeared/disappeared, progress toggled off) accept the
        // fresh server render.
        if (newCaption && newBarWrapper) {
          const nextMessage = newCaption.textContent;
          const nextValue = newBarWrapper.getAttribute('aria-valuenow') || '';
          const newBar = newBarWrapper.querySelector('.cart__shipping-progress__bar');
          const nextWidth = newBar ? newBar.style.width : '';

          // Keep the live nodes (uninterrupted gradient animation) and
          // morph only what changed.
          newCaption.replaceWith(oldShipCaption);
          newBarWrapper.replaceWith(oldShipBarWrapper);

          if (oldShipCaption.textContent !== nextMessage) {
            oldShipCaption.textContent = nextMessage;
          }
          if (oldShipBarWrapper.getAttribute('aria-valuenow') !== nextValue) {
            oldShipBarWrapper.setAttribute('aria-valuenow', nextValue);
          }
          const oldBar = oldShipBarWrapper.querySelector('.cart__shipping-progress__bar');
          if (oldBar && nextWidth && oldBar.style.width !== nextWidth) {
            // Existing `transition: width 0.3s ease` animates this.
            oldBar.style.width = nextWidth;
          }
          if (oldBar && oldShipGradientTime != null && typeof oldBar.getAnimations === 'function') {
            function restoreShipBarAnim() {
              const anim = oldBar.getAnimations().find(function (a) {
                return a.animationName === 'gradientShift';
              });
              if (!anim) return false;
              anim.currentTime = oldShipGradientTime;
              return true;
            }
            if (!restoreShipBarAnim()) requestAnimationFrame(restoreShipBarAnim);
          }
        }
      }

      const shipHold = document.getElementById('cart-shipping-progress-hold');
      if (shipHold) shipHold.replaceChildren();

      return replaced;
    }

    function afterNewCartSectionSwap() {
      markNewCartSummaryPending(false);
      if (window.MegaMacCart && typeof window.MegaMacCart.initNewCart === 'function') {
        window.MegaMacCart.initNewCart(document);
      }
      if (window.MegaMacCart && typeof window.MegaMacCart.hidePendingRemovals === 'function') {
        window.MegaMacCart.hidePendingRemovals();
      }
      restoreNewCartFocus();
      restoreNewCartFastCheckoutOpen();
      initNewCartPaymentButtons();
      if (window.MegaMacCart && typeof window.MegaMacCart.renderUndoToasts === 'function') {
        window.MegaMacCart.renderUndoToasts();
      }
      if (window.MegaMacCart && typeof window.MegaMacCart.initCartUpsell === 'function') {
        window.MegaMacCart.initCartUpsell();
      }

      // Notify any listeners (e.g. cart upsell) that the cart DOM was replaced.
      try {
        document.dispatchEvent(new CustomEvent('megamac:cart:domrefreshed'));
      } catch (_) {}
    }

    // Returns the cart section's id, for asking Shopify to render it alongside a cart request (`sections`).
    function getNewCartSectionId() {
      const cartForm = document.getElementById('cart-form');
      const sectionEl =
        (cartForm && cartForm.closest && cartForm.closest('section[id]')) ||
        document.querySelector('section[id*="__new_cart_"], section[id^="new_cart_"]');
      return (sectionEl && sectionEl.id) || lastNewCartSectionId || '';
    }

    window.MegaMacCart.getNewCartSectionId = getNewCartSectionId;

    // Counts cart changes made from this page and the header cart panel. Section HTML that came back with a
    // change is only used to redraw the page if the count hasn't moved since, i.e. it still shows the current cart.
    let cartMutationSeq = 0;
    window.MegaMacCart.noteCartMutation = function noteCartMutation() {
      cartMutationSeq += 1;
      return cartMutationSeq;
    };
    window.MegaMacCart.cartMutationSeq = function getCartMutationSeq() {
      return cartMutationSeq;
    };

    // `prefetchedHtml`: this section's HTML already rendered by Shopify (returned by /cart/change.js or
    // /cart/add.js via `sections`), which saves a round trip. Without it the section is fetched as before.
    async function refreshNewCartSection(prefetchedHtml) {
      refreshRequestId += 1;
      const requestId = refreshRequestId;

      const cartForm = document.getElementById('cart-form');
      const wrapperEl = document.querySelector(
        '[id^="shopify-section-"][id*="__new_cart_"], [id^="shopify-section-new_cart_"]'
      );
      const sectionEl =
        (cartForm && cartForm.closest && cartForm.closest('section[id]')) ||
        (wrapperEl ? wrapperEl.querySelector('section[id*="__new_cart_"], section[id^="new_cart_"]') : null) ||
        document.querySelector('section[id*="__new_cart_"], section[id^="new_cart_"]') ||
        null;
      const sectionId = (sectionEl && sectionEl.id) || lastNewCartSectionId || '';
      const wrapperId = (wrapperEl && wrapperEl.id) || (sectionId ? `shopify-section-${sectionId}` : '');

      async function fetchFullPageAndSwap() {
        const fullPageUrl = new URL(window.location.href);
        fullPageUrl.searchParams.delete('section_id');
        fullPageUrl.searchParams.set('_', String(Date.now())); // cache-bust
        const doc = await fetchCartPageDoc(fullPageUrl);
        if (requestId !== refreshRequestId) return false;
        if (window.MegaMacCart._newCartPendingUpdates || window.MegaMacCart._newCartUpdateInFlight) {
          // User has queued newer changes; discard this stale render.
          // The drain loop will trigger a fresh refresh when it settles.
          return true;
        }
        // Wait for a brief input-idle window: swapping the DOM between a
        // user's mousedown and mouseup swallows the click, which reads as
        // the counter stalling mid-burst.
        const IDLE_MS = 250;
        while (Date.now() - (window.MegaMacCart._lastCounterInteractionAt || 0) < IDLE_MS) {
          await new Promise(function (r) {
            setTimeout(r, 100);
          });
          if (requestId !== refreshRequestId) return false;
          if (window.MegaMacCart._newCartPendingUpdates || window.MegaMacCart._newCartUpdateInFlight) {
            // Newer changes queued while waiting — this render is stale.
            return true;
          }
        }
        // A press can land after the idle wait and before replaceWith.
        if (window.MegaMacCart._newCartPendingUpdates || window.MegaMacCart._newCartUpdateInFlight) {
          return true;
        }
        const replaced = swapNewCartFromDoc(doc, wrapperId, wrapperEl, sectionId, sectionEl, true);
        if (!replaced) return false;
        afterNewCartSectionSwap();
        return true;
      }

      async function fetchFullPageOrReload() {
        if (requestId !== refreshRequestId) return false;
        try {
          const replaced = await fetchFullPageAndSwap();
          if (replaced) return true;
        } catch (_) {}
        if (requestId !== refreshRequestId) return false;
        window.location.reload();
        return false;
      }

      if (!sectionId) {
        return fetchFullPageOrReload();
      }

      try {
        const requestUrl = new URL(window.location.href);
        requestUrl.searchParams.set('section_id', sectionId);
        requestUrl.searchParams.set('_', String(Date.now())); // cache-bust
        const doc =
          typeof prefetchedHtml === 'string' && prefetchedHtml
            ? new DOMParser().parseFromString(prefetchedHtml, 'text/html')
            : await fetchCartPageDoc(requestUrl);
        if (requestId !== refreshRequestId) return false;
        if (window.MegaMacCart._newCartPendingUpdates || window.MegaMacCart._newCartUpdateInFlight) {
          // User has queued newer changes; discard this stale render.
          // The drain loop will trigger a fresh refresh when it settles.
          return true;
        }
        // Wait for a brief input-idle window: swapping the DOM between a
        // user's mousedown and mouseup swallows the click, which reads as
        // the counter stalling mid-burst.
        const IDLE_MS = 250;
        while (Date.now() - (window.MegaMacCart._lastCounterInteractionAt || 0) < IDLE_MS) {
          await new Promise(function (r) {
            setTimeout(r, 100);
          });
          if (requestId !== refreshRequestId) return false;
          if (window.MegaMacCart._newCartPendingUpdates || window.MegaMacCart._newCartUpdateInFlight) {
            // Newer changes queued while waiting — this render is stale.
            return true;
          }
        }

        // A press can land after the idle wait and before replaceWith.
        if (window.MegaMacCart._newCartPendingUpdates || window.MegaMacCart._newCartUpdateInFlight) {
          return true;
        }

        const replaced = swapNewCartFromDoc(doc, wrapperId, wrapperEl, sectionId, sectionEl, false);
        if (!replaced) return fetchFullPageOrReload();

        lastNewCartSectionId = sectionId;
        afterNewCartSectionSwap();
        return true;
      } catch (_) {
        return fetchFullPageOrReload();
      }
    }

    window.MegaMacCart.refreshNewCartSection = refreshNewCartSection;

    function getCartUpdatesFromForm(formEl) {
      const updates = {};
      if (!formEl) return updates;

      const inputs = formEl.querySelectorAll('input[name^="updates["]');
      inputs.forEach(function (input) {
        if (input.disabled) return;
        // The header cart panel is still sending this line's quantity; posting it from here too could send a
        // value Shopify hasn't accepted yet (e.g. over stock).
        if (input.getAttribute('data-panel-pending') === 'true') return;
        const name = input.getAttribute('name') || '';
        const match = name.match(/^updates\[(.+)\]$/);
        if (!match) return;
        const key = match[1];
        const val = parseInt(input.value || '0', 10);
        updates[key] = Number.isFinite(val) ? val : 0;
      });

      return updates;
    }

    // All cart changes go through the theme-wide queue (layout/theme.liquid) so none overlap.
    function queuedCartFetch(url, body) {
      const send = function () {
        return fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(body),
        });
      };
      return typeof window.MegaMacCart.queueCartRequest === 'function'
        ? window.MegaMacCart.queueCartRequest(send)
        : send();
    }
    window.MegaMacCart.queuedCartFetch = queuedCartFetch;

    async function postCartUpdates(updates) {
      const res = await queuedCartFetch('/cart/update.js', { updates: updates });
      if (!res.ok) throw new Error('Cart update failed');
      window.MegaMacCart.noteCartMutation();
      return res.json();
    }

    async function drainNewCartPendingUpdates() {
      if (window.MegaMacCart._newCartUpdateDrainInProgress) return;
      window.MegaMacCart._newCartUpdateDrainInProgress = true;

      try {
        do {
          let hasPostedUpdates = false;
          let lastCart = null;

          // Drain the latest pending state; if multiple changes happen while a request is
          // in-flight, we only keep the most recent set of quantities ("latest wins").
          while (window.MegaMacCart._newCartPendingUpdates) {
            const updatesToSend = window.MegaMacCart._newCartPendingUpdates;
            window.MegaMacCart._newCartPendingUpdates = null;

            window.MegaMacCart._newCartUpdateInFlight = true;
            try {
              // Update server state for each queued snapshot, but defer UI re-render
              // until the queue fully drains to avoid visible intermediate quantities.
              markNewCartSummaryPending(true);
              lastCart = await postCartUpdates(updatesToSend);
              hasPostedUpdates = true;
            } catch (_) {
              // Shopify refused the update (e.g. over stock): show the cart as it is rather than reloading.
              window.MegaMacCart._newCartPendingUpdates = null;
              window.MegaMacCart._cartQtyIntent = null;
              // Cleared before the redraw below, which is skipped while an update is flagged as in flight.
              window.MegaMacCart._newCartUpdateInFlight = false;
              if (window.MegaMacCart && typeof window.MegaMacCart.fetchCartAndEmit === 'function') {
                try {
                  await window.MegaMacCart.fetchCartAndEmit();
                } catch (_e) {}
              }
              await refreshNewCartSection();
              return;
            } finally {
              window.MegaMacCart._newCartUpdateInFlight = false;
            }
          }

          if (hasPostedUpdates) {
            if (window.MegaMacCart && typeof window.MegaMacCart.emitCartUpdated === 'function') {
              window.MegaMacCart.emitCartUpdated(lastCart);
            }
            if (window.MegaMacCart && typeof window.MegaMacCart.emitCartQuantityChanged === 'function') {
              window.MegaMacCart.emitCartQuantityChanged(lastCart);
            }
            await refreshNewCartSection();
          }
        } while (window.MegaMacCart._newCartPendingUpdates);
      } finally {
        window.MegaMacCart._newCartUpdateDrainInProgress = false;
      }
    }

    const CART_UPDATE_DEBOUNCE_MS = 200;

    function clearNewCartUpdateDebounce() {
      if (!window.MegaMacCart._newCartUpdateDebounceTimer) return;
      window.clearTimeout(window.MegaMacCart._newCartUpdateDebounceTimer);
      window.MegaMacCart._newCartUpdateDebounceTimer = null;
    }

    function scheduleNewCartUpdateDrain() {
      clearNewCartUpdateDebounce();
      window.MegaMacCart._newCartUpdateDebounceTimer = window.setTimeout(function () {
        window.MegaMacCart._newCartUpdateDebounceTimer = null;
        drainNewCartPendingUpdates();
      }, CART_UPDATE_DEBOUNCE_MS);
    }

    function updateCartQuantitiesFromForm(formEl, options) {
      if (!formEl) return;
      const updates = getCartUpdatesFromForm(formEl);

      // If an update is already in-flight, don't drop this change. Store the latest
      // intended quantities and let the in-flight request finish first.
      window.MegaMacCart._newCartPendingUpdates = updates;
      const immediate = !!(options && options.immediate);
      if (immediate) {
        clearNewCartUpdateDebounce();
        return drainNewCartPendingUpdates();
      }

      scheduleNewCartUpdateDrain();
    }

    window.MegaMacCart.updateCartQuantitiesFromForm = updateCartQuantitiesFromForm;

    // Checkout posts the cart as Shopify holds it. A change made in the header cart panel may still be on its
    // way (debounced or in flight), so let it land first; the button shows "Recalculating" meanwhile.
    document.addEventListener('submit', function waitForPanelChangesBeforeCheckout(event) {
      const form = event.target;
      if (!form || form.id !== 'cart-form') return;
      if (form.dataset.checkoutReady === 'true') {
        delete form.dataset.checkoutReady;
        return;
      }
      if (
        !window.MegaMacCart ||
        typeof window.MegaMacCart.hasPendingPanelCartWork !== 'function' ||
        !window.MegaMacCart.hasPendingPanelCartWork()
      ) {
        return;
      }
      event.preventDefault();
      const submitter = event.submitter;
      markNewCartSummaryPending(true);
      window.MegaMacCart.waitForPanelCartIdle().then(function () {
        markNewCartSummaryPending(false);
        form.dataset.checkoutReady = 'true';
        if (submitter && typeof form.requestSubmit === 'function') form.requestSubmit(submitter);
        else form.submit();
      });
    });

    window.MegaMacCart.initNewCart = function initNewCart(root) {
      const scope = root || document;

      const $inputs = scope.querySelectorAll('[data-cart-item-counter-input]');
      const $form = scope.getElementById ? scope.getElementById('cart-form') : document.getElementById('cart-form');
      const undoRegion = scope.querySelector
        ? scope.querySelector('[data-cart-undo-region]')
        : document.querySelector('[data-cart-undo-region]');
      const stockToastTemplate =
        (scope.getElementById ? scope.getElementById('cart-stock-limit-template') : null) ||
        document.getElementById('cart-stock-limit-template');

      const TOAST_DURATION = 5000;
      let activeStockToast = null;
      let stockToastTimeout = null;

      function clearStockLimitToastDom(animateRemoval) {
        if (stockToastTimeout) {
          window.clearTimeout(stockToastTimeout);
          stockToastTimeout = null;
        }
        const existingToasts = undoRegion ? undoRegion.querySelectorAll('[data-cart-stock-toast]') : [];
        const removeToasts = function () {
          existingToasts.forEach(function (toast) {
            toast.remove();
          });
          activeStockToast = null;
        };
        if (animateRemoval !== false && existingToasts.length) {
          animateCartNoticeRegionMutation(undoRegion, removeToasts);
        } else {
          removeToasts();
        }
      }

      function clearAllToasts() {
        pendingStockLimitToast = null;
        clearStockLimitToastDom();
      }

      function mountStockLimitToast(text, durationMs) {
        if (!undoRegion || !stockToastTemplate || !text) return;

        if (stockToastTimeout) {
          window.clearTimeout(stockToastTimeout);
          stockToastTimeout = null;
        }
        const existingToasts = undoRegion.querySelectorAll('[data-cart-stock-toast]');

        const fragment = stockToastTemplate.content.cloneNode(true);
        const toast = fragment.querySelector('[data-cart-stock-toast]');
        const textEl = toast.querySelector('[data-cart-stock-toast-text]');
        const closeBtn = toast.querySelector('[data-cart-stock-toast-close]');

        textEl.textContent = text;

        insertCartNotice(undoRegion, toast, undoRegion.firstChild, existingToasts);
        activeStockToast = undoRegion.querySelector('[data-cart-stock-toast]');

        stockToastTimeout = window.setTimeout(function () {
          pendingStockLimitToast = null;
          clearStockLimitToastDom();
        }, durationMs);

        if (closeBtn) {
          closeBtn.addEventListener('click', function () {
            clearAllToasts();
          });
        }
      }

      function showStockLimitToast($input, maxQty) {
        if (!undoRegion || !stockToastTemplate) return;
        // Only when the cap is real stock. At the 999 ceiling the box just stops, as it does in the header panel;
        // "Only 999 available" read as a stock message.
        if ($input.getAttribute('data-cart-stock-limited') !== 'true') return;

        const titleFallback = stockToastTemplate.getAttribute('data-stock-toast-title-fallback') || '';
        const productTitle = $input.getAttribute('data-product-title') || titleFallback;

        const templateWithTitle = stockToastTemplate.getAttribute('data-stock-toast-template');
        const templateGeneric = stockToastTemplate.getAttribute('data-stock-toast-template-generic');

        const template = productTitle && templateWithTitle ? templateWithTitle : templateGeneric;
        const text = template ? template.replace('__QTY__', String(maxQty)).replace('__TITLE__', productTitle) : '';
        if (!text) return;

        pendingStockLimitToast = {
          text: text,
          expiresAt: Date.now() + TOAST_DURATION,
        };
        mountStockLimitToast(text, TOAST_DURATION);
      }

      // The header cart panel brought a line down to its stock (on load, or after Shopify refused a quantity):
      // show the same "Only N available" message next to the row here.
      window.MegaMacCart.showCartStockNotice = function showCartStockNotice(lineKey, maxQty) {
        const $qtyInput = document.querySelector('#cart-form input[name="updates[' + lineKey + ']"]');
        if (!$qtyInput) return;
        $qtyInput.setAttribute('max', String(maxQty));
        $qtyInput.setAttribute('data-cart-stock-limited', 'true');
        showStockLimitToast($qtyInput, maxQty);
      };

      function clampAllInputsToMax() {
        document.querySelectorAll('[data-cart-item-counter-input]').forEach(function ($qtyInput) {
          const maxAttr = parseInt($qtyInput.getAttribute('max'), 10);
          const maxQty = Number.isNaN(maxAttr) ? 999 : maxAttr;

          let value = parseInt($qtyInput.value, 10);
          if (Number.isNaN(value) || value < 1) value = 1;
          if (value > maxQty) value = maxQty;

          $qtyInput.value = value;
          $qtyInput.setAttribute('value', value);
        });
      }

      function getQtyBaseline($el) {
        if (!$el) return 1;
        const fromAttr = parseInt($el.getAttribute('data-cart-qty-baseline'), 10);
        if (!Number.isNaN(fromAttr)) return fromAttr;
        const fromValue = parseInt($el.value, 10);
        return Number.isNaN(fromValue) ? 1 : fromValue;
      }

      function setQtyBaseline($primary, $mirror, value) {
        const serialized = String(value);
        if ($primary) $primary.setAttribute('data-cart-qty-baseline', serialized);
        if ($mirror && $mirror !== $primary) $mirror.setAttribute('data-cart-qty-baseline', serialized);
      }

      function resolveCounterFields($counter) {
        if (!$counter) return null;
        const $eventInput = $counter.querySelector('[data-cart-item-counter-input]');
        if (!$eventInput) return null;
        const liveForm = document.getElementById('cart-form') || $form;
        const key =
          $eventInput.getAttribute('data-cart-item-key') ||
          ($eventInput.getAttribute('name') || '').replace(/^updates\[|\]$/g, '');
        const $livePrimary = liveForm && key ? liveForm.querySelector('input[name="updates[' + key + ']"]') : null;
        const $primary = $livePrimary || $eventInput;
        const $item = ($primary && $primary.closest('[data-cart-item]')) || $eventInput.closest('[data-cart-item]');
        const $mirror =
          $item && key
            ? $item.querySelector('[data-cart-item-counter-mirror][data-cart-item-key="' + key + '"]')
            : null;
        const $input = $counter.isConnected ? $eventInput : $primary;
        return {
          $input: $input,
          $primary: $primary,
          $mirror: $mirror,
          liveForm: liveForm,
          key: key,
        };
      }

      function writeCounterCount($input, $primary, $mirror, count) {
        function write($el) {
          if (!$el) return;
          $el.value = count;
          $el.setAttribute('value', count);
          $el.setAttribute('size', String(count).length);
          // + stops at the cap (stock, or the 999 ceiling) rather than clicking to a notice.
          const $inc = $el.closest('[data-cart-item-counter]')
            ? $el.closest('[data-cart-item-counter]').querySelector('[data-cart-item-counter-increment]')
            : null;
          if ($inc) {
            const maxAttr = parseInt($el.getAttribute('max'), 10);
            const maxQty = Number.isNaN(maxAttr) ? 999 : maxAttr;
            // Off at the cap, but still clickable: a click then shows the "Only N available" message instead.
            const atCap = count >= maxQty;
            $inc.setAttribute('aria-disabled', atCap ? 'true' : 'false');
            const template =
              (stockToastTemplate && stockToastTemplate.getAttribute('data-stock-toast-template-generic')) || '';
            $inc.title =
              atCap && $el.getAttribute('data-cart-stock-limited') === 'true'
                ? template.replace('__QTY__', String(maxQty))
                : '';
          }
        }
        write($input);
        if ($primary && $primary !== $input) write($primary);
        if ($mirror && $mirror !== $input) write($mirror);
      }

      function submitCounterIfChanged($input, $primary, $mirror, liveForm, nextCount, forceImmediate) {
        const baselineEl = $primary || $input;
        const originalCount = getQtyBaseline(baselineEl);
        if (nextCount === originalCount || !liveForm) return;
        setQtyBaseline(baselineEl, $mirror, nextCount);
        clampAllInputsToMax();
        paintOptimisticQuantityChange($input, originalCount, nextCount);
        if (window.MegaMacCart && typeof window.MegaMacCart.updateCartQuantitiesFromForm === 'function') {
          window.MegaMacCart.updateCartQuantitiesFromForm(liveForm, { immediate: !!forceImmediate });
        } else if (typeof liveForm.requestSubmit === 'function') {
          liveForm.requestSubmit();
        } else {
          liveForm.submit();
        }
      }

      function applyCartQtyStep($counter, delta) {
        if (!$counter || !delta) return;
        window.MegaMacCart._lastCounterInteractionAt = Date.now();
        const fields = resolveCounterFields($counter);
        if (!fields) return;

        const $input = fields.$input;
        const $primary = fields.$primary;
        const $mirror = fields.$mirror;
        const liveForm = fields.liveForm;
        const key = fields.key;
        const maxAttr = parseInt(($primary || $input).getAttribute('max'), 10);
        const maxQty = Number.isNaN(maxAttr) ? 999 : maxAttr;
        const intent = (window.MegaMacCart._cartQtyIntent = window.MegaMacCart._cartQtyIntent || {});
        const source = $primary || $input;
        let liveCount = key && intent[key] != null ? intent[key] : parseInt(source && source.value, 10);
        if (Number.isNaN(liveCount) || liveCount < 1) liveCount = 1;
        if (liveCount > maxQty) liveCount = maxQty;

        if (delta > 0 && liveCount >= maxQty) {
          showStockLimitToast($input, maxQty);
          return;
        }
        if (delta < 0 && liveCount <= 1) return;

        const nextCount = Math.max(1, Math.min(liveCount + delta, maxQty));
        if (key) intent[key] = nextCount;
        writeCounterCount($input, $primary, $mirror, nextCount);
        submitCounterIfChanged($input, $primary, $mirror, liveForm, nextCount, false);
      }

      window.MegaMacCart.applyCartQtyStep = applyCartQtyStep;

      function initializeCounter($input) {
        if ($input.dataset.cartCounterInit === 'true') return;
        const $counter = $input.closest('[data-cart-item-counter]');
        if (!$counter) return;

        const fields = resolveCounterFields($counter);
        if (!fields) return;
        const $primary = fields.$primary;
        const $mirror = fields.$mirror;
        const liveForm = fields.liveForm;

        // These listeners outlive the section swap now, so the cap has to be
        // read from the DOM each time rather than captured at init.
        function currentMaxQty() {
          const maxAttr = parseInt(($primary || $input).getAttribute('max'), 10);
          return Number.isNaN(maxAttr) ? 999 : maxAttr;
        }

        function normalizeCount(value) {
          const maxQty = currentMaxQty();
          let count = parseInt(value, 10);
          if (Number.isNaN(count) || count < 1) count = 1;
          if (count > maxQty) count = maxQty;
          return count;
        }

        const initialSourceInput = $primary || $input;
        const initialRawValue = initialSourceInput ? initialSourceInput.value : $input.value;
        const currentCount = normalizeCount(initialRawValue);

        writeCounterCount($input, $primary, $mirror, currentCount);
        if (!$primary || !$primary.hasAttribute('data-cart-qty-baseline')) {
          setQtyBaseline($primary || $input, $mirror, currentCount);
        }

        function handleInputChange() {
          window.MegaMacCart._lastCounterInteractionAt = Date.now();
          const maxQty = currentMaxQty();
          let newValue = parseInt($input.value, 10);
          // An emptied box is left alone while the shopper types; blur puts the last quantity back (below).
          if (Number.isNaN(newValue)) return;
          const exceededMax = newValue > maxQty;

          if (newValue < 1) {
            newValue = 1;
          } else if (newValue > maxQty) {
            newValue = maxQty;
          }

          const length = newValue.toString().length;
          const extraWidth = length === 3 ? 0.5 : 0;
          $input.style.setProperty('--cart__item__content__counter__input--width', `${length + extraWidth}ch`);

          writeCounterCount($input, $primary, $mirror, newValue);
          if (fields.key) {
            const intent = (window.MegaMacCart._cartQtyIntent = window.MegaMacCart._cartQtyIntent || {});
            intent[fields.key] = newValue;
          }

          if (exceededMax) {
            showStockLimitToast($input, maxQty);
          }
        }

        function handleBlur() {
          // Nothing readable in the box (emptied, or a stray e, + or -): the last quantity stays, nothing is sent.
          if (Number.isNaN(parseInt($input.value, 10))) {
            const last = getQtyBaseline($primary || $input);
            writeCounterCount($input, $primary, $mirror, last);
            if (fields.key && window.MegaMacCart._cartQtyIntent) window.MegaMacCart._cartQtyIntent[fields.key] = last;
            return;
          }
          handleInputChange();
          const nextCount = normalizeCount($input.value);
          // The <form> is replaced on every swap even though this counter is
          // not; the captured one would be detached and read as empty.
          const $liveForm = document.getElementById('cart-form') || liveForm;
          submitCounterIfChanged($input, $primary, $mirror, $liveForm, nextCount, true);
        }

        function handleFocus() {
          $input.select();
        }

        // Enter commits the quantity like Tab does. Left to the browser, it submits the form through its first
        // submit button, which is Checkout: the shopper typed a number and landed on the checkout page.
        function handleKeydown(event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            $input.blur();
            return;
          }
          // Digits only: a number box still lets e, +, - and . through, and those read as no quantity at all.
          if (event.key.length === 1 && !/[0-9]/.test(event.key) && !event.metaKey && !event.ctrlKey && !event.altKey) {
            event.preventDefault();
          }
        }

        $input.addEventListener('input', handleInputChange);
        $input.addEventListener('blur', handleBlur);
        $input.addEventListener('focus', handleFocus);
        $input.addEventListener('keydown', handleKeydown);

        $input.dataset.cartCounterInit = 'true';
      }

      $inputs.forEach(initializeCounter);

      (function reapplyCartQtyIntent() {
        const intent = window.MegaMacCart._cartQtyIntent;
        const liveForm = document.getElementById('cart-form') || $form;
        if (!intent || !liveForm) return;
        const pending = window.MegaMacCart._newCartPendingUpdates;
        const inflight = window.MegaMacCart._newCartUpdateInFlight;
        let changed = false;
        Object.keys(intent).forEach(function (key) {
          const $primary = liveForm.querySelector('input[name="updates[' + key + ']"]');
          if (!$primary) {
            delete intent[key];
            return;
          }
          const wanted = intent[key];
          const current = parseInt($primary.value, 10);
          if (current === wanted) {
            delete intent[key];
            return;
          }
          const queued = pending && pending[key] != null;
          if (!queued && !inflight) {
            // Server HTML won (stock cap, typed qty, or a finished update).
            delete intent[key];
            return;
          }
          const $item = $primary.closest('[data-cart-item]');
          const $mirror = $item
            ? $item.querySelector('[data-cart-item-counter-mirror][data-cart-item-key="' + key + '"]')
            : null;
          writeCounterCount($primary, $primary, $mirror, wanted);
          setQtyBaseline($primary, $mirror, wanted);
          changed = true;
        });
        if (changed && window.MegaMacCart.updateCartQuantitiesFromForm) {
          window.MegaMacCart.updateCartQuantitiesFromForm(liveForm);
        }
      })();

      if (pendingStockLimitToast) {
        const remaining = pendingStockLimitToast.expiresAt - Date.now();
        if (remaining > 0) {
          mountStockLimitToast(pendingStockLimitToast.text, remaining);
        } else {
          pendingStockLimitToast = null;
        }
      }
    };

    // Run once on initial page load, and can be called again after section replacement.
    window.MegaMacCart.initNewCart(document);

    (function bindCartQtyPointerListeners() {
      if (window.MegaMacCart._cartQtyPointerBound) return;
      window.MegaMacCart._cartQtyPointerBound = true;

      function closestQtyButton(el) {
        if (!el || typeof el.closest !== 'function') return null;
        return el.closest('[data-cart-item-counter-increment]') || el.closest('[data-cart-item-counter-decrement]');
      }

      function counterButtonFromEvent(event) {
        const raw = event && event.target;
        const el = raw && raw.nodeType === 1 ? raw : raw && raw.parentElement;
        return closestQtyButton(el);
      }

      function setQtyBtnPressed($btn, pressed) {
        document
          .querySelectorAll(
            '[data-cart-item-counter-increment].is-pressed, [data-cart-item-counter-decrement].is-pressed'
          )
          .forEach(function (el) {
            if (el !== $btn) el.classList.remove('is-pressed');
          });
        if (!$btn) return;
        $btn.classList.toggle('is-pressed', !!pressed);
      }

      // Counter nodes survive the section swap (see swapNewCartFromDoc), so a
      // tap always lands on a connected button and `click` is the single
      // source of truth for stepping — on mouse, touch and keyboard alike.
      // The buttons are real <button> elements, so Enter/Space activate them
      // natively and need no separate keydown path. `touch-action:
      // manipulation` on the counter removes the tap delay.
      document.addEventListener(
        'click',
        function onCartQtyClick(event) {
          const $btn = counterButtonFromEvent(event);
          if (!$btn) return;
          const $counter = $btn.closest('[data-cart-item-counter]');
          if (!$counter) return;
          const apply = window.MegaMacCart && window.MegaMacCart.applyCartQtyStep;
          if (typeof apply !== 'function') return;
          apply($counter, $btn.hasAttribute('data-cart-item-counter-increment') ? 1 : -1);
        },
        true
      );

      // Press feedback only — iOS does not reliably paint :active for taps
      // that do not scroll.
      document.addEventListener(
        'touchstart',
        function onCartQtyTouchStart(event) {
          const $btn = counterButtonFromEvent(event);
          if ($btn) setQtyBtnPressed($btn, true);
        },
        { capture: true, passive: true }
      );

      document.addEventListener(
        'touchend',
        function onCartQtyTouchEnd(event) {
          const $btn = counterButtonFromEvent(event);
          if (!$btn) return;
          window.setTimeout(function () {
            $btn.classList.remove('is-pressed');
          }, 80);
        },
        { capture: true, passive: true }
      );

      document.addEventListener(
        'touchcancel',
        function onCartQtyTouchCancel() {
          setQtyBtnPressed(null, false);
        },
        { capture: true, passive: true }
      );
    })();

    (function removeUndo() {
      const UNDO_STORAGE_KEY = 'cartUndoQueue';

      // The undo text comes from a data attribute whose title was escaped twice (by `t` and by `escape`).
      function decodeUndoText(text) {
        const el = document.createElement('textarea');
        el.innerHTML = String(text || '');
        return el.value;
      }
      const UNDO_DURATION = 15000;

      if (window.MegaMacCart._undoListenerBound) return;
      window.MegaMacCart._undoListenerBound = true;

      // Removes still waiting on Shopify, by variant id: { row, promise, undone }. The row is hidden (not
      // removed) until the section re-renders, so an undo pressed in that window can show it again at once.
      const pendingRemovals = new Map();
      const rowRemovalAnimations = new Map();
      const noticeAnimations = new WeakMap();
      const ROW_REMOVAL_ANIMATION_MS = 550;
      const ROW_RESTORATION_ANIMATION_MS = 400;
      const STACK_REPOSITION_ANIMATION_MS = 450;

      function cartStackChildren(excludedRow) {
        const wrapper = document.querySelector('#cart-form .cart__items-wrapper');
        if (!wrapper) return [];
        return Array.from(wrapper.children).filter(function (child) {
          if (child === excludedRow || child.style.display === 'none') return false;
          return true;
        });
      }

      function captureCartStackPositions(excludedRow) {
        const positions = new Map();
        cartStackChildren(excludedRow).forEach(function (element) {
          positions.set(element, element.getBoundingClientRect().top);
        });
        return positions;
      }

      function animateCartStackPositionChanges(positions) {
        positions.forEach(function (previousTop, element) {
          if (!element.isConnected || element.style.display === 'none') return;
          animateCartStackPosition(element, previousTop);
        });
      }

      function animateCartNoticeIn(toast) {
        const animation = toast.animate(
          [
            { opacity: 0, transform: 'scale(0.85)' },
            { opacity: 1, transform: 'scale(1)' },
          ],
          {
            duration: ROW_RESTORATION_ANIMATION_MS,
            easing: 'cubic-bezier(0.9, 0, 0.1, 1)',
          }
        );
        noticeAnimations.set(toast, animation);
        function clearNoticeEntrance() {
          if (noticeAnimations.get(toast) === animation) noticeAnimations.delete(toast);
        }
        animation.finished.then(clearNoticeEntrance, clearNoticeEntrance);
      }

      function dismissCartNotice(toast) {
        if (!toast || !toast.isConnected || toast.dataset.dismissing === 'true') return;
        toast.dataset.dismissing = 'true';
        // A leaving notice takes no more clicks: its Undo has been used or has lapsed.
        toast.style.pointerEvents = 'none';
        const entrance = noticeAnimations.get(toast);
        const computedStyle = window.getComputedStyle(toast);
        const startFrame = { opacity: computedStyle.opacity, transform: computedStyle.transform };
        if (entrance) entrance.cancel();
        const animation = toast.animate([startFrame, { opacity: 0, transform: 'scale(0.85)' }], {
          duration: ROW_REMOVAL_ANIMATION_MS,
          easing: 'cubic-bezier(0.9, 0, 0.1, 1)',
          fill: 'forwards',
        });
        noticeAnimations.set(toast, animation);
        animation.finished
          .then(function removeCartNotice() {
            if (noticeAnimations.get(toast) !== animation) return;
            noticeAnimations.delete(toast);
            animation.cancel();
            const undoRegion = toast.parentElement;
            animateCartNoticeRegionMutation(undoRegion, function removeNoticeFromRegion() {
              toast.remove();
            });
          })
          .catch(function ignoreCancelledCartNoticeDismissal() {});
      }

      function cancelCartRowRemoval(lineKey) {
        const entry = rowRemovalAnimations.get(lineKey);
        if (!entry) return null;
        const computedStyle = window.getComputedStyle(entry.row);
        const startFrame = { opacity: computedStyle.opacity, transform: computedStyle.transform };
        rowRemovalAnimations.delete(lineKey);
        entry.animation.cancel();
        entry.row.style.pointerEvents = '';
        entry.row.removeAttribute('aria-hidden');
        return startFrame;
      }

      function animateCartRowRestoration(row, startFrame) {
        if (!row) return;
        row.animate([startFrame || { opacity: 0, transform: 'scale(0.85)' }, { opacity: 1, transform: 'scale(1)' }], {
          duration: ROW_RESTORATION_ANIMATION_MS,
          easing: 'cubic-bezier(0.9, 0, 0.1, 1)',
        });
      }

      // `toTop`: an undone line goes to the top, where Shopify puts a re-added line; a remove that failed
      // leaves the row where it was, since Shopify never moved it.
      function restoreCartRow(row, lineKey, toTop) {
        if (!row) return;
        const startFrame = cancelCartRowRemoval(lineKey);
        row.style.display = '';
        if (toTop) moveCartRowToTop(row);
        animateCartRowRestoration(row, startFrame);
      }

      function animateCartRowRemoval(lineKey, row, onRemoved) {
        if (!row || rowRemovalAnimations.has(lineKey)) {
          if (!row && onRemoved) onRemoved();
          return;
        }
        row.style.pointerEvents = 'none';
        row.setAttribute('aria-hidden', 'true');
        const animation = row.animate(
          [
            { opacity: 1, transform: 'scale(1)' },
            { opacity: 0, transform: 'scale(0.85)' },
          ],
          {
            duration: ROW_REMOVAL_ANIMATION_MS,
            easing: 'cubic-bezier(0.9, 0, 0.1, 1)',
            fill: 'forwards',
          }
        );
        const entry = { animation: animation, row: row };
        rowRemovalAnimations.set(lineKey, entry);
        animation.finished
          .then(function finishCartRowRemoval() {
            if (rowRemovalAnimations.get(lineKey) !== entry) return;
            rowRemovalAnimations.delete(lineKey);
            const positionsBefore = captureCartStackPositions(row);
            animation.cancel();
            row.style.display = 'none';
            row.style.pointerEvents = '';
            row.removeAttribute('aria-hidden');
            animateCartStackPositionChanges(positionsBefore);
            if (onRemoved) onRemoved();
          })
          .catch(function ignoreCancelledCartRowRemoval() {});
      }

      // What a remove took off the page, by variant id, kept for as long as its undo is offered. Undo puts it
      // straight back instead of waiting for Shopify: a copy of the row, or, when it was the last item and the page
      // has switched to the empty cart, a copy of the whole cart section.
      const removedSnapshots = new Map();

      function findCartRow(lineKey) {
        if (!lineKey) return null;
        const input = document.querySelector('#cart-form [data-cart-item-key="' + CSS.escape(lineKey) + '"]');
        return input ? input.closest('[data-cart-item]') : null;
      }

      function isShownRow(row) {
        return row.style.display !== 'none';
      }

      function saveRemovedSnapshot(variantId, lineKey, $item, cartForm) {
        if (!$item) return;
        const rows = Array.from(cartForm.querySelectorAll('[data-cart-item]')).filter(isShownRow);
        const others = rows.filter(function (row) {
          return row !== $item;
        });
        const sectionWrapper = cartForm.closest('[id^="shopify-section-"]');

        const snapshot = {
          lineKey: lineKey,
          // A copy, not the row itself: each cart re-render moves the live row's quantity pickers into the new
          // render (and drops them when the line is gone), which left the restored row without one.
          row: $item.cloneNode(true),
          // Taken before the row is hidden, so the copy shows it.
          section: !others.length && sectionWrapper ? sectionWrapper.cloneNode(true) : null,
          timer: null,
        };

        const key = String(variantId);
        const previous = removedSnapshots.get(key);
        if (previous) window.clearTimeout(previous.timer);
        snapshot.timer = window.setTimeout(function () {
          if (removedSnapshots.get(key) === snapshot) removedSnapshots.delete(key);
        }, UNDO_DURATION + 1000);
        removedSnapshots.set(key, snapshot);
      }

      // Shows a removed item again at once. Shopify's reply then re-renders the cart for real.
      // Returns 'row' when the row copy went back, 'section' when the whole cart section did, else ''.
      function restoreRemovedSnapshot(variantId) {
        const key = String(variantId);
        const snapshot = removedSnapshots.get(key);
        if (!snapshot) return '';
        removedSnapshots.delete(key);
        window.clearTimeout(snapshot.timer);

        if (findCartRow(snapshot.lineKey)) return '';

        const row = snapshot.row;
        const list = document.querySelector('#cart-form .cart__items-wrapper');
        if (list) {
          clearInitFlags(row);
          const $copyImg = row.querySelector('img.cart__item__img');
          const $heldImg =
            $copyImg && typeof window.MegaMacCart.takeHeldCartImage === 'function'
              ? window.MegaMacCart.takeHeldCartImage(snapshot.lineKey, $copyImg.getAttribute('src') || '')
              : null;
          if ($heldImg) $copyImg.replaceWith($heldImg);
          // At the top, where Shopify puts a re-added line.
          const firstRow = list.querySelector('[data-cart-item]');
          const shipping = list.querySelector('[data-cart-shipping-progress-panel]');
          if (firstRow) firstRow.before(row);
          else if (shipping) shipping.before(row);
          else list.appendChild(row);
          animateCartRowRestoration(row);
          // Wire up the copy's quantity picker like any freshly rendered row.
          if (typeof window.MegaMacCart.initNewCart === 'function') window.MegaMacCart.initNewCart(document);
          return 'row';
        }

        // Empty cart: put back the page as it was, minus its old undo messages, then redraw the live ones into it.
        const section = snapshot.section;
        const current = section && document.getElementById(section.id);
        if (!current) return '';
        const copiedRow = findCartRowIn(section, snapshot.lineKey);
        if (copiedRow) copiedRow.style.display = '';
        section.querySelectorAll('[data-cart-undo], [data-cart-stock-toast]').forEach(function (toast) {
          toast.remove();
        });
        clearInitFlags(section);
        current.replaceWith(section);
        animateCartRowRestoration(copiedRow);
        // The copy's picture is a fresh element; use the parked original so it doesn't blink in.
        const $sectionImg = copiedRow ? copiedRow.querySelector('img.cart__item__img') : null;
        const $parkedImg =
          $sectionImg && typeof window.MegaMacCart.takeHeldCartImage === 'function'
            ? window.MegaMacCart.takeHeldCartImage(snapshot.lineKey, $sectionImg.getAttribute('src') || '')
            : null;
        if ($parkedImg) $sectionImg.replaceWith($parkedImg);
        afterNewCartSectionSwap();
        return 'section';
      }

      // For removes made from the header cart panel (see previewLineRemoved / previewLineRestored above).
      window.MegaMacCart.savePageRemovalSnapshot = function savePageRemovalSnapshot(lineKey, $item) {
        const cartForm = document.getElementById('cart-form');
        if (!cartForm || !$item) return;
        const removeLink = $item.querySelector('[data-cart-remove]');
        const variantId = (removeLink && removeLink.getAttribute('data-cart-variant-id')) || lineKey;
        saveRemovedSnapshot(variantId, lineKey, $item, cartForm);
      };

      window.MegaMacCart.restorePageRemovalSnapshot = function restorePageRemovalSnapshot(lineKey) {
        let found = '';
        removedSnapshots.forEach(function (snapshot, key) {
          if (snapshot.lineKey === lineKey) found = key;
        });
        return found ? restoreRemovedSnapshot(found) : '';
      };

      // A copy has the "already set up" flags but none of the listeners; clear them so setup runs again.
      function clearInitFlags(root) {
        [root].concat(Array.from(root.querySelectorAll('*'))).forEach(function (el) {
          Array.from(el.attributes).forEach(function (attr) {
            if (/^data-.+-init$/.test(attr.name)) el.removeAttribute(attr.name);
          });
        });
      }

      function findCartRowIn(root, lineKey) {
        const input = root.querySelector('[data-cart-item-key="' + CSS.escape(lineKey) + '"]');
        return input ? input.closest('[data-cart-item]') : null;
      }

      function sectionsBody(body) {
        const sectionId = getNewCartSectionId();
        if (!sectionId) return body;
        return Object.assign({}, body, { sections: sectionId, sections_url: window.location.pathname });
      }

      function sectionHtmlFrom(response) {
        const sectionId = getNewCartSectionId();
        return (response && response.sections && sectionId && response.sections[sectionId]) || '';
      }

      function getUndoNodes() {
        const undoRegion = document.querySelector('[data-cart-undo-region]');
        const template = document.getElementById('cart-undo-template');
        return { undoRegion: undoRegion, template: template };
      }

      function loadQueue() {
        try {
          const raw = window.localStorage.getItem(UNDO_STORAGE_KEY);
          if (!raw) return [];
          const data = JSON.parse(raw);
          if (!Array.isArray(data)) return [];
          const now = Date.now();
          return data.filter((item) => item.expiresAt && item.expiresAt > now);
        } catch (e) {
          return [];
        }
      }

      let queue = loadQueue();

      function saveQueue() {
        try {
          if (!queue.length) {
            window.localStorage.removeItem(UNDO_STORAGE_KEY);
          } else {
            window.localStorage.setItem(UNDO_STORAGE_KEY, JSON.stringify(queue));
          }
        } catch (e) {}
      }

      function addToQueue(entry) {
        queue.push(entry);
        saveQueue();
      }

      function removeFromQueue(id) {
        queue = queue.filter((item) => item.id !== id);
        saveQueue();
      }

      function createToast(entry, remainingMs, undoRegion, template, animateIn) {
        if (!undoRegion || !template) return;

        const fragment = template.content.cloneNode(true);
        const toast = fragment.querySelector('[data-cart-undo]');
        const textEl = toast.querySelector('[data-cart-undo-text]');
        const undoBtn = toast.querySelector('[data-cart-undo-btn]');
        const closeBtn = toast.querySelector('[data-cart-undo-close]');

        textEl.textContent = decodeUndoText(entry.message);
        toast.setAttribute('data-cart-undo-variant', String(entry.variantId));

        const timeoutMs = typeof remainingMs === 'number' ? remainingMs : UNDO_DURATION;
        const timeoutId = window.setTimeout(function () {
          // Remove from storage first so it can't be re-rendered during any refresh.
          removeFromQueue(entry.id);
          dismissCartNotice(toast);
        }, timeoutMs);

        function cleanup() {
          window.clearTimeout(timeoutId);
          // Remove from storage immediately so it can't be re-rendered during refresh.
          removeFromQueue(entry.id);
          dismissCartNotice(toast);
        }

        undoBtn.addEventListener('click', function () {
          window.clearTimeout(timeoutId);

          // Removed from the header cart panel: let the panel undo it (it waits for its own remove to land, and
          // updates this page too). Falls through when the panel no longer has it, e.g. after a reload.
          if (
            entry.owner === 'panel' &&
            window.MegaMacCart &&
            typeof window.MegaMacCart.undoPanelRemoval === 'function' &&
            window.MegaMacCart.undoPanelRemoval(entry.variantId)
          ) {
            cleanup();
            return;
          }

          // Close the copy of this message in the header cart panel.
          if (window.MegaMacCart && typeof window.MegaMacCart.dismissPanelUndo === 'function') {
            window.MegaMacCart.dismissPanelUndo(entry.variantId);
          }

          // Disable the button so a second click cannot add the item twice.
          if (undoBtn) {
            undoBtn.setAttribute('aria-disabled', 'true');
            undoBtn.disabled = true;
            undoBtn.style.pointerEvents = 'none';
          }

          const restoreQty = Number.isFinite(entry.quantity) ? entry.quantity : 0;
          const restoreCents = parseCartCents(entry.unitCents);
          const cartForm = document.getElementById('cart-form');
          if (cartForm && restoreQty > 0 && restoreCents != null) {
            paintOptimisticSubtotal(restoreQty, restoreCents);
            paintOptimisticItemCount(restoreQty);
          }
          markNewCartSummaryPending(true);

          // The remove may still be in flight, with its row only hidden: show it again now, and re-add only once
          // the remove has landed so the add can't be undone by it.
          // Dismiss now, as the row comes back: waiting for Shopify left it on screen after the item was back.
          // First, because it also takes it out of storage, so no re-render (including the restore below) redraws it.
          cleanup();

          const pendingRemoval = pendingRemovals.get(String(entry.variantId));
          if (pendingRemoval) pendingRemoval.undone = true;
          if (pendingRemoval && pendingRemoval.row && pendingRemoval.row.isConnected) {
            restoreCartRow(pendingRemoval.row, pendingRemoval.lineKey, true);
            // The remove disabled the row's quantity box (so a checkout post can't carry the line); the row is
            // back, so it must work again, and it is carried into every later re-render as it is.
            pendingRemoval.row.querySelectorAll('input[name^="updates["]').forEach(function ($qty) {
              $qty.disabled = false;
            });
            removedSnapshots.delete(String(entry.variantId));
          } else {
            // The remove has finished and the cart has re-rendered without the row.
            restoreRemovedSnapshot(entry.variantId);
          }
          // Show it again in the panel too, straight away.
          if (window.MegaMacCart && typeof window.MegaMacCart.panelPreviewRestore === 'function') {
            window.MegaMacCart.panelPreviewRestore(entry.variantId);
          }

          const readd = Promise.resolve(pendingRemoval && pendingRemoval.promise)
            .catch(function () {})
            .then(function () {
              return queuedCartFetch('/cart/add.js', sectionsBody({ id: entry.variantId, quantity: entry.quantity }));
            })
            .then(function (res) {
              if (!res.ok) throw new Error('Cart add failed');
              return res.json();
            })
            .then(function (addedItem) {
              const sectionHtml = sectionHtmlFrom(addedItem);
              if (addedItem) delete addedItem.sections;
              const seqAt = window.MegaMacCart.noteCartMutation();
              const emitP =
                window.MegaMacCart && typeof window.MegaMacCart.fetchCartAndEmit === 'function'
                  ? window.MegaMacCart.fetchCartAndEmit()
                  : Promise.resolve();

              if (window.MegaMacCart && typeof window.MegaMacCart.refreshNewCartSection === 'function') {
                return Promise.all([
                  emitP,
                  window.MegaMacCart.refreshNewCartSection(
                    window.MegaMacCart.cartMutationSeq() === seqAt ? sectionHtml : undefined
                  ),
                ])
                  .catch(function fallbackToNullCart() {
                    return [null];
                  })
                  .then(function notifyCartItemRestored(results) {
                    const cart = results && results[0];

                    if (window.MegaMacCart && typeof window.MegaMacCart.emitCartAdded === 'function') {
                      window.MegaMacCart.emitCartAdded(cart, addedItem, entry.quantity, 'undo');
                    }

                    const hasCartUi = !!document.querySelector(
                      '[data-cart-item-counter-input], [data-cart-remove], form#cart-form'
                    );
                    // The cart has items but the page still shows the empty state: a redraw was skipped
                    // because quantity updates were queued, or an older render won. Draw it again.
                    if (cart && cart.item_count > 0 && !hasCartUi) {
                      window.setTimeout(function () {
                        refreshNewCartSection();
                      }, 300);
                    }
                  });
              }

              return Promise.resolve(emitP)
                .catch(function fallbackToNullCart() {
                  return null;
                })
                .then(function notifyCartItemRestored(cart) {
                  if (window.MegaMacCart && typeof window.MegaMacCart.emitCartAdded === 'function') {
                    window.MegaMacCart.emitCartAdded(cart, addedItem, entry.quantity, 'undo');
                  }
                });
            })
            .catch(function () {
              // The re-add failed (e.g. the item sold out meanwhile): show the cart as Shopify has it.
              const emitP =
                window.MegaMacCart && typeof window.MegaMacCart.fetchCartAndEmit === 'function'
                  ? window.MegaMacCart.fetchCartAndEmit()
                  : Promise.resolve();
              return Promise.resolve(emitP)
                .catch(function () {})
                .then(function () {
                  return refreshNewCartSection();
                });
            })
            .finally(function () {
              if (pageReadds.get(String(entry.variantId)) === readd) pageReadds.delete(String(entry.variantId));
            });
          pageReadds.set(String(entry.variantId), readd);
        });

        if (closeBtn) {
          closeBtn.addEventListener('click', function () {
            cleanup();
            if (window.MegaMacCart && typeof window.MegaMacCart.dismissPanelUndo === 'function') {
              window.MegaMacCart.dismissPanelUndo(entry.variantId);
            }
          });
        }

        if (animateIn) insertCartNotice(undoRegion, toast);
        else undoRegion.appendChild(toast);
        if (animateIn) animateCartNoticeIn(toast);
      }

      function renderUndoToastsFromStorage(animatedEntryId) {
        const nodes = getUndoNodes();
        const undoRegion = nodes.undoRegion;
        const template = nodes.template;
        if (!undoRegion || !template) return;

        // Clear any existing toasts before restoring.
        const existing = undoRegion.querySelectorAll('[data-cart-undo]');
        existing.forEach(function (el) {
          el.remove();
        });

        // Refresh our in-memory view of the queue (important when other scripts write to localStorage).
        queue = loadQueue();

        const now = Date.now();
        queue.forEach(function (entry) {
          const remaining = entry.expiresAt - now;
          if (remaining > 0) {
            createToast(entry, remaining, undoRegion, template, entry.id === animatedEntryId);
          } else {
            removeFromQueue(entry.id);
          }
        });
      }

      window.MegaMacCart.renderUndoToasts = renderUndoToastsFromStorage;

      // A re-render for one change can land while another item's remove is still in flight, and would show that
      // item again for a moment. Hide those rows again (and track the new element so undo can reveal it).
      window.MegaMacCart.hidePendingRemovals = function hidePendingRemovals() {
        pendingRemovals.forEach(function (removal) {
          if (removal.undone) return;
          const input = document.querySelector('#cart-form [data-cart-item-key="' + CSS.escape(removal.lineKey) + '"]');
          const row = input && input.closest('[data-cart-item]');
          if (!row) return;
          row.style.display = 'none';
          removal.row = row;
        });
      };

      // If an item is re-added by some other UI (e.g. cart upsell), dismiss any
      // matching undo toast(s) so the user isn't prompted to "undo" something
      // that already happened.
      window.MegaMacCart.dismissUndoForVariant = function dismissUndoForVariant(variantId) {
        if (!variantId) return;
        const variantStr = String(variantId);

        // Refresh our in-memory view first.
        queue = loadQueue();
        const before = queue.length;
        queue = queue.filter(function (entry) {
          return String(entry.variantId) !== variantStr;
        });

        if (queue.length !== before) {
          saveQueue();
          renderUndoToastsFromStorage();
        }
      };

      function storeUndoEntry(payload) {
        const variantId = payload && payload.variantId;
        if (!variantId) return null;

        const quantity = parseInt((payload && payload.quantity) || '1', 10);
        const message = (payload && payload.message) || '';
        const unitCents = parseCartCents(payload && payload.unitCents);

        const now = Date.now();
        const entry = {
          id: String(variantId) + ':' + now,
          variantId: String(variantId),
          quantity: Number.isFinite(quantity) ? quantity : 1,
          message: message,
          createdAt: now,
          expiresAt: now + UNDO_DURATION,
        };
        if (unitCents != null) entry.unitCents = unitCents;
        // 'panel': removed from the header cart panel, which does the undo while it still can.
        if (payload && payload.owner) entry.owner = payload.owner;
        addToQueue(entry);
        return entry;
      }

      // Store an undo entry without immediately rendering the toast.
      // Useful when we want the toast to appear only after the cart DOM refresh finishes.
      window.MegaMacCart.storeUndo = storeUndoEntry;

      // Re-adds from this page's undo messages still on their way to Shopify, by variant id, so the panel can wait
      // for one before removing that item again.
      const pageReadds = new Map();
      window.MegaMacCart.pageReaddInFlight = function pageReaddInFlight(variantId) {
        return pageReadds.get(String(variantId)) || null;
      };

      // Runs the Undo of this page's message for an item, for the copy shown in the header cart panel.
      window.MegaMacCart.undoPageRemoval = function undoPageRemoval(variantId) {
        const btn = document.querySelector(
          '[data-cart-undo][data-cart-undo-variant="' + CSS.escape(String(variantId)) + '"] [data-cart-undo-btn]'
        );
        if (!btn || btn.disabled) return false;
        btn.click();
        return true;
      };

      window.MegaMacCart.enqueueUndo = function enqueueUndo(payload) {
        const entry = storeUndoEntry(payload);
        renderUndoToastsFromStorage(entry && entry.id);
      };

      (function restoreToastsFromStorage() {
        renderUndoToastsFromStorage();
      })();

      document.addEventListener('click', function (event) {
        const target = event.target.closest('[data-cart-remove]');
        if (!target) return;

        const cartForm = document.getElementById('cart-form');
        if (!cartForm || !cartForm.contains(target)) return;

        event.preventDefault();

        const href = target.getAttribute('href') || '';
        let lineKey = '';
        try {
          const url = new URL(href, window.location.origin);
          lineKey = url.searchParams.get('id') || '';
        } catch (_) {}

        const variantId = target.getAttribute('data-cart-variant-id');
        if (!variantId || !lineKey) {
          window.location.href = href;
          return;
        }
        // Already being removed (e.g. a double click).
        if (pendingRemovals.has(String(variantId))) return;

        const quantity = parseInt(target.getAttribute('data-cart-quantity') || '1', 10);
        const message =
          target.getAttribute('data-cart-undo-message') ||
          target.getAttribute('aria-label') ||
          target.textContent.trim();
        const $item = target.closest('[data-cart-item]');
        const unitCents = $item ? parseCartCents($item.getAttribute('data-unit-price-cents')) : null;
        const undoPayload = { variantId: variantId, quantity: quantity, message: message };
        if (unitCents != null) undoPayload.unitCents = unitCents;

        target.setAttribute('aria-disabled', 'true');
        target.style.pointerEvents = 'none';

        // Animate the row out first, then offer Undo once the card has left the stack.
        saveRemovedSnapshot(variantId, lineKey, $item, cartForm);
        const removal = {
          row: $item,
          lineKey: lineKey,
          promise: null,
          undone: false,
          failed: false,
          exitComplete: false,
          reconciling: false,
        };
        let undoShown = false;
        pendingRemovals.set(String(variantId), removal);
        function showRemovalUndo() {
          removal.exitComplete = true;
          if (undoShown || removal.failed || removal.reconciling) return;
          undoShown = true;
          if (window.MegaMacCart && typeof window.MegaMacCart.enqueueUndo === 'function') {
            window.MegaMacCart.enqueueUndo(undoPayload);
          }
          // Show it in the header cart panel too; its Undo comes back to this page's message.
          if (window.MegaMacCart && typeof window.MegaMacCart.showPanelUndo === 'function') {
            window.MegaMacCart.showPanelUndo({ variantId: variantId, message: message });
          }
        }
        animateCartRowRemoval(lineKey, $item, showRemovalUndo);
        // And take the row out of the panel now, so a panel +/- can't target a line that is going.
        if (window.MegaMacCart && typeof window.MegaMacCart.panelPreviewRemove === 'function') {
          window.MegaMacCart.panelPreviewRemove(lineKey);
        }

        const currentItemCount = parseCartCents(cartForm.getAttribute('data-cart-total-item-count'));
        const remainingCount =
          currentItemCount != null && Number.isFinite(quantity) ? currentItemCount - quantity : null;
        if (remainingCount != null && remainingCount > 0 && unitCents != null && quantity > 0) {
          paintOptimisticSubtotal(-quantity, unitCents);
          paintOptimisticItemCount(-quantity);
        }

        markNewCartSummaryPending(true);

        // Cancel any queued quantity updates for this cart so a stale
        // snapshot can't post after the line is removed.
        clearNewCartUpdateDebounce();
        if (window.MegaMacCart._newCartPendingUpdates) {
          delete window.MegaMacCart._newCartPendingUpdates[lineKey];
          if (!Object.keys(window.MegaMacCart._newCartPendingUpdates).length) {
            window.MegaMacCart._newCartPendingUpdates = null;
          }
        }

        // Make sure a checkout form submit can't post this line's quantity
        // while the removal is in flight.
        const $removedInput = cartForm.querySelector('input[name="updates[' + lineKey + ']"]');
        if ($removedInput) $removedInput.disabled = true;

        removal.promise = queuedCartFetch('/cart/change.js', sectionsBody({ id: lineKey, quantity: 0 })).then(function (
          res
        ) {
          if (!res.ok) throw new Error('Cart change failed');
          return res.json();
        });

        removal.promise
          .then(function (cart) {
            // Undo was pressed while this was in flight; it re-adds the line and re-renders the cart itself.
            if (removal.undone) return;

            const sectionHtml = sectionHtmlFrom(cart);
            if (cart) delete cart.sections;
            const seqAt = window.MegaMacCart.noteCartMutation();

            if (window.MegaMacCart && typeof window.MegaMacCart.emitCartUpdated === 'function') {
              window.MegaMacCart.emitCartUpdated(cart);
            }

            if (window.MegaMacCart && typeof window.MegaMacCart.emitCartRemoved === 'function') {
              window.MegaMacCart.emitCartRemoved(cart, variantId, quantity);
            }

            if (window.MegaMacCart._newCartPendingUpdates) {
              return drainNewCartPendingUpdates();
            }

            if (window.MegaMacCart && typeof window.MegaMacCart.refreshNewCartSection === 'function') {
              return window.MegaMacCart.refreshNewCartSection(
                window.MegaMacCart.cartMutationSeq() === seqAt ? sectionHtml : undefined
              );
            }
          })
          .catch(function () {
            // Put the row back and drop its undo before falling back.
            removal.reconciling = true;
            restoreCartRow($item, lineKey, false);
            if (removal.undone) {
              if (window.MegaMacCart && typeof window.MegaMacCart.refreshNewCartSection === 'function') {
                window.MegaMacCart.refreshNewCartSection();
              }
              return;
            }
            // The remove didn't go through, or the line was already gone (removed from the header panel first).
            // Post any other lines' queued quantity changes, then show the cart as Shopify has it. The undo stays
            // only when the item really is gone. Returned so the outer .finally waits before clearing the lock.
            const pending = window.MegaMacCart._newCartPendingUpdates;
            window.MegaMacCart._newCartPendingUpdates = null;
            const flush =
              pending && Object.keys(pending).length
                ? postCartUpdates(pending).catch(function () {})
                : Promise.resolve();
            return flush
              .then(function () {
                return typeof window.MegaMacCart.fetchCartAndEmit === 'function'
                  ? window.MegaMacCart.fetchCartAndEmit()
                  : null;
              })
              .catch(function () {
                return null;
              })
              .then(function (cart) {
                const stillThere =
                  !cart ||
                  (Array.isArray(cart.items) &&
                    cart.items.some(function (item) {
                      return item.key === lineKey;
                    }));
                if (stillThere) {
                  removal.failed = true;
                  if (typeof window.MegaMacCart.dismissUndoForVariant === 'function') {
                    window.MegaMacCart.dismissUndoForVariant(variantId);
                  }
                  if (typeof window.MegaMacCart.dismissPanelUndo === 'function') {
                    window.MegaMacCart.dismissPanelUndo(variantId);
                  }
                } else {
                  removal.reconciling = false;
                  return new Promise(function (resolveExit) {
                    const reconciledRow = findCartRow(lineKey) || ($item && $item.isConnected ? $item : null);
                    animateCartRowRemoval(lineKey, reconciledRow, function () {
                      showRemovalUndo();
                      resolveExit();
                    });
                  }).then(function () {
                    return refreshNewCartSection();
                  });
                }
                return refreshNewCartSection();
              });
          })
          .finally(function () {
            if (pendingRemovals.get(String(variantId)) === removal) pendingRemovals.delete(String(variantId));
            if (removal.failed) {
              const restoredRow = findCartRow(lineKey);
              restoreCartRow(restoredRow, lineKey, false);
              if (restoredRow) {
                restoredRow.querySelectorAll('input[name^="updates["]').forEach(function ($qty) {
                  $qty.disabled = false;
                });
              }
            }
            if (window.MegaMacCart && typeof window.MegaMacCart.panelConfirmRemove === 'function') {
              window.MegaMacCart.panelConfirmRemove(lineKey, removal.failed);
            }
            target.style.pointerEvents = '';
            target.removeAttribute('aria-disabled');
          });
      });
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orbital-p5-hero"] && !Shopify.designMode) return;
  try {
    
  (function orbitalP5Hero() {
    function handleScrollBtnClick(e) {
      const $btn = e.target.closest('[data-orbital-p5-hero-btn]');
      if (!$btn) return;

      const selector = $btn.getAttribute('data-orbital-p5-hero-scroll-target')?.trim();
      if (!selector) return;

      const $target = document.querySelector(selector);
      if (!$target) return;

      const accountForHeader = $btn.getAttribute('data-orbital-p5-hero-account-for-header') === 'true';
      const headerOffset = accountForHeader
        ? parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-group-height'), 10) || 0
        : 0;
      const extraOffset = parseInt($btn.getAttribute('data-orbital-p5-hero-scroll-offset'), 10) || 0;

      window.scrollTo({
        top: $target.getBoundingClientRect().top + window.scrollY - headerOffset - extraOffset,
        behavior: 'smooth',
      });
    }

    document.addEventListener('click', handleScrollBtnClick);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orbital-video-hero"] && !Shopify.designMode) return;
  try {
    
  (function orbitalVideoHero() {
    function handleScrollBtnClick(e) {
      const $btn = e.target.closest('[data-orbital-video-hero-btn]');
      if (!$btn) return;

      const selector = $btn.getAttribute('data-orbital-video-hero-scroll-target')?.trim();
      if (!selector) return;

      const $target = document.querySelector(selector);
      if (!$target) return;

      const accountForHeader = $btn.getAttribute('data-orbital-video-hero-account-for-header') === 'true';
      const headerOffset = accountForHeader
        ? parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-group-height'), 10) || 0
        : 0;
      const extraOffset = parseInt($btn.getAttribute('data-orbital-video-hero-scroll-offset'), 10) || 0;

      window.scrollTo({
        top: $target.getBoundingClientRect().top + window.scrollY - headerOffset - extraOffset,
        behavior: 'smooth',
      });
    }

    document.addEventListener('click', handleScrollBtnClick);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-hero"] && !Shopify.designMode) return;
  try {
    
  (function parallaxHero() {
    const parallaxHeroes = Array.from(document.querySelectorAll('[data-parallax-hero]')).map(function createParallaxHero($parallaxHero) {
      const scrollDistance = Number($parallaxHero.dataset.parallaxScrollDistance);

      return {
        $parallaxHero: $parallaxHero,
        $parallaxWrapper: $parallaxHero.querySelector('[data-parallax-wrapper]') || $parallaxHero,
        parallaxLayers: Array.from($parallaxHero.querySelectorAll('[data-parallax-layer]')).map(function createParallaxLayer($parallaxLayer) {
          const startTop = Number($parallaxLayer.dataset.parallaxStartTop);

          return {
            $parallaxLayer: $parallaxLayer,
            startTop: Number.isFinite(startTop) ? startTop : 0
          };
        }),
        scrollDistance: Number.isFinite(scrollDistance) && scrollDistance > 0 ? scrollDistance : 1,
        stickyStart: 0
      };
    });
    let animationFrameId = null;
    let viewportWidth = window.innerWidth;

    function clampScrollProgress(scrollProgress) {
      return Math.min(Math.max(scrollProgress, 0), 1);
    }

    function updateParallaxLayer(parallaxLayer, scrollProgress) {
      const currentY = parallaxLayer.startTop * (1 - scrollProgress);

      parallaxLayer.$parallaxLayer.style.setProperty('--parallax-current-y', `${currentY}px`);
    }

    function updateParallaxHeroLayout(parallaxHero) {
      const sectionTop = parallaxHero.$parallaxHero.getBoundingClientRect().top + window.scrollY;
      const stickyTop = Number.parseFloat(window.getComputedStyle(parallaxHero.$parallaxWrapper).top) || 0;

      parallaxHero.stickyStart = sectionTop - stickyTop;
    }

    function updateParallaxHeroViewportHeight(parallaxHero) {
      parallaxHero.$parallaxHero.style.setProperty('--parallax-hero-viewport-height', `${window.innerHeight}px`);
    }

    function updateParallaxHeroesViewportHeight() {
      parallaxHeroes.forEach(updateParallaxHeroViewportHeight);
    }

    function updateParallaxHeroesLayout() {
      parallaxHeroes.forEach(updateParallaxHeroLayout);
    }

    function updateParallaxHero(parallaxHero) {
      const scrollProgress = clampScrollProgress((window.scrollY - parallaxHero.stickyStart) / parallaxHero.scrollDistance);

      parallaxHero.parallaxLayers.forEach(function updateCurrentParallaxLayer(parallaxLayer) {
        updateParallaxLayer(parallaxLayer, scrollProgress);
      });
    }

    function updateParallaxHeroes() {
      parallaxHeroes.forEach(updateParallaxHero);
    }

    function requestParallaxUpdate() {
      if (animationFrameId !== null) {
        return;
      }

      animationFrameId = window.requestAnimationFrame(function updateCurrentAnimationFrame() {
        animationFrameId = null;
        updateParallaxHeroes();
      });
    }

    function handleResize() {
      if (window.innerWidth === viewportWidth) {
        return;
      }

      viewportWidth = window.innerWidth;
      updateParallaxHeroesViewportHeight();
      updateParallaxHeroesLayout();
      requestParallaxUpdate();
    }

    updateParallaxHeroesViewportHeight();
    updateParallaxHeroesLayout();
    updateParallaxHeroes();
    window.addEventListener('scroll', requestParallaxUpdate, { passive: true });
    window.addEventListener('resize', handleResize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendation-carousel"] && !Shopify.designMode) return;
  try {
    
  (function loadProductRecommendations() {
    const container = document.querySelector('#ProductRecommendations');
    if (!container) return;

    const productId = container.dataset.productId;
    const sectionId = container.dataset.sectionId;
    const limit = parseInt(container.dataset.limit || '8', 10);
    const baseUrl = container.dataset.recommendationsBaseUrl;

    if (!productId || !sectionId || !baseUrl) return;

    const url =
      baseUrl +
      '?section_id=' +
      encodeURIComponent(sectionId) +
      '&product_id=' +
      encodeURIComponent(productId) +
      '&limit=' +
      encodeURIComponent(limit);

    fetch(url)
      .then(function handleResponse(response) {
        return response.text();
      })
      .then(function handleText(text) {
        const html = document.createElement('div');
        html.innerHTML = text;

        const newTrack = html.querySelector('[data-reccom-product-carousel-track]');
        const currentTrack = container.querySelector('[data-reccom-product-carousel-track]');
        if (!newTrack || !currentTrack) return;

        currentTrack.innerHTML = newTrack.innerHTML;

        document.dispatchEvent(new CustomEvent('product-recommendations:loaded'));
      })
      .catch(function handleError(error) {
        console.error('Product recommendations error', error);
      });
  })();

  (function productCarousel() {
    const $btnPrev = document.querySelector('[data-reccom-product-carousel-btn="prev"]');
    const $btnNext = document.querySelector('[data-reccom-product-carousel-btn="next"]');
    const $track = document.querySelector('[data-reccom-product-carousel-track]');

    if (!$btnPrev || !$btnNext || !$track) return;

    function getMaxScroll() {
      return $track.scrollWidth - $track.clientWidth;
    }

    function updateButtonStates() {
      const scrollLeft = $track.scrollLeft;
      const maxScroll = getMaxScroll();

      $btnPrev.disabled = scrollLeft <= 1;
      $btnNext.disabled = scrollLeft >= maxScroll - 1;
    }

    function applyHeightIfMultilineTitles() {
      const MULTILINE_THRESHOLD = 1.5;

      function isTitleMultiline($title) {
        const computedStyle = getComputedStyle($title);
        const lineHeightValue = computedStyle.lineHeight;
        const fontSize = parseFloat(computedStyle.fontSize) || 16;
        const lineHeight =
          lineHeightValue === 'normal' ? fontSize * 1.2 : parseFloat(lineHeightValue) || fontSize * 1.2;
        const actualHeight = $title.offsetHeight;
        return actualHeight > lineHeight * MULTILINE_THRESHOLD;
      }

      const $titles = $track.querySelectorAll('.product-tile__content__title');
      const hasMultiline = Array.from($titles).some(isTitleMultiline);

      $track.classList.toggle('reccom-product-carousel__track--has-multiline', hasMultiline);
    }

    (function initializeButtonNavigation() {
      function scrollPrev() {
        $track.scrollBy({ left: -300, behavior: 'smooth' });
      }

      function scrollNext() {
        $track.scrollBy({ left: 300, behavior: 'smooth' });
      }

      function handleTrackScroll() {
        updateButtonStates();
      }

      $btnPrev.addEventListener('click', scrollPrev);
      $btnNext.addEventListener('click', scrollNext);
      $track.addEventListener('scroll', handleTrackScroll);

      updateButtonStates();
    })();

    applyHeightIfMultilineTitles();
    window.addEventListener('resize', applyHeightIfMultilineTitles);

    document.addEventListener('product-recommendations:loaded', function handleRecommendationsLoaded() {
      applyHeightIfMultilineTitles();
      updateButtonStates();
    });

    (function initializeDragScrolling() {
      const DRAG_THRESHOLD = 5;
      const DECELERATION = 0.92;
      const MIN_VELOCITY = 0.3;
      const VELOCITY_SAMPLES = 5;
      const MOMENTUM_SCALE = 8;
      const EDGE_PROXIMITY_THRESHOLD = 250;
      const EDGE_DECELERATION_MIN = 0.5;
      const STATIONARY_THRESHOLD_MS = 50;

      let isDown = false;
      let startX = 0;
      let scrollLeft = 0;
      let hasDragged = false;
      let velocityX = 0;
      let lastX = 0;
      let lastTime = 0;
      let animationId = null;
      let velocityHistory = [];

      function calculateEdgeFriction(distanceToEdge) {
        const t = distanceToEdge / EDGE_PROXIMITY_THRESHOLD;
        const easedT = t * t;
        return EDGE_DECELERATION_MIN + (1 - EDGE_DECELERATION_MIN) * easedT;
      }

      function momentumStep() {
        const maxScroll = getMaxScroll();
        const currentScroll = $track.scrollLeft;

        if (Math.abs(velocityX) <= MIN_VELOCITY) {
          animationId = null;
          updateButtonStates();
          return;
        }

        const distanceToStart = currentScroll;
        const distanceToEnd = maxScroll - currentScroll;
        const movingTowardStart = velocityX < 0;
        const movingTowardEnd = velocityX > 0;
        const nearStart = distanceToStart < EDGE_PROXIMITY_THRESHOLD;
        const nearEnd = distanceToEnd < EDGE_PROXIMITY_THRESHOLD;

        if (movingTowardStart && nearStart) {
          velocityX *= calculateEdgeFriction(distanceToStart);
        } else if (movingTowardEnd && nearEnd) {
          velocityX *= calculateEdgeFriction(distanceToEnd);
        } else {
          velocityX *= DECELERATION;
        }

        const newScroll = Math.max(0, Math.min(maxScroll, currentScroll + velocityX));
        $track.scrollLeft = newScroll;

        const atEdge = newScroll <= 0 || newScroll >= maxScroll;
        const lowVelocity = Math.abs(velocityX) < 2;
        if (atEdge && lowVelocity) {
          velocityX = 0;
        }

        if (Math.abs(velocityX) > MIN_VELOCITY) {
          animationId = requestAnimationFrame(momentumStep);
        }

        updateButtonStates();
      }

      function applyMomentum() {
        if (animationId) {
          cancelAnimationFrame(animationId);
        }
        animationId = requestAnimationFrame(momentumStep);
      }

      function calculateAverageVelocity() {
        if (velocityHistory.length === 0) return 0;
        const sum = velocityHistory.reduce(function addVelocity(a, b) {
          return a + b;
        }, 0);
        return sum / velocityHistory.length;
      }

      function startDragging(e) {
        if (animationId) {
          cancelAnimationFrame(animationId);
          animationId = null;
        }

        isDown = true;
        hasDragged = false;
        velocityX = 0;
        velocityHistory = [];
        $track.style.cursor = 'grabbing';
        $track.classList.add('reccom-product-carousel__track--dragging');
        startX = e.pageX - $track.offsetLeft;
        lastX = startX;
        lastTime = performance.now();
        scrollLeft = $track.scrollLeft;
        e.preventDefault();

        document.addEventListener('mouseup', stopDragging);
        document.addEventListener('mousemove', handleDragMove);
      }

      function stopDragging() {
        if (!isDown) return;

        document.removeEventListener('mouseup', stopDragging);
        document.removeEventListener('mousemove', handleDragMove);

        isDown = false;
        $track.style.cursor = 'grab';
        $track.classList.remove('reccom-product-carousel__track--dragging');

        const timeSinceLastMove = performance.now() - lastTime;
        const isStationary = timeSinceLastMove > STATIONARY_THRESHOLD_MS;

        if (isStationary) {
          velocityX = 0;
          return;
        }

        velocityX = calculateAverageVelocity() * MOMENTUM_SCALE;

        if (Math.abs(velocityX) > MIN_VELOCITY) {
          applyMomentum();
        }
      }

      function handleDragMove(e) {
        if (!isDown) return;
        e.preventDefault();

        const currentTime = performance.now();
        const x = e.pageX - $track.offsetLeft;
        const walk = x - startX;

        if (Math.abs(walk) > DRAG_THRESHOLD) {
          hasDragged = true;
        }

        const timeDelta = currentTime - lastTime;
        if (timeDelta > 0) {
          const instantVelocity = (lastX - x) / timeDelta;
          velocityHistory.push(instantVelocity);
          if (velocityHistory.length > VELOCITY_SAMPLES) {
            velocityHistory.shift();
          }
        }

        lastX = x;
        lastTime = currentTime;

        const maxScroll = getMaxScroll();
        const targetScroll = scrollLeft - walk;
        $track.scrollLeft = Math.max(0, Math.min(maxScroll, targetScroll));

        updateButtonStates();
      }

      function preventClickAfterDrag(e) {
        if (hasDragged) {
          e.preventDefault();
          e.stopPropagation();
        }
      }

      function preventLinkDrag(e) {
        e.preventDefault();
      }

      function setupLinkDragPrevention() {
        const $links = $track.querySelectorAll('a');
        $links.forEach(function attachPreventDrag($link) {
          $link.addEventListener('dragstart', preventLinkDrag);
        });
      }

      setupLinkDragPrevention();
      $track.addEventListener('mousedown', startDragging);
      $track.addEventListener('click', preventClickAfterDrag, true);

      document.addEventListener('product-recommendations:loaded', setupLinkDragPrevention);
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function product() {
    (function quantityCounter() {
      const $counter = document.querySelector('[data-product-info-counter]');
      const $input = document.querySelector('[data-product-info-counter-input]');
      const $incrementBtn = document.querySelector('[data-product-info-counter-increment]');
      const $decrementBtn = document.querySelector('[data-product-info-counter-decrement]');

      if (!$counter || !$input || !$incrementBtn || !$decrementBtn) return;

      let currentCount = parseInt($input.value, 10);

      // When overselling is off, the shopper can add at most the stock minus what is already in the cart.
      // The in-cart figure is rendered with the page and kept up to date from cart events after an add.
      const stockLimited = $input.getAttribute('data-stock-limited') === 'true';
      const stockQty = parseInt($input.getAttribute('data-stock-qty') || '0', 10) || 0;
      let inCartQty = parseInt($input.getAttribute('data-in-cart-qty') || '0', 10) || 0;
      const $form = $input.closest('form');

      function maxQty() {
        return stockLimited ? Math.max(0, stockQty - inCartQty) : 999;
      }

      function syncLimit() {
        const max = maxQty();
        $input.max = String(Math.max(1, max));
        // Off at the cap, but still clickable so it can answer; hovering it says why ("Only N available").
        const atCap = currentCount >= max;
        $incrementBtn.setAttribute('aria-disabled', atCap ? 'true' : 'false');
        $incrementBtn.title = stockLimited && atCap ? $input.getAttribute('data-stock-title') || '' : '';
      }

      function updateCount(newCount) {
        currentCount = newCount;
        $input.value = currentCount;
        $input.setAttribute('value', currentCount);
        const length = currentCount.toString().length;
        $input.setAttribute('size', length);
        const extraWidth = length === 3 ? 0.5 : 0;
        $input.style.setProperty('--product__info__counter__input--width', `${length + extraWidth}ch`);
        syncLimit();
      }

      function handleIncrement() {
        if (currentCount >= maxQty()) return;
        updateCount(currentCount + 1);
      }

      function handleDecrement() {
        if (currentCount <= 1) return;
        updateCount(currentCount - 1);
      }

      function handleInputChange(event) {
        let newValue = parseInt($input.value, 10);
        const max = Math.max(1, maxQty());
        // Nothing readable (an emptied box, or a stray e, + or -): left alone while typing, and the last
        // quantity comes back when the box loses focus.
        if (isNaN(newValue)) {
          if (event && event.type === 'blur') updateCount(currentCount);
          return;
        }
        if (newValue < 1) {
          newValue = 1;
        } else if (newValue > max) {
          newValue = max;
        }
        updateCount(newValue);
      }

      // Digits only: a number box still lets e, +, - and . through. Enter submits the add form straight from the
      // box, before any blur, so an emptied box gets its last quantity back first rather than sending a blank.
      function handleKeydown(event) {
        if (event.key === 'Enter') {
          if (isNaN(parseInt($input.value, 10))) updateCount(currentCount);
          return;
        }
        if (event.key.length === 1 && !/[0-9]/.test(event.key) && !event.metaKey && !event.ctrlKey && !event.altKey) {
          event.preventDefault();
        }
      }

      function handleFocus() {
        $input.select();
      }

      // Nothing left to add (the stock is already in the cart): stop the submit (the add-to-cart script honours
      // a prevented submit) and open the cart panel on that line, with "Only N available", so the click is
      // answered rather than swallowed.
      function blockSubmitWhenNoneLeft(event) {
        if (!stockLimited || maxQty() > 0) return;
        event.preventDefault();
        const variantId = $form && $form.querySelector('input[name="id"]') ? $form.querySelector('input[name="id"]').value : '';
        if (window.MegaMacCart && typeof window.MegaMacCart.showPanelStockLimit === 'function') {
          window.MegaMacCart.showPanelStockLimit(variantId, stockQty);
        }
      }

      $incrementBtn.addEventListener('click', handleIncrement);
      $decrementBtn.addEventListener('click', handleDecrement);
      $input.addEventListener('input', handleInputChange);
      $input.addEventListener('blur', handleInputChange);
      $input.addEventListener('focus', handleFocus);
      $input.addEventListener('keydown', handleKeydown);
      if ($form) $form.addEventListener('submit', blockSubmitWhenNoneLeft, true);

      document.addEventListener('megamac:cart:updated', function onCartUpdated(event) {
        const cart = event && event.detail && event.detail.cart;
        const variantId = $form && $form.querySelector('input[name="id"]') ? $form.querySelector('input[name="id"]').value : '';
        if (!cart || !Array.isArray(cart.items) || !variantId) return;
        inCartQty = cart.items.reduce(function (sum, item) {
          return String(item.variant_id) === String(variantId) ? sum + (item.quantity || 0) : sum;
        }, 0);
        if (currentCount > Math.max(1, maxQty())) updateCount(Math.max(1, maxQty()));
        else syncLimit();
      });

      syncLimit();
    })();

    (function colourPickerDragToScroll() {
      const DRAG_THRESHOLD = 5;
      const SCROLL_MULTIPLIER = 1;
      const $colourPicker = document.querySelector('[data-colour-picker-drag]');

      if (!$colourPicker) return;

      let isDown = false;
      let startX;
      let scrollLeft;
      let hasDragged = false;

      function preventLinkDragBehavior() {
        const $labels = $colourPicker.querySelectorAll('a, label');
        $labels.forEach(function disableLabelDrag($label) {
          $label.addEventListener('dragstart', function preventDragStart(e) {
            e.preventDefault();
          });
        });
      }

      function startDragging(e) {
        isDown = true;
        hasDragged = false;
        startX = e.pageX - $colourPicker.offsetLeft;
        scrollLeft = $colourPicker.scrollLeft;
        e.preventDefault();
      }

      function stopDragging() {
        if (isDown) {
          isDown = false;
        }
      }

      function handleDragMove(e) {
        if (!isDown) return;
        e.preventDefault();

        const x = e.pageX - $colourPicker.offsetLeft;
        const walk = (x - startX) * SCROLL_MULTIPLIER;

        if (Math.abs(walk) > DRAG_THRESHOLD) {
          hasDragged = true;
        }

        $colourPicker.scrollLeft = scrollLeft - walk;
      }

      function preventClickAfterDrag(e) {
        if (hasDragged) {
          e.preventDefault();
          e.stopPropagation();
        }
      }

      preventLinkDragBehavior();
      $colourPicker.addEventListener('mousedown', startDragging);
      document.addEventListener('mouseup', stopDragging);
      document.addEventListener('mousemove', handleDragMove);
      $colourPicker.addEventListener('click', preventClickAfterDrag, true);
    })();

    (function loadMoreImages() {
      const $gallery = document.querySelector('[data-product-gallery]');
      const $loadMoreBtn = document.querySelector('[data-product-gallery-load-more-btn]');

      if (!$gallery || !$loadMoreBtn) return;

      let isExpanded = false;

      function toggleGallery() {
        isExpanded = !isExpanded;

        const showLessText = $loadMoreBtn.getAttribute('data-text-show-less') || 'show less';
        const loadMoreText = $loadMoreBtn.getAttribute('data-text-load-more') || 'load more';

        if (isExpanded) {
          $gallery.classList.add('show-all');
          $loadMoreBtn.textContent = showLessText;
        } else {
          $gallery.classList.remove('show-all');
          $loadMoreBtn.textContent = loadMoreText;
        }
      }

      $loadMoreBtn.addEventListener('click', toggleGallery);
    })();

    (function shotOnGallerySlider() {
      const SLIDE_INTERVAL_MS = 4000;
      const ACTIVE_SLIDE_CLASS = 'product-shot-on-gallery__slide--active';
      const ACTIVE_DOT_CLASS = 'product-shot-on-gallery__dot--active';
      const $galleries = document.querySelectorAll('[data-product-shot-on-gallery]');

      if ($galleries.length === 0) return;

      function initialiseGallery($gallery) {
        const $slides = $gallery.querySelectorAll('[data-product-shot-on-slide]');
        const $dots = $gallery.querySelectorAll('[data-product-shot-on-dot]');
        if ($slides.length < 2) return;

        let activeIndex = 0;
        let slideInterval = null;

        function setDotPressedState(nextIndex) {
          $dots[activeIndex]?.setAttribute('aria-pressed', 'false');
          $dots[nextIndex]?.setAttribute('aria-pressed', 'true');
        }

        function goToSlide(nextIndex) {
          if (nextIndex === activeIndex || !$slides[nextIndex]) return;

          $slides[activeIndex].classList.remove(ACTIVE_SLIDE_CLASS);
          $dots[activeIndex]?.classList.remove(ACTIVE_DOT_CLASS);
          $slides[nextIndex].classList.add(ACTIVE_SLIDE_CLASS);
          $dots[nextIndex]?.classList.add(ACTIVE_DOT_CLASS);
          setDotPressedState(nextIndex);
          $slides[activeIndex].setAttribute('aria-hidden', 'true');
          $slides[nextIndex].setAttribute('aria-hidden', 'false');
          activeIndex = nextIndex;
        }

        function showNextSlide() {
          const nextIndex = (activeIndex + 1) % $slides.length;
          goToSlide(nextIndex);
        }

        function startSlider() {
          slideInterval = window.setInterval(showNextSlide, SLIDE_INTERVAL_MS);
        }

        function restartSlider() {
          window.clearInterval(slideInterval);
          startSlider();
        }

        function handleDotClick(event) {
          const dotIndex = Number.parseInt(event.currentTarget.getAttribute('data-product-shot-on-dot-index'), 10);
          if (Number.isNaN(dotIndex)) return;

          goToSlide(dotIndex);
          restartSlider();
        }

        $dots.forEach(function bindDotClick($dot) {
          $dot.addEventListener('click', handleDotClick);
        });

        startSlider();
      }

      $galleries.forEach(initialiseGallery);
    })();

    (function adjustSidePanelForAnnouncementBar() {
      const $anyPanel = document.querySelector('[data-product-panel]');

      if (!$anyPanel) return;

      function updateAnnouncementBarHeight() {
        const $announcementBar = document.querySelector('.announcement-bar');
        if ($announcementBar && window.getComputedStyle($announcementBar).display !== 'none') {
          const height = $announcementBar.offsetHeight;
          document.documentElement.style.setProperty('--announcement-bar-height', height + 'px');
        } else {
          document.documentElement.style.setProperty('--announcement-bar-height', '0px');
        }
      }

      updateAnnouncementBarHeight();

      const observer = new MutationObserver(function handleDomMutations(mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'childList' || mutation.type === 'attributes') {
            updateAnnouncementBarHeight();
          }
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
      observer.observe(document.head, { childList: true });
      window.addEventListener('resize', updateAnnouncementBarHeight);
    })();

    (function productSidePanels() {
      const $panels = document.querySelectorAll('[data-product-panel]');
      if ($panels.length === 0) return;

      const $headerGroup = document.querySelector('.header-group');
      const panels = new Map();
      let $activeContainer = null;
      let $triggeringButton = null;

      function updateBodyScroll() {
        const shouldLock = $activeContainer !== null && window.innerWidth <= 1220;
        document.body.classList.toggle('mm-side-panel-locked', shouldLock);
      }

      function handleOutsideClick(e) {
        if (!$activeContainer) return;
        const entry = panels.get($activeContainer.dataset.productPanel);
        if (!entry) return;
        if (entry.$panel.contains(e.target)) return;
        for (const $btn of entry.$btns) {
          if ($btn.contains(e.target)) return;
        }
        closePanel();
      }

      function closePanel() {
        if (!$activeContainer) return;
        $activeContainer.classList.remove('product__info__side-panel-container--active');
        $activeContainer = null;
        document.removeEventListener('click', handleOutsideClick);
        updateBodyScroll();
        const $returnTo = $triggeringButton;
        $triggeringButton = null;
        setTimeout(function () {
          $returnTo?.focus();
        }, 100);
      }

      function openPanel(id) {
        const entry = panels.get(id);
        if (!entry) return;
        if ($activeContainer === entry.$container) return;
        closePanel();
        entry.$container.classList.add('product__info__side-panel-container--active');
        $activeContainer = entry.$container;
        document.addEventListener('click', handleOutsideClick);
        setTimeout(function () {
          entry.$container.querySelector('[data-product-panel-close-btn]')?.focus();
        }, 100);
        updateBodyScroll();
      }

      $panels.forEach(function ($container) {
        const id = $container.dataset.productPanel;
        if (!id) return;

        const $panel = $container.querySelector('.product__info__side-panel');
        if (!$panel) return;

        const $btns = document.querySelectorAll('[data-product-panel-btn="' + id + '"]');
        if ($btns.length === 0) return;

        if ($headerGroup) $headerGroup.appendChild($container);

        panels.set(id, { $container: $container, $panel: $panel, $btns: $btns });

        $btns.forEach(function ($btn) {
          $btn.addEventListener('click', function handleButtonClick(e) {
            // preventDefault and stopPropagation are load-bearing twice over.
            // They stop this click reaching handleOutsideClick and immediately
            // reclosing the panel, AND they stop a trigger placed inside an
            // accordion <label> from toggling that accordion shut. Removing
            // either will break the specs trigger in the Description accordion.
            e.preventDefault();
            e.stopPropagation();
            $triggeringButton = $btn;
            openPanel(id);
          });
        });

        const $closeBtn = $container.querySelector('[data-product-panel-close-btn]');
        if ($closeBtn) {
          $closeBtn.addEventListener('click', function handleCloseClick(e) {
            e.preventDefault();
            e.stopPropagation();
            closePanel();
          });
        }
      });

      document.addEventListener('keydown', function handleEscape(e) {
        if (e.key !== 'Escape') return;
        if (!$activeContainer) return;
        closePanel();
      });
      window.addEventListener('resize', updateBodyScroll);
    })();

    (function dragToScrollMobileGallery() {
      const DRAG_THRESHOLD = 5;
      const SCROLL_MULTIPLIER = 1;
      const MOBILE_BREAKPOINT = 1024;
      const $gallery = document.querySelector('[data-product-gallery]');

      if (!$gallery) return;

      let isDown = false;
      let startX;
      let scrollLeft;
      let hasDragged = false;

      function isMobileViewport() {
        return window.innerWidth <= MOBILE_BREAKPOINT;
      }

      function startDragging(e) {
        if (!isMobileViewport()) return;

        const $activeModelViewer = e.target.closest('model-viewer[camera-controls]');
        if ($activeModelViewer) return;

        isDown = true;
        hasDragged = false;
        startX = e.pageX - $gallery.offsetLeft;
        scrollLeft = $gallery.scrollLeft;
        $gallery.classList.add('is-grabbing');
        e.preventDefault();
      }

      function stopDragging() {
        if (isDown) {
          isDown = false;
          $gallery.classList.remove('is-grabbing');
        }
      }

      function handleDragMove(e) {
        if (!isDown || !isMobileViewport()) return;
        e.preventDefault();

        const x = e.pageX - $gallery.offsetLeft;
        const walk = (x - startX) * SCROLL_MULTIPLIER;

        if (Math.abs(walk) > DRAG_THRESHOLD) {
          hasDragged = true;
        }

        $gallery.scrollLeft = scrollLeft - walk;
      }

      function preventClickAfterDrag(e) {
        if (hasDragged) {
          e.preventDefault();
          e.stopPropagation();
        }
      }

      $gallery.addEventListener('mousedown', startDragging);
      document.addEventListener('mouseup', stopDragging);
      document.addEventListener('mousemove', handleDragMove);
      $gallery.addEventListener('click', preventClickAfterDrag, true);
    })();

    (function customGalleryScrollbar() {
      const MOBILE_BREAKPOINT = 768;
      const $gallery = document.querySelector('[data-product-gallery]');
      const $scrollbar = document.querySelector('[data-product-gallery-scrollbar]');
      const $thumb = document.querySelector('[data-product-gallery-scrollbar-thumb]');

      if (!$gallery || !$scrollbar || !$thumb) return;

      let thumbWidth = 0;
      let trackWidth = 0;
      let maxThumbLeft = 0;
      let isDragging = false;
      let dragStartX = 0;
      let dragStartScrollLeft = 0;

      function isMobileViewport() {
        return window.innerWidth <= MOBILE_BREAKPOINT;
      }

      function updateDimensions() {
        if (!isMobileViewport()) {
          $scrollbar.style.display = 'none';
          return;
        }
        $scrollbar.style.display = '';

        trackWidth = $scrollbar.offsetWidth;
        const scrollWidth = $gallery.scrollWidth;
        const clientWidth = $gallery.clientWidth;

        if (scrollWidth <= clientWidth) {
          $scrollbar.style.visibility = 'hidden';
          return;
        }

        $scrollbar.style.visibility = '';
        const ratio = clientWidth / scrollWidth;
        thumbWidth = Math.max(ratio * trackWidth, 30);
        maxThumbLeft = trackWidth - thumbWidth;
        $thumb.style.width = thumbWidth + 'px';
        updateThumbPosition();
      }

      function updateThumbPosition() {
        const scrollWidth = $gallery.scrollWidth;
        const clientWidth = $gallery.clientWidth;
        const scrollLeft = $gallery.scrollLeft;
        const maxScrollLeft = scrollWidth - clientWidth;

        if (maxScrollLeft <= 0) return;

        const scrollRatio = scrollLeft / maxScrollLeft;
        const thumbLeft = scrollRatio * maxThumbLeft;
        $thumb.style.transform = 'translateX(' + thumbLeft + 'px)';
      }

      function onTrackClick(e) {
        if (e.target === $thumb || !isMobileViewport()) return;
        const rect = $scrollbar.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const clickRatio = (clickX - thumbWidth / 2) / maxThumbLeft;
        const clampedRatio = Math.max(0, Math.min(1, clickRatio));
        const maxScrollLeft = $gallery.scrollWidth - $gallery.clientWidth;
        $gallery.scrollLeft = clampedRatio * maxScrollLeft;
      }

      function onPointerDown(e) {
        if (!isMobileViewport()) return;
        isDragging = true;
        dragStartX = e.clientX || e.touches[0].clientX;
        dragStartScrollLeft = $gallery.scrollLeft;
        $scrollbar.classList.add('is-grabbing');
        e.preventDefault();
      }

      function onPointerMove(e) {
        if (!isDragging) return;
        const clientX = e.clientX || (e.touches && e.touches[0].clientX);
        if (clientX == null) return;
        const delta = clientX - dragStartX;
        const maxScrollLeft = $gallery.scrollWidth - $gallery.clientWidth;
        const scrollDelta = (delta / maxThumbLeft) * maxScrollLeft;
        $gallery.scrollLeft = dragStartScrollLeft + scrollDelta;
      }

      function onPointerUp() {
        isDragging = false;
        $scrollbar.classList.remove('is-grabbing');
      }

      $gallery.addEventListener('scroll', updateThumbPosition, { passive: true });
      window.addEventListener('resize', updateDimensions);
      window.addEventListener('load', updateDimensions);

      $scrollbar.addEventListener('click', onTrackClick);
      $scrollbar.addEventListener('mousedown', onPointerDown);
      $scrollbar.addEventListener('touchstart', onPointerDown, { passive: false });
      document.addEventListener('mousemove', onPointerMove);
      document.addEventListener('touchmove', onPointerMove, { passive: false });
      document.addEventListener('mouseup', onPointerUp);
      document.addEventListener('touchend', onPointerUp);

      updateDimensions();
    })();

    (function modelViewerInteract() {
      const $modelViewers = document.querySelectorAll('[data-product-gallery-model-viewer]');
      if (!$modelViewers.length) return;

      function setupModelViewer($modelViewer) {
        const $modelViewerBtn = $modelViewer.querySelector('[data-product-gallery-model-viewer-btn]');
        if (!$modelViewerBtn) return;

        let isInitialized = false;
        let $customCursor = null;

        function updateCursor(e) {
          if ($customCursor) {
            $customCursor.style.left = e.clientX + 'px';
            $customCursor.style.top = e.clientY + 'px';
          }
        }

        function showCursor() {
          if ($customCursor) $customCursor.style.display = 'block';
        }

        function hideCursor() {
          if ($customCursor) $customCursor.style.display = 'none';
        }

        function activateInteraction(e) {
          if (isInitialized) return;

          const $modelViewerCanvas = $modelViewer.shadowRoot?.querySelector('canvas');
          if (!$modelViewerCanvas) return;

          isInitialized = true;

          $modelViewer.setAttribute('camera-controls', '');
          $modelViewerBtn.style.display = 'none';

          $customCursor = document.createElement('img');
          $customCursor.src = window.modelViewerCursorUrl;
          $customCursor.alt = 'Custom Cursor';
          $customCursor.style.cssText = `
          position: fixed;
          pointer-events: none;
          z-index: 10000;
          width: 32px;
          height: 32px;
          transform: translate(-50%, -50%);
          display: none;
        `;
          document.body.appendChild($customCursor);

          const style = document.createElement('style');
          style.textContent = `
          canvas, .container, #default-ar-button { cursor: none !important; }
          * { cursor: none !important; }
        `;
          $modelViewer.shadowRoot.appendChild(style);
          $modelViewerCanvas.style.setProperty('cursor', 'none', 'important');

          updateCursor(e);
          showCursor();

          $modelViewer.addEventListener('mouseenter', showCursor);
          $modelViewer.addEventListener('mouseleave', hideCursor);
          $modelViewer.addEventListener('mousemove', updateCursor);
        }

        $modelViewer.addEventListener('load', function handleModelViewerLoad() {
          $modelViewerBtn.addEventListener('click', activateInteraction);
        });
      }

      $modelViewers.forEach(setupModelViewer);
    })();

    (function customVideoPlayers() {
      const $videoContainers = document.querySelectorAll('[data-product-gallery-video-container]');
      if (!$videoContainers.length) return;

      let activeDrag = null;

      // One page-level sound setting shared by every gallery video. The <video>
      // elements are rendered muted (browser autoplay rule) but nothing autoplays:
      // playback only ever starts from the shopper's tap on "Play Video", which is a
      // user gesture, so the video is unmuted on that first play and sound is on by
      // default. Muting one video turns the setting off for every video that starts
      // afterwards; only one video plays sound at a time.
      const AUDIO_CHECK_GIVE_UP_SECONDS = 1.5;
      const $allVideos = [];
      let soundOn = true;

      function muteOtherVideos($current) {
        $allVideos.forEach(function muteOther($other) {
          if ($other !== $current && !$other.muted) {
            $other.muted = true;
          }
        });
      }

      function handleSharedPointerMove(e) {
        if (!activeDrag) return;
        activeDrag.hasMoved = true;
        activeDrag.updateVideoTime(e);
      }

      function handleSharedPointerUp() {
        if (!activeDrag) return;

        const drag = activeDrag;
        activeDrag = null;

        if (drag.wasPlayingBeforeDrag) {
          const playPromise = drag.$video.play();
          if (playPromise !== undefined) {
            playPromise.catch(function onResumeError() {
              console.error('Video play was prevented');
            });
          }
        }
        drag.wasPlayingBeforeDrag = false;
      }

      document.addEventListener('pointermove', handleSharedPointerMove);
      document.addEventListener('pointerup', handleSharedPointerUp);

      function setupVideoPlayer($videoContainer) {
        const $video = $videoContainer.querySelector('[data-product-gallery-video]');
        const $videoControls = $videoContainer.querySelector('[data-product-gallery-video-controls-state]');
        const $playOverlayBtn = $videoContainer.querySelector('[data-product-gallery-video-play-overlay-btn]');
        const $playPauseButton = $videoContainer.querySelector('[data-product-gallery-video-play-pause]');
        const $progressBar = $videoContainer.querySelector('[data-product-gallery-video-progress]');
        const $muteButton = $videoContainer.querySelector('[data-product-gallery-video-mute]');

        if (!$video || !$playOverlayBtn || !$playPauseButton || !$progressBar || !$videoControls) return;

        $video.controls = false;
        $progressBar.style.touchAction = 'none';
        $allVideos.push($video);

        let animationFrameId = null;

        const playerState = {
          $video,
          hasMoved: false,
          wasPlayingBeforeDrag: false,
          updateVideoTime: updateVideoTime,
        };

        function setControlsState(state) {
          $videoControls.setAttribute('data-product-gallery-video-controls-state', state);
        }

        setControlsState('visible');

        function firstPlay() {
          const playPromise = $video.play();
          if (playPromise !== undefined) {
            playPromise
              .then(function onFirstPlaySuccess() {
                setControlsState('playing');
              })
              .catch(function onFirstPlayError() {
                console.error('Video play was prevented');
              });
          }
        }

        function togglePlayPause() {
          if ($video.paused || $video.ended) {
            const playPromise = $video.play();
            if (playPromise !== undefined) {
              playPromise
                .then(function onPlaySuccess() {
                  setControlsState('playing');
                })
                .catch(function onPlayError() {
                  console.error('Video play was prevented');
                });
            }
          } else {
            $video.pause();
            setControlsState('paused');
          }
        }

        function setProgressBarMax() {
          $progressBar.setAttribute('max', $video.duration);
        }

        function updateProgressBar() {
          $progressBar.value = $video.currentTime;

          if (!$video.paused && !$video.ended) {
            animationFrameId = requestAnimationFrame(updateProgressBar);
          }
        }

        function startProgressBarAnimation() {
          if (animationFrameId) cancelAnimationFrame(animationFrameId);
          updateProgressBar();
        }

        function stopProgressBarAnimation() {
          if (animationFrameId) {
            cancelAnimationFrame(animationFrameId);
            animationFrameId = null;
          }
        }

        function updateVideoTime(e) {
          if (!Number.isFinite($video.duration) || $video.duration === 0) return;

          const rect = $progressBar.getBoundingClientRect();
          if (rect.width === 0) return;

          const clickX = e.clientX - rect.left;
          const pos = Math.max(0, Math.min(1, clickX / rect.width));
          const newTime = pos * $video.duration;

          $video.currentTime = newTime;
          $progressBar.value = newTime;
        }

        function handleProgressBarClick(e) {
          if (playerState.hasMoved) {
            playerState.hasMoved = false;
            return;
          }
          updateVideoTime(e);
        }

        function handleProgressBarPointerDown(e) {
          playerState.hasMoved = false;
          playerState.wasPlayingBeforeDrag = !$video.paused && !$video.ended;
          activeDrag = playerState;
          if (playerState.wasPlayingBeforeDrag) {
            $video.pause();
          }
          updateVideoTime(e);
          e.preventDefault();
        }

        function handleVideoEnded() {
          setControlsState('paused');
          stopProgressBarAnimation();
          playerState.hasMoved = false;
        }

        function handleSeeked() {
          $progressBar.value = $video.currentTime;
        }

        // --- sound toggle -------------------------------------------------------
        // The button stays hidden until this video is confirmed to carry an audio
        // track. Detection is per browser engine: Firefox exposes mozHasAudio,
        // Safari exposes audioTracks, Chrome only reports decoded audio bytes once
        // playback has started (it decodes audio even while muted).
        let audioCheckDone = false;
        let audioCheckPlayedSeconds = 0;
        let audioCheckLastTime = null;

        function videoHasAudio() {
          if (typeof $video.mozHasAudio === 'boolean') {
            return $video.mozHasAudio;
          }
          if ($video.audioTracks && typeof $video.audioTracks.length === 'number') {
            return $video.audioTracks.length > 0;
          }
          if (typeof $video.webkitAudioDecodedByteCount === 'number') {
            return $video.webkitAudioDecodedByteCount > 0;
          }
          return false;
        }

        function syncMuteButton() {
          if (!$muteButton) return;
          const isMuted = $video.muted;
          const label = isMuted
            ? $muteButton.getAttribute('data-product-gallery-video-mute-label-unmute')
            : $muteButton.getAttribute('data-product-gallery-video-mute-label-mute');

          $muteButton.setAttribute('aria-pressed', isMuted ? 'false' : 'true');
          if (label) $muteButton.setAttribute('aria-label', label);
        }

        function stopAudioCheck() {
          audioCheckDone = true;
          $video.removeEventListener('loadedmetadata', checkForAudio);
          $video.removeEventListener('timeupdate', checkForAudio);
        }

        function checkForAudio() {
          if (audioCheckDone) return;

          if (videoHasAudio()) {
            stopAudioCheck();
            if ($muteButton) {
              syncMuteButton();
              $muteButton.hidden = false;
            }
            return;
          }

          // Give up once roughly 1.5s of real playback has gone by without audio.
          // Accumulate small forward steps only, so a scrub jump does not count.
          const currentTime = $video.currentTime;
          if (audioCheckLastTime !== null) {
            const delta = currentTime - audioCheckLastTime;
            if (delta > 0 && delta < 1) audioCheckPlayedSeconds += delta;
          }
          audioCheckLastTime = currentTime;

          if (audioCheckPlayedSeconds >= AUDIO_CHECK_GIVE_UP_SECONDS) {
            stopAudioCheck();
          }
        }

        function toggleMute() {
          const nextMuted = !$video.muted;
          soundOn = !nextMuted;
          if (soundOn) muteOtherVideos($video);
          $video.muted = nextMuted;
          syncMuteButton();
        }

        function applySoundSettingOnPlay() {
          if (!soundOn) return;
          muteOtherVideos($video);
          if ($video.muted) $video.muted = false;
        }

        if ($video.readyState >= 1) {
          setProgressBarMax();
          checkForAudio();
        }

        $playOverlayBtn.addEventListener('click', firstPlay);
        $video.addEventListener('click', togglePlayPause);
        $playPauseButton.addEventListener('click', togglePlayPause);
        $video.addEventListener('loadedmetadata', setProgressBarMax);
        $video.addEventListener('play', startProgressBarAnimation);
        $video.addEventListener('pause', stopProgressBarAnimation);
        $video.addEventListener('seeked', handleSeeked);
        $progressBar.addEventListener('click', handleProgressBarClick);
        $progressBar.addEventListener('pointerdown', handleProgressBarPointerDown);
        $video.addEventListener('ended', handleVideoEnded);

        if (!audioCheckDone) {
          $video.addEventListener('loadedmetadata', checkForAudio);
          $video.addEventListener('timeupdate', checkForAudio);
        }
        $video.addEventListener('play', applySoundSettingOnPlay);
        $video.addEventListener('volumechange', syncMuteButton);
        if ($muteButton) {
          $muteButton.addEventListener('click', toggleMute);
        }
      }

      $videoContainers.forEach(setupVideoPlayer);
    })();

    (function mobileFixedCTA() {
      const mql = window.matchMedia('(max-width: 768px)');
      const $originalButton = document.querySelector('.product__info__button');
      if (!$originalButton) return;

      const $footer = document.querySelector('.footer-hero');

      const $wrapper = document.createElement('div');
      $wrapper.className = 'product__info__fixed-cta';
      const $clone = $originalButton.cloneNode(true);
      $clone.classList.remove('product__info__button');
      $wrapper.appendChild($clone);
      document.body.appendChild($wrapper);

      $clone.addEventListener('click', function handleCloneClick(e) {
        e.preventDefault();
        $originalButton.click();
      });

      let ticking = false;

      function checkVisibility() {
        if (!mql.matches) {
          $wrapper.classList.remove('product__info__fixed-cta--visible');
          ticking = false;
          return;
        }

        const btnRect = $originalButton.getBoundingClientRect();
        const originalHidden = btnRect.bottom < 0;

        let footerVisible = false;
        if ($footer) {
          const footerRect = $footer.getBoundingClientRect();
          footerVisible = footerRect.top < window.innerHeight;
        }

        if (originalHidden && !footerVisible) {
          $wrapper.classList.add('product__info__fixed-cta--visible');
        } else {
          $wrapper.classList.remove('product__info__fixed-cta--visible');
        }
        ticking = false;
      }

      function onScroll() {
        if (!ticking) {
          requestAnimationFrame(checkVisibility);
          ticking = true;
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      checkVisibility();
    })();

    (function accordionTextSelection() {
      const $productCodeInput = document.getElementById('product__info__details__item2');
      if (!$productCodeInput) return;

      const $label = $productCodeInput.nextElementSibling;
      if (!$label) return;

      const $content = $label.querySelector('.product__info__details__accordion__content');
      if (!$content) return;

      $content.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
      });
    })();

    (function descriptionTextSelection() {
      const $descriptionInput = document.getElementById('product__info__details__item1');
      if (!$descriptionInput) return;

      const $label = $descriptionInput.nextElementSibling;
      if (!$label) return;

      const $content = $label.querySelector('.product__info__details__accordion__content');
      if (!$content) return;

      $content.addEventListener('click', function (e) {
        // The header row is the only thing that should toggle this accordion,
        // matching the Product Code one. Suppress every click on the content —
        // except on interactive elements, because warranty_info is output raw
        // and can contain a link, and the specs trigger lives in here too.
        if (e.target.closest('a, button, input, select, textarea')) return;
        e.preventDefault();
        e.stopPropagation();
      });
    })();

    (function readMoreLink() {
      const $readMore = document.querySelector('[data-read-more-description]');
      if (!$readMore) return;
      const READ_MORE_SCROLL_OFFSET_PX = 24;

      function getDocumentTop($element) {
        let top = 0;
        let $current = $element;

        while ($current) {
          top += $current.offsetTop;
          $current = $current.offsetParent;
        }

        return top;
      }

      function scrollToStickyAreaBottom() {
        const $sticky = document.querySelector('.product__info__sticky');
        if (!$sticky) return;

        const $stickyArea = $sticky.closest('.product-form') || $sticky.parentElement;
        if (!$stickyArea) return;

        const stickyAreaBottom = getDocumentTop($stickyArea) + $stickyArea.offsetHeight;
        const targetScrollTop = Math.max(0, stickyAreaBottom - window.innerHeight + READ_MORE_SCROLL_OFFSET_PX);

        window.scrollTo({ top: targetScrollTop, behavior: 'smooth' });
      }

      function isStickyInfoActive() {
        const $sticky = document.querySelector('.product__info__sticky');
        if (!$sticky) return false;
        if ($sticky.classList.contains('product__info__sticky--disabled')) return false;

        return window.getComputedStyle($sticky).position === 'sticky';
      }

      function getNonStickyScrollOffset() {
        const $mobileHeader = document.querySelector('[data-mobile-header]');
        if (!$mobileHeader) return READ_MORE_SCROLL_OFFSET_PX;

        const mobileHeaderStyles = window.getComputedStyle($mobileHeader);
        if (mobileHeaderStyles.display === 'none' || mobileHeaderStyles.position !== 'fixed') {
          return READ_MORE_SCROLL_OFFSET_PX;
        }

        const mobileHeaderHeight = $mobileHeader.offsetHeight;
        return Math.max(READ_MORE_SCROLL_OFFSET_PX, mobileHeaderHeight + READ_MORE_SCROLL_OFFSET_PX);
      }

      function scrollToDescriptionAccordion() {
        const $checkbox = document.getElementById('product__info__details__item1');
        if (!$checkbox) return;

        const $label = $checkbox.nextElementSibling;
        const $target = $label || $checkbox;
        const scrollOffset = getNonStickyScrollOffset();
        const targetScrollTop = Math.max(0, window.scrollY + $target.getBoundingClientRect().top - scrollOffset);

        window.scrollTo({ top: targetScrollTop, behavior: 'smooth' });
      }

      function scrollToReadMoreDestination() {
        if (isStickyInfoActive()) {
          scrollToStickyAreaBottom();
          return;
        }

        scrollToDescriptionAccordion();
      }

      function handleReadMoreClick(e) {
        e.preventDefault();
        const $checkbox = document.getElementById('product__info__details__item1');
        if (!$checkbox) {
          scrollToReadMoreDestination();
          return;
        }

        const $details = $checkbox.closest('.product__info__details');
        if ($details) {
          const $allInputs = $details.querySelectorAll('.product__info__details__input');
          $allInputs.forEach(function closeDetailsInput($input) {
            $input.checked = false;
          });
        }

        $checkbox.checked = true;
        scrollToReadMoreDestination();
      }

      $readMore.addEventListener('click', handleReadMoreClick);
    })();

    (function copySkuToClipboard() {
      const $copyBtn = document.querySelector('[data-copy-sku]');
      if (!$copyBtn) return;

      const $iconDefault = $copyBtn.querySelector('[data-copy-icon-default]');
      const $iconCheck = $copyBtn.querySelector('[data-copy-icon-check]');
      const FEEDBACK_DURATION_MS = 2000;
      let feedbackTimer = 0;

      function showCopiedFeedback() {
        if (!$iconDefault || !$iconCheck) return;
        $iconDefault.style.display = 'none';
        $iconCheck.style.display = '';
        $copyBtn.classList.add('product__info__details__copy-btn--copied');
        clearTimeout(feedbackTimer);
        feedbackTimer = setTimeout(function restoreCopyIcon() {
          $iconCheck.style.display = 'none';
          $iconDefault.style.display = '';
          $copyBtn.classList.remove('product__info__details__copy-btn--copied');
        }, FEEDBACK_DURATION_MS);
      }

      function handleCopyClick(event) {
        event.preventDefault();
        event.stopPropagation();
        const skuValue = $copyBtn.getAttribute('data-sku-value');
        navigator.clipboard
          .writeText(skuValue)
          .then(showCopiedFeedback)
          .catch(function onCopyError() {});
      }

      $copyBtn.addEventListener('click', handleCopyClick);
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function search() {
    (function searchInputExpander() {
      const $form = document.querySelector('.search__row__form');
      if (!$form) return;

      const $wrapper = $form.querySelector('[data-search-input-wrapper]');
      const $input = $form.querySelector('[data-search-input]');
      const $close = $form.querySelector('[data-search-close]');
      if (!$wrapper) return;
      if (!$input) return;

      const EXPANDED_CLASS = 'search__row__form__input-wrapper--expanded';

      function expand() {
        if (!$wrapper.classList.contains(EXPANDED_CLASS)) {
          $wrapper.style.minWidth = $wrapper.offsetWidth + 'px';
          $wrapper.classList.add(EXPANDED_CLASS);
          $input.focus();
          if ($close) $close.classList.add('search__row__form__close--visible');
        }
      }

      function collapse() {
        if ($close) $close.classList.remove('search__row__form__close--visible');
        $wrapper.style.minWidth = '';
        $wrapper.classList.remove(EXPANDED_CLASS);
        $input.value = '';
      }

      $wrapper.addEventListener('click', expand);
      if ($close) $close.addEventListener('click', collapse);
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sizzle"] && !Shopify.designMode) return;
  try {
    
  (function initSizzleReel() {
    const MOBILE_BREAKPOINT = 440;

    const $section = document.querySelector('.sizzle');
    if (!$section) return;

    const $playBtn = $section.querySelector('[data-sizzle-play]');
    const $desktopVideo = $section.querySelector('.sizzle__video--desktop');
    const $mobileVideo = $section.querySelector('.sizzle__video--mobile');
    let $activeVideo = null;

    if (!$playBtn || !$desktopVideo) return;

    function resolveVideoElement() {
      const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
      return (isMobile && $mobileVideo) ? $mobileVideo : $desktopVideo;
    }

    function openReel() {
      const $video = resolveVideoElement();
      if (!$video) return;

      teardownReel();

      $activeVideo = $video;
      $video.hidden = false;

      if ($video.requestFullscreen) {
        $video.requestFullscreen().then(function playOnFullscreen() {
          return $video.play();
        }).catch(function handleFullscreenError() {
          teardownReel();
        });
      } else if ($video.webkitEnterFullscreen) {
        $video.webkitEnterFullscreen();
        $video.play();
      }
    }

    function teardownReel() {
      if (!$activeVideo) return;

      $activeVideo.pause();
      $activeVideo.currentTime = 0;
      $activeVideo.hidden = true;
      $activeVideo = null;
    }

    function handleFullscreenExit() {
      if (!document.fullscreenElement) {
        teardownReel();
      }
    }

    $playBtn.addEventListener('click', openReel);
    document.addEventListener('fullscreenchange', handleFullscreenExit);
    $desktopVideo.addEventListener('webkitendfullscreen', teardownReel);
    if ($mobileVideo) {
      $mobileVideo.addEventListener('webkitendfullscreen', teardownReel);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-media-carousel"] && !Shopify.designMode) return;
  try {
    
  (function initializeSocialCarouselDrag() {
    const $carousel = document.querySelector('.carousel-instagram');
    const $primaryTrack = document.querySelector('.carousel-instagram__track--primary');
    const $secondaryTrack = document.querySelector('.carousel-instagram__track--secondary');

    if (!$carousel || !$primaryTrack || !$secondaryTrack) return;

    const DRAG_THRESHOLD = 5;
    const DECELERATION = 0.92;
    const MIN_VELOCITY = 0.3;
    const VELOCITY_SAMPLES = 5;
    const MOMENTUM_SCALE = 8;
    const RESUME_DELAY_MS = 2000;

    let isDown = false;
    let startX = 0;
    let hasDragged = false;
    let velocityX = 0;
    let lastX = 0;
    let lastTime = 0;
    let animationId = null;
    let velocityHistory = [];
    let resumeTimeoutId = null;
    let scrollPosition = 0;
    let dragStartScrollPosition = 0;
    let isUsingJsAnimation = false;
    let autoScrollAnimationId = null;
    let lastAutoScrollTime = 0;
    let isHovering = false;

    function getTrackWidth() {
      return parseFloat(getComputedStyle($carousel).getPropertyValue('--carousel-instagram-track-width')) || 1;
    }

    function getAnimationDuration() {
      return parseFloat(getComputedStyle($carousel).getPropertyValue('--carousel-instagram-duration')) || 10;
    }

    function getComputedTranslateX($element) {
      const style = window.getComputedStyle($element);
      const matrix = style.transform || style.webkitTransform;
      if (!matrix || matrix === 'none') return 0;
      const values = matrix.match(/matrix.*\((.+)\)/);
      if (!values) return 0;
      const parts = values[1].split(', ');
      return parseFloat(parts[4]) || 0;
    }

    function normalizeScrollPosition(position) {
      const trackWidth = getTrackWidth();
      let normalized = position % trackWidth;
      if (normalized < 0) {
        normalized += trackWidth;
      }
      return normalized;
    }

    function setTrackPositions() {
      const trackWidth = getTrackWidth();
      const normalized = normalizeScrollPosition(scrollPosition);
      const primaryOffset = -normalized;
      const secondaryOffset = trackWidth - normalized;
      $primaryTrack.style.transform = 'translate3d(' + primaryOffset + 'px, 0, 0)';
      $secondaryTrack.style.transform = 'translate3d(' + secondaryOffset + 'px, 0, 0)';
    }

    function captureCurrentScrollPosition() {
      const primaryX = getComputedTranslateX($primaryTrack);
      scrollPosition = normalizeScrollPosition(-primaryX);
    }

    function disableCssAnimation() {
      $primaryTrack.style.animation = 'none';
      $secondaryTrack.style.animation = 'none';
      isUsingJsAnimation = true;
    }

    function autoScrollStep(currentTime) {
      if (!lastAutoScrollTime) {
        lastAutoScrollTime = currentTime;
      }

      const deltaTime = currentTime - lastAutoScrollTime;
      lastAutoScrollTime = currentTime;

      const trackWidth = getTrackWidth();
      const duration = getAnimationDuration() * 1000;
      const pixelsPerMs = trackWidth / duration;

      scrollPosition += pixelsPerMs * deltaTime;
      setTrackPositions();

      autoScrollAnimationId = requestAnimationFrame(autoScrollStep);
    }

    function startAutoScroll() {
      if (autoScrollAnimationId) {
        cancelAnimationFrame(autoScrollAnimationId);
      }
      lastAutoScrollTime = 0;
      autoScrollAnimationId = requestAnimationFrame(autoScrollStep);
    }

    function stopAutoScroll() {
      if (autoScrollAnimationId) {
        cancelAnimationFrame(autoScrollAnimationId);
        autoScrollAnimationId = null;
      }
      lastAutoScrollTime = 0;
    }

    function pauseForInteraction() {
      if (resumeTimeoutId) {
        clearTimeout(resumeTimeoutId);
        resumeTimeoutId = null;
      }

      if (!isUsingJsAnimation) {
        captureCurrentScrollPosition();
        disableCssAnimation();
        setTrackPositions();
      } else {
        stopAutoScroll();
      }
    }

    function scheduleResumeAutoScroll() {
      if (resumeTimeoutId) {
        clearTimeout(resumeTimeoutId);
      }
      resumeTimeoutId = setTimeout(function resumeAutoScroll() {
        $carousel.classList.remove('carousel-instagram--dragging');
        if (!isHovering) {
          startAutoScroll();
        }
      }, RESUME_DELAY_MS);
    }

    function calculateAverageVelocity() {
      if (velocityHistory.length === 0) return 0;
      const sum = velocityHistory.reduce(function addVelocity(a, b) {
        return a + b;
      }, 0);
      return sum / velocityHistory.length;
    }

    function momentumStep() {
      if (Math.abs(velocityX) <= MIN_VELOCITY) {
        animationId = null;
        scheduleResumeAutoScroll();
        return;
      }

      velocityX *= DECELERATION;
      scrollPosition -= velocityX;
      setTrackPositions();

      animationId = requestAnimationFrame(momentumStep);
    }

    function applyMomentum() {
      if (animationId) {
        cancelAnimationFrame(animationId);
      }
      animationId = requestAnimationFrame(momentumStep);
    }

    let activePointerId = null;
    let isTouch = false;

    function startDragging(e) {
      if (activePointerId !== null) return;

      if (animationId) {
        cancelAnimationFrame(animationId);
        animationId = null;
      }

      pauseForInteraction();
      dragStartScrollPosition = scrollPosition;

      activePointerId = e.pointerId;
      isTouch = e.pointerType === 'touch';
      isDown = true;
      hasDragged = false;
      $carousel.classList.remove('carousel-instagram--dragging');
      velocityX = 0;
      velocityHistory = [];
      startX = e.pageX;
      lastX = startX;
      lastTime = performance.now();

      if (!isTouch) {
        $carousel.style.cursor = 'grabbing';
      }

      document.addEventListener('pointermove', handleDragMove);
      document.addEventListener('pointerup', stopDragging);
      document.addEventListener('pointercancel', stopDragging);
    }

    function stopDragging(e) {
      if (!isDown || e.pointerId !== activePointerId) return;

      document.removeEventListener('pointermove', handleDragMove);
      document.removeEventListener('pointerup', stopDragging);
      document.removeEventListener('pointercancel', stopDragging);

      activePointerId = null;
      isDown = false;

      if (!isTouch) {
        $carousel.style.cursor = '';
      }

      const timeSinceLastMove = performance.now() - lastTime;
      const isStationary = timeSinceLastMove > 50;

      if (isStationary || !hasDragged) {
        velocityX = 0;
        scheduleResumeAutoScroll();
        return;
      }

      velocityX = calculateAverageVelocity() * MOMENTUM_SCALE;

      if (Math.abs(velocityX) > MIN_VELOCITY) {
        applyMomentum();
      } else {
        scheduleResumeAutoScroll();
      }
    }

    function handleDragMove(e) {
      if (!isDown || e.pointerId !== activePointerId) return;

      const currentTime = performance.now();
      const x = e.pageX;
      const walk = x - startX;

      if (!hasDragged && Math.abs(walk) > DRAG_THRESHOLD) {
        hasDragged = true;
        $carousel.classList.add('carousel-instagram--dragging');
      }

      if (hasDragged) {
        e.preventDefault();
      }

      const timeDelta = currentTime - lastTime;
      if (timeDelta > 0) {
        const instantVelocity = (x - lastX) / timeDelta;
        velocityHistory.push(instantVelocity);
        if (velocityHistory.length > VELOCITY_SAMPLES) {
          velocityHistory.shift();
        }
      }

      lastX = x;
      lastTime = currentTime;

      scrollPosition = dragStartScrollPosition - walk;
      setTrackPositions();
    }

    function preventClickAfterDrag(e) {
      if (hasDragged) {
        e.preventDefault();
        e.stopPropagation();
      }
    }

    function preventLinkDrag(e) {
      e.preventDefault();
    }

    function setupLinkDragPrevention() {
      const $links = $carousel.querySelectorAll('a');
      $links.forEach(function attachPreventDrag($link) {
        $link.addEventListener('dragstart', preventLinkDrag);
      });
    }

    setupLinkDragPrevention();
    $carousel.style.touchAction = 'pan-y';
    $carousel.addEventListener('pointerdown', startDragging);
    $carousel.addEventListener('click', preventClickAfterDrag, true);

    $carousel.addEventListener('mouseenter', function handleMouseEnter() {
      isHovering = true;
      if (isUsingJsAnimation && !isDown) {
        stopAutoScroll();
      }
    });

    $carousel.addEventListener('mouseleave', function handleMouseLeave() {
      isHovering = false;
      if (isUsingJsAnimation && !isDown && !animationId) {
        startAutoScroll();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toast-notification-system"]) return;
  try {
    
  (function toastNotificationSystem() {
    const ToastType = Object.freeze({
      NEWSLETTER: Symbol('newsletter'),
      LOCATION: Symbol('location'),
      ADDED_TO_CART: Symbol('added-to-cart'),
      CUSTOM: Symbol('custom'),
      NEWSLETTER_RESULT: Symbol('newsletter-result'),
    });

    const STORAGE_KEY_LOCATION_DISMISSED = 'toast-location-dismissed-country';
    const STORAGE_KEY_NEWSLETTER_SUBSCRIBED = 'toast-newsletter-subscribed';
    const COOKIE_NEWSLETTER_DISMISSED = 'toast-newsletter-dismissed';
    const NEWSLETTER_DISMISS_DAYS = 1;

    const TOAST_ANIMATION_MS = 600;

    const TOAST_IMAGE_WIDTH = 100;

    let openNewsletterPanel = null;

    const $container = document.querySelector('[data-toast-container]');
    if (!$container) return;

    function parseAutoDismissSeconds(raw) {
      const parsed = parseInt(raw, 10);
      return Number.isFinite(parsed) && parsed >= 0 ? parsed : 5;
    }

    const LOCATION_AUTO_DISMISS_SECONDS = parseAutoDismissSeconds($container.dataset.locationAutoDismissSeconds);
    const NEWSLETTER_AUTO_DISMISS_SECONDS = parseAutoDismissSeconds($container.dataset.newsletterAutoDismissSeconds);

    function getCookie(name) {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? match[2] : null;
    }

    function setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/;SameSite=Lax';
    }

    function resizeShopifyCdnImage(url, width) {
      if (!url) return '';
      const separator = url.indexOf('?') === -1 ? '?' : '&';
      return url + separator + 'width=' + width;
    }

    function showToast(type, onDismiss) {
      const templateName = type.description;
      const $template = $container.querySelector('[data-toast-template="' + templateName + '"]');
      if (!$template) return null;

      const $clone = $template.content.cloneNode(true);
      const $toast = $clone.firstElementChild;

      const $closeBtn = $toast.querySelector('[data-toast-close]');
      if ($closeBtn) {
        $closeBtn.addEventListener('click', function handleDismiss() {
          if (onDismiss) onDismiss();
          const isSwipeDismiss = $toast.hasAttribute('data-swipe-dismissing');
          dismissToast($toast, type, isSwipeDismiss ? { skipAnimation: true } : undefined);
        });
      }

      $container.appendChild($clone);
      requestAnimationFrame(function revealToast() {
        $toast.classList.add('toast--revealed');
      });
      return $toast;
    }

    function getSiblingToasts($excludeToast) {
      const siblings = [];
      const children = $container.children;
      for (let i = 0; i < children.length; i++) {
        const child = children[i];
        if (child !== $excludeToast && child.tagName !== 'TEMPLATE') {
          siblings.push(child);
        }
      }
      return siblings;
    }

    function flipSiblings(siblings, positionsBefore) {
      siblings.forEach(function animateSibling($sibling, index) {
        const after = $sibling.getBoundingClientRect().top;
        const delta = positionsBefore[index] - after;
        if (delta === 0) return;
        $sibling.style.transition = 'none';
        $sibling.style.transform = 'translateY(' + delta + 'px)';
        requestAnimationFrame(function playFlip() {
          $sibling.style.transition = 'transform 600ms cubic-bezier(0.9, 0, 0.1, 1)';
          $sibling.style.transform = '';

          function cleanupFlip() {
            $sibling.removeEventListener('transitionend', handleTransitionEnd);
            $sibling.style.transition = '';
          }

          function handleTransitionEnd(e) {
            if (e.propertyName !== 'transform') return;
            cleanupFlip();
          }

          $sibling.addEventListener('transitionend', handleTransitionEnd);
          setTimeout(cleanupFlip, TOAST_ANIMATION_MS + 50);
        });
      });
    }

    function dismissToast($toast, type, options) {
      if ($toast.hasAttribute('data-toast-dismissed')) return;
      $toast.setAttribute('data-toast-dismissed', '');

      const skipAnimation = options && options.skipAnimation;

      if (type === ToastType.LOCATION) {
        const currentCountry = $container.dataset.currentCountry;
        localStorage.setItem(STORAGE_KEY_LOCATION_DISMISSED, currentCountry);
      }

      if (type === ToastType.NEWSLETTER) {
        setCookie(COOKIE_NEWSLETTER_DISMISSED, '1', NEWSLETTER_DISMISS_DAYS);
        sessionStorage.removeItem('toast-newsletter-page-views');
      }

      if (skipAnimation) {
        $toast.style.pointerEvents = 'none';
        return;
      }

      const siblings = getSiblingToasts($toast);
      const positionsBefore = siblings.map(function recordPosition($sibling) {
        return $sibling.getBoundingClientRect().top;
      });

      $toast.classList.add('toast--dismissing');
      setTimeout(function removeAndFlip() {
        $toast.remove();
        flipSiblings(siblings, positionsBefore);
      }, TOAST_ANIMATION_MS);
    }

    function startAutoDismiss($toast, toastType) {
      let seconds = 0;
      if (toastType === ToastType.LOCATION) seconds = LOCATION_AUTO_DISMISS_SECONDS;
      if (toastType === ToastType.NEWSLETTER) seconds = NEWSLETTER_AUTO_DISMISS_SECONDS;
      if (seconds === 0) return;

      let remainingMs = seconds * 1000;
      let startedAt = Date.now();
      let timeoutId = null;
      let isHovered = false;
      let isFocused = false;
      let isSelectOpen = false;

      const $select = $toast.querySelector('[data-toast-locale-select]');

      function startTimer() {
        if (timeoutId !== null) return;
        clearTimeout(timeoutId);
        startedAt = Date.now();
        timeoutId = setTimeout(function autoDismiss() {
          dismissToast($toast, toastType);
        }, remainingMs);
      }

      function pauseTimer() {
        if (timeoutId === null) return;
        clearTimeout(timeoutId);
        timeoutId = null;
        remainingMs = Math.max(0, remainingMs - (Date.now() - startedAt));
      }

      function syncTimer() {
        if (isHovered || isFocused || isSelectOpen) {
          pauseTimer();
        } else {
          startTimer();
        }
      }

      $toast.addEventListener('pointerenter', function handlePointerEnter(e) {
        if (e.pointerType !== 'mouse') return;
        isHovered = true;
        syncTimer();
      });

      $toast.addEventListener('pointerleave', function handlePointerLeave(e) {
        if (e.pointerType !== 'mouse') return;
        isHovered = false;
        syncTimer();
      });

      $toast.addEventListener('focusin', function handleFocusIn() {
        isFocused = true;
        syncTimer();
      });

      $toast.addEventListener('focusout', function handleFocusOut(e) {
        if ($toast.contains(e.relatedTarget)) return;
        isFocused = false;
        syncTimer();
      });

      if ($select) {
        let consumeNextSelectClick = false;
        let pickerStoleWindowFocus = false;
        let openWatcherRunning = false;

        function closeSelect() {
          if (!isSelectOpen) return;
          isSelectOpen = false;
          consumeNextSelectClick = false;
          pickerStoleWindowFocus = false;
          syncTimer();
        }

        function openSelect() {
          isSelectOpen = true;
          watchNativePicker();
          syncTimer();
        }

        function cleanupSelectListeners() {
          document.removeEventListener('pointerdown', handleDocumentPointerDown, true);
          window.removeEventListener('blur', handleWindowBlur);
          window.removeEventListener('focus', handleWindowFocus);
        }

        function watchNativePicker() {
          if (openWatcherRunning) return;
          openWatcherRunning = true;

          let seenOpen = false;
          const watchDeadline = Date.now() + 500;

          function watch() {
            if (!isSelectOpen || !$toast.isConnected) {
              openWatcherRunning = false;
              if (!$toast.isConnected) cleanupSelectListeners();
              return;
            }

            let isPickerOpen = false;
            try {
              isPickerOpen = $select.matches(':open');
            } catch (err) {
              isPickerOpen = false;
            }

            if (isPickerOpen) {
              seenOpen = true;
              requestAnimationFrame(watch);
              return;
            }

            if (seenOpen) {
              openWatcherRunning = false;
              closeSelect();
              return;
            }

            if (Date.now() < watchDeadline) {
              requestAnimationFrame(watch);
              return;
            }

            openWatcherRunning = false;
          }

          requestAnimationFrame(watch);
        }

        function handleWindowBlur() {
          if (isSelectOpen) pickerStoleWindowFocus = true;
        }

        function handleWindowFocus() {
          if (!$toast.isConnected) {
            cleanupSelectListeners();
            return;
          }
          if (!pickerStoleWindowFocus) return;
          closeSelect();
        }

        function handleDocumentPointerDown(e) {
          if (!$toast.isConnected) {
            cleanupSelectListeners();
            return;
          }
          if (!isSelectOpen) return;
          if (e.target === $select || $select.contains(e.target)) return;
          closeSelect();
        }

        $select.addEventListener('pointerdown', function handleSelectPointerDown() {
          if (!isSelectOpen) consumeNextSelectClick = true;
          openSelect();
        });

        $select.addEventListener('pointerup', function handleSelectPointerUp() {
          setTimeout(function releaseOpeningClick() {
            consumeNextSelectClick = false;
          }, 0);
        });

        $select.addEventListener('pointercancel', function handleSelectPointerCancel() {
          consumeNextSelectClick = false;
        });

        $select.addEventListener('touchstart', function handleSelectTouchStart() {
          openSelect();
        }, { passive: true });

        $select.addEventListener('click', function handleSelectClick() {
          if (consumeNextSelectClick) {
            consumeNextSelectClick = false;
            return;
          }
          closeSelect();
        });

        $select.addEventListener('keydown', function handleSelectKeydown(e) {
          if (e.key === 'Escape' || e.key === 'Tab') {
            closeSelect();
            return;
          }

          const opensPicker = e.key === ' ' || e.key === 'Enter' || e.key === 'F4' || e.key === 'ArrowDown' || e.key === 'ArrowUp';
          if (!opensPicker) return;
          openSelect();
        });

        $select.addEventListener('change', function handleSelectChange() {
          closeSelect();
        });

        document.addEventListener('pointerdown', handleDocumentPointerDown, true);
        window.addEventListener('blur', handleWindowBlur);
        window.addEventListener('focus', handleWindowFocus);
      }

      startTimer();
    }

    (function initEscapeKeyDismissal() {
      document.addEventListener('keydown', function handleEscapeKey(e) {
        if (e.key !== 'Escape') return;
        if (document.querySelector('.newsletter-panel-container--active')) return;
        if (document.querySelector('.toast-video-modal--active')) return;
        const $toast = $container.lastElementChild;
        if (!$toast || $toast.tagName === 'TEMPLATE') return;
        if ($toast.classList.contains('toast--dismissing')) return;
        const $closeBtn = $toast.querySelector('[data-toast-close]');
        if ($closeBtn) $closeBtn.click();
      });
    })();

    (function initSwipeToDismiss() {
      const SWIPE_THRESHOLD_PX = 80;
      const SWIPE_OPACITY_DIVISOR = 200;
      const SWIPE_TRANSITION_MS = 300;

      let touchStartX = 0;
      let touchStartY = 0;
      let lastDeltaX = 0;
      let $swipingToast = null;
      let isSwiping = false;

      function handleTouchStart(e) {
        const $toast = e.target.closest('.toast');
        if (!$toast || $toast.classList.contains('toast--dismissing')) return;

        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        lastDeltaX = 0;
        $swipingToast = $toast;
        isSwiping = false;
      }

      function handleTouchMove(e) {
        if (!$swipingToast) return;

        const deltaX = e.touches[0].clientX - touchStartX;
        const deltaY = e.touches[0].clientY - touchStartY;

        if (!isSwiping && Math.abs(deltaY) > Math.abs(deltaX)) {
          $swipingToast = null;
          return;
        }

        if (deltaX <= 0) {
          lastDeltaX = 0;
          if (isSwiping) {
            $swipingToast.style.transform = '';
            $swipingToast.style.opacity = '';
          }
          return;
        }

        isSwiping = true;
        lastDeltaX = deltaX;
        e.preventDefault();

        $swipingToast.style.transition = 'none';
        $swipingToast.style.transform = 'translateX(' + deltaX + 'px)';
        $swipingToast.style.opacity = String(Math.max(0, 1 - deltaX / SWIPE_OPACITY_DIVISOR));
      }

      function handleTouchEnd() {
        if (!$swipingToast || !isSwiping) {
          $swipingToast = null;
          return;
        }

        const swipeTransition = 'transform ' + SWIPE_TRANSITION_MS + 'ms ease-out, opacity ' + SWIPE_TRANSITION_MS + 'ms ease-out';

        if (lastDeltaX >= SWIPE_THRESHOLD_PX) {
          $swipingToast.setAttribute('data-swipe-dismissing', '');
          const $closeBtn = $swipingToast.querySelector('[data-toast-close]');
          if ($closeBtn) $closeBtn.click();

          const $dismissing = $swipingToast;
          requestAnimationFrame(function animateSwipeOut() {
            $dismissing.style.transition = swipeTransition;
            $dismissing.style.transform = 'translateX(120%)';
            $dismissing.style.opacity = '0';
          });

          setTimeout(function removeAfterSwipe() {
            const siblings = getSiblingToasts($dismissing);
            const positionsBefore = siblings.map(function recordPosition($sibling) {
              return $sibling.getBoundingClientRect().top;
            });
            $dismissing.remove();
            flipSiblings(siblings, positionsBefore);
          }, SWIPE_TRANSITION_MS);
        } else {
          const $returning = $swipingToast;
          $returning.style.transition = swipeTransition;
          $returning.style.transform = 'translateX(0)';
          $returning.style.opacity = '1';

          function cleanupSnapBack() {
            $returning.style.transition = '';
            $returning.style.transform = '';
            $returning.style.opacity = '';
            $returning.removeEventListener('transitionend', cleanupSnapBack);
          }

          $returning.addEventListener('transitionend', cleanupSnapBack);
          setTimeout(cleanupSnapBack, SWIPE_TRANSITION_MS + 50);
        }

        $swipingToast = null;
        isSwiping = false;
        lastDeltaX = 0;
      }

      $container.addEventListener('touchstart', handleTouchStart, { passive: true });
      $container.addEventListener('touchmove', handleTouchMove, { passive: false });
      $container.addEventListener('touchend', handleTouchEnd, { passive: true });
    })();

    (function initLocationToast() {
      if ($container.dataset.locationToastEnabled !== 'true') return;

      const currentCountry = $container.dataset.currentCountry;
      const dismissedCountry = localStorage.getItem(STORAGE_KEY_LOCATION_DISMISSED);

      const hasBeenDismissedForCurrentCountry = dismissedCountry === currentCountry;
      if (hasBeenDismissedForCurrentCountry) return;

      const $toast = showToast(ToastType.LOCATION);
      if ($toast) startAutoDismiss($toast, ToastType.LOCATION);
    })();

    (function initLocalizationForm() {
      const $form = document.getElementById('ToastLocalizationForm');
      if (!$form) return;

      function handleCountryChange(e) {
        if (e.target.name !== 'country_code') return;
        if (typeof $form.requestSubmit === 'function') {
          $form.requestSubmit();
        } else {
          $form.submit();
        }
      }

      $form.addEventListener('change', handleCountryChange);
    })();

    (function initNewsletterToast() {
      if ($container.dataset.newsletterToastEnabled !== 'true') return;

      const isSubscribed = $container.dataset.customerSubscribed === 'true';
      if (isSubscribed) return;

      const hasSubscribed = localStorage.getItem(STORAGE_KEY_NEWSLETTER_SUBSCRIBED) === '1';
      if (hasSubscribed) return;

      const hasBeenRecentlyDismissed = getCookie(COOKIE_NEWSLETTER_DISMISSED) !== null;
      if (hasBeenRecentlyDismissed) return;

      const DEFAULT_PAGE_THRESHOLD = 10;
      const parsedThreshold = parseInt($container.dataset.newsletterPageThreshold, 10);
      const NEWSLETTER_PAGE_THRESHOLD = Number.isFinite(parsedThreshold) && parsedThreshold >= 1 ? parsedThreshold : DEFAULT_PAGE_THRESHOLD;

      const SESSION_KEY_PAGE_VIEWS = 'toast-newsletter-page-views';

      const storedViews = parseInt(sessionStorage.getItem(SESSION_KEY_PAGE_VIEWS) || '0', 10);
      if (storedViews < NEWSLETTER_PAGE_THRESHOLD) {
        sessionStorage.setItem(SESSION_KEY_PAGE_VIEWS, String(storedViews + 1));
      }

      if (storedViews + 1 < NEWSLETTER_PAGE_THRESHOLD) return;

      const $toast = showToast(ToastType.NEWSLETTER);
      if ($toast) {
        startAutoDismiss($toast, ToastType.NEWSLETTER);
        $toast.addEventListener('click', function handleOpenPanel(e) {
          if (e.target.closest('[data-toast-close]')) return;
          dismissToast($toast, ToastType.NEWSLETTER);
          if (openNewsletterPanel) openNewsletterPanel();
        });
      }
    })();

    (function initNewsletterPanel() {
      const $panelContainer = document.querySelector('[data-newsletter-panel-container]');
      if (!$panelContainer) return;

      const $headerGroup = document.querySelector('.header-group');
      if ($headerGroup) $headerGroup.appendChild($panelContainer);

      const $panel = $panelContainer.querySelector('[data-newsletter-panel]');
      const $closeBtn = $panelContainer.querySelector('[data-newsletter-panel-close]');
      const $title = $panelContainer.querySelector('[data-newsletter-panel-title]');
      const $img = $panelContainer.querySelector('[data-newsletter-panel-img]');
      const $imgText = $panelContainer.querySelector('[data-newsletter-panel-img-text]');
      const $description = $panelContainer.querySelector('[data-newsletter-panel-description]');
      const $form = document.getElementById('newsletter-form');

      const defaultTitle = $title ? $title.textContent : '';
      const defaultImgSrc = $img ? $img.src : '';
      const defaultImgAlt = $img ? $img.alt : '';
      const defaultImgText = $imgText ? $imgText.textContent : '';
      const defaultDescription = $description ? $description.textContent : '';

      let $tagInput = null;
      let restoreGeneration = 0;

      function applyOverrides(detail) {
        if (!detail) return;
        if (detail.title && $title) $title.textContent = detail.title;
        if (detail.imageUrl && $img) {
          $img.style.opacity = '0';
          $img.src = detail.imageUrl;
          $img.alt = detail.title || defaultImgAlt;
          $img.addEventListener('load', function handleOverrideImageLoad() {
            $img.style.opacity = '';
          }, { once: true });
          $img.addEventListener('error', function handleOverrideImageError() {
            $img.src = defaultImgSrc;
            $img.alt = defaultImgAlt;
            $img.style.opacity = '';
          }, { once: true });
        }
        if (detail.imageText && $imgText) $imgText.textContent = detail.imageText;
        if (detail.description && $description) $description.textContent = detail.description;
        if (detail.tag && $form) {
          if ($tagInput) {
            $tagInput.remove();
            $tagInput = null;
          }
          $tagInput = document.createElement('input');
          $tagInput.type = 'hidden';
          $tagInput.name = 'contact[tags]';
          $tagInput.value = detail.tag;
          $form.appendChild($tagInput);
        }
      }

      function restoreDefaults() {
        if ($title) $title.textContent = defaultTitle;
        if ($img) {
          $img.style.opacity = '';
          $img.src = defaultImgSrc;
          $img.alt = defaultImgAlt;
        }
        if ($imgText) $imgText.textContent = defaultImgText;
        if ($description) $description.textContent = defaultDescription;
        if ($tagInput) {
          $tagInput.remove();
          $tagInput = null;
        }
      }

      openNewsletterPanel = function openPanel(detail) {
        if ($panelContainer.classList.contains('newsletter-panel-container--active')) return;
        restoreGeneration++;
        applyOverrides(detail);
        $panelContainer.classList.add('newsletter-panel-container--active');
        if (window.innerWidth <= 1220) document.body.style.overflow = 'hidden';
        document.addEventListener('click', handleOutsideClick);
        document.addEventListener('keydown', handlePanelEscape);
      };

      document.addEventListener('megamac:newsletter:open', function handleExternalOpen(e) {
        if (openNewsletterPanel) openNewsletterPanel(e.detail);
      });

      const PANEL_TRANSITION_MS = 300;

      function closePanel() {
        $panelContainer.classList.remove('newsletter-panel-container--active');
        document.body.style.overflow = '';
        document.removeEventListener('click', handleOutsideClick);
        document.removeEventListener('keydown', handlePanelEscape);
        const expectedGeneration = ++restoreGeneration;
        setTimeout(function deferredRestore() {
          if (restoreGeneration !== expectedGeneration) return;
          restoreDefaults();
        }, PANEL_TRANSITION_MS);
      }

      function handleOutsideClick(e) {
        if ($panel.contains(e.target)) return;
        if (e.target.closest('.toast--newsletter')) return;
        if (e.target.closest('[data-footer-newsletter-link]')) return;
        if (e.target.closest('[data-lc-open-panel]')) return;
        closePanel();
      }

      function handlePanelEscape(e) {
        if (e.key !== 'Escape') return;
        closePanel();
      }

      if ($closeBtn) {
        $closeBtn.addEventListener('click', function handleCloseClick(e) {
          e.preventDefault();
          e.stopPropagation();
          closePanel();
        });
      }

      if ($form) {
        $form.addEventListener('submit', function handleFormSubmit() {
          const $btn = $form.querySelector('[data-newsletter-form-btn]');
          if ($btn) {
            $btn.disabled = true;
            $btn.textContent = 'Subscribing...';
          }
        });
      }

      const $emailInput = document.getElementById('newsletter-email');
      const isTouchDevice = window.matchMedia('(pointer: coarse)').matches;
      if ($emailInput && isTouchDevice) {
        const KEYBOARD_SETTLE_DELAY_MS = 350;
        $emailInput.addEventListener('focus', function handleEmailFocus() {
          setTimeout(function scrollEmailIntoView() {
            $emailInput.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }, KEYBOARD_SETTLE_DELAY_MS);
        });
      }
    })();

    (function initFormResultToast() {
      const $formResult = document.querySelector('[data-newsletter-form-result]');
      if (!$formResult) return;

      const resultType = $formResult.dataset.newsletterFormResult;
      const SUCCESS_MESSAGE = "You're in! Thanks for subscribing.";
      const errorMessage = $formResult.dataset.newsletterFormErrorMessage || 'Something went wrong. Please try again.';
      const message = resultType === 'success' ? SUCCESS_MESSAGE : errorMessage;

      if (resultType === 'success') {
        const isGuest = $container.dataset.customerSubscribed === 'false';
        if (isGuest) {
          localStorage.setItem(STORAGE_KEY_NEWSLETTER_SUBSCRIBED, '1');
        }
        sessionStorage.removeItem('toast-newsletter-page-views');

        const $activeNewsletterToast = $container.querySelector('.toast--newsletter');
        if ($activeNewsletterToast) {
          dismissToast($activeNewsletterToast, ToastType.NEWSLETTER);
        }
      }

      const $toast = showToast(ToastType.NEWSLETTER_RESULT);
      if (!$toast) return;

      const $message = $toast.querySelector('[data-toast-form-result-message]');
      if ($message) $message.textContent = message;
    })();

    (function initCustomToasts() {
      const STORAGE_KEY_PREFIX = 'toast-custom-dismissed-';
      const $customToasts = $container.querySelectorAll('[data-toast-custom]');

      const currentHashes = [];
      $customToasts.forEach(function collectHash($toast) {
        if ($toast.dataset.customContentHash) {
          currentHashes.push($toast.dataset.customContentHash);
        }
      });

      for (let i = localStorage.length - 1; i >= 0; i--) {
        const key = localStorage.key(i);
        if (!key || !key.startsWith(STORAGE_KEY_PREFIX)) continue;
        const hash = key.slice(STORAGE_KEY_PREFIX.length);
        if (currentHashes.indexOf(hash) === -1) {
          localStorage.removeItem(key);
        }
      }

      $customToasts.forEach(function initSingleCustomToast($toast) {
        const contentHash = $toast.dataset.customContentHash;
        if (!contentHash) return;

        const storageKey = STORAGE_KEY_PREFIX + contentHash;
        const isDismissed = localStorage.getItem(storageKey) === '1';
        if (isDismissed) {
          $toast.remove();
          return;
        }

        const $closeBtn = $toast.querySelector('[data-toast-close]');
        if ($closeBtn) {
          $closeBtn.addEventListener('click', function handleCustomDismiss() {
            localStorage.setItem(storageKey, '1');
            const isSwipeDismiss = $toast.hasAttribute('data-swipe-dismissing');
            dismissToast($toast, ToastType.CUSTOM, isSwipeDismiss ? { skipAnimation: true } : undefined);
          });
        }

        const hasVideo = $toast.hasAttribute('data-custom-video');
        if (hasVideo) {
          $toast.style.cursor = 'pointer';
          $toast.addEventListener('click', function handleCustomVideoClick(e) {
            if (e.target.closest('[data-toast-close]')) return;
            e.preventDefault();
            const blockId = $toast.dataset.toastBlockId || '';
            const $modal = document.querySelector('[data-toast-video-modal="' + blockId + '"]');
            if ($modal) openVideoModal($modal);
          });
        }

        const $videoBtns = $toast.querySelectorAll('[data-toast-btn-video]');
        $videoBtns.forEach(function bindBtnVideo($btn) {
          $btn.addEventListener('click', function handleBtnVideoClick(e) {
            e.stopPropagation();
            const modalId = $btn.dataset.toastBtnVideo;
            const $modal = document.querySelector('[data-toast-video-modal="' + modalId + '"]');
            if ($modal) openVideoModal($modal);
          });
        });

        requestAnimationFrame(function revealCustomToast() {
          $toast.classList.add('toast--revealed');
        });
      });
    })();

    (function initVideoModals() {
      const $modals = document.querySelectorAll('[data-toast-video-modal]');
      if ($modals.length === 0) return;

      const mobileQuery = window.matchMedia('(max-width: 440px)');

      mobileQuery.addEventListener('change', function handleBreakpointChange() {
        $modals.forEach(function swapActiveVideo($modal) {
          if (!$modal.classList.contains('toast-video-modal--active')) return;
          const $allVideos = $modal.querySelectorAll('.toast-video-modal__video');
          $allVideos.forEach(function pauseAll($v) { $v.pause(); });
          const $next = getActiveVideo($modal);
          if ($next) {
            $next.volume = 0.25;
            $next.play().catch(function() {});
          }
        });
      });

      $modals.forEach(function bindModalClose($modal) {
        $modal.addEventListener('click', function handleBackdropClick(e) {
          if (e.target === $modal) closeVideoModal($modal);
        });
      });

      document.addEventListener('keydown', function handleVideoModalEscape(e) {
        if (e.key !== 'Escape') return;
        $modals.forEach(function closeIfActive($modal) {
          if (!$modal.classList.contains('toast-video-modal--active')) return;
          closeVideoModal($modal);
        });
      });
    })();

    function getActiveVideo($modal) {
      const $contents = $modal.querySelectorAll('.toast-video-modal__content');
      for (let i = 0; i < $contents.length; i++) {
        if ($contents[i].offsetParent !== null || getComputedStyle($contents[i]).display !== 'none') {
          return $contents[i].querySelector('.toast-video-modal__video');
        }
      }
      return $modal.querySelector('.toast-video-modal__video');
    }

    function openVideoModal($modal) {
      $modal.classList.add('toast-video-modal--active');
      document.body.style.overflow = 'hidden';
      const $video = getActiveVideo($modal);
      if ($video) {
        $video.volume = 0.25;
        $video.play().catch(function() {});
      }
    }

    function closeVideoModal($modal) {
      $modal.classList.remove('toast-video-modal--active');
      document.body.style.overflow = '';
      const $videos = $modal.querySelectorAll('.toast-video-modal__video');
      $videos.forEach(function pauseVideo($video) {
        $video.pause();
        $video.currentTime = 0;
      });
    }

    (function initAddedToCartToast() {
      const AUTO_DISMISS_MS = 8000;
      const SESSION_KEY_CART_TOASTS = 'toast-added-to-cart-queue';

      const activeToastsByVariant = {};

      function getStoredToasts() {
        const raw = sessionStorage.getItem(SESSION_KEY_CART_TOASTS);
        if (!raw) return [];
        try { return JSON.parse(raw); } catch (_) { return []; }
      }

      function saveToasts(toasts) {
        sessionStorage.setItem(SESSION_KEY_CART_TOASTS, JSON.stringify(toasts));
      }

      function removeStoredToast(expiresAt) {
        const toasts = getStoredToasts().filter(function excludeExpired(t) {
          return t.expiresAt !== expiresAt;
        });
        saveToasts(toasts);
      }

      function trackToast(variantId, $toast, expiresAt, timeoutId) {
        if (!variantId) return;
        const key = String(variantId);
        if (!activeToastsByVariant[key]) {
          activeToastsByVariant[key] = [];
        }
        activeToastsByVariant[key].push({ $toast: $toast, expiresAt: expiresAt, timeoutId: timeoutId });
      }

      function untrackToast(variantId, expiresAt) {
        if (!variantId) return;
        const key = String(variantId);
        if (!activeToastsByVariant[key]) return;
        activeToastsByVariant[key] = activeToastsByVariant[key].filter(function keepOthers(entry) {
          return entry.expiresAt !== expiresAt;
        });
        if (activeToastsByVariant[key].length === 0) {
          delete activeToastsByVariant[key];
        }
      }

      function renderCartToast(data, remainingMs) {
        function cleanupToast() {
          const entry = getTrackedEntry(data.variantId, data.expiresAt);
          if (entry) clearTimeout(entry.timeoutId);
          removeStoredToast(data.expiresAt);
          untrackToast(data.variantId, data.expiresAt);
        }

        const $toast = showToast(ToastType.ADDED_TO_CART, cleanupToast);
        if (!$toast) return;

        const $image = $toast.querySelector('[data-toast-product-image]');
        const $title = $toast.querySelector('[data-toast-product-title]');
        const $addedTitle = $toast.querySelector('[data-toast-added-title]');
        const $checkoutForm = $toast.querySelector('form');

        if ($checkoutForm) {
          $checkoutForm.addEventListener('submit', function handleCheckoutSubmit() {
            const $checkoutBtn = $checkoutForm.querySelector('[data-toast-checkout]');
            if ($checkoutBtn) $checkoutBtn.textContent = 'Loading...';
          });
        }

        if ($addedTitle && data.quantity > 1) {
          $addedTitle.textContent = 'Added (' + data.quantity + ')!';
        }

        if ($image) {
          $image.src = data.imageUrl
            ? data.imageUrl
            : resizeShopifyCdnImage(data.image, TOAST_IMAGE_WIDTH);
          $image.alt = data.title;
        }

        if ($title) {
          $title.textContent = data.title;
        }

        let timerRemainingMs = remainingMs;
        let timerStartedAt = Date.now();

        function autoDismiss() {
          cleanupToast();
          dismissToast($toast, ToastType.ADDED_TO_CART);
        }

        function startTimer() {
          timerStartedAt = Date.now();
          const entry = getTrackedEntry(data.variantId, data.expiresAt);
          const id = setTimeout(autoDismiss, timerRemainingMs);
          if (entry) entry.timeoutId = id;
          return id;
        }

        function pauseTimer() {
          const entry = getTrackedEntry(data.variantId, data.expiresAt);
          if (entry) clearTimeout(entry.timeoutId);
          const elapsed = Date.now() - timerStartedAt;
          timerRemainingMs = Math.max(0, timerRemainingMs - elapsed);
        }

        $toast.addEventListener('pointerenter', function handlePointerEnter(e) {
          if (e.pointerType !== 'mouse') return;
          pauseTimer();
        });
        $toast.addEventListener('pointerleave', function handlePointerLeave(e) {
          if (e.pointerType !== 'mouse') return;
          startTimer();
        });

        const timeoutId = startTimer();
        trackToast(data.variantId, $toast, data.expiresAt, timeoutId);
      }

      function getTrackedEntry(variantId, expiresAt) {
        if (!variantId) return null;
        const entries = activeToastsByVariant[String(variantId)];
        if (!entries) return null;
        return entries.find(function matchByExpiry(entry) {
          return entry.expiresAt === expiresAt;
        }) || null;
      }

      function handleCartAdded(e) {
        if (e && e.detail && e.detail.source === 'undo') return;
        if (
          ((window.MegaMacCart &&
            window.MegaMacCart.addToCartFeedbackMode &&
            window.MegaMacCart.addToCartFeedbackMode()) ||
            'drawer') !== 'notification'
        )
          return;

        const addedItem = e.detail && e.detail.addedItem;
        if (!addedItem) return;

        const addedQuantity = (e.detail && e.detail.addedQuantity) || 1;
        const expiresAt = Date.now() + AUTO_DISMISS_MS;
        const toastData = {
          title: addedItem.product_title || addedItem.title,
          image: addedItem.featured_image ? addedItem.featured_image.url : addedItem.image,
          imageUrl: (e.detail && e.detail.imageUrl) || '',
          variantId: String(addedItem.variant_id || addedItem.id || ''),
          quantity: addedQuantity,
          expiresAt: expiresAt,
        };

        const stored = getStoredToasts();
        stored.push(toastData);
        saveToasts(stored);

        renderCartToast(toastData, AUTO_DISMISS_MS);
      }

      function handleCartRemoved(e) {
        const removedVariantId = e.detail && e.detail.removedVariantId;
        if (!removedVariantId) return;

        const key = String(removedVariantId);
        const entries = activeToastsByVariant[key];
        if (!entries || entries.length === 0) return;

        entries.forEach(function dismissEntry(entry) {
          clearTimeout(entry.timeoutId);
          removeStoredToast(entry.expiresAt);
          dismissToast(entry.$toast, ToastType.ADDED_TO_CART);
        });
        delete activeToastsByVariant[key];
      }

      (function restorePersistedToasts() {
        if (
          ((window.MegaMacCart &&
            window.MegaMacCart.addToCartFeedbackMode &&
            window.MegaMacCart.addToCartFeedbackMode()) ||
            'drawer') !== 'notification'
        )
          return;

        const stored = getStoredToasts();
        const now = Date.now();
        const stillValid = stored.filter(function isNotExpired(t) {
          return t.expiresAt > now;
        });

        saveToasts(stillValid);

        stillValid.forEach(function restoreToast(data) {
          const remainingMs = data.expiresAt - now;
          renderCartToast(data, remainingMs);
        });
      })();

      document.addEventListener('megamac:cart:added', handleCartAdded);
      document.addEventListener('megamac:cart:removed', handleCartRemoved);
    })();
  })();

  } catch(e) { console.error(e); }
})();
})();
